import common from './jwys/common_es';
import footer from './jwys/system/footer_es';
import emptyVanBook from "./jwys/send/emptyVanBook_es";
import waybillFill from "./jwys/send/waybillFill_es";
import transportStatistics from "./jwys/order/transportStatistics_es";

//按照菜单顺序从左到右，子菜单从上到下排序
export default {
  //公共部分
  common,

  //TODO 首页


  //TODO 首页end


  //TODO 发送业务
  emptyVanBook,//铁路箱预定
  waybillFill,//自备箱发货
  //TODO 发送业务end


  //TODO 到达业务
  arrivalBusiness: {
    cxtj: 'ສົ່ງໃໝ່ອີກຄັ້ງ',
    sfjz: 'ຮອດສະຖານນີລົດໄຟແລ້ວບໍ່',
    wjz: 'ຍັງບໍ່ທັນເຂົ້າສະຖານີ',
    yjz: 'ເຂົ້າສະຖານີແລ້ວ',
    sczt: 'ສະຖານະຖືກລຶບ',
    ysc: 'ລຶບແລ້ວ',
    wsc: 'ຍັງບໍ່ໄດ້ລຶບ',
    pdr: 'ຜູ້ມອບວຽກງງານ',
    ygq: 'ໝົດອາຍຸແລ້ວ',
    yscz: 'ຍົກເລີກແລ້ວ',
  },
  //TODO 到达业务end


  //TODO 货运服务

  //TODO 货运服务end


  //TODO 办理指南

  //TODO 办理指南end


  //TODO 联系我们

  //TODO 联系我们end


  //TODO 我的订单
  transportStatistics,
  //TODO 我的订单end


  //TODO 系统设置
  footer,
  //TODO 系统设置end
  jzxyz: {
    hxzt: 'ສະຖານະຕູ້ຄອນເທນເນີ ສົ່ງກັບຄືນ',
    cmrq: 'ວັນທີອອກຈາກປະຕູ',
    sscz: 'ສະຖານີທີ່ສັງກັດຢູ່',
    hxsq: 'ການສະເໜີສົ່ງຕູ້ຄອນເທນເນີກັບຄືນ',
    hxqr: 'ຢືນຢັນສົ່ງຕູ້ຄອນເທນເນີກັບຄືນ',
    jkh: 'ປ້າຍລົດບັນທຸກ',
    qrm: 'ລະຫັດຢືນຢັນ',
    yqrhx: 'ຢືນຢັນການສົ່ງຕູ້ຄອນເທນເນີກັບຄືນແລ້ວ'
  },
  roleManagement: {
    czlx: 'ປະເພດການດຳເນີນງານ',
    czjg: 'ຜົນສະຫຼຸບການດຳເນີນງານ',
    cznr: 'ເນື້ອຫາການດຳເນີນງານ:',
    // bbh:'版本号',
    // bbmc:'版本名称',
    // bbxt:'版本系统',
    // gxtsy:'更新提示语',
    // sfqz:'是否强制',
    // bxy:'不需要',
    // xy:'需要',

    czsj: 'ໂປຣເເກຣມ:',
    jsmc: 'ຊື່ເຂດຂໍ້ມູນ',
    ms: 'ຄຳບັນຍາຍ',
    czysl: 'ຈໍານວນຕູ້',
    cjsj: 'ສ້າງ:',
    jsxx: 'Role information',
    qxxx: 'ຂໍ້ມູນເພື່ອອະນຸຍາດສິດຂອງ',
    zs1: 'ກະລຸນາໃສ່ຊື່ບໍລິກໂຕເລກ ທີ່ບໍ່ມີຕົກໂຕເລກ',
    zs2: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງເຊັກສອນຫນ້ວຍອັກສອນຫລືໂຕເລກ',
    czyh: 'Operator number',
    czyxm: 'ຊື່ຜູ້ຈັດຜູ້ໃຊ້',
    czylx: 'ຮູບແບບຜູ້ໃຊ້',
    tlj: 'ໂປຣເເກຣມຫ້ອງການ',
    qsrtlj: 'ກະລຸນາໃສ່ຄະນະກໍາມະການທໍາດ້',
    zm: 'ຊື່ໂຕເລືອກ',
    qsrzm: 'ກະລຸນາໃສ່ຊື່ໂຕເລືອກ',
    tjsj: 'ເພີ່ມເວລາ:',
    mmcz: 'ຕັ້ງຄ່າລະຫັດຜ່ານ',
    zhxx: 'ຂໍ້ມູນເພີ້ມບັນຊີຜູ້ໃຊ້',
    ssj: 'ໂປຣເເກຣມຫ້ອງການ',
    ssz: 'ສະຖານະການທີ່ກ່ຽວຂ້ອງ',
    zcyjs: 'ເຂດຂໍ້ມູນ',
    qtxx: 'ຂໍ້ມູນອື່ນໆ',
    sjh: 'ໂຕອັກສອນ ໂທລະສັບເເບບທີ່',
    sfzhm: 'ບໍ່ມີຊ່ວເລກໂຕເລກ',

  },
  index: {
    jzxYz: 'ການເຄື່ອນຍ້າຍຕູ້ຄອນເທນເນີ',
    zwhx: 'ການສົ່ງຕູ້ຄອນເທນເນີກັບຄືນ ຢູ່ ນອກສະຖານີ',
    sy: 'ໜ້າຫຼັກ',
    ysfw: 'ບໍລິການການຂົນສົ່ງ',
    smjy: 'ການເຮັດທຸລະກໍາ',
    tsyjy: 'ຄໍາຮ້ອງທຸກ ແລະ ຄໍາແນະນໍາ',
    gjfw: 'ການບໍລິການລະຫວ່າງປະເທດ',
    tlxyd: 'ການສັ່ງຈອງຕູ້ລົດໄຟ',
    tlxydllys: 'ການຈອງຕູ້ຄອນເທນເນີຂອງທາງລົດໄຟ - ການຂົນສົ່ງແບບຄວບຄຸມຄວາມເຢັນ',
    glydtx: 'ຂຽນໃບຂົນສົ່ງສິນຄ້າສາກົນ',
    rxqtx: 'ຂຽນໃບສະເໜີຄວາມຕ້ອງການປະຈໍາວັນ',
    gjfw1: 'ບໍລິການເພື່ອທ່ານ“',
    gjfw2: 'ວ່ອງໄວ, ເພີງພາໄດ້ ແລະໝັ້ນຄົງ',
    gjfw3: '” ບໍລິການຂົນສົ່ງດ້ວຍລົດໄຟຂ້າມພົມແດນ ຢ່າງມີຄຸນນະພາບສູງ',
    gnfw: '”ເປັນບໍລິສັດດຽວໃນລາວ ທີ່ໃຫ້ບໍລິການຂົນສົ່ງດ້ວຍລົດໄຟຂ້າມພົມແດນ ຢ່າງມີຄຸນນະພາບສູງ',
    zbxfh: 'ການຂົນສົ່ງຕູ້ຂອງຕົນເອງ',
    zbxfhllys: 'ການຈັດສົ່ງສິນຄ້າດ້ວຍຕູ້ຄອນເທນເນີຂອງຕົນເອງ - ການຂົນສົ່ງແບບຄວບຄຸມຄວາມເຢັນ',
    gnfwt: 'ບໍລິການພາຍໃນປະເທດ',
    lyfwp: '”ບໍລິການຂົນສົ່ງດ້ວຍລະບົບຕູ້ແຊເຢັນຜ່ານເສັ້ນທາງລົດໄຟ ຢ່າງມີຄຸນນະພາບສູງ.',
    lyfwt: 'ຂົນສີນຄ້າໂດຍນຳໃຊ້ຕູຄອນເທັນເນີເຮັດຄວາມເຢັນ',

    title: 'ການຂົນສົ່ງສາກົນທາງລົດໄຟລາວ-ຈີນ',
    hello: 'ສະບາຍດີ',
    grsz: 'ການຕັ້ງຄ່າສ່ວນຕົວ',
    yhxxwh: 'ການປ້ອງກັນຂໍ້ມູນຜູ້ນໍາໃຊ້',
    shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    hz_hdbd: 'ການກ່ຽວພັນຂອງຕົວແທນຂົນສົ່ງສິນຄ້າ/ເຈົ້າຂອງສິນຄ້າ',
    jbrgl: 'ການຄຸ້ມຄອງຜູ້ປະສານງານ ',
    xgmm: 'ປ່ຽນລະຫັດຜ່ານ',
    tcdl: 'ອອກຈາກລະບົບ',
    fsyw: 'ທຸລະກໍາການຈັດສົ່ງ',
    gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',
    gnys: 'ຂົນສົ່ງພາຍໃນປະເທດ',
    yxqtb: 'ແຈ້ງແຜນຕອ້ງການຂົນສົ່ງສີນຄ້າປະຈຳເດືອນ',
    rxqtb: 'ບົດລາຍງານຄວາມຕ້ອງການປະຈໍາວັນ',
    glydtb: 'ຂຽນຟອມໃບຂົນສົ່ງສິນຄ້າສາກົນ',
    zx: 'ໂຫຼດເຄືອງເຂົ້າຕູຄອນເທເນີ',
    ddyw: 'ທຸລະກຳການຮັບສີນຄ້າ',
    yylx: 'ນັດຮັບສິນຄ້າ',
    yyhx: 'ນັດການສົ່ງຕູ້ຄືນ',
    hyfw: 'ບໍລິການການຂົນສົ່ງ',
    hwzz: 'ການຕິດຕາມສີ້ນຄ້າ',
    glhwzz: 'ການຕິດຕາມສິນຄ້າລະຫວ່າງປະເທດ',
    gnhwzz: 'ຕິດຕາມສິນຄ້າພາຍໃນປະເທດ',
    ddyc: 'ຄາດຄະເນເວລາມາຮອດ',
    zxcxx: 'ຂໍ້ມູນການຂື້ນລົງລົດ',
    yfcx: 'ກວດສອບຄ່າຂົນສົ່ງ',
    hwlp: 'ການຮຽກຮ້ອງຊົດເຊີຍສິນຄ້າ',
    blzn: 'ການແນະນໍາວິທີການດໍາເນີນການ',
    baox: 'ປະກັນໄພ',
    lxwm: 'ຕິດຕໍ່ຫາພວກເຮົາ',
    tsjy: 'ຄຳແນະນຳການຮຽກຮ້ອງ',
    myOrders: 'ໃບສັ່ງຈອງສິນຄ້າ ຂອງຂ້ອຍ',
    ddzx: 'ສູນລາຍການຈອງ',
    yxqlb: 'ຕາຕະລາງສັງລວມຄວາມຕ້ອງການ ປະຈໍາເດືອນ',
    ydxlb: 'ຕາຕະລາງສັງລວມການສັ່ງຈອງຕູ້ຄອນເທນເນີ',
    rxqlb: 'ຕາຕະລາງສັງລວມຄວາມຕ້ອງການ ປະຈໍາວັນ',
    glydlb: 'ຕາຕະລາງສັງລວມ ໃບຂົນສົ່ງສິນຄ້າສາກົນ',
    ydzf: 'ຍົກເລີກໃບບິນ',
    czyxglyd: "ໃບຂົນສົ່ງສິນຄ້າລະຫວ່າງປະເທດ ຍັງຢູ່ໃນສະຖານະມີຜົນນໍາໃຊ້ຢູ່, ບໍ່ສາມາດຍົກເລີກໄດ້",
    hytj: 'ລວບລວມຂໍ້ມູນການຂົນສົ່ງສິນຄ້າ',
    jqsddcx: 'ຄົ້ນຫາໃບຮັບຈັດສົ່ງສິນຄ້າ',
    jqsddcqr: 'ເຊັນອະນຸມັດໃບຮັບຈັດສົ່ງສິນຄ້າ',
    wdpj: 'ໃບບິນຂອງຂ້ອຍ',
    yfkjymx: 'ລາຍລະອຽດທຸລະກໍາການຊໍາລະເງິນລ່ວງໜ້າ',
    pjqr: 'ຢືນຢັນໃບບິນ',
    qrtczh: 'ຢືນຢັນອອກຈາກບັນຊີບໍ່?',
    tis: 'ຄໍາແນະນໍາ',
    qd: 'ຢືນຢັນແນ່ນອນ',
    qx: 'ຍົກເລີກ',
    ydh_xh: 'ເລກທີໃບຂົນສົ່ງ/ເລກຕູ້',
    qsrydh_xh: 'ກາລຸນາລະບຸເລກບິນໃບຂົນສົ່ງສິນຄ້າ/ເລກຕູ້',
    sjhm: 'ເບີໂທລະສັບ',
    yzm: 'ລະຫັດຢືນຢັນ',
    djhq: 'ຄລິກເພື່ອຮັບ',
    ljcx: 'ສອບຖາມຕອນນີ້',
    wyfh: 'ຂ້ອຍຕ້ອງການຈັດສົ່ງສິນຄ້າ',
    wylh: 'ຂ້ອຍຕ້ອງການຮັບສິນຄ້າ',
    ywzd: 'ການແນະນໍາທາງທຸລະກໍາ',
    czfw: 'ການບໍລິການຢູ່ສະຖານນີລົດ',
    xwzx: 'ຂໍ້ມູນຂ່າວສານ',
    ckqb: 'ກວດສອບທັງໝົດ',
    tzgg: 'ແຈ້ງການ',
    xxcxblzn: 'ການຊອກຫາຂໍ້ມູນແລະດຳເນີນການ',
    qsryzm: 'ກາລຸນາລະບຸລະຫັດຢືນຢັນ',
    appxz: 'ດາວໂຫຼດ App',
    fwcx: 'ສອບຖາມການບໍລິການ',
    fwrx: 'ສາຍດ່ວນບໍລິການ',
    wtfk: 'ຜົນຕອບຮັບຂອງບັນຫາ',
    yyxz: 'ເລືອກພາສາ',
    glydtbllys: 'ຕື່ມຂໍ້ມູນໃສ່ໃນການຂົນສົ່ງລະບົບຕ່ອງໂສ້ເຢັນລະຫວ່າງປະເທດ',
    cxfy: 'ຄ່າທໍານຽມຄົ້ນຫາຂໍ້ມູນ',
    czxx: 'ຂໍ້ມູນ ສະຖານນີລົດໄຟ',
    bllc: 'ຂັ້ນຕອນການດໍາເນີນການ',
  },
  oneClickDelivery: {
    blhg: 'ດໍາເນີນເອກະສານກ່ຽວກັບດ່ານພາສີ ແລະຈົດບັນທຶກວຽກງານບໍລິຫານອື່ນໆ',
    fhrsm: 'ຜູ້ສົ່ງສິນຄ້າລະບຸຂໍ້ມູນເພີ່ມເຕີມ',
    tip255: 'ຕູ້ເປົ່າ',
    tip476: 'ຕູ້ໜັກ',
    tip260: 'ສະພາບນ້ຳໜັກຕູ້ເປົ່າ',
    qxzkhmc: 'ກະລຸນາເລືອກຊື່ລູກຄ້າ',
    yjfh: 'ກົດເທື່ອດຽວໃນການຂົນສົງ',
    apxs: 'ຈັດຈໍານວນຕູ້ຄອນເທນເນີ',
    fh: 'ສົ່ງສິນຄ້າ',
    kxxx: 'ຂໍ້ມູນຕູ້ຄອນເທນເນີເປົ່າ',
    bjzz: 'ນໍ້າໜັກລວມ(KG)ທີ່ເຮັດເຄື່ອງໝາຍໄວ້',
    tpinfo: 'ເນື້ອໃນດັ່ງລຸ່ມນີ້ຕ້ອງໃຫ້ສອດຄ່ອງກັບໃບແຈ້ງພາສີ, ກະລຸນາຕື່ມຂໍມູນໃສ່ໃຫ້ລະອຽດ',
    ghhthm: 'ເລກທີສັນຍາການສະໜອງສິນຄ້າ',
    ycyrwgxx: 'ຂໍ້ມູນບໍ່ກ່ຽວຂ້ອງກັບຜູ້ໃຫ້ບໍລິການຂົນສົ່ງ',
    dpx: 'ລໍຖ້າການຈັດສັນ ຕູ້ຄອນເທນເນີ ',
    ypx: 'ຈັດຕູ້ໃຫ້ແລ້ວ',
    txw: 'ສໍາເລັດການຈັດສັນ ຕູ້ຄອນເທນເນີ',
    lxtz: 'ແຈ້ງການຮັບຕູ້ຄອນເທນເນີ',
    jzyy: 'ການຈອງເຂົ້າສະຖານີ',
    jzxydh: 'ເລກທີການຈອງຕູ້ຄອນເທນເນີ',
    lxlx: 'ປະເພດຕູ້ຄອນເທນເນີ ທີ່ຮັບ',
    xxx: 'ຂໍ້ມູນຕູ້ຄອນເທນເນີ',
    tzsj: 'ເວລາແຈ້ງການ',
    qyyjz: 'ຈອງຄິວເຂົ້າສະຖານີ',
    yylx: 'ປະເພດການຈອງ',
    yyjzrq: 'ວັນທີການຈອງເຂົ້າສະຖານີ',
    cheh: 'ຖອນກັບ',
    ckjzm: 'ກວດເບິ່ງລະຫັດເຂົ້າສະຖານີ',
    lx: 'ຮັບຕູ້ຄອນເທນເນີ',
    sx: 'ສົ່ງຕູ້ຄອນເທນເນີ',
    jzlx: 'ປະເພດຕູ້ເຂົ້າສະຖານີ',
    jzrq: 'ວັນທີເຂົ້າສະຖານີ',
    xzxqd: 'ເລືອກແບບຟອມໃບຄໍາຮ້ອງ',
    jqsdfw: 'ບໍລິການຮັບຈັດສົ່ງ',
    wlgs: 'ບໍລິສັດ ໂລຈິສຕິກ',
    qsdz: 'ທີ່ຢູ່ຮັບສົ່ງ',
    kch: 'ໝາຍເລກລົດບັນທຸກ',
    siji: 'ຄົນຂັບລົດ',
    xzmdzshqkkchhsj:'ເມື່ອເວລາເລືອກທາງເຂົ້າສະຖານນີລົດໄຟແລ້ວ, ເລກລົດບັນທຸກ ແລະຂໍ້ມູນຄົນຂັບຈະຖືກລຶບລ້າງ, ຢືນຢັນຈະດໍາເນີນການຕໍ່ບໍ່ ?',
    txrqddrq: 'ວັນທີຮັບເອົາຕູ້ຄອນເທນເນີ/ວັນທີຕູ້ຄອນເທນເນີມາຮອດ',
    qxzcz: 'ກະລຸນາເລືອກສະຖານີລົດ',
    qwsjzyyxx: 'ກະລຸນາຕື່ມຂໍ້ມູນການຈອງເຂົ້າສະຖານີໃຫ້ລະອຽດ',
    jzm: 'ລະຫັດການເຂົ້າສະຖານີ',
    yxqx: 'ໄລຍະເວລາທີ່ມີຜົນນໍາໃຊ້',
    lckm: 'ໄລຍະທາງ(km)',
    ysrqts: 'ຖ້າກໍານົດວັນທີຈັດສົ່ງໄດ້ແລ້ວ, ກະລຸນາຕື່ມຂໍ້ມູນໃສ່ແບບຟອມ',
    dxxx: 'ຂໍ້ມູນຈອງຕູ້',
    dxxxts: 'ກະລຸນາເລືອກຄວາມຕ້ອງການປະຈໍາເດືອນ ຫຼັງຈາກນັ້ນຕື່ມຂໍ້ມູນໃສ່',
    kxxxts: 'ພາຍຫຼັງສະຖານີຍອມຮັບແລ້ວ ກໍ່ຈະສະແດງໃຫ້ເຫັນ',
    ysxxts: 'ກະລຸນາຢືນຢັນວັນທີຂົນສົ່ງຫຼັງຈາກນັ້ນຕື່ມຂໍ້ມູນໃສ່',
    sfch: "ຕ້ອງການຍ້ອນກັບບໍ່",
    bljd: "ຄວາມຄືບໜ້າຂອງການດໍາເນີນງານ",
    yjzlkx: "ຮອດສະຖານນີລົດໄຟແລ້ວ(ຮັບຕູ້ຄອນເທນເນີເປົ່າ)",
    yczlkx: "ກໍາລັງເຂົ້າສະຖານນີລົດໄຟ(ສົ່ງຕູ້ຄອນເທນເນີທີ່ມີສິນຄ້າ)",
    yjzszx: "ຮອດສະຖານນີລົດໄຟ(ສົ່ງຕູ້ຄອນເທນເນີທີ່ມີສິນຄ້າ)",
    yczszx: "ອອກສະຖານນີລົດໄຟແລ້ວ(ສົ່ງຕູ້ຄອນເທນເນີທີ່ມີສິນຄ້າ)",
    yjzlzx: "ຮອດສະຖານນີລົດໄຟ(ຮັບຕູ້ຄອນເທນເນີທີ່ມີສິນຄ້າ)",
    yczlzx: "ກໍາລັງເຂົ້າສະຖານນີລົດໄຟ(ສົ່ງຕູ້ຄອນເທນເນີເປົ່າ)",
    yjzskx: "ຮອດສະຖານນີລົດໄຟແລ້ວ(ສົ່ງຕູ້ຄອນເທນເນີເປົ່າ)",
    yczskx: "ອອກສະຖານນີລົດໄຟແລ້ວ(ສົ່ງຕູ້ຄອນເທນເນີເປົ່າ)",
  },
  accept: {
    tbsj: 'ເວລາ ການແຈ້ງເຕືອນ',
    qxz: 'ກະລຸນາເລືອກ',
    zt: 'ສະຖານະ',
    dsl: 'ຖ້າການຍອມຮັບ',
    sltg: 'ຜ່ານການຍອມຮັບ',
    yzf: 'ຍົກເລີກ',
    cx: 'ຄົ້ນຫາ',
    qk: '(ລົບຂໍ້ມູນທັງໝົດ)',
    tjjy: 'ສົ່ງຄຳແນະນຳ',
    dsltsjy: 'ການຕິດຕັ້ງ ແລະ ຂໍແນະນຳ ເພື່ອຍອມຮັບໄດ້',
    t: '3',
    slsj: 'ວັນຖືກສອນຫລັງ:',
    tszt: 'ຫົວຂໍ້ການຮຽກຮ້ອງ:',
    tsnr: 'ເນື້ອຫາການຮຽກຮ້ອງ',
    fj: 'ຂໍ້ຄວາມຈຳ',
    ck: 'ກວດເບິ່ງ',
    tsz: 'ສະຖານະຂໍ້ມູນ',
    tsrxm: 'ຊື່ຜູ້ຄົກຖາມ',
    tsrsfzhm: 'ໂຕເລກໂຕເລກຂອງ ຕົບຜູ້ຕ່າງໆ',
    lxfs: 'ຂໍ້ມູນແພັກເກດ',
    yx: 'ໂຕອັກສອນ',
    yb: 'ຊື່ເລກໂຕເລກ:',
    tsrdz: 'ບັນຮູ້ຂອງຜູ້ຈົດເຫັບຜູ້ຕ່າງໆ',
    cz: 'ການດຳເນີນການ',
    slxq: 'ບໍ່ມີຂໍ້ມູນລາຍລະອຽດຂອງ',
    sl: 'ກຳລັດເຈົ້າວ',
    zf: 'ຈ່າຍເງິນ',
    slyj: 'ຍອມຮັບຄຳແປ',
    qx: 'ຍົກເລີອກ',
    qd: 'ເພີ່ມເຕີມ',
    qsrnr: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງ',
    jdxq: 'ຂໍ້ມູນເພີ້ມກ່ຽວຂ້ອງ',
    sljg: 'ບໍ່ຮູ້ໃຊ້ຜົນກະທົບ',
    czy: 'ຜູ້ຈັດເເຈກ',
    fjlb: 'ລາຍການໄຟລ໌ເເນບ',
    zxyl: 'ເຕົມຄຳແດ້ນພິມງານ',
    xz: 'ເພີ່ມເຕີມ',
    tsjy: 'ຄຳແນະນຳການຮຽກຮ້ອງ',
    jbxx: 'ຂໍ້ມູນພື້ນຖານ',
    tsxx: 'ຂໍ້ມູນທີ່ເຂົ້າຮ່ວມ',
    scfj: 'ຕິດຕັ້ງຂໍ້ມູນ',
    jwjtdcc: 'ກະລຸນາໃສ່ແຟ້ມໃສ່ນ, ຫລືອ',
    djsc: 'ຄລິກເພື່ອອັບໂຫລດ',
    tj: 'ສົ່ງອອກ',
    fh: 'ກັບຄືນ',

  },
  backlog: {
    fhf: 'ສະຖານີຕົ້ນທາງ',
    shf: 'ຜູ້ຮັບສິນຄ້າ',
    hydl: 'ຍີນດີເຂົ້າໂປຣເເກຣມ',
    nscdlsjs: 'ໂຕເລືອກໃນການເຂົ້າຮ່ອນໃຕ່',
    dbsx: 'ເພື່ອເຮັດວຽກ',
    zcsh: 'ເບີ່ງເເຍງໂປຣເເກຣມ',
    qyxxxgsh: 'ປັບປຸງຂໍ້ມູນກ່ຽວກັບ ການບັນທຶກ',
    jdxqsl: 'ສະຖານະການຕ້ອງອາໃສ່ການສືບສຳຫ້',
    rxqsl: 'ການຕ້ອງອາໃສທີ່ປະຈຸບັນ',
    zcxhtsh: 'ສຶກສາກ່ຽວກັບການແພັກເກດ ແລະ ສ່າງຄວາມຮູ້ຕ່າງໆ',
    lpsl: 'ຍອມຮັບການຮຽກຮ້ອງ',
    tsjy: 'ຄຳແນະນຳການຮຽກຮ້ອງ',
    ycktx: 'ຂະບວນການຕ້າງລາຍການຕ່າງໆທີ່ສຸດ',
    ltgl: 'ເບີ່ງເເຍງຂໍ້ມູນ',
    zxhf: 'ການຕອບກັບໃໝ່ລ່າສຸດ',
    htzs: 'ຫົວຂໍ້ທັງໝົດ',
    t: '3',
    xh: 'ລໍາດັບ',
    tbsj: 'ເວລາ ການແຈ້ງເຕືອນ',
    xm: 'ມີບັນທຶກ',
    sfzh: 'ເລກໂຕເລກ',
    js: 'ບົດຄວາມສະດວກ',
    qymc: 'ຊື່ທົ່ວໄປ:',
    cz: 'ການດຳເນີນການ',
    sh: 'ເພື່ອກວດສອບ',
    yhmc: 'ຊື່ຜູ້ໃຊ້',
    jdxqh: 'ເລກຄວາມຕ້ອງການປະຈຳເດືອນ',
    hwpm: 'ສິນຄ້າ',
    ds: 'ໂຕງານ',
    tyf: 'ຜູ້ຂົນສົ່ງສິນຄ້າ',
    sl: 'ກຳລັດເຈົ້າວ',
    rxqtbsl: 'ຂະບວນການຕ້ອງການໃສ່ໃຈ ແລະ ຍອມຮັບຮອງຕ່າງໆ',
    xqdh: 'ຕອບສະຫນອງຂໍ້ມູນ:',
    xqcs: 'ຈຳນວນລົດທີ່ຮ້ອງຂໍ',
    fz: 'ສະຖານີທີ່ອອກເດີນທາງ',
    dz: 'ສະຖານີປາຍທາງ',
    ddbgsl: 'ການຮັບຮອງຕ່າງໆໃນການປ່ຽນແປງລະບົບ',
    cc: 'ໂຕເລກໂຮງ',
    clzt: 'ສະຖານະຂໍ້ມູນ',
    bgdz: 'ປ່ຽນສະຖານີປາຍທາງ',
    bgshf: 'ຮູ້ຈັດເເຈກ',
    hth: 'ໂຕກຕ່າງໆ:',
    tbqy: 'ບໍລິສັດ ທີ່ແຈ້ງເຕືອນ',
    ydh: 'ກໍລະນີສຶດ ',
    ht: 'ສົນທະນາ',
    xq: 'ຂໍ້ມູນລາຍລະອຽດ',
    ycktxsh: 'ກວດສອບການຖອນເງີນຊຳລະລ່ວງໜ້າ',
    txje: 'ຈຳນວນເງີນທີ່ຖອນ(ຢວນ)',
  },
  containerDelate: {
    crumbs0: 'ຕົວໄປ',
    crumbs1: 'ຍົກເລີກໃບບິນ',
    xqdgl: 'ການຄຸ້ມຄອງຄໍາສັ່ງຄວາມຕ້ອງການ',
    ydzfts: 'ລວມທັງຂໍ້ມູນເລກຕູ້ຄອນເທນເນີ ທີ່ບໍ່ສາມາດຍົກເລີກໄດ້',
    ydhw: 'ເລກທີໃບຂົນສົ່ງແມ່ນ',
    jdjhh: 'ເລກທີແຜນການໄລຍະຂັ້ນຕອນ',
    hyxhdsjbkzf: "ລວມທັງຂໍ້ມູນເລກຕູ້ຄອນເທນເນີ ທີ່ບໍ່ສາມາດຍົກເລີກໄດ້",
    xgjdjh: "ດັດແກ້ ແຜນການໄລຍະຂັ້ນຕອນ",
    qxzxtydhsj: "ກະລຸນາເລືອກຂໍ້ມູນໝາຍເລກການຈອງດຽວກັນ"
  },
  freightInfo: {
    zfrq: 'ວັນທີຈ່າຍເງິນ',
    pjlx: 'ປະເພດໃບບິນ',
    zf: 'ຄ່າໃຊ້ຈ່າຍຕ່າງໆ',
    yf: 'ຄ່າຂົນສົ່ງ',
    zt: 'ຄືນຄ່າເບັດຕະເລັດ',
    yt: 'ຄືນຄ່າຂົນສົ່ງ',
    zhuangt: 'ສະຖານະ',
    yzf: 'ຍົກເລີກ',
    dzf: 'ລໍຖ້າຊຳລະ',
    zfzt: 'ສະຖານະການຊໍາລະ',
    fkr: 'ຜູ້ຈ່າຍເງິນ',
    zfsj: 'ເວລາຈ່າຍເງິນ',
    zhifu: 'ຈ່າຍເງິນ',
    tk: 'ຄືນເງິນ',
    ytk: 'ຄືນເງິນແລ້ວ',
    plzf: 'ຈ່າຍເປັນງວດ',
    fy: 'ຄ່າໃຊ້ຈ່າຍ',
    yck: 'ເງິນຝາກລ່ວງໜ້າ',
    xj: 'ເງິນສົດ',
    bczf: 'ຈ່າຍໃນຄັ້ງນີ້',
    yebz: 'ຍອດເງິນບໍ່ພຽງພໍ, ກະລຸນາເຕີມເງິນທີ່ອິນເຕີເຟສການຈັດການເງິນຝາກລ່ວງໜ້າ!',

    hsxx: 'ຢືນຢັນຂໍ້ມູນ',
    he: 'ຢືນຢັນ',
    jq: 'ຮັບເອົາ',
    sd: 'ສົ່ງເຖິງ',
    nr: 'ເນື້ອໃນ',
    gxrq: 'ວັນທີອັບເດດ',
    qsrfplx: 'ກະລຸນາໃສ່ປະເພດໃບບິນ',
    xxxxrxdz: 'ລາຍລະອຽດມີດັ່ງນີ້, ທີ່ຢູ່',
    qsrtlj: 'ກະລຸນາໃສ່ສໍານັກງານທາງລົດໄຟ',
    wjlqywd: 'ເພື່ອສ້າງເອກະສານຂອງບໍລິສັດແລະສະແດງບໍລິສັດໃນເວທີການຄ້າທຸລະກິດ,ກະລຸນາຂຽນປະຫວັດຫຍໍ້ຂອງບໍລິສັດຢ່າງລະອຽດ',
    sczj: 'ອັບໂຫລດເອກະສານຢັ້ງຢືນ',
    shtg: 'ຜ່ານການກວດສອບ',
    swdjdz: 'ທີ່ຢູ່ລົງທະບຽນພາສີ',
    qygflj: 'ລິ້ງທາງການຂອງວິສາຫະກິດ',
    sh: 'ກວດສອບທົບທວນ',
    jymx: 'ລາຍລະອຽດທຸລະກຳ',
    czje: 'ຈໍານວນຕື່ມເງິນ',
    ydbs: 'ຈຳນວນໃບບິນ',
    ydfy: 'ຄ່າໃຊ້ຈ່າຍໃບບິນ',
    hzbs: 'ມີໃບຂົນສົ່ງສິນຄ້າເບັດຕະເລັດຈໍານວນ',
    hzfy: 'ຄ່າໃຊ້ຈ່າຍຕ່າງໆ',
    tkbs: 'ຈໍານວນການຄືນເງິນ',
    tkfy: 'ລາຍຈ່າຍຄືນເງິນ',
    ckpz: 'ກວດເບິ່ງຫຼັກຖານ',
    yfzf: 'ຈ່າຍຄ່າຂົນສົ່ງ',
    tbr: 'ຜູ້ຂຽນ',
    ptjl: 'ບັນທຶກທຳມະດາ',
    fhjbr: 'ຜູ້ດຳເນີນການສົ່ງສິນຄ້າ',
    fhjbrdh: 'ເບີໂທຜູ້ດຳເນີນການສົ່ງສິນຄ້າ',
    xxxh: 'ຮູບແບບຕູ້ປະເພດຕູ້',
    zj: 'ກະແຈຫຼັກ',
    dfrq: 'ເວລາສົ່ງແລະຮອດ',
    cljjd: 'ໃບສົ່ງມອບລົດ',
    glyd: 'ໃບບິນຂົນສົ່ງສາກົນ',
    cljjdh: 'ໝາຍເລກໃບສົ່ງມອບລົດ',
    nf: 'ປີ',
    gjzmc: 'ຊື່ສະຖານີຊາຍແດນ',
    jfcyrmc: 'ຊື່ຜູ້ມອບໃຫ້ບໍລິການຂົນສົ່ງ',
    jscyrmc: 'ຊື່ຜູ້ຮັບໃຫ້ບໍລິການຂົນສົ່ງ',
    zcs: 'ຈໍານວນລົດບັນທຸກໜັກ',
    kcs: 'ຈໍານວນລົດເປົ່າ',
    hwjjdh: 'ໝາຍເລກໃບມອບສົ່ງສິນຄ້າ',
    jjdmc: 'ຊື່ສະຖານີມອບສົ່ງ',
    lccc: 'ຖ້ຽວລົດໄຟ'
  },
  advancePayStation: {
    khmc: 'ຊື່ລູກຄ້າ',
    qsrkhmc: 'ກະລຸນາຕື່ມຊື່ລູກຄ້າໃສ່',
    yckye: 'ເງິນຍອດທີ່ຍັງເຫຼືອສຳລັບຄ່າຝາກລ່ວງໜ້າ',
    cz: 'ເຕີມເງິນ',
    tx: 'ຖອນອອກ',
    khxxsc: 'ການລົບຂໍ້ມູນລູກຄ້າ',
    khmcxg: 'ແກ້ໄຂຊື່ລູກຄ້າ',
    khxxbd: 'ການຜູກມັດຂໍ້ມູນລູກຄ້າ',
    jymx: 'ລາຍລະອຽດທຸລະກຳ',
    jylx: 'ປະເພດທຸລະກຳ',
    qxzxqlx: 'ກະລຸນາເລືອກປະເພດຄວາມຕ້ອງການ',
    jysj: 'ເວລາເຮັດທຸລະກຳ',
    jyls: 'ບັນທຶກລາຍລະອຽດຂອງການຊື້ຂາຍໃນບັນຊີທະນາຄານ',
    pjh: 'ໝາຍເລກໃບບິນ',
    dycz: 'ສະຖານີຫັກເງິນ',
    bz: 'ສະກຸນເງິນ',
    je: 'ຍອດເງິນ (ຢວນ)',
    fh: 'ກັບຄືນ',
    bjpz: 'ແກ້ໄຂໃບຮັບຮອງ',
    czje: 'ຈໍານວນຕື່ມເງິນ',
    qsrzcje: 'ກະລຸນາຕື່ມຈໍານວນທີ່ຈະເຕີມໃສ່',
    qx: 'ຍົກເລີກ',
    qd: 'ຢືນຢັນແນ່ນອນ',
    xdkhmc: 'ຊື່ລູກຄ້າໃໝ່',
    khbd: 'ການຜູກມັດລູກຄ້າ',
    txje: 'ຈຳນວນເງີນທີ່ຖອນ(ຢວນ)',
    qsrtxje: 'ກະລຸນາຕື່ມຈໍານວນເງິນທີ່ຈະຖອນໃສ່',
    yckglyz: 'ການຢັ້ງຢືນການຄຸ້ມຄອງເງິນຝາກລ່ວງໜ້າ',
    qsrmm: 'ກະລຸນາໃສ່ລະຫັດຜ່ານ',
    xgmm: 'ປ່ຽນລະຫັດຜ່ານ',
    qsrymm: 'ກະລຸນາຕື່ມລະຫັດຜ່ານເດີມໃສ່',
    qsrxmm: 'ກະລຸນາຕື່ມລະຫັດຜ່ານປັດຈຸບັນໃສ່',
    qzcsrxmm: 'ກະລຸນາຕື່ມລະຫັດຜ່ານປັດຈຸບັນໃສ່ອີກຄັ້ງ',
    jyxq: 'ລາຍລະອຽດຂອງການຊື້ຂາຍ',
    czmc: 'ຊື່ສະຖານີລົດ',
    rq: 'ວັນທີ',
    ydbs: 'ຈຳນວນໃບບິນ',
    ydfy: 'ຄ່າໃຊ້ຈ່າຍໃບບິນ',
    hzbs: 'ມີໃບຂົນສົ່ງສິນຄ້າເບັດຕະເລັດຈໍານວນ',
    hzfy: 'ຄ່າໃຊ້ຈ່າຍຕ່າງໆ',
    tkbs: 'ຈໍານວນການຄືນເງິນ',
    tkfy: 'ລາຍຈ່າຍຄືນເງິນ',
    ckpz: 'ກວດເບິ່ງຫຼັກຖານ',
  },
  login: {
    bgctext1: 'ການຂົນສົ່ງຂ້າມຊາຍແດນ·ການຂົນສົ່ງສິນຄ້າທົ່ວໂລກ',
    sjh: 'ໂຕອັກສອນ ໂທລະສັບເເບບທ',
    wyydty: 'ຂ້ອຍໄດ້ອ່ານແລ້ວ ແລະຕົກລົງເຫັນດີ',
    yhxy: 'ສັນຍາບໍລິການຜູ້ໃຊ້',
    he: 'ແລະ',
    ysqtk: 'ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ',
    hmzh: 'ຍັງບໍ່ມີເລກບັນຊີ',
    ljzc: 'ລົງທະບຽນຕອນນີ້',
    qnydty: 'ກະລຸນາອ່ານ ແລະ ຕົກລົງ',
    xxts: 'ຂໍ້ຄວາມແຈ້ງເຕືອນ',
    xyhdwcyz: 'ປັດຂວາເພື່ອສໍາເລັດການຢັ້ງຢືນ',

    title: 'ເຂົ້າຮ່ວມອັບ',
    user: 'ຊື່ຜູ້ໃຊ້',
    pwd: 'ລະຫັດຜ່ານ',
    code: 'ໂຕເລກລຸ້ນ',
    word1: 'ທາງລົດໄຟລາວ-ຈີນ',
    word2: 'ການສຶກສາ',
    word3: 'ຈີນ ເລກໂນໂລຊີ ອີຣົບ ເປນນັກສະແດງໃຫ້ເສລິພາບ',
    jzw: 'ຈື່ລະຫັດ',
    wjmm: 'ລືມລະຫັດຜ່ານ',
    text1T: 'ເຂດຂໍ້ມູນ ອູກຄະນະສູນ(ການປະຕິບັດຕັ້ງ）',
    text1: 'ຜູ້ໃຊ້ທາງອັກສອນຫລືໂຕເລກ ແມ່ນມີຄວາມຮ້ອນໃຫຍ່ທີ່ສຸດ, ການຕິດເຊື້ອໄຟຟ້າທີ່ມີຢູ່ໃສ່ດິນ, ແລະ ການຕິດເຊື້ອໄຟຟ້າທີ່ມີສຸດິນ ແມ',
    text2T: 'ໂປຣເເກຣມຊ໌ ໂອຄານ (ເຂດຂໍ້ມູນ)',
    text2: 'ຄວາມຍາວທີ່ສຸດໃຈດ້ານການເມືອງ 508.5 ສິດ, ຄວາມຮ້ອນໃຕ້ດິນຟ້າອາກາດ, ສູງກອນ, ສູງຂໍ້ໂນໂລຍ ທີ່ໄຟຟ້າທີ່ສຸດ 16 ແມັດ/ເຂົ້າ.',
    text3T: 'ໂປຣເເກຣມຂອງ ໂປຣເເກຣມ (ໂປຣເເກຣມຟີລ໌)',
    text3: 'ຄວາມຍາວໂດຍລວມຂອງ ລັກໂຕເລກ ແມ່ນ 044.51 kg, ລວມທັງຮູບພະລັງງານໄຟຟ້າ, ໂຮງງານໄຟຟ້າໂຕເລກ, ໂຮງງານໄຟຟ້າທີ່ສຸດົດລະບຽບແລະສຸມໄຫມຂອງໂຕເລກ (16',

    logintip1: 'ການກວດສອບການລົງທະບຽນຍັງບໍ່ສໍາເລັດ, ທ່ານຕ້ອງການເຂົ້າໄປແກ້ໄຂຂໍ້ມູນໃນໜ້າລົງທະບຽນບໍ?',
    logintip2: 'ບັນຊີນີ້ຖືກລະງັບການນໍາໃຊ້, ກະລຸນາຕິດຕໍ່ຫາຜູ້ດູແລລະບົບ',
    logintip3: 'ບັນຊີນີ້ຖືກລ໋ອກ,ກະລຸນາຕິດຕໍ່ຫາຜູ້ຄວບຄຸມລະບົບ',
    mmdl: 'ລະຫັດຜ່ານ',
    dxdl: 'SMS',
    lztlhy: "ແພລດຟອມ ການດໍາເນີນການຂົນສົ່ງສິນຄ້າທາງລົດໄຟລາວ-ຈີນ"
  },
  forgetPW: {
    wjmm: 'ລືມລະຫັດຜ່ານ',
    sjqjh: 'ກາລຸນາເລືອກລະຫັດລະຫວ່າງເຂດຂອງໂທລະສັບຖື',
    sjh: 'ໂຕອັກສອນ ໂທລະສັບເເບບທ',
    sjyzm: 'ລະຫັດຢືນຢັນໂທລະສັບມືຖື',
    xzmm: 'ລະຫັດຜ່ານໃໝ່',
    qrmm: 'ຢືນ​ຢັນ​ລະ​ຫັດ',
    qxz: 'ກະລຸນາເລືອກ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    back: 'ອອກຈາກລະບົບ',
    next: 'ຂັ້ນຕອນຕໍ່ໄປ',
    qd: 'ຢືນຢັນແນ່ນອນ',
    qsrmm: 'ກະລຸນາໃສ່ລະຫັດຜ່ານ',
    qzcsrmm: 'ກະລຸນາໃສ່ລະຫັດອີກຄັ້ງ',
    lcsrmmbyz: 'ລະຫັດຜ່ານທີ່ໃສ່ສອງເທື່ອບໍ່ກົງກັນ',
    qsrsjhm: 'ກະລຸນາຕື່ມເບີໂທລະສັບໃສ່',
    qxzsjqh: 'ກາລຸນາເລືອກລະຫັດເຂດຂອງໂທລະສັບຖື',
    qsrdxyzm: 'ກະລຸນາຕື່ມລະຫັດຢືນຢັນທີ່ສົ່ງທາງຂໍ້ຄວາມ',
    hcxhq: 'ໄດ້ຮັບໃໝ່ຫຼັງຈາກ s',
    hqyzm: 'ຮັບລະຫັດຢືນຢັນ',
    xgcg: 'ແກ້ໄຂ ສໍາເລັດ',
    qdl: 'ເຂົ້າສູ່ລະບົບ',
    qx: 'ຍົກເລີກ',
    mmxgsb: 'ດັດແກ້ລັດຫັດຜ່ານ ລົ້ມເຫຼວ!',
  },
  dayDemandApply: {
    rxqtb: 'ບົດລາຍງານຄວາມຕ້ອງການປະຈໍາວັນ',
    qxzysfs: 'ກະລຸນາເລືອກວິທີການຈັດສົ່ງ',
    jzx: 'ຕົວໄປ',
    zc: 'ການຂົນສົງໂດຍລົດໄຟ',
  },
  containerPreOrder: {
    shzt: "ສະຖານະກວດສອບການອະນຸມັດ",
    zti: 'ຮັບສິນຄ້າດ້ວຍຕົນເອງ',
    crumbs0: 'ຕົວໄປ',
    crumbs1: 'ເປັນອະນຸລັກໃສບັນທີ່ເປັນຫວ່າ',
    khxxt: 'ຕົວໄປ',
    khxx: 'ຂໍ້ມູນທີ່ເປັນປະໂຫຍດກ່ຽວກັບ',
    ssqy: 'ຂື້ນກັບບໍລິສັດ',
    select: 'ກະລຸນາເລືອກ',
    fhxxt: 'ສົ່ງ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    fz: 'ສະຖານີທີ່ອອກເດີນທາງ',
    fj: 'ໂປຣເເກຣມຫ້ອງການການພັດທະນາ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    txz: 'ສະຖານີເອົາຕູ້',
    txdz: 'ທີ່ຢູ່',
    jbr: 'ຮູບແບບ່ວໄປ',
    sfzh: 'ເລກໂຕເລກ',
    jbrsj: 'ເບີໂທຜູ້ດຳເນີນການ',
    shxxt: 'ຮັບ ',
    shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',
    shr: 'ທົ່ວໄປ',
    dz: 'ທົ່ວໄປ',
    zdz: 'ສະຖານີ ປາຍທາງ',
    dj: 'ກໍ່ບ້ານເມືອງ',
    xcdd: 'ສະຖານທີ່ເອົາເຄື່ອງລົງລົດ',
    bllx: 'ຮູບແບບການນຳ້',
    blcc: 'ໂຕເລກໂຮງ',
    dxxxt: 'ຂ່າວ',
    dxxx: 'ຂໍ້ມູນຈອງຕູ້',
    xl: 'ຊະນິດຕູ້',
    xlmx: 'ຂໍ້ມູນລາຍລະອຽດແກ້ງ',
    xx: 'ຂະໜາດຕູ້',
    txrq: 'ວັນທີ່ເອົາຕູ້ອອກ',
    sfyx: 'ມີຜົນນໍາໃຊ້ບໍ່',
    yx: "Valid",
    wx: "ບໍ່ມີປະສິດທິຜົນ",
    syxs: 'ໂຕເລືອກທີ່ຍ່າຍຢູ່',
    xs: 'ຈໍານວນຕູ້',
    hwmc: 'ຊື່ສິນຄ້າ',
    ysxxt: 'ສົງອ',
    ysxx: 'ຂໍ້ມູນຂົນສົ່ງ',
    zzjgcl: 'ວັດສະດຸເພີ່ມຄວາມແໜ້ນໜາໃຫ້ສິນຄ້າ',
    cc: 'ບັນທຶກໄຟລ໌',
    lc: 'ເກັບຮ້ອນໄວ້ທີ່ (ລວມທັງໂຮງ)',
    bxys: 'ປົນສຸດງອອກສິນຄ້າ',
    jtxcd: 'ຂໍ້ມູນທີ່ກ່ຽວຂ້ອງພາຍໃສ່',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    zfszt: 'ຂໍ້ມູນ',
    zfsz: 'ຕັ້ງຄ່າຈ່າຍລະອຽງ',
    zffs: 'ວິທີຈ່າຍເງີນ',
    yfk: 'ບັນຊີຊຳລະເງີນລວ່ງໜ້າ',
    xj: 'ເງີນສົດ',
    zp: 'ກວດດ້ອບ',
    yhk: 'ຊ່ວແລກ໌',
    hzzf: 'ສຳຮອງຄວາມຈຳນວຍຄວາມສະດວກ',
    bzxz: 'ເລືອກປະເພດເງີນ',
    jp: 'ກີບ',
    rmb: 'ຢວນ',
    my: 'ໂດລາ',
    kydje: 'ຈໍານວນເງິນທີ່ສາມາດດໍາເນີນການຈອງໄດ້',
    ldwlt: 'ໂປຣ',
    ldwl: 'ການຂົນສົງລະຫວ່າງສະຖານີຕົ້ນທາງກັບປາຍທາງ',
    ldwlw: 'ອີງຕັ້ງຕ້ອງການທ່ານ, ທ່ານສາມາດເລືອກຕ້ອງໃສ່ອຸລະກິດດ້ານການເມືອງ ເຊັ່ນ: ທ່ານອມຮັບໄດ້, ສົ່ງສິນຄ້າ, ບໍລິສັນຄ້າ ແລະ ອີງຕ່າງໆ.',
    mdz: 'ຂົນສົງສີນຄ້າກັບມາເຂົ້າສາຖານີ',
    zdm: 'ຂົນສົງສີນຄ້າຈາກສາຖານີໄປສົງ',
    smqh: 'ຢູ່ໃນເວລາປັບປູງຂະນານຈໍ',
    smsh: 'ຫນ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    licheng: 'ໄລຍະທາງ(km)',
    qianmi: 'ພື້ນີ້',
    shdd: 'ບັດຳເນີນການສົ່ງອອກ',
    dianhua: 'ໂທລະໂທ',
    lxrxm: 'ຊື່ຄົນຕິດຕໍ່',
    xqsm: 'ຄວາມຕ້ອງການ ຄຳບັນຍາຍ',
    qhdd: 'ສະຖານທີໄປຮັບສີ້ນຮັບສີ້ນຄ້າ',
    tyrqdjs: 'ຜູ້ຂົນສົງສີນຄ້າຢືນຢັນຈຳນວນ',
    qhgsfy: 'ຄ່າໃຊ້ຈ່າຍໃນການໄປຮັບ-ສົງ',
    tijiao: 'ສົ່ງອອກ',
    qink: 'ລົບຂໍ້ມູນທັງໝົດ',
    qkxzy: 'ແຫ້ມີຈຳນວຍຄວາມສະດວກ',
    qsrxs: 'ກະລຸນາຕື່ມຈຳນວນຕູ້',
    xsw: 'ຈຳນວນຕູ້ແມ່ນ',
    syxsw: 'ຈຳນວນຕູ້ທີ່ຍັງເຫຼືອແມ່ນ',
    xsbjdysyxs: 'ຈຳນວນຕູ້ບໍ່ສາມາດຫຼາຍກວ່າຈຳນວນຕູ້ທີ່ຍັງເຫຼືອ',
    ktxsbndy: 'ຈຳນວນຕູ້ທີ່ເອົາອອກບໍ່ສາມາດຫຼາຍກ່ອນ',
    shxxts: 'ການບໍລິການຂົນສົ່ງລະຫວ່າງປະເທດສະຖານີປາຍທາງເລືອກ"ສະຖານີບໍ່ເຕັນ(ຊາຍແດນ)", ສະຖານີປາຍທາງສຸດທ້າຍເລືອກສະຖານີທີ່ຂົນສົ່ງຮອດຕົວຈິງ, ຕົວຢ່າງ" ສະຖານີ Wangjiaying West"',
    qsrfj: 'ກະລຸນາລະບຸຕົ້ນທາງ',
    qsrtxz: 'ກະລຸນາລະບຸ ສະຖານີຮັບເອົາຕູ້ຄອນເທນເນີ',
    qsrdj: 'ກະລຸນາລະບຸ ປາຍທາງ',
    qsrxshu: 'ກະລຸນາລະບຸຈໍານວນຕູ້ຄອນເທນເນີ',
    qxzhwmc: 'ກະລຸນາເລືອກຊື່ສິນຄ້າ',
    yjxmhjy: 'ເລກທີລາຍການຄ່າຂົນສົ່ງ ສາມາດລະບຸໄດ້9ຕົວເລກເທົ່ານັ້ນ',
    khhjy: 'ຂໍ້ມູນບັນຊີທະນາຄານ ບໍ່ສາມາດຈົ່ງຫວ່າງເປົ່າໄດ້, ແລະລະບຸຕົວໜັງສືຈີນບໍ່ໃຫ້ກາຍ85ຕົວຫຼື170ຕົວອັກສອນແລະຕົວເລກ',
    nsdzjy: 'ຂໍ້ມູນບັນຊີທະນາຄານ ບໍ່ສາມາດຈົ່ງຫວ່າງເປົ່າໄດ້, ແລະລະບຸຕົວໜັງສືຈີນບໍ່ໃຫ້ກາຍ85ຕົວຫຼື170ຕົວອັກສອນແລະຕົວເລກ',
    qxzqsdz: 'ກະລຸນາເລືອກທີ່ຢູ່ຈຸດເລີ່ມຕົ້ນ',
    qtxqsdz: 'ກະລຸນາຂຽນທີ່ຢູ່ຈຸດເລີ່ມຕົ້ນໂດຍລະອຽດເຊັ່ນ:ຖະໜົນ,ເຮືອນເລກທີ ແລະອື່ນໆ',
    xxdzcd: 'ຄວາມຍາວຂອງລາຍລະອຽດທີ່ຢູ່ໃຫ້ຢູ່ໃນລະຫວ່າງ8-200ຕົວອັກສອນແລະຕົວເລກ(1ຕົວໜັງສືຈີນເທົ່າກັບ2ຕົວອັກສອນແລະຕົວເລກ)',
    qxzmddz: 'ກະລຸນາເລືອກທີ່ຢູ່ປາຍທາງ',
    qtxmddz: 'ກະລຸນາເລືອກທີ່ຢູ່ປາຍທາງໂດຍລະອຽດເຊັ່ນ:ຖະໜົນ,ເຮືອນເລກທີ ແລະອື່ນໆ',
    fsdlxrxm: 'ຊື່ແລະນາມສະກຸນຂອງຜູ້ປະສານງານການຈັດສົ່ງສິນຄ້າ ບໍ່ສາມາດຈົ່ງຫວ່າງເປົ່າ',
    fsdhbnwk: 'ເບີໂທຕິດຕໍ່ການຈັດສົ່ງສິນຄ້າ ບໍ່ສາມາດຈົ່ງຫວ່າງເປົ່າ!',
    qxzzffs: 'ກະລຸນາເລືອກຮູບແບບການຊໍາລະເງິນ',
    qxzbz: 'ກະລຸນາເລືອກສະກຸນເງິນ',
    qtxjd: 'ກະລຸນາລະບຸທີຢູ່ລະອຽດເຊັ່ນ:ຖະໜົນ,ເລກທີເຮືອນ ແລະອື່ນໆ',
    qtxmdz: 'ກະລຸນາລະບຸຂໍ້ມູນໄລຍະທາງຈາກຕົ້ນທາງເຖິງສະຖານີປາຍທາງ!',
    mdzlcxx: 'ກະລຸນາລະບຸຂໍ້ມູນໄລຍະທາງຈາກຕົ້ນທາງເຖິງສະຖານີປາຍທາງ!',
    qtxmdztyr: 'ກະລຸນາລະບຸການຢືນຢັນຈໍານວນສິນຄ້າຈາກຜູ້ຈັດສົ່ງ ແຕ່ຕົ້ນທາງເຖິງສະຖານີປາຍທາງ!',
    mdztyr: 'ການຢືນຢັນຈໍານວນສິນຄ້າຈາກຜູ້ຈັດສົ່ງ ແຕ່ຕົ້ນທາງເຖິງສະຖານີປາຍທາງ ສາມາດລະບຸເປັນຕົວເລກໄດ້ເທົ່ານັ້ນ!',
    mdzqhfy: 'ການຄິດໄລ່ຄ່າໃຊ້ຈ່າຍໃນຮັບສິນຄ້າ ຈາກຕົ້ນທາງເຖິງສະຖານີປາຍທາງ ສາມາດລະບຸເປັນຕົວເລກໄດ້ເທົ່ານັ້ນ!',
    dddlxr: 'ຊື່ແລະນາມສະກຸນຂອງຜູ້ຕິດຕໍ່ພົວພັນຢູ່ປາຍທາງ ບໍ່ສາມາດຈົ່ງຫວ່າງເປົ່າໄດ້',
    dddlxrcw: 'ຊື່ແລະນາມສະກຸນຂອງຜູ້ຕິດຕໍ່ພົວພັນຢູ່ປາຍທາງ ຂຽນຜິດ',
    ddddh: 'ເບີໂທຕິດຕໍ່ພົວພັນຢູ່ປາຍທາງ ບໍ່ສາມາດຈົ່ງຫວ່າງເປົ່າໄດ້',
    qtxzdm: 'ກະລຸນາລະບຸຂໍ້ມູນໄລຍະທາງຈາກສະຖານີປາຍທາງເຖິງຕົ້ນທາງ!!',
    zdmlcxx: 'ຂໍ້ມູນໄລຍະທາງຈາກສະຖານີປາຍທາງເຖິງຕົ້ນທາງ ສາມາດລະບຸເປັນຕົວເລກໄດ້ເທົ່ານັ້ນ!',
    qxzyxsfzj: 'ກະລຸນາເລືອກປະເພດບັດປະຈໍາຕົວທີ່ຍັງມີອາຍຸການນໍາໃຊ້',
    qtxyxsfzj: 'ກະລຸນາລະບຸເລກບັດປະຈໍາຕົວທີ່ຍັງມີອາຍຸການນໍາໃຊ້',
    qtxtyrdm: 'ກະລຸນາລະບຸເລກບັດເຄດິດທີ່ຖືກກົດໝາຍຂອງຜູ້ຈັດສົ່ງ',
    qsrtydm: 'ກະລຸນາລະບຸເລກບັດເຄດິດທີ່ຖືກຕ້ອງ',
    qxzdcrq: 'ກະລຸນາເລືອກວັນທີຈອງລົດ',
    qsrsjshr: 'ກະລຸນາລະບຸຊື່ຜູ້ຮັບສິນຄ້າຕົວຈິງ',
    qtxtyjbrxm: 'ກະລຸນາລະບຸຊື່ແລະນາມສະກຸນຂອງຜູ້ປະສານງານຈັດສົ່ງສິນຄ້າ',
    qtxtyjbrsfz: 'ກະລຸນາລະບຸເລກບັດປະຈໍາຕົວຂອງຜູ້ປະສານງານຈັດສົ່ງສິນຄ້າ',
    qtxtyjbrsjh: 'ກະລຸນາລະບຸເບີໂທຂອງຜູ້ປະສານງານຈັດສົ່ງສິນຄ້າ',
    qtxshjbrxm: 'ກະລຸນາລະບຸຊື່ແລະນາມສະກຸນຂອງຜູ້ປະສານງານຮັບສິນຄ້າ',
    qtxshjbrsfz: 'ກະລຸນາລະບຸເລກບັດປະຈໍາຕົວຂອງຜູ້ປະສານງານຮັບສິນຄ້າ',
    qtxshjbrsjh: 'ກະລຸນາລະບຸເບີໂທຂອງຜູ້ປະສານງານຮັບສິນຄ້າ',
    qsrxl: 'ກະລຸນາລະບຸປະເພດຕູ້ຄອນເທນເນີ',
    qsrxlmx: 'ກະລຸນາລະບຸລາຍລະອຽດປະເພດຕູ້ຄອນເທນເນີ',
    qsrxx: 'ກະລຸນາລະບຸຮູບລັກສະນະຕູ້ຄອນເທນເນີ',
    tyrthmmyz: 'ສາມາດລະບຸລັດຫັດຜ່ານ6ຕົວເລກໄດ້ເທົ່ານັ້ນ',
    qsrtyrmc: 'ກະລຸນາລະບຸຊື່ຜູ້ຈັດສົ່ງສິນຄ້າ',
    qtxtyrqdjs: 'ກະລຸນາລະບຸຂໍ້ມູນການຢືນຢັນຈໍານວນສິນຄ້າຂອງຜູ້ຈັດສົ່ງສິນຄ້າ!',
    xxxsjy: 'ຖ້າຂະໜາດຕູ້ຄອນເທນເນີແມ່ນ20ຟຸດ ຈໍານວນຕູ້ຕ້ອງເປັນເລກຄູ່!',
    fdzbuxt: 'ສະຖານີຕົ້ນທາງແລະປາຍທາງບໍ່ສາມາດເປັນສະຖານີດຽວກັນໄດ້',
    qxzzfr: 'ກະລຸນາເລືອກຜູ້ຊໍາລະເງິນ',
    zfr: 'ຜູ້ຈ່າຍເງິນ',
    qxxztyr: 'ກະລຸນາເລືອກຜູ້ຈັດສົ່ງກ່ອນ',
    yfkyebz: 'ຈໍານວນເງິນທີ່ຊໍາລະລ່ວງໜ້າບໍ່ພຽງພໍ!',
    zfrid: 'ID ຜູ້ຊໍາລະເງິນ ບໍ່ສາມາດຈົ່ງຫວ່າງເປົ່າ',
    dzmdzdz: 'ເວລາເຖິງສະຖານີບໍ່ເຕັນ(ຊາຍແດນ), ກະລຸນາເລືອກສະຖານີປາຍທາງ',
    xhzzdy: 'ນໍ້າໜັກຕູ້ຄອນເທນເນີທັງໝົດ ຕ້ອງຫຼາຍກວ່ານໍ້າໜັກລົດບັນທຸກ',
    shenher: 'ຜູ້ກວດສອບ',
    zt: 'ສະຖານະ',

  },
  dailyTransportDemand: {
    qxzbgrxqhchec: 'ກະລຸນາເລືອກຄວາມຕ້ອງການປະຈໍາວັນ ຫຼື ຖ້ຽວລົດທີ່ຕ້ອງການປ່ຽນປາຍທາງ',
    dtslrxqbg: 'ກະລຸນາເລືອກການຍອມຮັບເງື່ອນໄຂດຽວທີ່ປ່ຽນແປງຄວາມຕ້ອງການປະຈໍາວັນທີ່ຈະສົ່ງຮອດກ່ອນຈະບັນຈຸໃສ່ລົດ',
    rxqbnbg: 'ສະຖານະຄວາມຕ້ອງການປະຈໍາວັນແມ່ນກໍາລັງລໍຖ້າຮັບການດໍາເນີນການ/ ໄດ້ປະຕິເສດ/ ໄດ້ຂົນລົງລົດ/ ໄດ້ມອບໝາຍ, ເຊິ່ງບໍ່ສາມາດປ່ຽນປາຍທາງໄດ້',
    dslrxq: 'ກະລຸນາເລືອກສະຖານະດໍາເນີນການຂອງຄວາມຕ້ອງການປະຈໍາວັນ',
    td1: 'ຄວາມຕ້ອງການກໍາລັງດໍາເນີການ, ຍັງບໍ່ສາມາດຖອນການຈອງໄດ້',
    td2: 'ກະລຸນາເລືອກສະຖານະດໍາເນີນການໃນຄວາມຕ້ອງການປະຈໍາວັນ ເພື່ອຖອນການຈອງ',
    yqxtd: 'ໄດ້ຍົກເລີກການຖອນຈອງເເລ້ວ',
    yqx: "ຍົກເລີກແລ້ວ",
    tdcg: 'ຍົກເລີກການຈອງໄດ້ສໍາເລັດ',
    sfqrtd: 'ຢືນຢັນຈະຖອນການຈອງຄືນ ຫຼື ບໍ່ ?',
    yjf: 'ສົ່ງມອບແລ້ວ',
    yxc: 'ລົງລົດແລ້ວ',
    yzc: 'ບັນຈຸໃສ່ລົດແລ້ວ',
    tb: 'ແຈ້ງ',
    xqgj: 'ທາມລາຍຄວາມຕ້ອງການ',
    t: 'ໂປຣເເກຣມ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    qxzqsrq: 'ກະລຸນາໃສ່ເລີ້ມໂປຣເເກຣມ',
    qxzzzrq: 'ກະລຸນາໃສ່ໄລທີ່ສຸດທ້າຍ',
    qxz: 'ກະລຸນາເລືອກ',
    qb: 'ທັງໝົດ',
    zzjg: 'ພົດພາດຂະນະຕິດຕັ້ງ',
    bx: 'ລາຊະອານາຈ',
    cc: 'ບັນທຶກໄຟລ໌',
    gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',
    ptys: 'ຂົນສົ່ງທົ່ວໄປ',
    ytd: 'ບໍ່ຮູ້ຈັດເຈົ້າຂອງ',
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຄວາມຕ້ອງການທີ່ປະຈຸບັນ',
    ydlx: 'ປະເພດໃບບິນ',
    yyh: 'ເລກສັ່ງຈອງ',
    xqh: 'ເລກຮ້ອງຂໍ',
    jzxydh: 'ເລກທີຈອງຕູ້ຄອນເທນເນີ',
    fz: 'ສະຖານີທີ່ອອກເດີນທາງ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    zyrq: 'ວັນທີ່ຂົນສົ່ງ',
    wpmc: 'ຊື່ເປນນີ້',
    shr: 'ຜູ້ຮັບສິນຄ້າ',
    tbsj: 'ເວລາ ການແຈ້ງເຕືອນ',
    rxqzt: 'ສະຖານະຄວາມຕ້ອງການປະຈຳວັນ',
    dsl: 'ຖ້າການຍອມຮັບ',
    dddsl: 'ລໍຖ້າພະແນກຄວບຄຸມການເດີນລົດຍອມຮັບແຜນ',
    sltg: 'ຜ່ານການຍອມຮັບ',
    yjj: 'ປະຕິເສດ',
    cx: 'ຄົ້ນຫາ',
    rxqxj: 'ວິດຄວາມຕ້ອງການໃຫມ່',
    wxts1: 'ຂໍ້ມູນ: ຄວາມຕ້ອງການທີ່ໄດ້ຈັດຢູ່ທຸກປະຈຸບັນ ສາມາດຖາມກ່ຽວກັບສະພາບການຕ່າງໆ',
    wxts2: 'ເພື່ອສ້າງ ໃຫມ່ໄດ້ຜູ້ສ້າງພາຍໃຕ່ທີ່ຕ້ອງການ',
    qsryyh: 'ກະລຸນາໃສ່ຊ່ວຍຄວາມຈຳ',
    qsrxqh: 'ກະລຸນາໃສ່ລາຍຊື່ທີ່ຕ້ອງການ',
    dcexcel: 'ສົ່ງອອກ exel',
    pldy: 'ໂປຣເເກຣມຫ້ວໄປ',
    ck: 'ກວດເບິ່ງ',
    ckxq: 'ກວດສອບລາຍລະອຽດ',
    drzj: 'ລາຊວນທຸກປະຈຸບັນ',
    zt: 'ສະຖານະ',
    yslx: 'ຮູບແບບການຂົນສົ່ງ',
    blzb: 'ປະເພດ ການຈັດການ',
    qqlx: 'ປະເພດການຮຽກຮ້ອງ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    hwmc: 'ຊື່ສິນຄ້າ',
    wptz: 'ອົກຂະລະທິດສະຖານະຂອງ',
    xqcs_slcs: 'ຈໍານວນລົດ ທີ່ຕ້ອງການ / ຈໍານວນລົດ ທີ່ອານຸມັດ',
    xqds_slds: 'ຈຳນວນນ້ຳໜັກ ທີ່ຕ້ອງການ / ຈຳນວນນ້ຳ ໜັກທີ່ອານຸມັດ',
    cz: 'ປະເພດລົດ',
    ystz: 'ລັກສະນະ ການຂົ່ນສົ່ງ',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    caozuo: 'ການດຳເນີນການ',
    dslyyd: 'ການອະນຸລັກແບບຕ່າງໆ',
    yszyyd: 'ການອະນຸລັບປຸນຄ່າຕ່າງໆ',
    td: 'ບໍ່ຮ້ອງຄຳແປ',
    zc: 'ການຂົນສົງໂດຍລົດໄຟ',
    jzx: 'ຕົວໄປ',
    zq: 'ກະລຸນາຮີບຮ້ອນແດ່',
    bq: 'ໂປຣເເກຣມທົວໄປ',
    drgj: 'ລວມໃນມື້ນີ້',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    jsrq: 'ວັນທີ່ສິ້ນສຸດ',

    qsryxq: 'ກາລຸນາລະບຸຕົວເລກຄວາມຕ້ອງການປະຈໍາເດືອນ',
    qsrtyr: 'ກາລຸນາລະບຸຊື່ຜູ້ມອບໝາຍ ການຂົນສົ່ງ',
    hztip: 'ຖ້າບໍ່ລະບຸເຈົ້າຂອງສິນຄ້າ, ເຈົ້າຂອງສິນຄ້າກໍ່ຈະບໍ່ສາມາດກວດກາຕິດຕາມສະພາບການຂົນສົ່ງສິນຄ້າ',
    qsrzmwjmc: 'ກາລຸນາລະບຸຊື່ເອກະສານທີ່ຢັ້ງຢືນ',
    qsczmwjtp: 'ກາລຸນາອັບໂຫຼດຮູບພາບເອກະສານທີ່ຢັ້ງຢືນ',
    qsrddgj: 'ກາລຸນາລະບຸ ປະເທດປາຍທາງ',
    qsrkaz: 'ກາລຸນາລະບຸ ດ່ານສາກົນ',
    qsrshr: 'ກາລຸນາລະບຸ ຜູ້ຮັບສິນຄ້າ',
  },
  dailyTransportDemandDetail: {
    gjz: 'ໂຮງງານຂອງຂໍ້ມູນ',
    ddgj: 'ປະເທດປາຍທາງ',
    ysfw: 'ບໍລິການການຂົນສົ່ງ',
    rysxq: 'ແຜນຂົນສົ່ງປະຈຳວັນ',
    ysrq: 'ວັນທີ່ຂົນສົ່ງ',
    yyh: 'ເລກສັ່ງຈອງ',
    yslx: 'ຮູບແບບການຂົນສົ່ງ',
    xqxx: 'ຂໍ້ມູນລາຍລະອຽດ',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    hwpm: 'ສິນຄ້າ',
    hwtz: 'ລັກສະນະພິເສດຂອງສິນຄ່າ',
    ysfs: 'ຮູບແບບການຂົນສົ່ງ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    tyf: 'ຜູ້ຂົນສົ່ງສິນຄ້າ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    fj: 'ໂປຣເເກຣມຫ້ອງການການພັດທະນາ',
    txdz: 'ທີ່ຢູ່',
    jbr: 'ຄົນດຳເນີນການ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    sj: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',
    shr: 'ຜູ້ຮັບເຄື່ອງ',
    dz: 'ສະຖານີປາຍທາງ',
    dj: 'ເຫລວດ້ວຍ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    jqsdxx: 'ສິ່ງອຳນວຍຄວາມສະດວກຜ່ານເພີ່ມຄູ່ສົນທະນາ',
    mdz: 'ຂົນສົງສີນຄ້າກັບມາເຂົ້າສາຖານີ',
    zdm: 'ຂົນສົງສີນຄ້າຈາກສາຖານີໄປສົງ',
    ysxx: 'ຂໍ້ມູນຂົນສົ່ງ',
    xqds: 'ຈໍານວນໂຕນທີ່ຕ້ອງການ',
    xqcs: 'ຈຳນວນລົດທີ່ຮ້ອງຂໍ',
    cz: 'ປະເພດລົດ',
    fw: 'ບໍ່ລິການ',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    dzzfyhfzf: 'ຜູ້ທີ່ຈະກໍສຳລັບສຳລັບການເຮັດວຽກໃຫ້',
    zffs: 'ວິທີຈ່າຍເງີນ',
    bz: 'ລົດລົງ',
    yszyyd: 'ການອະນຸລັບປຸນຄ່າຕ່າງໆ',
    w: 'ບໍ່ມີ',
    zzsxx: 'ຂໍ້ມູນມູນຄ່າພາສີເພີ່ມເຕີມ ',
    fplx: 'Invoice type',
    spfmc: 'ຊື່ຂອງ',
    nsrsbh: 'ຄ່າຈຳນວຍຄວາມສະດວກຜູ້ຈັນຍາດ',
    zh: 'ບັນຊີຜູ້ໃຊ້',
    khh: 'ທະນາຄານທີ່ເປີດບັນຊີ',
    dh: 'ໂປຣເເກຣມທົວໄປ',
    diz: 'ບັດຜ່ານ',
    fh: 'ກັບຄືນ'
  },
  dailyTransportDemandDetailNew: {
    mz: 'ຊື່:',
    yjxqduns: 'ຈໍານວນໂຕນທີ່ຕ້ອງການທີ່ຄາດຄະເນ',
    xqzjxqchec: 'ຄວາມຕ້ອງການຂອງທ່ານໃນຄັ້ງນີ້ລວມເປັນ: ຄວາມຕ້ອງການຕໍ່ຖ້ຽວ:',
    qxzscsj: 'ກະລຸນາເລືອກຂໍ້ມູນທີ່ຈະລົບລ້າງ',
    drwj: 'ດຶງອອກຈາກໄຟລ໌ເອກະສານ',
    qsrcx: 'ກະລຸນາຕື່ມລຸ້ນພາຫະນະໃສ່',
    hsds: 'ຢືນຢັນ ຈໍາ ນວນກ້ອນ',
    qsrbxje: 'ກະລຸນາຕື່ມຍອດເງິນປະກັນໄພໃສ່',
    scfjgsbk: 'ຮູບແບບໄຟລ໌ແນບທີ່ອັບໂຫລດປະກອບມີ​: ຮູບພາບ​, PDF​，word​, excel​, txt​',
    zzwjsc: 'ອັບໂຫຼດເອກະສານຄຸນສົມບັດ​',
    xxxxrx: 'ລາຍລະອຽດມີດັ່ງນີ້, ທີ່ຢູ່',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    jsrq: 'ວັນທີ່ສິ້ນສຸດ',
    jdxqdm: 'ແຕກຕ້ອງໃສ່ລາຍການຕ້ອງການ',
    jdqxh: 'ສະຖານະການຕ້ອງການບໍ່',
    qsrjdxqh: 'ກະລຸນາໃສ່ແລກໂຕເລກທີ່ຕ້ອງການ',
    qsrhthyyxyxj: 'ປ້ອນເລກໂຕະຫຼາດ ທີ່ມີຄຸຍາຍເຕັດເຫັນ',
    qdzccxt: '1. ການຮັບຮອງຕ່າງໆ ສິ່ງແວດລ້ອມແລະການພັດທະນາໂປຣເເກຣມຄວາມຮູ້ຕ່າງໆ ທີ່ສຸດໃນປົວຈັງ ສາມາດປັບປຸງດິນນະໂຍບາຍຂອງແຫຼ່ງຂ່ອຍອາ;',
    qdsmjyht: '2. ປ້ອນຈິດຕະໂຫຍດການຄ້າຂົນຄ້າ ເພື່ອຮັບປຸງສະພາບການຄ້າຂົນຄ້າ.',
    yddcx: 'ມາຮອດແລ້ວ',
    ysrq: 'ວັນທີ່ຂົນສົ່ງ',
    qxzzyrq: 'ກະລຸນາໃສ່ລາຍລະຫວ່າງການຄ້າ',
    xqlx: 'ຮູບແບບຕ້ອງການ',
    qxzxqlx: 'ກະລຸນາໃສ່ແພັກເກດ',
    gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',
    ptys: 'ຂົນສົ່ງທົ່ວໄປ',
    excelImp: 'ດຶງອອກເປັນexcel',
    xzmb: 'ຮູບແບບທີ່ຕິດຕັ້ງ',
    lsxqImp: 'ສົ່ງອອກສິນຄ້ອງການປະຫວັດສາດ (History)',
    impLsxq: 'ສົ່ງອອກຄວາມຕ້ອງການຂອງປະຫວັດສາດ',
    send: 'ມີແມ່ນ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    cyfhr: 'ຜູ້ຈ່າຍພາຍໃຕ້ທົ່ວໄປ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    qsrtyf: 'ກະລຸນາໃສ່ຜູ້ສົ່ງອອກສິກ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    fj: 'ໂປຣເເກຣມຫ້ອງການການພັດທະນາ',
    dj: 'ກໍ່ບ້ານເມືອງ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    zyx: 'ລິ້ງຄຳສ່ວນບຸກຄົນ',
    tlhc: 'ລານສີນຄ້າທາງລົດໄຟ',
    lxr: 'ຕິດຕໍ່',
    qsrlxr: 'ກະລຸນາໃສ່ແພັກເກດ',
    dh: 'ໂທລະໂທ',
    qsrdh: 'ກະລຸນາໃສ່ລາຍຊື່ໂຕເລກ',
    txdz: 'ທີ່ຢູ່',
    qsrtxdz: 'ກະລຸນາໃສ່ອີເມວລ໌',
    jbr: 'ຮູບແບບ່ວໄປ',
    qsrjbr: 'ກະລຸນາໃສ່ຮູບຮູບແບບ',
    sfz: 'ໂປຣເເກຣມ',
    qsrsfz: 'ກະລຸນາໃສ່ແຜ່ນດີສິດຂອງເຈົ້າ',
    sj: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    qsrsj: 'ກະລຸນາໃສ່ລາຍຊື່ໂທລະສັບເຈົ້າຂອງ',
    zffs: 'ວິທີຈ່າຍເງີນ',
    collect: 'ຕົວໄປ',
    shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',
    cyshf: 'ແນວຄິດການໂດຍທົ່ວໄປ',
    ddgj: 'ປະເທດປາຍທາງ',
    gjz: 'ໂຮງງານຂອງຂໍ້ມູນ',
    qxzgjz: 'ກະລຸນາໃສ່ສະຖານະຂໍ້ມູນ',
    shr: 'ຜູ້ຮັບສິນຄ້າ',
    qsrshf: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງ',
    dz: 'ສະຖານີປາຍທາງ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    goods: 'ສຸດ',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    hwpm: 'ສິນຄ້າ',
    qxzhwm: 'ກະລຸນາໃສ່ຊື່ແພັກເກດ',
    hwtzfrl: 'ລັກສະນະພິເສດຂອງສິນຄ່າ: ຄ່າຂອງເຂດຂໍ້ມູນຮ້ອນແກ້ວ (confal / kg)',
    ps: 'ສິ່ງອຳນວຍຄວາມສະດວກ',
    bps: 'ຄົນຈະບໍ່ເຄື່ອງມືອງ',
    sdz: 'ໂຕເອີ້ນລົບ',
    fsdz: 'ບໍ່ມີໃຫຍ່ທີ່ສຸດ',
    hwms: 'ຄຳບັນຍາຍ ຂອງຄຸນຄ່າ',
    qsrhwms: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງຄ່າ',
    jzzx: 'ສະນິເລກຄຳສັ່ງ',
    qxzcx: 'ກະລຸນາໃສ່ຊື່ແຟ້ມ',
    cx1: 'ຕັ້ງຄ່າ 15 ມີສິດ (32 ມີນາ)',
    cx2: 'ໂຕເລືອກຕັ້ງຄ່າສະເພາະປະຈຸບັນ',
    cx3: 'ໂຕເລືອກຕັ້ງຄ່າສະເພາະອານາລັກສອນຫລືໂຕເລກ',
    cx4: 'ຕັ້ງຄ່າຮ່ວມໃຕ້ດິນຟ້າອຸດ 15 ມຸລາ',
    cx5: 'ໂຕອັກສະນະນິດສະດີ: 15 ມິນເກຶດ',
    hwbz: 'ແພັກເກດສະຫຼາດ',
    maxzl: 'ຄ່າຂອງເງ່າຍໃຫຍ່ທີ່ສູງ (kg)',
    bz: 'ສະກຸນເງິນ',
    qsrbz: 'ກະລຸນາໃສ່ຫມາຍເຫດ',
    yszyyd: 'ການອະນຸລັບປຸນຄ່າຕ່າງໆ',
    yszycz: 'ຄົ້ນຫາເຫຼ່ງດງອອກະສົມ',
    lcId: 'ໂປຣເເກຣມ',
    sfzsfsj: 'ສະຖານີຕົ້ນທາງ / ເວລາທີ່ສົ່ງອອກ',
    zdzzdsj: 'ໂປຣເເກຣມເຄື່ອງມືອງ/ມີນເວລາທີ່ຫາຍໂຕ',
    ls: 'ຄວາມຫຍາຍເຫດ',
    hours: 'ຊ່ວງ',
    min: 'ມີນາທຸດ',
    move: 'ສົງອອກສິນຄ້າ',
    ysxx: 'ຂໍ້ມູນຂົນສົ່ງ',
    syds: 'ລຸນາໃຫຍ່ທີ່ຍ່າຍຢູ່:',
    sycs: 'ໂຕເລກັບທີ່ມີປັນຫາ:',
    tbfs: 'ວິທີແຈ້ງແຜນ',
    anc: 'ວິທີແຈ້ງແຜນ',
    anD: 'ຂັ້ນສຸງ',
    zclc: 'ໂຮງຮຽນລອນກຸ່ມ',
    xqcs: 'ຈຳນວນລົດທີ່ຮ້ອງຂໍ',
    qsrxqcs: 'ກະລຸນາໃສ່ລາຍຊື່ໂປຣເເກຣມ',
    ds: 'ໂຕງານ',
    qsrds: 'ກະລຸນາໃສ່ວຍຄວາມຈຳ',
    cz: 'ປະເພດລົດ',
    qsrcz: 'ກະລຸນາໃສ່ຊື່ແຟ້ມ',
    peng: 'ຜົດພາດ',
    chang: 'ມີປັນຫາ',
    ping: '=',
    guan: 'ປັນຊ໌',
    jzx: 'ຕົວໄປ',
    liangshi: 'ປັບປຸງດິນ',
    cs: 'ໂຕເລກໂທ',
    sqrcs: 'ກະລຸນາຕື່ມຈຳນວນລົດ',
    zzjg: 'ພົດພາດຂະນະຕິດຕັ້ງ',
    bx: 'ລາຊະອານາຈ',
    cc: 'ບັນທຶກໄຟລ໌',
    bxje: 'ຄ່າຈຳນວຍຄວາມສະດວກ',
    sqrbxje: 'ກະລຸນາໃສ່ຄ່າສະເພາະຈໍາໂປຣເເກຣມ',
    zyrq: 'ວັນທີ່ຂົນສົ່ງ',
    cx: 'ໂຕເລກ',
    dzzfyhzf: 'ຜູ້ທີ່ຈະກໍສຳລັບສຳລັບການເຮັດວຽກໃຫ້',
    yfk: 'ບັນຊີຊຳລະເງີນລວ່ງໜ້າ',
    mtype: 'ລົດລົງ',
    jp: 'ເງິນກີບ',
    rmb: 'ເງິນຢວນ',
    my: 'ເງິນໂດລາ',
    jzsxxz: 'ຂໍ້ມູນທີ່ກ່ຽວຂ້ອງ',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    qsrjzsx: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງ',
    duo: 'ຜົນຫລາຍຮ້ອຍໄດ້',
    dsly: 'ໂຮງງານໄຟຟ້າທີ່ມີການສົນສົງ',
    qxzlylb: 'ກະລຸນາໃສ່ແຫ່ກເກດຳເນີນການຕົວໄປ',
    tsly: 'ປັບປຸງດິນ​ໂຮງງານໄຟຟ້າອິດ',
    ggndxqxzgyly: 'ຕ້ອງເລືອກຕ່າງໆທີ່ມີການສົນພັກທາງການຄ້າສະເພາະໃຕ້ທີ່ຕ້ອງການທ່ານ',
    ssjd: 'ຖານຂໍ້ມູນ ທີ່ກ່ຽວຂ້ອງ',
    qxzssjd: 'ກະລຸນາໃສ່ແລກໂຕເລືອກ',
    fglb: 'ຂໍ້ມູນທີ່ກ່ຽວຂ້ອງພາຍໃສ່',
    qxzfglb: 'ກະລຸນາໃສ່ລາຍການແບບຄຳສັ່ງ',
    dglb: 'ຂໍ້ມູນເວລາ',
    qxzdglb: 'ກະລຸນາໃສ່ລາຍການແບບຄຳສັ່ງ',
    cm: 'ຊື່ທົ່ວໄປ',
    cbdw: 'ໂຕເອີ້ນລົງ',
    cblx: 'ຮູບແບບັນຊີເນື່ອງ',
    fg: 'ຕິດຕັ້ງໂອຕ່າງໆ',
    dg: 'ເຫລວດ້ວຍ',
    hxlx: 'ຮູບແບບທີ່ມີບັນຫາ',
    yj: 'ລວງສຸງ',
    zyqzrq: 'ເລີ້ມແລະການຈໍາກັບເເອນໂຄງການຫມາຍສອງຈ້ຳ',
    zzsxx: 'ຂໍ້ມູນມູນຄ່າພາສີເພີ່ມເຕີມ',
    zen: 'ເພີ້ມ',
    fplx: 'ຮູບແບບັນຊີບັນຫາ',
    qxzfplx: 'ກະລຸນາໃສ່ຊື່ຄໍາສັ່ງ',
    ptfp: 'ການທໍາມະການຖ້າ',
    zyfp: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    spfmc: 'ຊື່ຂອງ',
    qsrspfmc: 'ກະລຸນາໃສ່ຊື່ສຳລັບຮູບແບບ',
    khh: 'ທະນາຄານທີ່ເປີດບັນຊີ',
    qsrkhhmc: 'ກະລຸນາໃສ່ຊື່ແຟ້ມຄ່າຕັ້ງ',
    nsrsbh: 'ຄ່າຈຳນວຍຄວາມສະດວກຜູ້ຈັນຍາດ',
    qsrnsrsbh: 'ກະລຸນາໃສ່ແລກໂຕເລກໂຕເລກ',
    khhzh: 'ບັນຊີຜູ້ໃຊ້ບັນຊີຜູ້ໃຊ້',
    qsrkhhzh: 'ກະລຸນາໃສ່ແລກໂຕເລກລຸ້ນສົ່ງໂຕເລກລຸ້ນ',
    zcdz: 'ບັນຊີທົວລັບ',
    qsrzcdiz: 'ກະລຸນາໃສ່ອີເເລກໃສ່',
    lxdh: 'ເບີໂທຕິດຕໍ່',
    qsrlxdh: 'ກະລຸນາໃສ່ຊື່ໂຕເລກ',
    jie: 'ຂໍ້ມູນກ່ຽວກັບ',
    jqsdxx: 'ສິ່ງອຳນວຍຄວາມສະດວກຜ່ານເພີ່ມຄູ່ສົນທະນາ',
    mdz: 'ຂົນສົງສີນຄ້າກັບມາເຂົ້າສາຖານີ',
    cyjqxx: 'ປັກຕິດຕັ້ງຂໍ້ມູນເພີ້ມບັນຫາ',
    address: 'ບັດຜ່ານ',
    qxzsheng: 'ກະລຸນາໃສ່ແຂວງ',
    qsrsheng: 'ກະລຸນາໃສ່ແຂວງ',
    qxzshi: 'ກະລຸນາໃສ່ລາຍໃສ່ນຈຸ',
    qsrshi: 'ກະລຸນາໃສ່ລາຍໃສ່',
    qxzq: 'ເຂດຂໍ້ມູນ',
    qsrq: 'ກະລຸນາໃສ່ເຂດຂໍ້ມູນ',
    qsrxxdz: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງ',
    lc: 'ໄລຍະທາງ',
    smzc: 'ຫນ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    xqsm: 'ບັນຖຶກສອນຫລືໂຕເລກ',
    tyrqdjs: 'ຜູ້ຂົນສົງສີນຄ້າຢືນຢັນຈຳນວນ',
    qhfygs: 'ກຳລັງອອກສິນຄ່າສະເພາະ',
    zdm: 'ຂົນສົງສີນຄ້າຈາກສາຖານີໄປສົງ',
    cysdxx: 'ການຕັບຜູ້ນຳເນີນການຍົງ',
    fyss: 'ການຕັບຜູ້ນຳເນີນການຍົງ',
    bc: 'ສ້າງອະນຸລັກ',
    qk: 'ລົບຂໍ້ມູນທັງໝົດ',
    glyjyf: 'ຄິດວ່າ',
    yysjydwz: 'ຄະນະຄວາມຍຸດລົງ',
    dtbxx: 'ຂໍ້ມູນຮັບເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    xqh: 'ເລກຮ້ອງຂໍ',
    yyh: 'ເລກສັ່ງຈອງ',
    hwmc: 'ຊື່ສິນຄ້າ',
    wptz: 'ອົກຂະລະທິດສະຖານະຂອງ',
    xqcs_slcs: 'ຈຳນວນລົດທີ່ຮ້ອງຂໍ/ຈຳນວນລົດທີ່ອານຸມັດ',
    xqds_slds: 'ຈຳນວນນ້ຳໜັກທີ່ຮ້ອງຂໍ/ຈຳນວນນ້ຳໜັກທີ່ອານຸມັດ',
    ystz: 'ລັກສະນະ ການຂົ່ນສົ່ງ',
    hqhw: 'ບ່ອນວາງສິນຄ້າ',
    tbrq: 'ວັນທີ່ຂຽນຟອມ',
    xqly: 'ແຫຼ່ງຄວາມຕ້ອງການ',
    qt: 'ອື່ນ ໆ',
    xg: 'ແປງ',
    sc: 'ລຶບ',
    ckxq: 'ກວດສອບລາຍລະອຽດ',
    tj: 'ສົ່ງອອກ',
    dc: 'ສົ່ງອອກ',
    plsc: 'ລົບຈຳນວນຫຼາຍ',
    fh: 'ກັບຄືນ',
    ydd: 'ມາຮອດແລ້ວ',
    jdxqh: 'ເລກຄວາມຕ້ອງການປະຈຳເດືອນ',
    chax: 'ຄົ້ນຫາ',
    yslx: 'ຮູບແບບການຂົນສົ່ງ',
    zhi: 'to',
    wccs: 'ໂຕເລກລຸ້ນເທົ່າກັບທີ່ມີຢູ່',
    tbsj: 'ເວລາ ການແຈ້ງເຕືອນ',
    operation: 'ການດຳເນີນການ',
    sl: 'ກຳລັດເຈົ້າວ',
    cyjqdz: 'ບໍ່ມີຕິດຕັ້ງ',
    sheng: 'ພື້ນຖານ',
    shi: 'd',
    qu: 'ເຂດຂໍ້ມູນ',
    cysddz: 'ບົດຳເນີນການທົ່ວໄປ',
    yddh: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    jbrsfz: 'ຮູບແບບຂອງ X ໃນເວບຮູບແບບ',
    jbrsjhm: 'ເບີໂທຜູ້ດຳເນີນການ',
    zzl: 'ນ້ຳໜັກລວມ',
    hlbj: 'ກູນນາ ປາ ໂອລິກ',
    zwsj: 'ບໍ່ມີຂໍ້ມູນເພີ້ມ',
    pyyyrdhwxx: 'ສໍາລັບຂໍ້ມູນທີ່ມີຈຳນວນຂໍ້ມູນເເປຍ,ຊື່ຍາວເລກລົງ ແລະ ຊື່ເເລະຫລກໂປຣເເກຣມຫລືໂປຣເເກຣມ',
    hg: 'ແພັກເກຍອມ',
    wxpl: 'ຂໍ້ມູນທີ່ບໍ່ໃດ້',
    wxxhwystyrzzzh: 'ເບີ່ງເເຍງໂຕເລກັນພັດທະນາ ໂປຣເເກຣມ',
    wxz: 'ວິລາ ໂອລິເຊນໂລຢີສຸງກອນ',
    mdj: 'ບໍ່ເຕນ (ຊາຍແດນ)',
    tbrxq: 'ຄວາມຕ້ອງການທີ່ປະຈຸບັນ',
    rxqsltg: 'ການຕ້ອງອາໃສທີ່ປະຈຸບັນຖືກຖອດຖອນ',
    rxqyzc: 'ຄວາມຕ້ອງການທີ່ຕ້ອງໃສ່',
    rxqyfc: 'ຄວາມຕ້ອງການປະຈຸບັນໂຕະ',
    rxqzt: 'ຄວາມຕ້ອງການປະຈໍາວັນທີ່ກໍາລັງສົ່ງອອກ',
    rqxydd: 'ຄວາມຕ້ອງການທີ່ປະຈຸບັນຫຍັງ',
    rxqyxc: 'ຄວາມຕ້ອງການທີ່ບໍ່ໄດ້ຕ້ອງໃຫມ່',
    rxqyjf: 'ການຕ້ອງການສຳລັບໃຫມ່',
    rxqyjj: 'ການຕ້ອງການຂອງປະຈຸບັນຖືກຖອດຖອນ',
    rxqytd: 'ຂະໜາດທີ້ຈໍາເປັນບໍ່ສາມາດເຂົ້າກັບຂໍ້ມູນ',
    yfc: 'ລົດອອກແລ້ວ',
    ydz: 'ເຂົ້າຮ່ວມ',
    qsrhscs: 'ກະລຸນາໃສ່ແຊວແຊກແຊງຂໍ້ມູນເລກໂຕເລກ',
    qsrhsyy: 'ກະລຸນາໃສ່ລາຍສິດຂອງຄືນຄ່າຕັ້ງ',
    qsrhsds: 'ກະລຸນາໃສ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    qxzjzxx: 'ກະລຸນາໃສ່ອັກສອນຫລືໂຕເລກ',
    ghsjgsbzq: 'ມີຮູບແບບທີ່ບໍ່ສາມາດເຂົ້າກັນທຸກໂຕເລກ ຫລືໂຕເລກ',
    qsryhm: 'ປ້ອນຊື່ຜູ້ໃຊ້ໄດ້',
    qyzyhm: 'ກະລຸນາໃສ່ຊື່ຜູ້ໃຊ້',
    qxzysrq: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງສົ່ງອອກ',
    qxzhwpm: 'ກະລຸນາໃສ່ຊື່ແພັກເກດ',
    qxz: 'ກະລຸນາເລືອກ',
    qsrcs: 'ກະລຸນາຕື່ມຈຳນວນລົດ',
    xqcsbw0: 'ໂຕເລກລ່ານຖ້ອງການຕໍ່ສາມາດ 0',
    xqdsbmcg9999: 'ໂຮງຮຽກຮ້ອງຈິງ ທີ່ຕ້ອງການ ບໍ່ສາມາດປ່ອນໃຕ້ດິສຸດ',
    qsrbjje: 'ກະລຸນາໃສ່ຄ່າສະເພາະໃຫມ່',
    qxzfz: 'ກະລຸນາໃສ່ສະຖານະຂໍ້ມູນ',
    qsrzcdd: 'ກະລຸນາໃສ່ລາຍຊື່ເເຟ້ມ',
    qsrzcddszjy: 'ກະລຸນາໃສ່ອ້າງຮູບແບບ 2-400',
    qsrzqsfzhm: 'ກະລຸນາໃສ່ແລກໂຕເລກໂຕເລກໂຕເລກໂຕເລກໂຕເລກ',
    qsrdhhm: 'ກະລຸນາໃສ່ລາຍຊື່ໂຕເລກ',
    qxzdz: 'ກະລຸນາໃສ່ແລກໂຕເລືອກ',
    qsrxcdd: 'ກະລຸນາໃສ່ລາຍລະອຽດແຟ້ມ',
    qsrxcddszjy: 'ກະລຸນາໃສ່ລາຍຊື່ແຕກຕ່າງໆ 2-400',
    qsrtyrqdjs: 'ກະລຸນາໃສ່ວນຫຼາຍທີ່ຈໍາກັບຂໍ້ມູນທີ່ຕັ້ງຄ່າ',
    qsrqhfygs: 'ກະລຸນາໃສ່ການສືບສຳຫລັບຜູ້ໃຊ້',
    qsrsjhm: 'ກະລຸນາໃສ່ລາຍຊື່ໂທລະສັບເເບບທ່',
    qsrlc: 'ກະລຸນາໃສ່ລາຍຊຸດ',
    qsrxqsm: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງຄວາມຕ້ອງການ',
    qsrmc: 'ກະລຸນາໃສ່ຊື່ທ່ານ',
    qsrkhh: 'ກະລຸນາໃສ່ອຸດລະບຽບຂໍ້ມູນທີ່',
    qsrzh: 'ກະລຸນາໃສ່ລາຍຊື່ບັນຊີຜູ້ໃຊ້',
    qsrdz: 'ກະລຸນາໃສ່ອີກສອນຫລືໂຕເລກ',
    lj: 'ຟີນຊ໌',
    d6700: '6700ເຕັກດ (T)',
    buxian: 'ບໍ່ມີເເບບ',
    cj_nh: 'ໂອລິມປີ ທີ່, ລວມທັງຢູ່ໃກ້ດິນ',
    jztlslymtcpjd: 'ຈິດເຊື້ອໄຟລ໌ ທີ່ສູງຂໍ້ມູນເຊື້ອໄຟລ໌',
    bjhhyxgs: 'ປະເທດຈີກຽດ ຫລື ໂປຣເເກຣມ ຫລື ໂປຣເເກຣມ ຫລື ອິງກອນ',
    tjg_shg: 'ທຽກກີດສະຖານ - ໂອຄາຢ່າງປະເທດ',
    day1: '1 ວັນນີ້',
    gzhhyxgs: 'ສູນນານຸກຄະນະກໍາມະການດ້ວຍສູງກອນ, ອັກຄະນະກໍາມະການດ້ານການເມືອງ',
    acad: 'ໂດຍຜ່ານແພງກັ້ບພະລັດອາເມລິກາງ',
    qxzrxq: 'ກະລຸນາໃສ່ຄວາມຕ້ອງການທີ່ປະຈຸບັນ',
    qxzsrzy: 'ກະລຸນາໃສ່ແຫຼ່ງຂໍ້ມູນທີ່ສົ່ງອອກ',
    qdsfsc: 'ການດຳເນີນການນີ້ຈະເຮັດໃຫ້ເກີດຜ່ອນເຟ້ມ. ທ່ານລົງເລີ່ມລະບົບ?',
    ts: 'ຂໍ້ມູນ',
    qd: 'ຕິດຕັ້ງ',
    qx: 'ຍົກເລີອກ',
    sccg: 'ລຶບບັນຫາເຫດ',
    yqxsc: 'ລຶບບໍ່ຖືກຖອດຖອນ',
    qxztjxqsq: 'ກະລຸນາໃສ່ຄວາມຕ້ອງການຈະລຶບ',
    tqcg: 'ປ່າຍໄປທີ່ສຳເລັບຜູ້ໃຊ້',
    qxztjqqjxtj: 'ກະລຸນາໃສ່ຄວາມຕ້ອງການທີ່ຈະຕ້ອງໃສ່',
    qdjzxmktb: 'ກະລຸນາໃສ່ລາຍຊື່ແບບຄຳສັ່ງຂໍ້ມູນ',
    czcg: 'ການດຳເນີນການທີ່ສຳເລັດ',
    czsb: 'ການດໍາເນີນງານລົ້ມເຫລວ',
    wxts: 'ຫຍາຍເຫດ',
    sctpjy1: 'ຂະໜາດຮູບແບບທີ່ຖືກຕິດຕັ້ງ ບໍ່ສາມາດປ່າຍກວ່າ 2 M',
    sctpjy2: 'ແຟ້ມມີຢູ່ແລ້ວ',
    sctpjy3: 'ຄ່າຈຳນວຍຄວາມສະດວກຜ່ານແຟ້ມຕ່າງໆທີ່ບໍ່ສາມາດສູງກວ່າ',
    sctpjy4: 'ໃນປະຈຸບັນ, 3 ແຟ້ມເຊິ່ງຕ້ອງຖືກຕ້ອງຖືກຕ້ອງ, ແລະ ໃນເວລານີ້ເປັນມາ',
    sctpjy5: ' ໂຕເລືອກ ແຟ້ມ ',
    sctpjy6: 'ແຟ້ມ',
    qnqdtbxxtj: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງທີ່ຈະຖືກຕ້ອງ！',
    drcg: 'ສົ່ງອອກທີ່ຫາສຳເລັດ',
    rxq: 'ຄວາມຕ້ອງການທີ່ປະຈຸບັນ',
    dtblbzdyz: 'ໂປຣເເກຣມທີ່ຈະເຂົ້າກັບຂໍ້ມູນແຟ້ມເຊິ່ງຕ້ອງສົ່ງເສີມໃສ່ເກີອບ 2 ຂໍ້ມູນແຟ້ມ',
    xgcg: 'ໂຕປັບ',
    xjcg: 'ເເຟ້ມໃຫມ່ທີ່ຫາສຳເລັດ',
    xqlx_gjly_ptys: 'ຄວາມຕ້ອງການຄ່າ 0 - ສົງກອນດ້ວຍຄວາມຮ່ອນໃຕ້ດິນຟ້າອາກາດ 1 - ສົງກອນດ້ວຍຄວາມຮ່ອນໃຕ້ດິນຟ້າອາກາດ',
    qsrtbrxx: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງຂໍ້ມູນ',
    qyzyhxx: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງໃຊ້',
    fzxxyz1: 'ສະຖານະຂໍ້ມູນເສຍເລີ່ມລະບົບ ບໍ່ແມ່ນີ້ສະຖານະບໍ່ໃດ້',
    fzxxyz2: 'ສະຖານະຂໍ້ມູນເສຍເລັອກທີ່ມາດຕະຖານ ບໍ່ແມ່ນມີຄວາມຕ້ອງການ ຂອງຕະຖານ. ກະລຸນາໃສ່ລາຍຂໍ້ມູນສະຖານະຂໍ້ມູນເສຍເລັອກ.',
    dbxqyz1: 'ຂໍແນະນຳ: ສະຖານະການທີ່ສົ່ງອອກີດຽວເທົ່ານັ້ນ ສາມາດຈະຕ້ອງຄວາມຕ້ອງການຂອງສະຖານະການທີ່ນີ້',
    dbxqyz2: 'ຂໍແນະນຳ: ທ່ານສາມາດຂໍ້ຕົດເພີ່ມຕ້ອງການຂອງບົດທອບ ທີ່ສະຖານະການທີ່ເປັນເຈົ້າຮ່ວມໄດ້',
    dbxqyz3: 'ທຸກໃສບັນທີ່ເຂົ້າຮ່ວມກັນພັດທະນາ ທຸກໃສສຸດ ທີ່ຕ້ອງການໃນສະຖານະນີ້ໄດ້',
    dbxqyz4: 'ຈໍານວນພາຫະນະທີ່ຕື່ມໃສ່ຫ້າມຫຼາຍກວ່າຈໍານວນພາຫະນະທີ່ຍັງເຫຼືອຂອງ\n' +
      'ຄວາມຕ້ອງການເປັນໄລຍະນີ້',
    qxzfzzd: 'ກະລຸນາໃສ່ແຈງເຖິກພື້ນຖານ',
    zyydyz1: 'ແຫຼ່ງຂໍ້ມູນຫລາຍຮ້ອຍທີ່ຕ້ອງມີ ແລະ ສິ່ງທີ່ເປັນມາດຕະຖານ ໄດ້ບໍ່ສາມາດຈັບຄ່າ',
    qxzdzzd: 'ກະລຸນາເລືອກສະຖານີທີ່ສົ່ງຮອດ',
    zyydyz2: 'ບໍ່ສາມາດຊອກ',
    qxzscnr: 'ກະລຸນາໃສ່ລາຍການ',
    yhxxyz1: 'ໂປຣເເກຣມຄ່າຕັ້ງຂໍ້ມູນໃຫ້ບໍ່ໄດ້',
    yhxxyz2: 'ກະລຸນາໃສ່ແຫ່ງຂໍ້ມູນໃຫ້ຫລັງຈາກທົກວດສອບຂໍ້ມູນຳໃຊ້',
    yhxxyz3: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງນໍາໃຊ້ແລະສົ່ງອອກຄວາມຕ້ອງການປະຫວັດສາດ',
    hscs: 'ກວດເບິ່ງຈໍານວນລົດ',
    hsyy: 'ກວດເບ ສາເຫດ',
    yfss: 'ຄ່າຂົນສົ່ງ ຄິດໄລ່',
    ty: 'ຕິດຕັ້ງ',
    jj: 'ປະຕິເສດ',

    ybtrxq: 'ໄດ້ລາຍງານຄວາມຕ້ອງການປະຈໍາວັນ',
    fhr: 'ສະຖານີຕົ້ນທາງ',
    kydcs: 'ຈຳນວນລົດທີ່ມີໃຫ້ຈອງ',

  },
  dailyTransportDemandDetailRes: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຄວາມຕ້ອງການທີ່ປະຈຸບັນ',
    crumbs2: 'ຜົນຜະລິດພາດຂະນະສ້າງປະຈຸບັນ'
  },
  multimodalTransport: {
    yxfhrq: 'ເລືອກເເລ້ວ: ວັນທີຝາກເຄື່ອງ ',
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຄວາມຕ້ອງການທີ່ປະຈຸບັນ',
    crumbs2: 'ການອະນຸລັກແບບຕ່າງໆ',
    crumbs3: 'ລາຍການຕ້ອງການຂອງຂ້າພະເຈົ້າ',
    qxz: 'ກະລຸນາເລືອກ',
    fhrq: 'ພົນສົ່ງອອກປະຈຸບັນ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    dz: 'ສະຖານີປາຍທາງ',
    hwpm: 'ສິນຄ້າ',
    zzl: 'ນ້ຳໜັກລວມ',
    tyf: 'ຜູ້ຂົນສົ່ງສິນຄ້າ',
    shf: 'ຜູ້ຮັບສິນຄ້າ',
    yyh: 'ເລກສັ່ງຈອງ',
    xqh: 'ເລກຮ້ອງຂໍ',
    lylb: 'ຕົວເຕັກໂນໂລຍໂຕ:',
    thly: 'ປັບປຸງດິນ​ໂຮງງານໄຟຟ້າອິດ',
    ssjd: 'ຖານຂໍ້ມູນ ທີ່ກ່ຽວຂ້ອງ:',
    fg: 'ຕິດຕັ້ງໂອຕ່າງໆ:',
    dg: 'ເຫລວດ້ວຍ:',
    cx: 'ຄົ້ນຫາ',
    yd: 'ຕັ້ງຄ່າ',
    lx: 'ເະນິດ',
    cc: 'ໂຕເລກໂຮງ',
    yjfhsj: 'ການນໍາໃຊ້ໃດ້',
    yjddsj: 'ຄາດວ່າຈະມາຮອດໃນເວລາ',
    ls: 'ຄວາມຫຍາຍເຫດ',
    sfz_sfsj: 'ສະຖານີຕົ້ນທາງ / ເວລາທີ່ສົ່ງອອກ',
    zdz_zdsj: 'ໂປຣເເກຣມເຄື່ອງປາຍທາງອັກສອນໂປຣເເກຣມ',
    cz: 'ປະເພດລົດ',
    bc: 'ສ້າງອະນຸລັກ',
    zx: 'ໂຕເລກລຸ້ນ',
    zm: 'ຊື່ໂຕເລືອກ',
    dzsj: 'ຜູ້ຈັດເວລາ',
    czsj: 'ຜົນສະເເດງອອກ',
    tlsj: 'ມີຊ່ວຍສະຖານະທຳອັນ',
    dtjlylb: 'ຕັ້ງຄ່າອຸປະກອນກ່ຽວກັບການສົ່ງອອກສິນຄ້າຕ່າງໆ',
    tj: 'ສົ່ງອອກ',
    xg: 'ແປງ',
    sc: 'ລຶບ',
    fh: 'ກັບຄືນ',
  },
  arriveChangeInput: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ແຜນຂົນສົ່ງປະຈຳວັນ',
    crumbs2: 'ຂໍ້ມູນລາຍລະອຽດ',
    xqdh: 'ເລກຄວາມຕ້ອງການ',
    cc: 'ໂຕເລກໂຮງ',
    huo: 'ສຸດ',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    hwpm: 'ສິນຄ້າ',
    hwtz: 'ລັກສະນະພິເສດຂອງສິນຄ່າ',
    frl: 'ຄ່າດ້ວຍຄວາມຈຳ',
    bz: 'ສະກຸນເງິນ',
    yun: 'ສົງອອກສິນຄ້າ',
    ysxx: 'ຂໍ້ມູນຂົນສົ່ງ',
    ds: 'ໂຕງານ',
    fw: 'ບໍ່ລິການ',
    zzjgcl: 'ວັດສະດຸເພີ່ມຄວາມແໜ້ນໜາໃຫ້ສິນຄ້າ',
    bjys: 'ສົນສຸດງອອກສິນຄ້າ',
    cangchu: 'ສາງ',
    wu: 'ບໍ່ມີ',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    cx: 'ໂຕເລກ',
    cs: 'ໂຕເລກໂທ',
    fa: 'ສົ່ງ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    tyf: 'ຜູ້ຂົນສົ່ງສິນຄ້າ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    lxdh: 'ເບີໂທຕິດຕໍ່',
    txdz: 'ທີ່ຢູ່',
    jbr: 'ຮູບແບບ່ວໄປ',
    jbrdh: 'ໂຕເລກໂຕເລກໂຕເລກ',
    jbrsfz: 'ຮູບແບບຂອງ X ໃນເວບຮູບແບບ',
    sfz: 'ໂປຣເເກຣມ',
    sj: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    bian: 'ການປ່ຽນແປງ',
    bgxx: 'ປ້ຽນແປງຂໍ້ມູນ',
    cyshr: 'ແນວຄິດການໂດຍທົ່ວໄປ',
    shf: 'ຜູ້ຮັບສິນຄ້າ',
    ysfw: 'ບໍລິການການຂົນສົ່ງ',
    dz: 'ສະຖານີປາຍທາງ',
    qsrdz: 'ກະລຸນາໃສ່ບັນກະລຸນາໃສ່',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    tj: 'ສົ່ງອອກ',
    fh: 'ກັບຄືນ',
    cyshxx: 'ຂໍ້ມູນຮັບເຄື່ອງທີ່ໃຊ້ປະຈຳ'
  },
  dailygoodsOrder: {
    crumbs0: 'ກົດລະບຽບທີ່ມີສຸດ',
    lztlyxgs: 'ອັນນີ້ເຄເບີງ ໂຮງຮຽນລອນດອນ',
    hwydlc: 'ໂປຣເເກຣມ (ໂຮງ)',
    xqh: 'ເລກຮ້ອງຂໍ',
    zyrq: 'ວັນທີ່ຂົນສົ່ງ',
    tuo: 'ຄືຊິວິດ',
    yun: 'ສົງອອກສິນຄ້າ',
    fan: 'ບັນນານ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    zcd: 'ໂຕເອີ້ນລົບ',
    name: 'ຊື່',
    address: 'ບັດຜ່ານ',
    hwyd: 'ກົດລະບຽບທີ່ມີສຸດ',
    dh: 'ໂທລະໂທ',
    jbrxm: 'ຂໍ້ມູນຄຳສຸດ',
    sfz: 'ໂປຣເເກຣມ',
    sj: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    shou: 'ຮັບ',
    huo: 'ສຸດ',
    dz: 'ສະຖານີປາຍທາງ',
    xcd: 'ໂຕເອີ້ນລົບ',
    hwpm: 'ສິນຄ້າ',
    hwtz: 'ລັກສະນະພິເສດຂອງສິນຄ່າ',
    frl: 'ຄ່າດ້ວຍຄວາມຈຳ',
    ps: 'ສິ່ງອຳນວຍຄວາມສະດວກ',
    bps: 'ຄົນຈະບໍ່ເຄື່ອງມືອງ',
    sdz: 'ໂຕເອີ້ນລົບ',
    fsdz: 'ບໍ່ມີໃຫຍ່ທີ່ສຸດ',
    beiz: 'ໝາຍເຫດ',
    ysfw: 'ບໍລິການການຂົນສົ່ງ',
    zzdjcl: 'ພົດລະບົບຄຳສຸດດ້ວຍຄວາມສະດວກ',
    bjys: 'ສົນສຸດງອອກສິນຄ້າ',
    cangchu: 'ສາງ',
    tyfjzsx: 'ຂຽນໂປຣເເກຣມ',
    zzsfplx: 'ຮູບແບບຂອງ MIT ຄໍາສັບ',
    ptfp: 'ການທໍາມະການຖ້າ',
    zyfp: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    spfmc: 'ຊື່ຂອງ',
    nsrsbh: 'ຄ່າຈຳນວຍຄວາມສະດວກຜູ້ຈັນຍາດ',
    khhjzh: 'ບັນຊີຜູ້ໃຊ້ບັນຊີຜູ້ໃຊ້',
    fyhej: 'ຄ່າຈຳນວນເຕັມຜົນທີ່ (ຫົວ)',
    chec: 'ໂຕເລກໂຮງ',
    cs: 'ໂຕເລກໂທ',
    ds: 'ໂຕງານ',
    ydmx: 'ຂໍ້ມູນທີ່ກ່ຽວກັບ',
    ydh: 'ກໍລະນີສຶດ ',
    cx: 'ໂຕເລກ',
    ch: 'ໂຕເລກໂປຣເເກຣມ',
    bz: 'ຄ່າຈຳນວຍຄວາມສະດວກ',
    zz: 'ຕິດຕັ້ງ',
    lc: 'ໄລຍະທາງ',
    zfy: 'ຄ່າຈຳນວນເຕັງ (ມູນ)',
    fymx: 'ລາຍລະອຽບຜູ້ຊ່ຽວຊານ',
    fh: 'ກັບຄືນ'
  },
  workbench: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຂ້ອຍເຮັດວຽກໂດຍສະເພາະ',
    dbsx: 'ເພື່ອເຮັດໃຫ້ເກີດຂໍ້ມູນ',
    xq: 'ຄວາມຕ້ອງການ',
    rxq: 'ຄວາມຕ້ອງການທີ່ປະຈຸບັນ',
    jdxq: 'ຂະບວນການຕ້ອງການ',
    sm: 'ການຄ້າ ແລະ ການຄ້າ',
    gdyd: 'ລືກສອນໂຕເລກ',
    dxjy: 'ການກ່ຽວກັບການບັນທຶກ',
    jmjm: 'ກໍລະນີດກຽມ',
    hetong: 'ໂປຣເເກຣມ',
    smht: 'ການຄ້າລະຫັກທາງການຄ້າ',
    xx: 'ຂ່າວ',
    zyxx: 'ຂ່າວ່າ ທີ່ມີບັນຫາ',
    jhxx: 'ແຟ້ມເຕັກສອນຫລັກ',
    wdlyb: 'ໂຕອັກສະນະຂອງຂ້າພະເຈົ້າ',
    zxhf: 'ການຕອບກັບໃໝ່ລ່າສຸດ',
    yfbht: 'ສົນທະນາ',
    tjfx: 'ການສຶກສາມະນຸດສາດ (ສະຖານະ)',
    ntj: 'ຂໍ້ມູນເພີ້ມປະຈຸບັນ',
    ytj: 'ສະຖານະການຖ້າປະຈຸບັນ',
    dyzj: 'ລວມຕົວລິກປະຈຸບັນ',
    xqcs: 'ຈຳນວນລົດທີ່ຮ້ອງຂໍ',
    yscs: 'ໂຕເລກຂອງ ລົງເປັດໃຫຍ່ງ',
    xqdxl: 'ຄ່າຈຳນວຍຄວາມສະດວກ',
    nzj: 'ທຸດສະທຳອິດສະຖານ',
    wfqd_cjl: 'ຂ້ອຍເລີ້ມໂປຣເເກຣມ - ສຳລັບໂປຣເເກຣມ',
    wcyd_cjl: 'ຂ້ອຍໄດ້ເຂົ້າຮ່ວມຢູ່ໃນ -  ຈຸດທິດ',
    yzj: 'ທຸກຕິດຕັ້ງ',
    cjl: 'ຜົນອອກທີ່ກ່ຽວຂ້ອງພາຍນອກ (ຕຸດ)',
    cje: 'ຫົກເລືອກ (ທີ່)',
    wfqd: 'ຂ້ອຍເລີ້ມໂປຣເເກຣມ',
    wcyd: 'ຂ້ອຍເຂົ້າຮ່ວມກັບ',
    qdgs: 'ໂຕເລກລິກສອນຫລືໂຕເລກ',
    zds: 'ໂຕເຕັກໂນໂລກ (ຕຸງ)',
    zhte: 'ລາຊະອານາຈັກອັນຄ່າຕັ້ງ (y)',
    ysht: 'ຄວາມແຕກຕ່າງປະກອນ',
    zzl: 'ນ້ຳໜັກລວມ (ຊຸນານ)',
    tiao: '3',
    dtb: 'ລໍຖ້າແຈ້ງແຜນ',
    dzf: 'ສຳລັບຜູ້ຊ່ຽວຊານ',
    sm_gdyd: 'ການຄ້າ - ຈະລົດລະບຽບ',
    dfb: 'ເພື່ອສຳເລັອກ',
    dsl: 'ຖ້າການຍອມຮັບ',
    sm_dxjy: 'ຄ້າຄ້າ - ການກົດດ້າງພາຍໃສ່',
    dqr: 'ຕ້ອງຮູ້ຕັ້ງຄ່າ',
    sm_jmjm: 'ຄໍາສຸດ - ບໍລິສຸດ',
    ht_smht: 'ແຕກຕ່ງ - ຄວາມແຕກຕ່າງສັ່ງ',
    dqrsh: 'ຄຳນົບຄຳນົດເພີ່ມຕັ້ງຄ່າ',
    lyb_zxhf: 'ຂໍ້ມູນເລກຂໍ້ມູນ - ການຕອບກັບໃໝ່ລ່າສຸດ'
  },
  transportDetil: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ວັນເລກໂນໂລຢີ ແມ່ນ ເປນນັກໂປຣເເກຣມທຳລັບໄຂດປົກລະດູຮ້ອນໄຂດ້ານການເມືອງ, ໂປຣເເກຣມປ່ຽນໂປຣເເກຣມປ່ຽນໂປຣເເກຣມປ່ຽນໂປຣເເກຣມປ່າໄມ້ນ ແລະ ເປັນຊ່ອງໂ ການທາງເລືອກຕ່າງໆ ໄດ້ເຂົ້າຮ່ວມຕົວຢູ່ພາຍໃຕ້ດິນເຂດປ່າໄມ້ນ ແລະ ສິ່ງເຂດຂອງໂກລິກໂນໂລຍ, ຈາຄານ, ຈາຄານ, ອີວານ, ຈາຄານ, ຍູນນານ ແລະ ຈຳອັກໂນໂລຍີ. ຄຳແລກຄຳສຸມ ຂໍ້ມູນການສົ່ງອອກສິນຄ້າ ທີ່ຕັ້ງສິນຄ້າ ທີ່ສິງຂໍ້ມູນເຫ້າ ແລະ ການຕັ້ງຂໍ້ມູນການສ່າຍສິນຄ້າ ແມ່ນເປັນການສົ່ງອອກສິນຄ້າຈໍາ ແລະ ເປັນການສົ່ງອອກສິນຄ້າລາຍການຕ່າງໆ ທີ່ສິງຂ່າຍສິນຄ້າ ທີ່ສິງຂ່າຍສິນຄ້າ ທີ່ສັ່ງຢ່າງເຊັ່ນ: ປະເທດຈ ຈໍາຈ່າຍສິນຄ້າ, ປະເທດຈໍາຈ່າຍສິນຄ້າ ແລະ ຈໍາຈ່າຍສິນຄ້າ, ລວມທີ່ສູງຂ່າຍສິນຄ້າ ແລະ ກ່ຽວຂ່ອງກ່າຍສິນຄ້າ. ມີຜູ້ໃຊ້ເວລາ.',
    ysfaxz: 'ໂຕເລືອກທີ່ສິ່ງອຳນວຍຄວາມສະດວກ',
    jdxqtb: 'ສະຖານະການຕ້ອງໃສ່ຄວາມຕ້ອງການຂອງຕອບສະຫນອງ',
    rxqtb: 'ບົດລາຍງານຄວາມຕ້ອງການປະຈໍາວັນ',
    hwzz: 'ການຕິດຕາມສີ້ນຄ້າ',
    xqtb: 'ຄວາມຕ້ອງການໃສ່ລາຍໃສ່',
    xqtb_text: 'ມັນແມ່ນໄດ້ຖືກຈ່າຍພາຍໃສ່ຄວາມຕ້ອງການຂອງສົ່ງອອກສິນຄ້າ ແລະ ຕ້ອງໃສ່ຄວາມຕ້ອງການຂອງສົ່ງອອກສິນຄ້າ ທີ່ປະຈຸບັນ ຫຼັງຈາກການຕ້ອງໃສ່ຄວາມຕ້ອງການ, ໂປຣເເກຣມ ສາມາດຕ້ອງໃສ່ສະຖານະປະຈຸບັນ ຕ້ອງຂອງທຸກຕ້ອງຄວາມຕ້ອງການ.',
    jdxqtb_text: 'ຄວາມຕ້ອງການຂອງຂໍ້ມູນເພື່ອຂໍ້ມູນເພື່ອຂໍ້ມູນເພື່ອຕ້ອງຄວາມຕ້ອງການຂອງຕະລັດອາເມລິກາງ. ໃນຂະບວນການຕ້ອງການຂອງຕະຫຼາດ ສາມາດປ່ຽນແປງຢ່າງປະຈຸບັນ ຕ້ອງຄວາມຕ້ອງການຂອງຕ',
    rxqtb_text: 'ການຕ້ອງຄວາມຕ້ອງການຂອງອາຫານ ແມ່ນສົ່ງອອກສິນຄ້າ ທີ່ຕ້ອງໃສ່ຄວາມຕ້ອງການຂອງອາຫານ ເພື່ອສະໜັບສະໜູນການສົ່ງອອກສິນຄ້າ ໃນປະຈຸບັນທີ່ຈໍາກັດຕັ້ງ. ການຕ້ອງຄວາມຕ້ອງການທີ່ປະຈຸບັນສົ່ງອອກສິນຄ້າ 12:0 ໃນຊ່ ໃນຂະບວນການຕ່າງໆທີ່ນີ້, ສິ່ງອຳນວຍຄວາມສະດວກຕ່າງໆຈະຖືກອະນຸລັງເຖິກຮ່ອງ ແລະ ສິ່ງອຳນວຍຄວາມສະດວກຕ່າງໆທີ່ເປັນໄປໄດ້.',
    yszyyd: 'ການອະນຸລັບປຸນຄ່າຕ່າງໆ',
    yszyyd_text: 'ການອະນຸລັບປຸງດ້ານແຫ່ງອອກສິນຄ້າ ທີ່ມີປະສິດທິພາບ, ປົດລະບຽບແລະສິ່ງແວດລ້ອມທີ່ມີປະສິດທິພາບ ອີງຕັ້ນມາດຕະຖານຂອງຊ່ວງເວລາທີ່ຈໍາກັດຕັ້ງ, ຂໍ້ມູນທີ່ຈໍາກັດຕັ້ງ, ເສລີທີ່ຈໍາກັດຕັ້ງ ແລະ ຊ່ວເລກໂນໂລຍີທີ່ຈໍາກັດຕັ້ງ, ສະຖານະອານາໄລວມທີ່ຊ່ວຍສົ່ງເສີມບູນ, ການສະໜັບສະໜູນການສົ່ງເສີມຄວາມສະດວກຕ່າງໆ ແລະ ນອກຈາກນັ້ນ, ທ່ານນໍາໃຊ້ສຸຂາພິບາຍດ້ານການເມືອງສໍາລັບ ບ ບັນຕຸກຄົນ, ຫຼຸດຜ່ອນຈໍານວນດ້ານການເມືອງສໍາລັບ ແລະ ເປັນຜ່ອນຈໍານວນເຕັກພ່ອງ. ການທຽບກັບການສົ່ງອອກສິນຄ້າອຸລະກິດປະເພດຕ່າງໆ, ສິ່ງອຸປະສັກທາງການຄ້າແມ່ນເປັນອັນຕະຫຼາດ: (2) ການປະຕິບັດດ້ວຍການປະຕິບັດດ້ວຍໃຫ້ຂຽນໂປຣເເກຣມ -- - ພົດທະນາຈຸດເພື່ອຕອບສະຫນອງຂໍ້ຕົກດ້ວຍຄວາມຈຳນວນ ແລະ ສັ່ງຂໍ້ຕົກດ້ວຍຄວາມຈຳນວນ: ຍົກເລີຍໃນຂະບວນການຕ່າງໆພາຍໃນຂະບວນການຕ່າງໆທີ່ບໍ່ໄດ້ເກີດຜ່ອນກໍ (3) ຄວາມດຳເນີນການຢູ່ ໄຫວເນີນການຕໍາອິດ - ແຫຼ່ງພະລັງງານຄວາມຮ້ອນໃຕ້ດິນຟ້າອັກທາງການຄ້າ, ທີ່ມີປະສິດທິພາບ ແລະ ມີປະສິດທິພາບ, ແລະ ເປັນປະໂຫຍດການຄ້າອັນດັ',
    ds: 'ຂວາງ',
    sjgd: 'ມີເເບບໃດທີຖຶກເລີກ',
    dd: 'ມີນຳ້ທີ່ໃດ້',
    zchxczdgd: 'ກຳລັງອອກສິດລະບັບສະຖານະການທີ່ກ່ຽວກັບ ແລະ ບໍ່ຕ້ອງ',
    dx: 'ຂໍ້ຄວາມ',
    qcysxlgd: 'ຮູບແບບທົ່ວໄປຕ່າງໆ',
    dj: 'ຄ່າຈຳ',
    ysjggd: 'ຄ່າຈຳນວຍຄວາມສະດວກຕ່າງໆ',
    dcc: 'ໂຕເລກໂຮງງານໄຟລັກ',
    ccgd: 'ໂຕເລກໂຮງງານໄຟລັກ',
    gslyxz: 'ໂຕເລືອກໃນການປ່ຽນໂປຣເເກຣມ',
    gslyxz_text: 'ການກົນພັກທາງການຄ້າສະແດງໃຫ້ເຫັນວ່າ ທີ່ສ້າງພື້ນຖານ ເພື່ອປັບປຸງດິນຟ້າອັກທາງການຄ້າ, ຊ່ວຍຈຸດເຊື່ອນໄຟຟ້າອັນດ້ວຍຄວາມຈຳນວຍຄວາມສະດວກຕ່າງໆ ແລະ ຕົວຈິດກ່ຽວກັບການອຸບປຸງຂ່າວເຕ່າງໆ ແລະ ກົນພັກທ ອີງຕັ້ງຂໍ້ມູນແຫຼ່ງຂໍ້ມູນເສຍທີ່ເປັນປະໂຫຍດກ່ຽວກັບ ອຸລະກິດການດ້ວຍສົ່ງອອກສິນຄ້າຕ່າງໆໃນສະຖານະໂຫຍດກ່ຽວກັບການສົ່ງອອກສິນຄ້າຕ່າງໆງ ແລະ ລວມຕົວຈັດການຕ່າງໆຂອງພວກເຂ ຫລັງຈາກອ້າງຮູ້ກ່ຽວກັບ, The Customs_BAR_ສິ່ງອຳນວຍຄວາມສະດວກຜູ້ໃຊ້ອຸປະກອນກ່ຽວກັບການນໍາໃຊ້ສິ່ງອຳນວຍຄວາມສະດວກຜູ້ໃຊ້ປະກອນກ່ຽວກັບ',
    hwzz_text: 'ຫຼັງຈາກການຕ້ອງການຂອງຄວາມຕ້ອງການຂອງສົ່ງອອກສິນຄ້າ, ສະຖານະພາບການຜະລິດພະລັງງານນັ້ນສາມາດຈໍາ, ແຈ່ງອອກສິນຄ້າ ແລະ ປ່ອນໄຟຕ່າງໆ. ໃນລະຫວ່າງການສົ່ງອອກສິນຄ້າ, ບໍລິກຄ້ນ ສາມາດສຶກສາຂໍ້ມູນໃຫ້ກັບທຸລະກິດຢ່າງການຄ້າ, ລວມທັງສະຖານະຂອງຄ່າ, ຂໍ້ມູນເລກຂໍ້ມູນເລກປະຫວັດສະຫຼາດ ແລະ ຄ່າຂົ ໂປຣເເກຣມ ສາມາດສ້າງໂປຣເເກຣມ ຫລື ອີງຕໍ່ສະຖານະການດ້ານສົ່ງອອກສິນຄ້າ ເພື່ອຍອມຊື້ສິນຄ້າ.'
  },
  workbenchInfo: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຂ້ອຍເຮັດວຽກໂດຍສະເພາະ',
    crumbs2: 'ຂ່າວ',
    xxlz: 'ເລກຂໍ້ມູນລຸ້ນ:',
    zyxl: 'ຂ່າວ່າ ທີ່ມີບັນຫາ',
    jhxx: 'ແຟ້ມເຕັກສອນຫລັກ',
    xlly: 'ຂໍ້ມູນ:',
    zt: 'ສະຖານະ:',
    wd: 'ບໍ່ອ່ານອ່ານ',
    yd: 'ອ່ານອ່ານ',
    xqdh: 'ເລກຄວາມຕ້ອງການ:',
    qsrxqdh: 'ກະລຸນາໃສ່ລາຍໃສ່ແພັກເກດ',
    shjyh: 'ການຄ້າອິກທາງການຄ້າ ບໍ່ແມ່ນ:',
    qsrsmjyh: 'ກະລຸນາໃສ່ລາຍຊື່ການຄ້າຕ່າງຫລັກ',
    tsksrq: 'ໂປຣເເກຣມຫລັງໂປຣເເກຣມ:',
    xzrq: 'ກະລຸນາເລືອກວັນທີ່',
    tsjsrq: 'ວັນທີ່ສິ້ນສຸດ:',
    cx: 'ຄົ້ນຫາ',
    qk: '(ລົບຂໍ້ມູນທັງໝົດ)',
    qd: 'ຕິດຕັ້ງ',
    bjyd: 'ໂຕອ່ານອ່ານ',
    sc: 'ລຶບ',
    fh: 'ກັບຄືນ'
  },
  LoadUnloadVehicleInfo: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຂໍ້ມູນການຂື້ນລົງລົດ',
    zcxx: 'ຂໍ້ມູນການຂື້ນລົດ',
    xqdh: 'ເລກຄວາມຕ້ອງການ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    dz: 'ສະຖານີປາຍທາງ',
    zcrq: 'ໂຕເອີ້ນລະບົບ',
    zhi: 'to',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    jsrq: 'ວັນທີ່ສິ້ນສຸດ',
    zcrqzndekzrq: 'ໂຕເອີ້ຈໍາອັນດ້ວຍຄວາມຫມາຍເຫດ',
    zcz: 'ກຳລັງອອກ...',
    ywc: '(ພົມຕິບ)',
    cx: 'ຄົ້ນຫາ',
    dc: 'ສົ່ງອອກ',
    qxz: 'ກະລຸນາເລືອກ',
    xcxx: 'ຂໍ້ມູນການລົງລົດ',
    xcrq: 'ຍົກເລີອກ',
    xcrqzndekxrq: 'ທ່ານແຕກໃສ່ເກີດຂໍ້ມູນທີ່ກ່ຽວກັບ',
    xcz: 'ຍົກເລີອກ',
    zt: 'ສະຖານະ',
    kzsj: 'ເວລາເລີ່ມຕົ້ນ',
    zwsj: 'ເວລາສິ້ນສຸດ',
    hs: 'ສິງຫາຍະເວລາ',
    hwpm: 'ສິນຄ້າ',
    fz_dz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ-ສະຖານີລົດໄຟທີ່ສົ່ງຮອດ໌',
    tyf: 'ຜູ້ຂົນສົ່ງສິນຄ້າ',
    sgf: 'ທົ່ວໄປ',
    jbr_jbrdh: 'ໂຕເຕັດເຈົ້າ / ໂຕເຕັດເຈົ້າ',
    zckb: 'ກຳລັດເຈົ້າຮ້ວມກັບ',
    gj: 'ໂດຍລວມ',
    che: 'ປັກເກດ',
    yz: 'ຕິດຕັ້ງ',
    ch: 'ໂຕເລກໂປຣເເກຣມ',
    jssj: 'ສຸດທ້າຍ',
    kxsj: 'ເກີດຜ່ອນໃສ່ງເວລາ',
    xwsj: 'ເກີດຜ່ອນໃສ່ງເວລາ',
    xckb: 'ແກ້ໄຂລາຍກັນຍານ',
    yx: 'ຖືກຕິດຕັ້ງ'
  },
  cargoTracking: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ການຕິດຕາມສີ້ນຄ້າ',
    xqdh: 'ເລກຄວາມຕ້ອງການ',
    qsrxqdh: 'ກະລຸນາໃສ່ລາຍໃສ່ແພັກເກດ',
    cx: 'ຄົ້ນຫາ',
    fhyhlb: 'ກະລຸນາໃສ່ລາຍການຄ້າ',
    shi: 'ເລີ່ມຕົ້ນ',
    zong: 'ສຸດທ້າຍ',
    xh: 'ລໍາດັບ',
    cz: 'ສະຖານີລົດໄຟ',
    dzsj: 'ຜູ້ຈັດເວລາ',
    czsj: 'ຜົນສະເເດງອອກ'
  },
  leagueOfNationsWaybill: {
    nwdsl: "ເຄື່ອຂ່າຍພາຍໃນກໍາລັງລໍຖ້າອະນຸມັດ",
    qscjjddh: 'ກະລຸນາສ້າງໝາຍເລກໃບມອບຮັບ',
    sfzfctyd: 'ຍົກເລີກໃບສົ່ງນີ້ຫຼືບໍ່ ?',
    tjqfsfcg: ' ຍື່ນໃຫ້ເປີດສິນຄ້າທີ່ປິດຕາຍໄດ້ສໍາເລັດ',
    tjqfsfsb: ' ຍື່ນໃຫ້ເປີດສິນຄ້າທີ່ປິດຕາຍບໍ່ສໍາເລັດ',
    qsrnrhqd: 'ກະລຸນາຕື່ມເນື້ອໃນໃສ່ແລ້ວຢືນຢັນ',
    yxs: 'ສະແດງໃຫ້ເຫັນແລ້ວ',
    qzsj: 'ເວລາເລີ່ມຕົ້ນ ແລະ ສິ້ນສຸດ',
    scjjddh: 'ເລກທີໃບມອບວຽກ',
    jzx1: 'ແພັກເກຍອມ 1',
    jzx2: 'ແພັກເກຍອມ 2',
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ປົບປູງຖ່າຍໃຕ້ດິນ',
    crumbs2: 'ຕອບສະຫນອງຄວາມຕ້ອງການໃນການປົວເຕັງ',
    ph: 'ເລກຊຸດ',
    yyh: 'ເລກສັ່ງຈອງ',
    gjydh: 'ບໍ່ມີນເອກະສົມໂດຍົ່ວໄປ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    qsrfz: 'ກະລຸນາເລືອກສະຖານີຕົ້ນທາງ',
    fhr: 'ສະຖານີຕົ້ນທາງ',
    qsrfhf: 'ກະລຸນາໃສ່ຜູ່ສົນທະນາ',
    tbrq: 'ວັນທີ່ຂຽນຟອມ',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    jsrq: 'ວັນທີ່ສິ້ນສຸດ',
    zdz: 'ສະຖານີ ປາຍທາງ',
    dz: 'ສະຖານີປາຍທາງ',
    qsrzdz: 'ກະລຸນາໃສ່ບັນກະລຸນາໃສ່',
    shr: 'ທົ່ວໄປ',
    qsrshf: 'ກະລຸນາໃສ່ເພື່ອເຂົ້າໂປຣເເກຣມ',
    ch: 'ເລກໂທ ທ',
    xh: 'ລໍາດັບ',
    ydzt: 'ສະຖານະໃບບິນ',
    bllb: 'ປະເພດການດຳເນີນງານ',
    qxz: 'ກະລຸນາເລືອກ',
    cx: 'ຄົ້ນຫາ',
    qk: '(ລົບຂໍ້ມູນທັງໝົດ)',
    xqxj: 'ຄວາມຕ້ອງການໃຫມ່',
    qx: 'ລຶບບ',
    zt: 'ສະຖານະ',
    dsl: 'ຖ້າການຍອມຮັບ',
    ysl: 'ຍອມຮັບແຜນແລ້ວ',
    yzc: 'ຂື້ນລົດແລ້ວ',
    yfc: 'ລົດອອກແລ້ວ',
    ydd: 'ມາຮອດແລ້ວ',
    yxc: 'ລົງລົດແລ້ວ',
    yjf: 'ສົ່ງມອບແລ້ວ',
    lkzf: 'ການນຳໃຊ້ຕູ້ບໍ່ໄດ້ຕາມແຜນ (ຍົກເລີກ) ',
    zccx: 'ເກີດຂໍ້ຜິດພາດຂະນະລົກເລີອກ',
    jgcx: 'ການຖອດຖອນໃຫມ່',
    glydh: 'ເລກໃບບິນສາກົນ',
    zc: 'ການຂົນສົງໂດຍລົດໄຟ',
    jzx: 'ແພັກເກຍອມ',
    fhrmc: 'ຊື່ຜູ້ສົ່ງສິນຄ້າ',
    fzzm: 'ຊື່ສະຖານີຕົ້ນທາງ',
    shrmc: 'ຊື່ຜູ້ຮັບສິນຄ້າ',
    gjz: 'ໂຮງງານຂອງຂໍ້ມູນ',
    tbsj: 'ເວລາ ການແຈ້ງເຕືອນ',
    fhrtxdz: 'ອີເເມວລ໌ໃຫ່ມແວລ໌',
    shrtxdz: 'ບັນຖືກສຽງໂທ',
    bcqd: 'ຕິດຕັ້ງຂໍ້ມູນ (ຊ່ວຍເຫລືມ)',
    xz: 'ບໍ່ມີຕັ້ງຄ່າທີ່ຖຶກບັນທຶກ',
    ck: 'ກວດສອບ',
    swjl: 'ການບັນທຶກທາງທຸລະກິດ',
    clqd: 'ຮູບມີນຳ້',
    ckxq: 'ກວດສອບລາຍລະອຽດ',
    hwjjd: 'ລາຍການຄ່າຕັ້ງ ແລະ ຍອມຮວມເຂົ້າຮ່ວມ',
    jzxqd: 'ລາຍການແບບຕ່າງໆ',
    sfbg: 'ປ່ຽນສະຖານີປາຍທາງຫຼືບໍ່',
    cz: 'ປະເພດລົດ',
    bgdz: 'ປ່ຽນສະຖານີປາຍທາງ',
    xzjcsdqfjl: 'ມີບັນຫາເອກທີ່ລະຫວ່າງກອງເບີ່ງເເຍງລະບົບ',
    ydzb: 'ໂຕເລືອກທີ່ເປັນມາດຕະຖານ',
    gshr: 'ກຳນົດເພີ່ມຕົ້ນ',
    gxshrjfhwdcyr: 'ສໍາລັບຜູ້ສົ່ງອອກສິນຄ້າທີ່ສົ່ງອອກສິນຄ້າໃນທຸກຄົນສົ່ງອອກ',
    qb: 'ທັງໝົດ',
    d1l: 'ຄໍາເນົອກ ທົ່ວໄປ',
    d2l: 'Second copy',
    d3l: 'ຄໍາເນື້ອຫາຄືນຄ່າ',
    d4l: 'ພື້ນນານີສີ່ ປີດ',
    d5l: 'ແຫ້ມວ່າ 5',
    d6l: 'ໂຕເອົາ 6',
    dy: 'ປິດ',
    bc: 'ບັນທຶກໄຟລ໌',
    zf: 'ບັນຖຶກສຽງໂທ',
    fh: 'ກັບຄືນ',
    tj: 'ສົ່ງອອກ',
    sc: 'ລຶບ',
    qxiao: 'ຍົກເລີອກ',
    qr: 'ທົກຮູ້ບ',
    qd: 'ທົກຮູ້ບ',
    hwysbgyqs: 'ໂຕ້ອງການໃນການປ່ຽນແປງຂ່ອນໄຫວ',
    bgyqr: 'ກະລຸນາປ່ຽນໂປຣເເກຣມ',
    yz: 'ປັນຍົງ',
    jbrsfzxx: 'ຂໍ້ມູນລາຍລະອຽດຂອງຈັດຕົວຈັກ',
    ddmlh: 'ຮ້ອງຂໍ້ມູນເເດຍເນື່ອງ ບໍ່',
    khtj: 'Customer filling',
    bgsx: 'ປ່ຽນແປງ',
    xdz: 'ທ່ານເຂົ້າຮ່ວມໃຫມ່',
    xshr: 'ແນວຄິໃຫມ່',
    yhwydjzsx: 'ໂປຣເເກຣມໂປຣເເກຣມຫລືໂຕເລກ',
    ydhm: 'ກໍລະນີສຶດ (Law N)',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    blzb: 'ປະເພດ ການຈັດການ',
    czch: 'ຮູບແບບ ແລະ ເລກໂທ',
    hwmc: 'ຊື່ສິນຄ້າ',
    js: 'ໂຕເລກໂທ',
    zl: 'ຊ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    cyrq: 'ວັນທີ່ຂົນສົ່ງ',
    bgyy: 'ສາເຫດຂອງການປ່ຽນແປງ',
    cyrtj: 'ລວມກັບຜູ້ກ່ອນໃສ່',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    ydz: 'ໂຮງງານໄຂໍ້ມູນເທົ່າກັນທຸກໂທດ',
    yshr: 'ແນວຄິດການມາດຕະຖານ',
    wslyy: 'ສາເຫດຂອງບໍ່ສາມາດຍອມຕິດຕັ້ງ',
    bgclz: 'ກະລຸນາປ່ຽນ ໂປຣເເກຣມ',
    jbr: 'ຄົນດຳເນີນການ',
    bgxxtx: 'ກະຣຸນາເລກລິບ',
    xuh: 'ລໍາດັບ',
    wpmc: 'ຊື່ເປນນີ້',
    bz: 'ແພັກເກດ',
    tiji: 'ປະລິມານ',
    jg: 'ຄ່າຈຳ',
    beizhu: 'ຮູບພາບ',
    congzhi: 'ຕິດຕັ້ງ',
    cyrjz: 'ຂໍ້ມູນບັນທຶກຂອງຜູ້ຈັດສົ່ງ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    // dsl:'ລໍຖ້າຍອມຮັບ',
    // ysl:'ຍອມຮັບເຮັດ',
    // yzc:'ບັນຈຸໃສ່ລົດແລ້ວ',
    // yfc:'ລົດອອກໄປແລ້ວ',
    // ydd:'ມາຮອດແລ້ວ',
    // yxc:'ຂົນເຄື່ອງລົງແລ້ວ ',
    // yjf:'ໄດ້ມອບໝາຍແລ້ວ',
    // lkzf:'ການນຳໃຊ້ຕູ້ບໍ່ໄດ້ຕາມແຜນ (ຍົກເລີກ)',
    // zccx:'ຍົກເລີກການບັນຈຸເຄື່ອງໃສ່ລົດ',
    jfcx: 'ຍົກເລີກການມອບຮັບ',
    cyr: 'ຜູ້ຂົນສົ່ງ',
    wwdtj: 'ຈໍາເປັນຕ້ອງສົ່ງ',
    wwdsl: "ຖ້າການຍອມຮັບ",
    luok: 'ການນຳໃຊ້ຕູ້ຢ່າງບໍ່ໄດ້ຕາມແຜນ',
    shjj: 'ກວດສອບການປະຕິເສດ',
    qxzdtjzt: 'ກາລຸນາເລືອກການສົ່ງໃບຂົນສົ່ງສິນຄ້າສາກົນ ໃນສະຖານະ “ ຈໍາເປັນຕ້ອງໄດ້ສົ່ງ”',
    yxqh: 'ເລກໃບສະເໜີຄວາມຕ້ອງການ ປະຈໍາເດືອນ',
    cxcg: 'ຄົ້ນ​ຫາ​ສໍາ​ເລັດ​ຜົນ​',
    xhbky: 'ໝາຍເລກກ່ອງບໍ່ມີໃຫ້',
    jzxbtx: "ກະ​ລຸ​ນາ​ຕື່ມເນື້ອ​ໃນ​ໃສ່​​ແລ້ວ​ຄລິກຢືນຢັນ. ຊ່ອງ​ຂໍ້​ມູນ​ຍົກ​ເວັ້ນ 'ບັນ​ທຶກ​ຜູ້​ບໍ​ລິ​ການຂົ່ນສົ່ງ​' ແມ່ນ​ຕ້ອງ​ຕື່ມທັງ​ຫມົດ​​.",
    zstxyt: 'ຕື່ມຂໍ້ມູນໃສ່ຢ່າງໜ້ອຍໜຶ່ງຂໍ້ຂອງຂໍ້ມູນຕູ້ຄອນເທນເນີ',
    jzxxhcx: 'ໝາຍເລກຕູ້ທີ່ລະບຸນັ້ນບໍ່ໄດ້ຢູ່ໃນຂໍ້ມູນໝາຍເລກຕູ້ຂອງຊຸດນີ້. ທ່ານຕ້ອງການລຶບລາຍຊື່ ແລະ ຕື່ມຂໍ້ມູນໃສ່ອີກບໍ?',
    bltjyz: 'ໃບບິນລະຫວ່າງປະເທດທີ່ສົ່ງມານັ້ນບໍ່ສາມາດຍື່ນສົ່ງໄດ້ອີກ.',
    sfhycz: 'ໝາຍເລກປິດລ໋ອກປ້ອງກັນສິນຄ້າ ແມ່ນບໍ່ສາມາດຊໍ້າກັນໄດ້',
  },
  LNWayBillAdd: {
    yqctts: '当前国联运单对应的日需求已超出提出时间范围，请在修改国联运单之后选择新的运输日期并提交(ES)', // 允许重提标志提示
    fkjs: "ບັນທຶກການຊໍາລະເງິນ",
    dyil: "ໜ້າທີໜຶ່ງ",
    derl: "ໜ້າທີສອງ",
    dsanl: "ໜ້າທີສາມ",
    dsil: "ໜ້າທີສີ່",
    dwul: "ໜ້າທີຫ້າ",
    dliul: "ໜ້າທີຫົກ",
    qztitle: 'ຫຼັງຈາກສົ່ງແລ້ວ ລະບົບກໍ່ຈະອັດຕະໂນມັດແຈ້ງໃຫ້ທ່ານລົງລາຍເຊັນ, ກະລຸນາຢືນຢັນ',
    qxtxdygjzx: 'ກະລຸນາຕື່ມເລກຕູ້ຄອນເທັນເນີທໍາອິດໃສ່ກ່ອນ',
    ccaozjyjscsj: 'ການດຳເນີນງານນີ້ເເມ່ນຈະລົບຂໍ້ມູນອອກຖາວອນ',
    zdxqytsj: 'ສາມາດເລືອກຂໍ້ມູນໄດ້ຫຼາຍສຸດພຽງແຕ່ໜຶ່ງຂໍ້ມູນ',
    qsrhwmz: 'ກະລຸນາໃສ່ນ້ຳໜັກລວມຂອງສິນຄ້າ',
    qsrjzxxh: 'ກະລຸນາໃສ່ເລກຕູ້ຄອນເທັນເນີ',
    bcz: 'ກຳລັງບັນທຶກ....',
    qsrmbmc: 'ກະລຸນາໃສ່ຊື່ແມ່ແບບ',
    qzssrygziz: 'ກະລຸນາຕື່ມນໍ້າໜັກຕົນຕົວຢ່າງຕໍ່າໜຶ່ງອັນໃສ່',
    qzssrygzaizl: 'ກະລຸນາຕື່ມນ້ຳໜັກບັນທຸກຢ່າງຕໍ່າໜຶ່ງຢ່າງໃສ່',
    qtxygjzxxh: 'ກະລຸນາຕື່ມເລກຕູ້ຄອນເທັນເນີໜຶ່ງເຄື່ອງໃສ່',
    qlryghwxx: 'ກະລຸນາໃສ່ຂໍ້ມູນສິນຄ້າໜຶ່ງຢ່າງ',
    qzssrygchelxxhm: 'ກະລຸນາຕື່ມໝາຍເລກຂໍ້ມູນພາຫະນະຢ່າງຕໍ່າໜຶ່ງຄັນໃສ່',
    qsrdzmc: 'ກະລຸນາໃສ່ຊື່ສະຖານີທີ່ສົ່ງຮອດ',
    qxzddl: 'ກະລຸນາເລືອກເສັ້ນທາງປາຍທາງ',
    qsrfzmc: 'ກະລຸນາໃສ່ຊື່ສະຖານີທີ່ຈະສົ່ງອອກ',
    sfscbtshuj: 'ຈະລົບຂໍ້ມູນນີ້ຫຼືບໍ່ ?',
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ປົບປູງຖ່າຍໃຕ້ດິນ',
    crumbs2: 'ປົບປຸງດິນ (pipe)',
    fh: 'ກັບຄືນ',
    yyh: 'ເລກສັ່ງຈອງ',
    wdrxq: 'ຂ້ອຍວ່ານຕ້ອງການ',
    bllb: 'ປະເພດການດຳເນີນງານ',
    jzx: 'ແພັກເກຍອມ',
    zc: 'ການຂົນສົງໂດຍລົດໄຟ',
    bgdz: 'ປ່ຽນສະຖານີປາຍທາງ',
    ydzb: 'ໂຕເລືອກທີ່ເປັນມາດຕະຖານ',
    gshr: 'ກຳນົດເພີ່ມຕົ້ນ',
    wdmb: 'ເຕັກມດູນ ຂ້າພະເຈົ້າ',
    ts1: 'ຄຳເຕືອນ: ກ່ອນຈະອອກຈາກໜ້າເວັບເປັນເວລາດົນກະລຸນາບັນທຶກຂໍ້ມູນທີ່ຕື່ມກ່ອນ, ເພື່ອປ້ອງກັນຂໍມູນສູນຫາຍ.',
    bcwmb: 'ບັນທຶກໄຟລ໌',
    mbmc: 'ຊື່ເລກໂຕເລກ',
    bzjs: 'ຂໍ້ມູນເລກລຸ້ນ',
    qxz: 'ກະລຸນາເລືອກ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    dtbxx: 'ຂໍ້ມູນຮັບເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    quanx: 'ລຶບບ',
    zt: 'ສະຖານະ',
    qr: 'ທົກຮູ້ບ',
    qd: 'ທົກຮູ້ບ',
    dsl: 'ຖ້າການຍອມຮັບ',
    ysl: 'ຍອມຮັບແຜນແລ້ວ',
    yzc: 'ຂື້ນລົດແລ້ວ',
    yfc: 'ລົດອອກແລ້ວ',
    ydd: 'ມາຮອດແລ້ວ',
    yxc: 'ລົງລົດແລ້ວ',
    yjf: 'ສົ່ງມອບແລ້ວ',
    lkzf: 'ການນຳໃຊ້ຕູ້ບໍ່ໄດ້ຕາມແຜນ (ຍົກເລີກ)',
    zccx: 'ເກີດຂໍ້ຜິດພາດຂະນະລົກເລີອກ',
    jgcx: 'ການຖອດຖອນໃຫມ່',
    glydh: 'ເລກໃບບິນສາກົນ',
    xh: 'ລໍາດັບ',
    hwzl: 'ນ້ຳໜັກ ສິນຄ້າ',
    sfjh: 'ເລກສາຍລ໋ອກ',
    fhrmc: 'ຊື່ຜູ້ສົ່ງສິນຄ້າ',
    fzzm: 'ຊື່ສະຖານີຕົ້ນທາງ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    shrmc: 'ຊື່ຜູ້ຮັບສິນຄ້າ',
    gjz: 'ໂຮງງານຂອງຂໍ້ມູນ',
    xinzfhrdz: 'ເພີ່ມີເລກໂທ້ອງສົ່ງອອກ',
    tbsj: 'ເວລາ ການແຈ້ງເຕືອນ',
    cz: 'ປະເພດລົດ',
    xg: 'ແປງ',
    tj: 'ສົ່ງອອກ',
    plsc: 'ລົບຈຳນວນຫຼາຍ',
    scmb: 'ລຶບບັນຊີລຶບ',
    xzfhrdz: 'ໂຕເລືອກບ່ຳລັບຜູ້ໃຊ້',
    xzfhr: 'ໂຕເລືອກ ຕ້ອງໂປຣເເກຣມ',
    qsrfhrmc: 'ກະລຸນາໃສ່ຊື່ທົ່ວໄປໂປຣເເກຣມ',
    cx: 'ຄົ້ນຫາ',
    szdq: 'ບໍ່ຮູ້',
    zg: 'ຈີນ',
    lw: 'ເເຣແກດ',
    jdmc: 'ຊື່ແຟ້ກ',
    dllb: 'dllb',
    dh: 'ໂປຣເເກຣມທົວໄປ',
    yx: 'ໂຕອັກສອນ',
    mail: 'ໂຕອັກສອນ',
    sh: 'ໂປຣເເກຣມ',
    bj: 'ແກ້ໄຂ',
    sc: 'ລຶບ',
    xz: 'ບໍ່ມີຕັ້ງຄ່າທີ່ຖຶກບັນທຶກ',
    qxzshrdz: 'ບໍ່ຮ້ອງໃສ່ບັນທຶກ',
    qsrshrmc: 'ກະລຸນາໃສ່ຊື່ທີ່ຄຳສັ່ງ',
    xzyz: 'ຕ້ອງເລືອກພາສາ',
    qxzyz: 'ກະລຸນາເລືອກເດືອນ',
    gmswxtsbm: 'ໂປຣເເກຣມແກຣມສຳລັບລົບ',
    qsrgmswxtsbm: 'ກະລຸນາໃສ່ອິດສະຖານະທຳລາຍລະອຽດຂອງລະບົບ',
    qxzszqy: 'ກະລຸນາໃສ່ລາຍການແບບງ່າຍ',
    xxdz: 'ອີເເມວລ໌ທີ່ລະອຽດຂອງ',
    qsrgmxxdz: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງປະຊາຊົນ',
    csqh: 'ໂປຣເເກຣມທົວໄປ',
    qsrcsqh: ' ກະລຸນາໃສ່ລາຍລະອຽດຂອງເຂດຂໍ້ມູນ',
    qsrdh: 'ກະລຸນາໃສ່ລາຍຊື່ໂຕເລກ',
    chuanz: 'ເຂົ້າຮ່ວມ',
    qsrcz: 'ກະລຸນາໃສ່ແຫ້ມຜູ້ໃຊ້',
    qsryx: 'ກະລຸນາໃສ່ອີເມວລ໌',
    ts2: 'If the above information is not filled in as required, it may cause backlog during customs clearance.',
    bc: 'ບັນທຶກໄຟລ໌',
    qx: 'ຍົກເລີອກ',
    xzshrdz: 'ເພີ່ມີບັນຊີໃສ່',
    bgxxtx: 'ມີບັນຫາການປ່ຽນແປງ',
    ydz: 'ໂຮງງານໄຂໍ້ມູນເທົ່າກັນທຸກໂທດ',
    yshr: 'ແນວຄິດການມາດຕະຖານ',
    ddmlh: 'ຮ້ອງຂໍ້ມູນເເດຍເນື່ອງ ບໍ່',
    bgyqr: 'ກະລຸນາປ່ຽນໂປຣເເກຣມ',
    xshr: 'ແນວຄິໃຫມ່',
    xdz: 'ທ່ານເຂົ້າຮ່ວມໃຫມ່',
    bgyy: 'ສາເຫດຂອງການປ່ຽນແປງ',
    xzhwxx: 'ຂໍ້ມູນໃຫມ່ໄດ້',
    xqdh: 'ເລກຄວາມຕ້ອງການ',
    xh1: 'ກໍລະນີບໍ່ແມ່ນ 1',
    xh2: 'ກໍລະນີບໍ່ແມ່ນ 2',
    jzxxh: 'ຮູບແບບທີ່ມີຮູບແບບ',
    jzxzz: 'ຕໍ່ມີການດີສຸດ (kg)',
    bjzz: ' ລວມທັງຊ່ວຍຄວາມຈຳ (kg)',
    bxje: 'ຄ່າຈຳນວຍຄວາມສະດວກ',
    sffbhsl: 'ກົດລະບຽບແລະ ຕຸລາໂນໂລຍີ ອີເລກໂນໂລຍີ ແລະ ຄ່າສຸດ',
    sffbhjh: 'ທົວເລກລຸ້ນ / ເຄື່ອງຫມາຍເລກໂຕເລກລຸ້ນ',
    xnhw: 'ຂ່າຍໄປທີ່້ໃນຫ້ອງການ',
    zwmc: 'ຊື່ຈີງ',
    qsrhwmc: 'ກະລຸນາໃສ່ຊື່ຜູ້ສຸດ',
    zghgbm: 'ຈີນສຸລະກາກອນ ຄຳສຸລະກາດ (ໂປຣເເກຣມ ຫລື) ',
    wwmc: 'ຊື່ຂອງພາສານອື່ນໆ',
    tyhwpmbm: 'ໂປຣເເກຣມຊື່ທົ່ວໄປ',
    tyyjhwtjbm: 'ຂໍ້ມູນຖານຂໍ້ມູນຖຸກສອນຫລືໂຕເລກ (LT)',
    ptp: 'ປັກຜະລິດຕະພັນ ໂດຍທົ່ວໄປ',
    wxp: 'ຂໍ້ມູນທີ່ບໍ່ໃດ້',
    wxhwbm: 'Dangerous goods code (ET)',
    bz: 'ຮູບພາບ',
    bzlx: 'ຮູບແພັກເກດ',
    bzmc: 'ຊື່ຄົນຕິດຕໍ່',
    bzdm: 'ແພັກເກດ',
    js: 'ໂຕເລກໂທ',
    dz: 'ກຳລັງຂຶ້ນຕົ້',
    sz: 'ຄວາມຈຳນວຍຄວາມສະດວກ',
    gz: 'ຍົກເວີດ',
    hwzzl: 'ຄ່າຈຳນວຍຄວາມສະດວກຜູ້ຜະລິດຕະພັນ',
    hwmz: 'ນ້ຳໜັກສິນຄ້າກັບປະເພດຫຸ້ມຫໍ່(kg)',
    ysyj: 'ຄົນກອນ',
    ysyjmc: 'ຊື່ໂປຣເເກຣມສຳລັບຫ້ອງການລາຍຊື່',
    ysyjsl: 'ໂປຣມແກຣມສຳລັບຫ້ອງການ',
    ysyjzl: 'ຈຸດທີ່ມີອຸປະກອນຈໍານປ່ຽນໂປຣເເກຣມ (kg)',
    ysyjsm: 'ຫມາຍເຫດ້ານອຸປະກອນຈໍານປ່ອຍອາກອນ',
    rxqh: 'ເລກຄວາມຕ້ອງການປະຈຳວັນ',
    ysrq: 'ວັນທີ່ຂົນສົ່ງ',
    blzb: 'ປະເພດ ການຈັດການ',
    tyf: ' ຜູ້ຂົນສົ່ງສິນຄ້າ',
    shf: 'ຜູ້ຮັບສິນຄ້າ ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    daoz: 'ສະຖານີປາຍທາງ',
    hwpm: 'ສິນຄ້າ',
    xqcs_slcs: 'ຈຳນວນລົດທີ່ຮ້ອງຂໍ/ຈຳນວນລົດທີ່ອານຸມັດ',
    xqds_slds: 'ຈຳນວນນ້ຳໜັກທີ່ຮ້ອງຂໍ/ຈຳນວນນ້ຳໜັກທີ່ອານຸມັດ',
    bjfhrdz: 'ແກ້ໄຂຂໍ້ມູນທີ່ກ່ຽວກັບ',
    xzjck: 'ເລືອກປະເພດຂາອອກ-ຂາເຂົ້າ',
    qxzjck: ' ເລືອກປະເພດຂາອອກ-ຂາເຂົ້າ',
    ck: ' ສົ່ງອອກ',
    jk: ' ຂາເຂົ້າ',
    qtxzqdxh: 'ກະລຸນາຕື່ມໃສ່ເລກຕູ້ທີ່ຖືກຕ້ອງ',
    sfsl: 'ຈໍານວນການໜີບກົ່ວ',
    zzh: 'ລວມນໍ້າໜັກ(kg)',
    xzjzxxx: 'ຂໍ້ມູນຕູ້ຄອນເທນເນີທີ່ເພີ່ມໃໝ່',
    bjjzxxx: 'ຂໍ້ມູນການກະກຽມຕູ້ຄອນເທນເນີ',
    fhrqz: 'ຜູ້ຈັດສົ່ງສິນຄ້າລົງລາຍເຊັນແລະຈໍ້າກາ',
    czqz: 'ລາຍເຊັນຂອງສະຖານີ',
    zjxsz: "ຕູ້ຄອນເທນເນີເພີ່ມຈໍານວນໄດ້ເຖິງ",
    cczjscytxsj: 'ການດໍາເນີນການນີ້ ຈະລຶບຂໍ້ມູນທີ່ໄດ້ປ້ອນໄວ້ແລ້ວນັ້ນອອກ, ທ່ານແນ່ໃຈວ່າຈະດໍາເນີນການຕໍ່ຫຼືບໍ່',
    zengjia: 'ເພີ່ມ',
    zdkzjzxh: 'ເກີນຂອບເຂດຈໍານວນຕູ້ຄອນເທນເນີສູງສຸດແລ້ວ',
    zjxsxdydqxs: "ຈໍານວນຕູ້ຄອນເທນເນີທີ່ຕ້ອງການເພີ່ມ ແມ່ນຕ້ອງຫຼາຍກວ່າຈໍານວນໃນປັດຈຸບັນ"
  },
  phaseTransportDemand: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຄວາມຕ້ອງການຂອງຕະຫຼາດ',
    crumbs2: 'ຄວາມຕ້ອງການຂອງຕະຫຼາດ',
    jdxqh: 'ເລກຄວາມຕ້ອງການປະຈຳເດືອນ',
    qsrjdxqh: 'ກະລຸນາໃສ່ແລກໂຕເລກທີ່ຕ້ອງການ',
    hwpm: 'ສິນຄ້າ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    ysrq: 'ວັນທີ່ຂົນສົ່ງ',
    qxzqsrq: 'ກະລຸນາໃສ່ເລີ້ມໂປຣເເກຣມ',
    qxzzzrq: 'ກະລຸນາໃສ່ໄລທີ່ສຸດທ້າຍ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    qsrtyf: 'ກະລຸນາໃສ່ຜູ່ສົນທະນາ',
    tbsj: 'ເວລາ ການແຈ້ງເຕືອນ',
    dz: 'ສະຖານີປາຍທາງ',
    shr: 'ປ້າຍໄປທີ່ ',
    qsrshf: 'ກະລຸນາໃສ່ເພື່ອເຂົ້າໂປຣເເກຣມ',
    ydlx: 'ປະເພດໃບບິນ',
    qb: 'ທັງໝົດ',
    gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',
    ptys: 'ຂົນສົ່ງທົ່ວໄປ',
    zt: 'ສະຖານະ',
    dsl: 'ຖ້າການຍອມຮັບ',
    sltg: 'ຜ່ານການຍອມຮັບ',
    btg: 'ບໍ່ຜ່ານ',
    yzf: 'ຍົກເລີກ',
    chax: 'ຄົ້ນຫາ',
    jdxqxj: 'ຄວາມຕ້ອງການຂອງສະຖານະໃຫມ່',
    ts1: 'ຂໍ້ມູນ: ຄວາມຕ້ອງການຂອງຂະບວນການຍ່າຍຢ່າງໃສ່ອີງຕໍ່ສະພາບການຕ່າງໆ',
    dcexcel: 'ສົ່ງອອກ exel',
    pldy: 'ໂປຣເເກຣມຫ້ວໄປ',
    dyzj: 'ລວມຕົວລິກປະຈຸບັນ',
    tiao: 'ໂຕເລກໂທ',
    yslx: 'ຮູບແບບການຂົນສົ່ງ',
    blzb: 'ປະເພດ ການຈັດການ',
    zhenc: 'ການຂົນສົງໂດຍລົດໄຟ',
    jzx: 'ຕົວໄປ',
    slh: 'ເລກການຍອມຮັບ',
    zhi: 'to',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    xqcs_wccs: 'ຈໍານວນລົດ ທີ່ຕ້ອງການ / ຈໍານວນລົດ ທີ່ສໍາເລັດ',
    xqds_slds: 'ຈຳນວນນ້ຳໜັກທີ່ຮ້ອງຂໍ/ຈຳນວນນ້ຳໜັກທີ່ອານຸມັດ',
    chez: 'ສະຖານີລົດໄຟ',
    cz: 'ການດຳເນີນການ',
    ckxq: 'ກວດສອບລາຍລະອຽດ',
    xg: 'ແປງ',

    yxqh: 'ເລກຄວາມຕ້ອງການປະຈຳເດືອນ',
    jbr_lxdh: 'ຮູບແບບ່ວໄປ/ເລກໂຕອັກສອນໂຕເຕັກ',
    xqxs_wcxs: 'ຈໍານວນຕູ້ ທີ່ຕ້ອງການ / ຈໍານວນຕູ້ ທີ່ສໍາເລັດ',
    xx_xl: 'ຂະໜາດຕູ້/ຊະນິດຕູ້',
    xs: 'ເຈົ້າຂອງຕູ້',
    td: 'ບໍ່ຮ້ອງຄຳແປ',
    tdyy: 'ເຫດຜົນການຍົກເລີກ ການສັ່ງຈອງ',
    jzxyd: 'ໃບຂົນສົ່ງຕູ້ຄອນເທນເນີ',
    xyb: 'ຂັ້ນ​ຕອນ​ຕໍ່​ໄປ',
    rxqtb: 'ບົດລາຍງານຄວາມຕ້ອງການປະຈໍາວັນ',
    pltj: 'ການຍື່ນສະເຫນີຈໍານວນຫລາຍ',
    bytb: 'ສົ່ງບົດລາຍງານປະຈໍາເດືອນນີ້',
    byysxq: 'ຄວາມຕ້ອງການໃນການຂົງສົ່ງປະຈໍາເດືອນນີ້',
  },
  phaseTransportDemandNew: {
    jdxqtb: 'ຂອບເຂດຈຳນວນໂຕນທີ່ຕ້ອງການຍື່ນແຈ້ງເປັນໄລຍະແມ່ນ 10 ໂຕນຫາ 50 ໂຕນ',
    xqdsbnw0: 'ຈຳນວນໂຕນທີ່ຕ້ອງການບໍ່ສາມາດເປັນ0',
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຄວາມຕ້ອງການຂອງຕະຫຼາດ',
    crumbs2: 'ຄວາມຕ້ອງການໃຫມ່',
    jie: 'ສຽງ',
    jdxqlx: 'ຮູບແບບທີ່ຕ້ອງການ',
    xqlx: 'ຮູບແບບຕ້ອງການ',
    qxzxqlx: 'ກະລຸນາໃສ່ແພັກເກດ',
    gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',
    ptys: 'ຂົນສົ່ງທົ່ວໄປ',
    ysyf: 'ເດືອນທີ່ເຮັດການຂົ່ນສົ່ງ',
    qxzyf: 'ກະລຸນາເລືອກເດືອນ',
    tjrq: 'ວັນທີ ຍື່ນສະເໜີ',
    ysrq: 'ວັນທີ່ຂົນສົ່ງ',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    jsrq: 'ວັນທີ່ສິ້ນສຸດ',
    tis: 'ຄຳແນະນຳ:ກະລຸນາແຈ້ງແຜນຕອ້ງຂົນສົ່ງກອ່ນວັນທີ່20ພາຍໃນເດືອນນີ້',
    huo: 'ສຸດ',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    hwpm: 'ສິນຄ້າ',
    qxzhwpm: 'ກະລຸນາໃສ່ຊື່ແພັກເກດ',
    hwpmtis: 'ບໍ່ມີຊື່ຜູ້ຜະລິດຕະພັນ',
    blzb: 'ປະເພດ ການຈັດການ',
    zhenc: 'ການຂົນສົງໂດຍລົດໄຟ',
    jzx: 'ຕົວໄປ',
    pashi: 'ສິ່ງອຳນວຍຄວາມສະດວກ',
    bupashi: 'ຖືກຕິດຕັ້ງ ໃນຂະບວນການຍົງທຳມະບໍ່',
    sdz: 'ໂຕເອີ້ນລົບ',
    fsdz: 'ບໍ່ມີໃຫຍ່ທີ່ສຸດ',
    hwbz: 'ແພັກເກຍຂອງຄ່າ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    qxz: 'ກະລຸນາເລືອກ',
    zdjzl: 'ຫນ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ(kg)',
    jxxx: 'ສະນິເລກຄຳສັ່ງ',
    qxzcx: 'ກະລຸນາໃສ່ຊື່ແຟ້ມ',
    jxxx1: 'ໂຕເລືອກຕັ້ງຄ່າສະເພາະປະຈຸບັນ',
    jxxx2: 'ຕົວຈຳນວຍຄວາມສະດວກູນຳ້ທີ່ສູງຂຶ້ນ',
    jxxx3: 'ຮູບແຕ້ມມິນຟ້າອົງກອນ',
    jxxx4: 'ຄວາມສູດວກຕ່າງໆ',
    jxxx5: 'ສູງຫາ, ເຂົ້າຮູບແຕ່ງຫ້ອງ',
    jxxx6: 'ຕັ້ງຄ່າປະຫວ່າງປະຫວັດສາດ (8 ຟ້າ)',
    jxxx7: 'ຕັ້ງຄ່າ 15 ມີສິດ (32 ມີນາ)',
    jxxx8: 'ຕົວຢ່າງປະຫວັດສະຫຼາດ, ປົດຢ່າງປະຫວັດສະຫຼາດ',
    jxxx9: '10 ມິນເຕັ້ງ 15 ມິນ (32 ມິນເຕັ້ງ)',
    jxxx10: 'ໂຕອັກສະເຫນີສິງ 32 ມີລວມຮວມຕົວງ',
    jxxx11: 'ໂຕເອີດສະຫຼາດ (8 ຟ້າ)',
    jxxx12: '10 ມິນເຕັ້ງ 15 ມິນ',
    jxxx13: 'ໂຕອັກສອນຫລືໂຕເຕັນອື່ນໆ',
    jxxx14: 'ໂຕອັກຕ່າງໆອື່ນໆທີ່ບໍ່ແມ່ນມາດຕະຖານ',
    jxxx15: 'ໂຕເລືອກຕັ້ງຄ່າສະເພາະອານາລັກສອນຫລືໂຕເລກ',
    jxxx16: 'ເຂົ້າຮ່ອນໄຟຟ້ານຳ້ທີ່ສູງຊ່ວງ',
    jxxx17: 'ພະລັງງານນຳ້ທີ່ພະລັງງານນຳ້',
    jxxx18: 'ໂຕເອີ້ນລະຫວ່າດ້ວຍ',
    jxxx19: 'ຕັ້ງຄ່າປະຫວ່າງສູງ 15 ມິນເກີງ',
    jxxx20: 'ຕົກໃສ່ອິກໃສ່ເກືອໜ້ອຍໜຶ່ງ',
    jxxx21: 'ໂຕເອີດສະຖານະໃຕ້ເກີດໜ້ອຍໜຶ່ງ',
    jxxx22: 'ໂຕອັກສອນຫລືໂຕເຕັນອື່ນໆ',
    jxxx23: 'ໂຕອັກຕ່າງໆທີ່ບໍ່ແມ່ນໂຕອັກສອນຫລືໂຕເຕັກ',
    jxxx24: 'ໂຕເລືອກຕັ້ງຄ່າສະພາຍໃຕ້ທຸກຄົນ',
    jxxx25: 'ເຂົ້າຮ່ອນໄຟຟ້າທີ່ສູງຂຶ້ນ',
    jxxx26: 'ໂຕອັກສະເຫນີງ 15 ມິນ',
    jxxx27: 'ໂຕເອີຣົບ 15 ມິນາ 1 ຕຸລາ ໂຟຟີລ໌',
    jxxx28: 'ໂຕອັກສອນຫລືໂຕເຕັນອື່ນໆ',
    jxxx29: 'ໂຕອັກຕ່າງໆທີ່ບໍ່ແມ່ນໂຕອັກສອນຫລືໂຕເລກ',
    yun: 'ສົງອອກສິນຄ້າ',
    ysxx: 'ຂໍ້ມູນຂົນສົ່ງ',
    dunshu: 'ຈຳນວນໂຕນ',
    qsrdunshu: 'ກະລຸນາໃສ່ວຍຄວາມຈຳ',
    chez: 'ປະເພດລົດ',
    ches: 'ຈຳນວນລົດ',
    chests: 'ກະລຸນາໃສ່ລາຍຊື່ໂຕເລກແລະເລືອກ ເຂດຂໍ້ມູນ',
    chuk: 'ສົ່ງອອກ',
    zzjgcl: 'ວັດສະດຸເພີ່ມຄວາມແໜ້ນໜາໃຫ້ສິນຄ້າ',
    gnbx: 'ປະກັນໄພພາຍໃນປະເທດ',
    cangchu: 'ສາງ',
    bjys: 'ສົນສຸດງອອກສິນຄ້າ',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    qsrjzsx: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງ',
    tbfs: 'ວິທີແຈ້ງແຜນ',
    anche: 'ກະລຸນາໃສ່ແຫ້ນພິມ',
    andun: 'ຂັ້ນສຸງ',
    fa: 'ສົ່ງ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    cyfhxx: 'ຂໍ້ມູນສົ່ງເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    jbr: 'ຮູບແບບ່ວໄປ',
    qsrfz: 'ກະລຸນາເລືອກສະຖານີຕົ້ນທາງ',
    faju: 'ໂປຣເເກຣມຫ້ອງການການພັດທະນາ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    zyx: 'ລິ້ງຄຳສ່ວນບຸກຄົນ',
    tlhc: 'ລານສີນຄ້າທາງລົດໄຟ',
    lxdh: 'ເບີໂທຕິດຕໍ່',
    qsrfhrdh: 'ກະລຸນາໃສ່ແລກໂຕເລກໂຕລີໂຕລິກ',
    txdz: 'ທີ່ຢູ່',
    qsrfhrdz: 'ກະລຸນາໃສ່ຂໍ້ມູນທີ່ຢູ່ຜູ້ສົ່ງສິນຄ້າ',
    shou: 'ຮັບ',
    shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',
    cyshxx: 'ຂໍ້ມູນຮັບເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    ddgj: 'ປະເທດປາຍທາງ',
    gjz: 'ສະຖານີຊາຍແດນ',
    qxzgjz: 'ກະລຸນາໃສ່ສະຖານະຂໍ້ມູນ',
    shr: 'ຜູ້ຮັບເຄື່ອງ',
    daoz: 'ສະຖານີປາຍທາງ',
    qsrdz: 'ກະລຸນາໃສ່ບັນກະລຸນາໃສ່',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    qsrtxdz: 'ກະລຸນາໃສ່ອີເມວລ໌',
    zzsxx: 'ຂໍ້ມູນມູນຄ່າພາສີເພີ່ມເຕີມ ',
    zeng: 'ເພີ້ມ',
    fplx: 'ຮູບແບບັນຊີບັນຫາ',
    qxzfplx: 'ກະລຸນາໃສ່ຊື່ຄໍາສັ່ງ',
    ptfp: 'ການທໍາມະການຖ້າ',
    zyfp: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    spfmc: 'ຊື່ຂອງ',
    qsrspfmc: 'ກະລຸນາໃສ່ຊື່ສຳລັບຮູບແບບ',
    khh: 'ຖານຮາກ ຟ້າອັນດຸເຂົ້າ',
    qsrkhhmc: 'ກະລຸນາໃສ່ຊື່ແຟ້ມຄ່າຕັ້ງ',
    nsrsbh: 'ຄ່າຈຳນວຍຄວາມສະດວກຜູ້ຈັນຍາດ',
    qsrnsrsbh: 'ກະລຸນາໃສ່ແລກໂຕເລກໂຕເລກ',
    zhanhao: 'ບັນຊີຜູ້ໃຊ້ບັນຊີຜູ້ໃຊ້',
    qsrzhhzh: 'ກະລຸນາໃສ່ແລກໂຕເລກລຸ້ນສຸງ',
    dizhi: 'ບັດຜ່ານ',
    qsrzcdz: 'ກະລຸນາໃສ່ອີກສອນຫລືໂຕເລກ',
    dianhua: 'ໂທລະໂທ',
    qsrlxdh: 'ກະລຸນາໃສ່ຊື່ໂຕເລກ',
    bc: 'ບັນທຶກ',
    qk: '(ລົບຂໍ້ມູນທັງໝົດ)',
    dtbxx: 'ຂໍ້ມູນຮັບເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    yyh: 'ເລກສັ່ງຈອງ',
    qzrq: 'ວັນທີ່ເລີ່ມຕົ້ນແລະສີ້ນສຸດ',
    zhi: 'to',
    hwtz: 'ລັກສະນະພິເສດຂອງສິນຄ່າ',
    tbds: 'ແຈ້ງນ້ຳໜັກ',
    tbcs: 'ໂຕເລກລຸ້ນສົ່ງອອກໄປ',
    bxys: 'ປົນສຸດງອອກສິນຄ້າ',
    mdj: 'ໂຕເອີາ (ສິ່ງແວດລ້ອມ)',
    dz_xcdd: 'ສະຖານີປາຍທາງ/ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    lxdh_txdz: 'ເບີໂທຕິດຕໍ່ / ອີເມວລ໌',
    fz_zcdd: 'ສະຖານີຕົ້ນທາງ/ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    zzs: 'ກ່ຽວກັນຄ່າຫວ່າງພາຍໃນຈຳ',
    cz: 'ປະເພດລົດ',
    xg: 'ແປງ',
    sc: 'ລຶບ',
    qlsc: 'ລົບຈຳນວນຫຼາຍ',
    fh: 'ກັບຄືນ',
    tj: 'ສົ່ງອອກ',
    daochu: 'ດຶງອອກ',
    lsxq: 'ຄວາມຕ້ອງການຂອງປະຫວັດສາດ (History)',
    cyfhr: 'ຜູ້ຈ່າຍພາຍໃຕ້ທົ່ວໄປ',
    cyshr: 'ແນວຄິດການໂດຍທົ່ວໄປ',
    qxzchez: 'ກະລຸນາເລືອກປະເພດພາຫະນະ',
    qxzksrq: 'ກະລຸນາເລືອກວັນທີທີ່ເລີ່ມຕົ້ນ',
    qxzjsrq: 'ກະລຸນາເລືອກວັນທີທີ່ສິ້ນສຸດ',

    ybtyxq: 'ໄດ້ສົ່ງລາຍງານຄວາມຕ້ອງການປະຈໍາເດືອນ',
    ljck: 'ກວດເບິ່ງຕອນນີ້',
    jbrzjh: 'ໝາຍເລກປະຈຳຕົວຂອງຜູ້ຈັດການ',
    qhdz: 'ກະລຸນາໃສ່ບັນທຶກ',
    zcdz: 'ທີ່ຢູ່ຂົນຂຶ້ນລົດ',
    xiangs: 'ຈໍານວນຕູ້',
    hwjz_mx: 'ມູນຄ່າສິນຄ້າ(ແຕ່ລະຕູ້)',
    hwjz_mc: 'ມູນຄ່າສິນຄ້າ(ຕໍ່ຄັນລົດ)',
    qt: 'ອື່ນ ໆ',
    bggs: 'ບໍລິສັດ ແຈ້ງພາສີ',
    cfl: 'ຕົ້ນທາງ',
    ddl: 'ປາຍທາງ',
  },
  phaseTransportDemandResult: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຄວາມຕ້ອງການຂອງຕະຫຼາດ',
    crumbs2: 'ຜົນອອກທີ່ຕ້ອງການໃຫມ່'
  },
  phaseTransportDemandDetail: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຄວາມຕ້ອງການຂອງຕະຫຼາດ',
    crumbs2: 'ຂໍ້ມູນລາຍລະອຽດ',
    ysrq: 'ວັນທີ່ຂົນສົ່ງ',
    zhi: 'to',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    hwpm: 'ສິນຄ້າ',
    hwtz: 'ອົກຂະລະທິດແຟລັກ',
    frl: 'ຄ່າດ້ວຍ ແລກໂນໂລກ(kcal/kg)',
    hwms: 'ຄຳບັນຍາຍ ຂອງຄຸນຄ່າ',
    jxxx: 'ສະນິເລກຄຳສັ່ງ',
    ysfs: 'ຮູບແບບການຂົນສົ່ງ',
    zhenc: 'ການຂົນສົງໂດຍລົດໄຟ',
    jzx: 'ຕົວໄປ',
    beiz: 'ໝາຍເຫດ',
    ysxx: 'ຂໍ້ມູນຂົນສົ່ງ',
    dunshu: 'ຈຳນວນໂຕນ',
    chex: 'ໂຕເລກ',
    ches: 'ໂຕເລກໂທ',
    fuw: 'ບໍ່ລິການ',
    zzjgcl: 'ວັດສະດຸເພີ່ມຄວາມແໜ້ນໜາໃຫ້ສິນຄ້າ',
    bjys: 'ສົນສຸດງອອກສິນຄ້າ',
    cangchu: 'ສາງ',
    wu: 'ບໍ່ມີ',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    faju: 'ໂປຣເເກຣມຫ້ອງການການພັດທະນາ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    lxdh: 'ເບີໂທຕິດຕໍ່',
    txdz: 'ທີ່ຢູ່',
    shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',
    ddgj: 'ປະເທດປາຍທາງ',
    jwz: 'ຫ້ອງນຳ້ທີ່ຂ້າງລັກ',
    daoz: 'ສະຖານີປາຍທາງ',
    shr: 'ຜູ້ຮັບເຄື່ອງ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    zzsxx: 'ຂໍ້ມູນມູນຄ່າພາສີເພີ່ມເຕີມ ',
    fplx: 'ຮູບແບບັນຊີບັນຫາ',
    spfmc: 'ຊື່ຂອງ',
    nsrsbh: 'ຄ່າຈຳນວຍຄວາມສະດວກຜູ້ຈັນຍາດ',
    zhangh: 'ບັນຊີຜູ້ໃຊ້ບັນຊີຜູ້ໃຊ້',
    khh: 'ທະນາຄານທີ່ເປີດບັນຊີ',
    dianh: 'ໂທລະໂທ',
    dizhi: 'ບັດຜ່ານ',
    fh: 'ກັບຄືນ'
  },
  phaseDemandInfoSupple: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຄວາມຕ້ອງການຂອງຕະຫຼາດ',
    crumbs2: 'ພາຍໃຕ້ຄວາມຕ້ອງການການປ່ຽນແປງຂໍ້ມູນ',
    xqlx: 'ຮູບແບບຕ້ອງການ',
    qxzxqlx: 'ກະລຸນາໃສ່ແພັກເກດ',
    gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',
    ptys: 'ຂົນສົ່ງທົ່ວໄປ',
    ysyf: 'ເດືອນທີ່ເຮັດການຂົ່ນສົ່ງ',
    qxzyf: 'ກະລຸນາເລືອກເດືອນ',
    tjrq: 'ວັນທີ ຍື່ນສະເໜີ',
    ysrq: 'ວັນທີ່ຂົນສົ່ງ',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    jsrq: 'ວັນທີ່ສິ້ນສຸດ',
    tis: 'ແຈ້ງເຕືອນ:ກະລຸນາຍື່ນແຈ້ງໃບຂົນສົ່ງສາກົນ ກ່ອນວັນທີ 15 ເດືອນນີ້',
    huo: 'ສຸດ',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    hwpm: 'ສິນຄ້າ',
    qxzhwpm: 'ກະລຸນາໃສ່ຊື່ແພັກເກດ',
    hwts: 'ບໍ່ມີຊື່ຜູ້ຜະລິດຕະພັນ',
    blzb: 'ປະເພດ ການຈັດການ',
    qxz: 'ກະລຸນາເລືອກ',
    zhenc: 'ການຂົນສົງໂດຍລົດໄຟ',
    jzx: 'ຕົວໄປ',
    pashi: 'ສິ່ງອຳນວຍຄວາມສະດວກ',
    bups: 'ຖືກຕິດຕັ້ງ ໃນຂະບວນການຍົງທຳມະບໍ່',
    sdz: 'ໂຕເອີ້ນລົບ',
    fsdz: 'ບໍ່ມີໃຫຍ່ທີ່ສຸດ',
    hwbz: 'ແພັກເກຍຂອງຄ່າ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    zdjzl: 'ຫນ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ(kg)',
    jxxx: 'ສະນິເລກຄຳສັ່ງ',
    qxzcx: 'ກະລຸນາໃສ່ຊື່ແຟ້ມ',
    jxxx1: 'ໂຕເລືອກຕັ້ງຄ່າສະເພາະປະຈຸບັນ',
    jxxx2: 'ຕົວຈຳນວຍຄວາມສະດວກູນຳ້ທີ່ສູງຂຶ້ນ',
    jxxx3: 'ຮູບແຕ້ມມິນຟ້າອົງກອນ',
    jxxx4: 'ຄວາມສູດວກຕ່າງໆ',
    jxxx5: 'ສູງຫາ, ເຂົ້າຮູບແຕ່ງຫ້ອງ',
    jxxx6: 'ຕັ້ງຄ່າປະຫວ່າງປະຫວັດສາດ (8 ຟ້າ)',
    jxxx7: 'ຕັ້ງຄ່າ 15 ມີສິດ (32 ມີນາ)',
    jxxx8: 'ຕົວຢ່າງປະຫວັດສະຫຼາດ, ປົດຢ່າງປະຫວັດສະຫຼາດ',
    jxxx9: '10 ມິນເຕັ້ງ 15 ມິນ (32 ມິນເຕັ້ງ)',
    jxxx10: 'ໂຕອັກສະເຫນີສິງ 32 ມີລວມຮວມຕົວງ',
    jxxx11: 'ໂຕເອີດສະຫຼາດ (8 ຟ້າ)',
    jxxx12: '10 ມິນເຕັ້ງ 15 ມິນ',
    jxxx13: 'ໂຕອັກສອນຫລືໂຕເຕັນອື່ນໆ',
    jxxx14: 'ໂຕອັກຕ່າງໆອື່ນໆທີ່ບໍ່ແມ່ນມາດຕະຖານ',
    jxxx15: 'ໂຕເລືອກຕັ້ງຄ່າສະເພາະອານາລັກສອນຫລືໂຕເລກ',
    jxxx16: 'ເຂົ້າຮ່ອນໄຟຟ້ານຳ້ທີ່ສູງຊ່ວງ',
    jxxx17: 'ພະລັງງານນຳ້ທີ່ພະລັງງານນຳ້',
    jxxx18: 'ໂຕເອີ້ນລະຫວ່າດ້ວຍ',
    jxxx19: 'ຕັ້ງຄ່າປະຫວ່າງສູງ 15 ມິນເກີງ',
    jxxx20: 'ຕົກໃສ່ອິກໃສ່ເກືອໜ້ອຍໜຶ່ງ',
    jxxx21: 'ໂຕເອີດສະຖານະໃຕ້ເກີດໜ້ອຍໜຶ່ງ',
    jxxx22: 'ໂຕອັກສອນຫລືໂຕເຕັນອື່ນໆ',
    jxxx23: 'ໂຕອັກຕ່າງໆທີ່ບໍ່ແມ່ນໂຕອັກສອນຫລືໂຕເຕັກ',
    jxxx24: 'ໂຕເລືອກຕັ້ງຄ່າສະພາຍໃຕ້ທຸກຄົນ',
    jxxx25: 'ເຂົ້າຮ່ອນໄຟຟ້າທີ່ສູງຂຶ້ນ',
    jxxx26: 'ໂຕອັກສະເຫນີງ 15 ມິນ',
    jxxx27: 'ໂຕເອີຣົບ 15 ມິນາ 1 ຕຸລາ ໂຟຟີລ໌',
    jxxx28: 'ໂຕອັກສອນຫລືໂຕເຕັນອື່ນໆ',
    jxxx29: 'ໂຕອັກຕ່າງໆທີ່ບໍ່ແມ່ນໂຕອັກສອນຫລືໂຕເລກ',
    yun: 'ສົງອອກສິນຄ້າ',
    ysxx: 'ຂໍ້ມູນຂົນສົ່ງ',
    dunshu: 'ຈຳນວນໂຕນ',
    qsrds: 'ກະລຸນາໃສ່ວຍຄວາມຈຳ',
    chez: 'ປະເພດລົດ',
    ches: 'ຈຳນວນລົດ',
    chests: 'ກະລຸນາໃສ່ລາຍຊື່ໂຕເລກແລະເລືອກ ເຂດຂໍ້ມູນ',
    chuk: 'ສົ່ງອອກ',
    zzjgcl: 'ວັດສະດຸເພີ່ມຄວາມແໜ້ນໜາໃຫ້ສິນຄ້າ',
    gnbx: 'ປະກັນໄພພາຍໃນປະເທດ',
    gjys: 'ສົນສຸດງອອກສິນຄ້າ',
    cangchu: 'ສາງ',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    qsrjzsx: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງ',
    tbfs: 'ວິທີແຈ້ງແຜນ',
    anche: 'ອີງຕາມລົດ',
    andun: 'ອີງຕາມນ້ຳໜັກ',
    fa: 'ສົ່ງ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    cyfhxx: 'ຂໍ້ມູນສົ່ງເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    tyf: 'ຜູ້ຂົນສົ່ງສິນຄ້າ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    qsrfz: 'ກະລຸນາເລືອກສະຖານີຕົ້ນທາງ',
    faj: 'ໂປຣເເກຣມຫ້ອງການການພັດທະນາ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    zyx: 'ລິ້ງຄຳສ່ວນບຸກຄົນ',
    tlhc: 'ລານສີນຄ້າທາງລົດໄຟ',
    lxdh: 'ເບີໂທຕິດຕໍ່',
    qsrfhrdh: 'ກະລຸນາໃສ່ແລກໂຕເລກໂຕລີໂຕລິກ',
    txdz: 'ທີ່ຢູ່',
    qsrtxdz: 'ກະລຸນາໃສ່ອີເມວລ໌',
    shou: 'ຮັບ',
    shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',
    cyshxx: 'ຂໍ້ມູນຮັບເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    ddgj: 'ປະເທດປາຍທາງ',
    gjz: 'ສະຖານີຊາຍແດນ',
    qxzgjz: 'ກະລຸນາໃສ່ສະຖານະຂໍ້ມູນ',
    shr: 'ຜູ້ຮັບເຄື່ອງ',
    daoz: 'ສະຖານີປາຍທາງ',
    qsrdz: 'ກະລຸນາໃສ່ບັນກະລຸນາໃສ່',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    zeng: 'ເພີ່ມ',
    zzsxx: 'ຂໍ້ມູນມູນຄ່າພາສີເພີ່ມເຕີມ ',
    fplx: 'ຮູບແບບັນຊີບັນຫາ',
    qxzfplx: 'ກະລຸນາໃສ່ຊື່ຄໍາສັ່ງ',
    ptfp: 'ການທໍາມະການຖ້າ',
    zyfp: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    spfmc: 'ຊື່ຂອງ',
    qsrspfmc: 'ກະລຸນາໃສ່ຊື່ສຳລັບຮູບແບບ',
    khh: 'ທະນາຄານທີ່ເປີດບັນຊີ',
    qsrkhhmc: 'ກະລຸນາໃສ່ຊື່ແຟ້ມຄ່າຕັ້ງ',
    nsrsbh: 'ຄ່າຈຳນວຍຄວາມສະດວກຜູ້ຈັນຍາດ',
    qsrnsrsbh: 'ກະລຸນາໃສ່ແລກໂຕເລກໂຕເລກ',
    zhanh: 'ບັນຊີຜູ້ໃຊ້ບັນຊີຜູ້ໃຊ້',
    qsrkhhzh: 'ກະລຸນາໃສ່ແລກໂຕເລກລຸ້ນສຸງ',
    dizhi: 'ບັດຜ່ານ',
    qsrzcdd: 'ກະລຸນາໃສ່ອີກສອນຫລືໂຕເລກ',
    dianh: 'ໂທລະໂທ',
    qsrlxrdh: 'ກະລຸນາໃສ່ຊື່ໂຕເລກ',
    fanhui: 'ກັບຄືນ',
    tijiao: 'ສົ່ງອອກ',
    cyfhr: 'ຜູ້ຈ່າຍພາຍໃຕ້ທົ່ວໄປ',
    cyshr: 'ແນວຄິດການໂດຍທົ່ວໄປ'
  },
  wayBillInfo: {
    jlsxsb: ' ບັນທຶກໜ້າວຽກລົ້ມເຫລວ',
    jlsxcg: ' ບັນທຶກໜ້າວຽກໄດ້ສໍາເລັດ',
    yyhbyz: 'ເລກສັ່ງຈອງບໍ່ກົງກັນ!',
    bgxqbyz: 'ຄວາມຕ້ອງການທີ່ປ່ຽນແປງບໍ່ສອດຄ່ອງກັນ!',
    bgsb: ' ປ່ຽນແປງບໍ່ສຳເລັດ',
    bgcg: ' ປ່ຽນແປງສຳເລັດແລ້ວ',
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ເບີ່ງເເຍງລະບົບ',
    hph: 'ເລກໃບບິນ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    xqh: 'ເລກຮ້ອງຂໍ ',
    hwmc: 'ຊື່ສິນຄ້າ',
    zcrq: 'ວັນທີຂົນລົງສິນຄ້າຈາກລົດ',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    jsrq: 'ວັນທີ່ສິ້ນສຸດ',
    tyf: 'ຜູ້ຂົນສົ່ງສິນຄ້າ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    qsrshf: 'ກະລຸນາໃສ່ເພື່ອເຂົ້າໂປຣເເກຣມ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    tbrq: 'ວັນທີ່ຂຽນຟອມ',
    shf: 'ຜູ້ຮັບສິນຄ້າ ',
    shr: 'consignee',
    daoz: 'ສະຖານີປາຍທາງ',
    ztai: 'ສະຖານະ',
    dsl: 'ຖ້າການຍອມຮັບ',
    sltc: 'ວ່ານັ້ນຖຶກສອນຫລັງ',
    yzc: 'ຂື້ນລົດແລ້ວ',
    yfc: 'ລົດອອກແລ້ວ',
    ydd: 'ມາຮອດແລ້ວ',
    yxc: 'ລົງລົດແລ້ວ',
    yjf: 'ສົ່ງມອບແລ້ວ',
    chax: 'ຄົ້ນຫາ ',
    qink: '(ລົບຂໍ້ມູນທັງໝົດ)',
    ydzt: 'ສະຖານະໃບບິນ',
    xqdh: 'ເລກຄວາມຕ້ອງການ',
    cheh: 'ໂຕເລກໂປຣເເກຣມ',
    chengz: 'ກຸ່ມ',
    fou: 'ປະຕິເສດ',
    hwpm: 'ສິນຄ້າ',
    hqhw: 'ບ່ອນວາງສິນຄ້າ',
    yunf: 'ແວຣ໌',
    zaf: 'ອິດການ',
    xcrq: 'ຍົກເລີອກ',
    jfrq: 'ວ່າຍຂໍ້ຄວາມທີ່ສຸດເຄື່ອງ',
    hwyd: 'ກົດລະບຽບທີ່ມີສຸດ',
    hwzz: 'ການຕິດຕາມສີ້ນຄ້າ',
    gjck: 'ຜົດພາດ ລະຫວ່າງກ',
    sfbg: 'ປ່ຽນສະຖານີປາຍທາງຫຼືບໍ່ ',
    ybg: 'ປ່ຽນ',
    bgdz: 'ປ່ຽນສະຖານີປາຍທາງ',
    pldyyd: 'ກົດລະບົບຄຳສັ່ງ',
    back: 'ອອກຈາກລະບົບ',
    huoq: 'ເຂດຂໍ້ມູນ',
    huow: 'ບໍ່ຮູ້',
    tbsx: 'ເຂດຂໍ້ມູນ',
    hwdcsj: 'ເວລາມາຮອດສະໜາມຂອງສິນຄ້າ',
    qued: 'ຕິດຕັ້ງ',
    chak: 'ກວດເບິ່ງ',
    ydaoz: 'ໂຮງງານໄຂໍ້ມູນເທົ່າກັນທຸກໂທດ',
    yshr: 'ແນວຄິດການມາດຕະຖານ',
    bgxxtx: 'ມີບັນຫາການປ່ຽນແປງ',
    ddmlh: 'ຮ້ອງຂໍ້ມູນເເດຍເນື່ອງ ບໍ່',
    bgyqr: 'ກະລຸນາປ່ຽນໂປຣເເກຣມ',
    xshr: 'ແນວຄິໃຫມ່',
    xdaoz: 'ທ່ານເຂົ້າຮ່ວມໃຫມ່',
    bgyy: 'ສາເຫດຂອງການປ່ຽນແປງ',
    sctp: 'ໂຕເອີ້ນລະບົບ',
    hwysbgqqs: 'ໂຕ້ອງການໃນການປ່ຽນແປງຂ່ອນໄຫວ',
    zhangy: 'ປັນຍົງ',
    jbrsfxx: 'ຂໍ້ມູນລາຍລະອຽດຂອງຈັດຕົວຈັກ',
    khtj: 'ແຕກຕ່າສ່ວນຕົວໄປ',
    bgsx: 'ປ່ຽນແປງ',
    yhwydjzsx: 'ໂປຣເເກຣມໂປຣເເກຣມຫລືໂຕເລກ',
    ydhm: 'ກໍລະນີສຶດ (Law N)',
    blzb: 'ປະເພດ ການຈັດການ',
    czch: 'ຮູບແບບ ແລະ ເລກໂທ',
    jianshu: 'ເລກໂຕເລກ',
    zhongliang: 'ຊ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    cyrq: 'ວັນທີ່ຂົນສົ່ງ',
    cyrtj: 'ລວມກັບຜູ້ກ່ອນໃສ່',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    wslyy: 'ສາເຫດຂອງບໍ່ສາມາດຍອມຕິດຕັ້ງ',
    bgclz: 'ກະລຸນາປ່ຽນ ໂປຣເເກຣມ',
    jbr: 'ຄົນດຳເນີນການ',
    chez: 'ສະຖານີລົດໄຟ',
    dzsj: 'ຜູ້ຈັດເວລາ',
    czsj: 'ຜົນສະເເດງອອກ',
    xxxl: 'ຮູບແບບຕູ້ ແລະ ປະເພດຕູ້',
  },
  myboard: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ຂ້ອຍເຮັດວຽກໂດຍສະເພາະ',
    crumbs2: 'ໂຕອັກສະນະຂອງຂ້າພະເຈົ້າ',
    htzs: 'ຫົວຂໍ້ທັງໝົດ',
    htlx: 'ຮູບແບບສຶກສາ',
    qxzhtlx: 'ກະລຸນາໃສ່ແພັກເກດ',
    mtgj: 'ຜູ້ສະຫນອງຂໍ້ມູນ',
    mtxq: 'ຄວາມຕ້ອງການຂອງອາບນຳ້',
    wuliu: 'ຄະນິດສາດ (Biology)',
    qit: 'other',
    sous: 'ຄົ້ນຫາ',
    xjht: 'ສົມໃຫມ່',
    huati: 'ສົນທະນາ',
    qsrht: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງ',
    htnr: 'ປະກອບໄປດ້ວຍສິ່ງທີ່',
    qsrhtnr: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງຄຳສັ່ງ',
    fjlb: 'ບໍ່ມີຕັ້ງຄ່າທີ່ຖຶກບັນທຶກ',
    scfj: 'ຕິດຕັ້ງຂໍ້ມູນ',
    jwjcdcc: 'ກະລຸນາໃສ່ແຟ້ມໃສ່ນ, ຫລືອ',
    djsc: 'ຄລິກເພື່ອອັບໂຫລດ',
    qx: 'ຍົກເລີອກ',
    fabu: 'release',
    huifu: 'ຕອບສະຫນອງ',
    gkl: 'ການຮູບລິບປູງດິນ',
    tshu: '10 ຂໍ້ມູນ / ຫ້ອງຖ່ງ'
  },
  msgboardetail: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ໂປຣເເກຣມຂໍ້ມູນ',
    crumbs2: 'ລາຍລະອຽດຂອງເຂດຂໍ້ມູນ',
    huif: 'ຕອບສະຫນອງ',
    shanchu: 'ລຶບ',
    louzhu: 'ທົ່ວໄປ',
    xiazai: 'ຕິດຕັ້ງ',
    gkl: 'ການຮູບລິບປູງດິນ',
    tshu: '10 ຂໍ້ມູນ / ຫ້ອງຖ່ງ',
    qygw: 'ໂປຣເເກຣມຫ້ອງການ',
    sqhf: 'Collapse reply',
    oneLou: '1 ພື້ນ',
    qsrhfnr: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງ',
    fabu: 'release',
    ckgd: 'ເບິ່ງເພີ່ມຕື່ມ',
    tiao_ye: 'ໂປຣເເກຣມ / ໂປຣເເກຣມ',
    fbhf: 'ເພື່ອຕອບສະຫນອງຂໍ້ມູນ',
    scfj: 'ຕິດຕັ້ງຂໍ້ມູນ',
    jwjcdcc: 'ກະລຸນາໃສ່ແຟ້ມໃສ່ນ, ຫລືອ',
    djsc: 'ຄລິກເພື່ອອັບໂຫລດ',
    xght: 'ໂປຣເເກຣມຂໍ້ມູນທີ່ກ່ຽວຂ້ອງ'
  },
  msgboard: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'ໂປຣເເກຣມຂໍ້ມູນ',
    htlx: 'ຮູບແບບສຶກສາ',
    qxzhtlx: 'ກະລຸນາໃສ່ແພັກເກດ',
    mtgj: 'ຜູ້ສະຫນອງຂໍ້ມູນ',
    mtxq: 'ຄວາມຕ້ອງການຂອງອາບນຳ້',
    wuliu: 'ຄະນິດສາດ (Biology)',
    qita: 'other',
    quanbu: 'ທັງໝົດ',
    qsrgjcss: 'ກະລຸນາປ່ອນຄໍາສໍາຄັນໃສ່ເພື່ອຄົ້ນຫາ',
    sousuo: 'ຄົ້ນຫາ',
    xjht: 'ສົມໃຫມ່',
    huati: 'ສົນທະນາ',
    qsrht: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງ',
    htnr: 'ປະກອບໄປດ້ວຍສິ່ງທີ່',
    qsrhtnr: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງຄຳສັ່ງ',
    fjlb: 'ບໍ່ມີຕັ້ງຄ່າທີ່ຖຶກບັນທຶກ',
    scfj: 'ຕິດຕັ້ງຂໍ້ມູນ',
    jwjcdcc: 'ກະລຸນາໃສ່ແຟ້ມໃສ່ນ, ຫລືອ',
    djsc: 'ຄລິກເພື່ອອັບໂຫລດ',
    quxiao: 'ຍົກເລີອກ',
    fabu: 'release',
    zuixin: 'ໃຫມ່',
    remen: 'ຢູ່',
    whf: 'ບໍ່ມີເເບບໃດ້',
    htzs: 'ຫົວຂໍ້ທັງໝົດ',
    huif: 'ຕອບສະຫນອງ',
    gkl: 'ການຮູບລິບປູງດິນ',
    tiaoshu: '10 ຂໍ້ມູນ / ຫ້ອງຖ່ງ'
  },
  complaintsSuggestions: {
    tjsb: 'ຍື່ນສົ່ງບໍ່ສຳເລັດ',
    tjcgcx: 'ຍື່ນສົ່ງສຳເລັດແລ້ວ, ກະລຸນາກວດເບິ່ງຢູ່ທີ່ປະຫວັດຄຳນຳກ່ຽວກັບການຮ້ອງທຸກ!',
    dqxzsc20: 'ຂະໜາດລວມຂອງໄຟລ໌ທີ່ອັບໂຫຼດນີ້ແມ່ນເກີນ 20M​, ກະລຸນາກວດສອບແລ້ວອັບໂຫຼດໃໝ່ອີກຄັ້ງ',
    dqxzsc5: 'ປັດຈຸບັນນີ້ຈໍາກັດໃຫ້ອັບໂຫລດໄດ້ 5 ໄຟລ໌',
    tsjy: 'ຄຳແນະນຳການຮຽກຮ້ອງ',
    lstsjycx: 'ຂໍ້ມູນເຄຍຖາມກ່ຽວກັບ ບ',
    tsz: 'ສະຖານະຂໍ້ມູນ',
    zt: 'ສະຖານະຂໍ້ມູນ:',
    cx: 'ສຶກສາ',
    fh: 'ຍ້າຍໄປທີ່',
    zxyl: 'ເຕົມຄຳແດ້ນພິມງານ',
    xz: 'ເພີ່ມເຕີມ',
    qxz: 'ກະລຸນາເລືອກ',
    scsj: 'ໂຕເອີ້ນລະບົບ',
    fjlx: 'ບັນທຶກບັນທຶກ',
    wjmc: 'ຊື່ເເຟ້ມ',
    cz: 'ປະເພດລົດ',
    fjlb: 'ບໍ່ມີຕັ້ງຄ່າທີ່ຖຶກບັນທຶກ',
    sljg: 'ບໍ່ຮູ້ໃຊ້ຜົນກະທົບ',
    tsrxm: 'ຊື່ຜູ້ຄົກຖາມ',
    lxfs: 'ຂໍ້ມູນແພັກເກດ',
    yx: 'ໂຕອັກສອນ',
    yb: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    tsrsfzh: 'ຄ່າຂອງເລກໂຕເລກຂອງ ຕົວລັກ',
    tssj: 'ເວລາຮ້ອງທຸກ',
    fj: 'ເອກະສານຊ້ອນທ້າຍ',
    tsrdz: 'ບັນຊີຜູ້ພົກຕ່າງໆ',
    tszt: 'ຫົວຂໍ້ການຮຽກຮ້ອງ',
    tsnr: 'ເນື້ອຫາການຮຽກຮ້ອງ',
    scfj: 'ຕິດຕັ້ງຂໍ້ມູນ',
    tj: 'ສົ່ງອອກ',
    qk: '(ລົບຂໍ້ມູນທັງໝົດ)',
    jbxx: 'ຂໍ້ມູນພື້ນຖານ',
    tsxx: 'ຂໍ້ມູນທີ່ເຂົ້າຮ່ວມ'
  },
  cargoService: {
     lhmtx: 'ກະລຸນາເກັບຮັກສາໄວ້ໃຫ້ດີ, ນໍາໃຊ້ໃນເວລາຮັບສິນຄ້າ',
    hxsj: 'ເວລາສົ່ງຕູ້ຄອນເທນເນີກັບຄືນ',
    ddh: 'ເລກໃບສັ່ງຈອງ',
    dlr: 'ຜູ້ຕາງໜ້າ',
    ddyw: 'ທຸລະກຳການຮັບສີນຄ້າ',
    yylx: 'ນັດຮັບສິນຄ້າ',
    xcsj: 'ເວລາຂົນຖ່າຍສິນຄ້າລົງຈາກຍານພາຫະນະ',
    plyy: 'ການສັ່ງຈອງເປັນຊຸດ',
    lhsj: 'ເວລາຮັບສິນຄ້າ',
    qxzlhsj: 'ກາລຸນາເລືອກເວລາຮັບສິນຄ້າ',
    lhm: 'ເລກນໍ້າເບີຮັບສິນຄ້າ',
    sclhm: 'ສ້າງເລກນໍ້າເບີຮັບສິນຄ້າ',
    qdjsclhm: 'ກາລຸນາກົດເພື່ອສ້າງເລກນໍ້າເບີຮັບສິນຄ້າ',
    sclhmm: 'ສ້າງເລກນໍ້າເບີ ຮັບສິນຄ້າ 6ຕົວເລກ',
    fhdwdh: 'ເບີໂທລະສັບຂອງພາກສ່ວນຈັດສົ່ງສິນຄ້າ',
    czjwfm: 'ຊ່ວງເວລານີ້ ສະຖານນີລົດຂ້ອນຂ້າງຫຍຸ້ງຍາກ',
    qggyysj: 'ສະຖານນີລົດເກີດຄວາມຫຍຸ້ງຍາກ, ກາລາປ່ຽນເວລາສັ່ງຈອງໃໝ່',
    qxzytsj: 'ກາລຸນາເລືອກຂໍ້ມູນຢ່າງໜ້ອຍໜຶ່ງລາຍການເພື່ອດໍາການປະຕິບັດງານ',
    yyhx: 'ນັດການສົ່ງຕູ້ຄືນ',
    hxz: 'ສະຖານທີ່ຮັບຕູ້ຄືນ',
    jcmdh: 'ເລກໃບຜ່ານປະຕູເຂົ້າອອກ',
    qxnts: 'ຈໍານວນວັນໃນຂອບເຂດເວລາທີ່ກໍານົດ',
    lhrq: 'ວັນທີຮັບສິນຄ້າ',
    hxm: 'ເລກຕູ້ທີ່ສົ່ງຄືນ',
    schxm: 'ສ້າງເລກຕູ້ທີ່ຈະສົ່ງຄືນ',
    qdjschxm: 'ກະລຸນາຄລິກ(ກົດ)ເພື່ອສ້າງລະຫັດການສົ່ງຕູ້ຄອນເທນເນີກັບຄືນ',
    schxmm: 'ສ້າງລະຫັດການສົ່ງຕູ້ຄອນເທນເນີກັບຄືນ ດ້ວຍ6ຕົວເລກ',
    sysl: 'ຈໍານວນການນໍາໃຊ້',
    fzzxf: 'ຄ່າຍົກຍໍສະຖານີຕົ້ນທາງ',
    bxf: 'ຄ່າປະກັນໄພ',
    jzxsyf: 'ຄ່ານໍາໃຊ້ຕູ້ຄອນເທນເນີ',
    jcfyhj: 'ລວມຄ່າໃຊ້ຈ່າຍພື້ນຖານ',
    bzzdys: 'ໝາຍເຫດ(ຈໍານວນນໍ້າໜັກໂຕນ ແລະປະລິມານການຂົນສົ່ງສູງສຸດ)',
    hwlp: 'ການຮຽກຮ້ອງຊົດເຊີຍສິນຄ້າ',
    tpjd: 'ຮຽກຮ້ອງຄວາມຄືບໜ້າການຊົດເຊີຍ',
    lpxqh: 'ເລກນໍ້າເບີຮຽກຮ້ອງການຊົດເຊີຍ',
    hsxs: 'ຈໍານວນຕູ້ສິນຄ້າທີ່ເສຍຫາຍ',
    fqlp: 'ເລີ່ມຕົ້ນການຮຽກຮ້ອງໃຫ້ຊົດເຊີຍ',
    pllp: 'ຈໍານວນຊຸດທີ່ຮຽກຮ້ອງໃຫ້ຊົດເຊີຍ',
    slcz: 'ສະຖານນີລົດທີ່ໄດ້ຮັບອານູຍາດດໍາເນີນການ',
    ssxh: 'ເລກນໍ້າເບີຕູ້ທີ່ໄດ້ຮັບຄວາມເສຍຫາຍ',
    ssxs: 'ຈໍານວນຕູ້ທີ່ໄດ້ຮັບຄວາມເສຍຫາຍ',
    hwssqk: 'ສະພາບຄວາມເສຍຫາຍຂອງສິນຄ້າ',
    yqpcje: 'ກໍານົດຈໍານວນເງິນໃນການຊົດເຊີຍ',
    slz: 'ຈຸດທີ່ຮັບດໍາເນີນການ',
    czslyj: 'ຮັບຄໍາຄິດເຫັນເພື່ອດໍາເນີນການໃນສະຖານນີລົດ',
    czslr: 'ຜູ້ຮັບດໍາເນີນການໃນສະຖານນີລົດ',
    czslsj: 'ເວລາຮັບດໍາເນີນການໃນສະຖານນີລົດ',
    lpsqs: 'ໃບສະເໜີຮຽກຮ້ອງໃຫ້ຊົດເຊີຍ',
    swjldc: 'ບັນທຶກການສົ່ງອອກທາງການຄ້າ',
    hyjldc: 'ບັນທຶກການສົ່ງອອກໃນການຂົນສົ່ງສິນຄ້າ',
    wanc: 'ສໍາເລັດ',
    lpsq: 'ສະເໜີໃຫ້ດໍາເນີນການຊົດເຊີຍ',
    qxzzsyt: 'ກະລຸນາເລືອກໜຶ່ງຂໍ້ບັນທຶກຢ່າງໜ້ອຍ',
    qxzzsyt1: "ກະລຸນາເລືອກຢ່າງໜ້ອຍໜຶ່ງລາຍການທີ່ຈະສົ່ງ",
    hwjz: 'ມູນຄ່າສິນຄ້າ',
    mxbxje: '(ຈໍານວນເງິນມູນຄ່າປະກັນໄພຂອງສິນຄ້າໃນແຕ່ລະຕູ້ຄອນເທນເນີ)',
    jdxqxzts: "ກະລຸນາເລືອກວັນທີຈັດສົ່ງສິນຄ້າ ຕາມຄວາມຕ້ອງການປະຈໍາເດືອນ, ຖ້າວ່າການຮັບຕູ້ຄອນເທນເນີໃນທ້າຍເດືອນປັດຈຸບັນ, ວັນທີຈັດສົ່ງກໍ່ຈະແມ່ນຢູ່ໃນຕົ້ນເດືອນໜ້າ, ສະນັ້ນຕ້ອງເລືອກຄວາມຕ້ອງການປະຈໍາເດືອນຂອງເດືອນຕໍ່ໄປ, ແລະຖ້າເລືອກຜິດ ກໍ່ຈະເຮັດໃຫ້ທ່ານບໍ່ສາມາດສົ່ງຄໍາຮ້ອງຄວາມຕ້ອງການປະຈໍາວັນໄດ້",
    qfh: 'ໄປສົ່ງສິນຄ້າ',
    sfszbx: 'ແມ່ນຕູສວ່ນບຸກຄົນ?',
    hwzlkg: 'ນ້ຳໜັກສິນຄ້າ (kg)',
    dxzdzz: 'ຄວາມສາມາດໃນການໂຫຼດສູງສຸດຂອງຕູ້ດຽວ (ໂຕນ)',
    sscs: 'ຈໍານວນລົດທີ່ເສຍຫາຍ',
    ssch: 'ໝາຍເລກລົດທີ່ເສຍຫາຍ',
    hwlpxq: 'ລາຍລະອຽດການຮ້ອງຂໍສິນຄ້າ',
    hyjllb: 'ບັນຊີລາຍຊື່ບັນທຶກການຂົນສົ່ງ',
    swjllb: 'ບັນຊີລາຍຊື່ບັນທຶກທຸລະກິດ',
    yyjl: 'ບັນທຶກການນັດໝາຍ',
    qxzhxsj: 'ກະລຸນາເລືອກເວລາການສົ່ງຕູ້ຄອນເທນເນີກັບຄືນ',
    qsrch: 'ກະລຸນາໃສ່ໝາຍເລກລົດ',
    qsrssxh: 'ກະລຸນາລະບຸຈໍານວນຕູ້ຄອນເທນເນີທີ່ໄດ້ຮັບຄວາມເສຍຫາຍ',
    qsrhwssqk: 'ກະລຸນາລະບຸສະພາບຄວາມເສຍຫາຍຂອງສິນຄ້າ',
    qscfj: 'ກະລຸນາອັບໂຫຼດໄຟລແນບ',
  },
  myOrders: {
    dqye: 'ຍອດເງິນປະຈຸບັນ',
    kyye: 'ຍອດເງິນທີ່ໃຊ້ໄດ້',
    cjje: 'ຈຳນວນເງິນທີ່ຊໍາລະຊ້າ',
    djye: 'ຈໍານວນເງິນແຊ່ແຂງ',
    fylx: 'ປະເພດຂອງຄ່າໃຊ້ຈ່າຍ',
    jyje: 'ຈໍານວນເງິນການເຮັດທຸລະກໍາ',
    pzh: 'ໝາຍເລກໃບຢັ້ງຢືນ',
    range7d: '7 ມື້ທີ່ຜ່ານມາ',
    range10d: '10 ມື້ທີ່ຜ່ານມາ',
    range30d: '30 ມື້ທີ່ຜ່ານມາ',
    periodfirst: 'ຕົ້ນເດືອນ',
    periodsecond: 'ກາງເດືອນ',
    periodthird: 'ທ້າຍເດືອນ',
    zxje: 'ຈໍານວນເງິນນ້ອຍທີ່ສຸດ​',
    zdje: 'ຈໍານວນເງິນສູງສຸດ',
    yzn: 'ເລືອກປີ',
    jylsh: 'ເລກລໍາດັບການເຮັດທຸລະກໍາ',
    loading: 'ກຳລັງໂຫຼດສຸດຄວາມສາມາດ',
  },
  processMap: {
    crumbs0: 'ການແນະນໍາວິທີການດໍາເນີນການ',
    crumbs1: 'ຂັ້ນຕອນການດໍາເນີນການທຸລະກໍາ',
    crumbs2: 'ຂໍ້ມູນລົດໄຟ',
    czjbxx: 'ຂໍ້ມູນພື້ນຖານສະຖານີລົດໄຟ',
    jzxxx: 'ຂໍ້ມູນຕູ້ຄອນເທນເນີ',
    yjfl: 'ອັດຕາລາຄາ',
    yunf: 'ຄ່າຂົນສົ່ງ',
    zaf: 'ຄ່າໃຊ້ຈ່າຍອື່ນໆ',
    flfgjxgwj: 'ກົດລະບຽບ,ກົດໝາຍ ແລະເອກະສານທີ່ກ່ຽວຂ້ອງ',
    tbxz: 'ຕ້ອງຮູ້ກ່ຽວກັບປະກັນໄພ',
    bxtk: 'ເງື່ອນໄຂປະກັນໄພ',
    hyblwt: 'ບັນຫາການດໍາເນີນການຂົນສົ່ງສິນຄ້າ',
    fhlc: 'ຂັ້ນຕອນການຈັດສົ່ງສິນຄ້າ',
    lhlc: 'ຂັ້ນຕອນການຮັບສິນຄ້າ',
    sfych: 'ມີລົດຍົກ forklift ບໍ່',
    fwdh: 'ເບີໂທໃຫ້ບໍລິການ',
    yysj: 'ເວລາເຮັດວຽກ',
    xzpl: 'ປະເພດສິນຄ້າທີ່ຈໍາກັດ',
    dz: 'ທີ່ຢູ່',
    qtyq: 'ຂໍ້ກໍານົດອື່ນໆ',
    zfzl: 'ໂຫຼດນໍາໜັກສູງສຸດ(t)',
    hc: 'ການປ່ຽນຄວາມຍາວ',
    rj: 'ຄວາມຈຸ（m³）',
    zht: 'ນໍ້າໜັກໃນຕົວ(t)',
    fb: 'ແຍກລາຍຈ່າຍ',
    fblx: 'ປະເພດແຍກລາຍຈ່າຍ',
    tdjb: 'ລະດັບອັດຕາການປ່ຽນແປງ',
    fjbd: 'ການປ່ຽນແປງເພີ່ມເຕີມ',
    wjm: 'ຊື່ເອກະສານ',
    fbdw: 'ພາກສ່ວນທີ່ປະກາດ',
    wt: 'ບັນຫາ',
    xwzx: 'ໃຫ້ຄໍາປຶກສາດ້ານຂໍ້ມູນຂ່າວສານ',
    xwbt: 'ຫົວຂໍ້ຂໍ້ມູນຂ່າວສານ',
    xwxq: 'ລາຍລະອຽດຂໍ້ມູນຂ່າວສານ',
    ggbt: 'ຫົວຂໍ້ທີ່ປະກາດ',
    ggxq: 'ເນື້ອໃນລາຍລະອຽດທີ່ປະກາດ',
    meiyou: 'ບໍ່ມີ',
    you: 'ມີ',
    yjlx: 'ປະເພດລາຄາຂົນສົ່ງ',
    bzyj: 'ລາຄາຂົນສົ່ງມາດຕະຖານ',
    tzyj: 'ລາຄາຂົນສົ່ງທີ່ດັດແກ້',
    tfmx: 'ລາຍລະອຽດລະດັບອັດຕາການປ່ຽນແປງ',
    tddj: 'ລະດັບຄວາມປ່ຽນແປງ',
    tdks: 'ເລີ່ມສະແດງລະດັບອັດຕາການປ່ຽນແປງ',
    tdjs: 'ສິ້ນສຸດລະດັບອັດຕາການປ່ຽນແປງ',
    sfatdjs: 'ຄິດໄລ່ຕາມລະດັບອັດຕາການປ່ຽນແປງແມ່ນບໍ່',
    jfgz: 'ຫຼັກການການຄິດໄລ່ຄ່າໃຊ້ຈ່າຍ',
    tddw: 'ຫົວໜ່ວຍຂອງລະດັບອັດຕາການປ່ຽນແປງ',
    bzqh: '​ສະ​ຫຼັບ​ສະ​ກຸນ​ເງິນ​',
    wtd: 'ບໍ່ມີການໄລ່ລະດັບ',
    wtxqym: 'ໜ້າລາຍລະອຽດ ແລະ ບັນຫາ',
    zwxz: 'ດາວໂຫລດເອກະສານຕົ້ນສະບັບ',
    fjxz: 'ດາວໂຫລດເອກະສານສະບັບສໍາເນົາ',
    bjzzt: 'ນໍ້າໜັກທີ່ສາມາດໂຫຼດໃສ່ໄດ້(t)',
    nbcc: 'ຂະໜາດພາຍໃນ(ຍາວxກ້ວາງxສູງ)（mm）',
    wbcc: 'ຂະໜາດດ້ານນອກ(ຍາວxກ້ວາງxສູງ)（mm）',
    qtcz: 'ຍານພາຫະນະປະເພດຕ່າງໆ',
    cncc: 'ດ້ານໃນລົດ(ຍາວxກ້ວາງxສຸງ)（mm）',
    ctcz: 'ວັດສະດຸຂອງຕົວລົດ',
    zxjzxj: 'ໄລຍະຫ່າງລະຫວ່າງແກນກາງຂອງໂບກີ(bogie)（mm）',
    dmzgmgd: 'ລະດັບຄວາມສູງແຕ່ໜ້າດິນ ເຖິງ ໜ້າລາງລົດໄຟ（mm）',
    kczxgd: 'ຄວາມສູງຈຸດສູນຖ່ວງຂອງລົດເປົ່າ（mm）',
    cmcc: 'ຂະໜາດປະຕູລົດ(ກ້ວາງxສູງ)（mm）',
    gtcc: 'ຂະໜາດຖັງ(ຍາວxເສັ້ນຜ່າສູນກາງ)（mm）',
    ytu: 'ປະໂຫຍດໃນການນໍາໃຊ້',
    ted: 'ຈຸດເດັ່ນ',
    syss: 'ຄວາມໄວໃນທາງການຄ້າ（km/h）',
    clzdkg: 'ຂະໜາດໃຫຍ່ສຸດຂອງຍານພາຫະນະ(ກ້ວາງxສູງ)（mm）',
    mianj: 'ເນື້ອທີ່（m²）',
  },
  settings: {
    ysmm: 'ລະຫັດເດີມ',
    xz: 'ເພີ່ມ',
    dxdz: 'ການປັບແຕ່ງ',
    dzqz: 'ລາຍເຊັນອີເລັກໂທຣນິກ ',
    xgfhxx: 'ແກ້ໄຂຂໍ້ມູນການຈັດສົ່ງ',
    cpxqxxxg: 'ການດັດແກ້ຂໍ້ມູນຄວາມຕ້ອງການຂອງຜະລິດຕະພັນ',
    qyzcmc: 'ຊື່ບໍລິສັດ',
    jbrsj: 'ເບີໂທຜູ້ດຳເນີນການ',
    cpgyxx: 'ຂໍ້ມູນການມີຢູ່ຂອງຜະລິດຕະພັນ',
    kcwd: 'ສາງ (10,000 ໂຕນ)',
    xzmm: 'ລະຫັດຜ່ານໃໝ່',
    ql: 'ຊູນຟູຣິກທັງໝົດ(%)',
    cpxqxxxj: 'ຂໍ້ມູນຄວາມຕ້ອງການສິນຄ້າໃໝ່',
    yx: 'ກ່ອງຈົດໝາຍ',
    lxdh: 'ເບີໂທຕິດຕໍ່',
    xgshxx: 'ແກ້ໄຂຂໍ້ມູນໃບຮັບເງິນ',
    qy: 'ໂລໂກ້ວິສາຫະກິດ',
    hff: 'ບັນຫາລະເຫີຍ(%)',
    txdz: 'ທີ່ຢູ່',
    zh: 'ບັນຊີ',
    qxz: 'ກະລຸນາເລືອກ',
    jgyd: 'ລາຄາ (ຢວນ/ໂຕນ)',
    qsrnr: 'ກະລຸນາໃສ່ເນື້ອໃນ',
    qygwlj: 'ການເຊື່ອມໂຍງເວັບໄຊທ໌ທາງການຂອງວິສາຫະກິດ',
    jbr: 'ຜູ້ຈັດການ',
    cmqy: 'ວິສາຫະກິດຜະລິດຖ່ານຫີນ',
    fbsj: 'ເວລາເຜີຍແຜ່',
    jg: 'ລາຄາ',
    mtlx: 'ປະເພດຖ່ານຫີນ',
    scxgzj: 'ອັບໂຫລດເອກະສານທີ່ກ່ຽວຂ້ອງ:',
    sfzhm: 'ເລກ ID',
    js: 'ບົດບາດ',
    tyfmc: 'ຜູ້ຂົນສົ່ງສິນຄ້າ',
    sc: 'ລຶບ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    sj: 'ໂທລະສັບມືຖື',
    qyjj: 'ຂໍ້ມູນບໍລິສັດ',
    qsrmm: 'ກະລຸນາໃສ່ລະຫັດຜ່ານ',
    kyts: 'ມື້ທີ່ສາມາດໃຊ້ໄດ້',
    ck: 'ກວດເບິ່ງ',
    xgdsly: 'ແກ້ໄຂການຂົນສົ່ງຫຼາຍແບບ',
    jbrsfz: 'ID ຜູ້ຈັດການ',
    qyyx: 'ອີເມວລັດວິສາຫະກິດ',
    ggsx: 'ຄຸນສົມບັດສະເພາະ',
    spfmc: 'ຊື່ Billee',
    tj: 'ສົ່ງ',
    cz: 'ປະເພດລົດ',
    qsrshf: 'ກະລຸນາໃສ່ຜູ້ຮັບ',
    tp: 'ຮູບ',
    qylx: 'ປະເພດຂອງວິສາຫະກິດ',
    shfmc: 'ຊື່ຜູ້ຮັບສົ່ງ',
    dh: 'ໂທລະສັບ',
    xjdsly: 'ການຂົນສົ່ງ multimodal ໃຫມ່',
    hskmx: 'ຄວາມສາມາດໃນການ grindability',
    khxmc: 'ຊື່ທະນາຄານ',
    qsf: 'ຄວາມຊຸ່ມຊື່ນຢ່າງເຕັມທີ່(%)',
    cptp: 'ຮູບພາບຜະລິດຕະພັນ',
    qydz: 'ທີ່ຢູ່ບໍລິສັດ',
    qymc: 'ຊື່​ບໍ​ລິ​ສັດ',
    mhrrx: 'ການລະລາຍຂີ້ເທົ່າຖ່ານຫີນ(℃)',
    ccbc: 'ຈຳນວນລົດໄຟ/ຖ້ຽວບິນ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    zgjqzxsdhlw: 'ສູງສຸດສອງຕໍາແໜ່ງທົດສະນິຍົມ',
    dz: 'ສະຖານີປາຍທາງ',
    qydh: 'ເບີໂທລັດວິສາຫະກິດ',
    gdthl: 'ເນື້ອໃນຄາບອນຄົງທີ່(%)',
    yhjbxx: 'ຂໍ້ມູນພື້ນຖານຂອງຜູ້ໃຊ້',
    grsz: 'ການຕັ້ງຄ່າສ່ວນຕົວ',
    fzfg: 'ສະຖານີຂາອອກ / ທ່າເຮືອອອກເດີນທາງ',
    nsrsbh: 'ໝາຍເລກປະຈຳຕົວຜູ້ເສຍພາສີ',
    shj: 'ຫ້ອງການກວດສອບ',
    qrmm: 'ຢືນ​ຢັນ​ລະ​ຫັດ',
    yxzh: 'ບັນ​ຊີ​ທະ​ນາ​ຄານ',
    qyxcz: 'ຮູບພາບການເຜີຍແຜ່ຂອງບໍລິສັດ',
    dzdg: 'ມາຮອດ / ມາຮອດ',
    rhwd: 'ການ​ບໍ​ລິ​ໂພກ​ປະ​ຈໍາ​ວັນ (10,000 ໂຕນ​)',
    khx: 'ທະນາຄານ',
    mmxg: 'ປ່ຽນ​ລະ​ຫັດ​ຜ່ານ',
    fsxx: 'ສົ່ງແລະຮັບຂໍ້ມູນ',
    ssqy: 'ຂື້ນກັບບໍລິສັດ',
    fh: 'ກັບຄືນ',
    kgdsd: 'ມີໂຕນ (ໂຕນ)',
    qyjbxx: 'ຂໍ້ມູນພື້ນຖານຂອງບໍລິສັດ',
    cpgxxx: 'ຂໍ້​ມູນ​ການ​ສະ​ຫນອງ​ຜະ​ລິດ​ຕະ​ພັນ​ແລະ​ຄວາມ​ຕ້ອງ​ການ​',
    fz: 'ສົ່ງສະຖານີ',
    xjshxx: 'ຂໍ້ມູນການສົ່ງໃຫມ່ທີ່ໃຫມ່',
    kgds: 'ໂຕເອີ້ມ',
    qsrdxyzm: 'ກະລຸນາຕື່ມລະຫັດຢືນຢັນທີ່ສົ່ງທາງຂໍ້ຄວາມ',
    hmqy: 'ວິສາຫະກິດ Coal -Consuming',
    yhmc: 'ຊື່ຜູ້ໃຊ້',
    dxyzm: 'ລະຫັດຢືນຢັນທາງຂໍ້ຄວາມ',
    cpgyxxxj: 'ຂໍ້ມູນການສະຫນອງສິນຄ້າສ້າງໃຫມ່',
    fplx: 'ປະເພດໃບເກັບເງິນ',
    xg: 'ແປງ',
    xh: 'ລໍາດັບ',
    lylb: 'ປະເພດທີ່ເຊື່ອມໂຍງ',
    xj: 'ສ້າງໃຫມ່',
    cpxqxx: 'ຂໍ້ມູນຄວາມຕ້ອງການຂອງສິນຄ້າ',
    xm: 'ຊື່',
    zjxm: "ຊື່ແລະນາມສະກຸນຕາມບັດ",
    xgmm: 'ປ່ຽນ​ລະ​ຫັດ​ຜ່ານ',
    gysj: 'ເວລາສະຫນອງ',
    xzrq: 'ວັນທີຄັດເລືອກ',
    hf: 'ສີເທົາ(%)',
    xjfhxx: 'ຂໍ້ມູນການສົ່ງໃຫມ່',
    yyzz: 'ໃບອະນຸຍາດດໍາເນີນທຸລະກິດ',
    zzjgdmz: 'ໃບຢັ້ງຢືນລະຫັດອົງກອນ',
    swdjz: 'ໃບທະບຽນອາກອນ',
    zzsxx: 'ຂໍ້ມູນມູນຄ່າພາສີເພີ່ມເຕີມ',
    message: 'ໃບສະຫມັກຂອງທ່ານໄດ້ຖືກສົ່ງແລ້ວ, ກະລຸນາລໍຖ້າການອະນຸມັດຢ່າງອົດທົນ!',
    cyfhxx: 'ຂໍ້ມູນສົ່ງເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    xjcg: 'ຜົນສໍາເລັດໃຫມ່',
    xgcg: 'ດັດແກ້ຢ່າງສໍາເລັດຜົນ',
    cyshxx: 'ຂໍ້ມູນຮັບເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    cydsly: 'ການຂົນສົ່ງທີ່ມີຫຼາຍການນໍາໃຊ້',
    mm: 'ລະຫັດຜ່ານ',
    hwggsx: 'ຄຸນລັກສະນະສະເພາະ',
    sctp: 'ອັບໂຫລດຮູບພາບ',
    cpgyxxxg: 'ການດັດແກ້ຂໍ້ມູນການສະຫນອງສິນຄ້າ',
    z: 'ເພື່ອ',
    yh: 'ຜູ້ໃຊ້',
    xx: 'ຂໍ້ມູນຂ່າວສານ',
    sfzzmz: 'ແຟ້ມຜົນທີ່ກ່ອນໃຕ້ຂອງ',
    sfzbmz: 'ສຳຫລັບຜູ້ນທີ່ເຂົ້າຮ່ວມກັນພັດທະນາ',
    qy1: 'ໂປຣເເກຣມທົວໄປ',
    jbxx: 'ຂໍ້ມູນພື້ນຖານ',
    xyb: 'ຂັ້ນ​ຕອນ​ຕໍ່​ໄປ',
    fhdz: 'ທີ່ຢູ່ຕົ້ນທາງບ່ອນຈັດສົ່ງສິນຄ້າ',
    shouq: 'ທົບເຂົ້າ',
    gduo: 'ເພີ່ມເຕີມ',
    tiaoj: 'ເງື່ອນ​ໄຂ',
    shdz: 'ທີ່ຢູ່ປາຍທາງບ່ອນຮັບເອົາສິນຄ້າ',
    qtxxm: 'ກາລຸນາຂຽນຊື່ແລະນາມສະກຸນ',
    guoj: 'ສັນຊາດ',
    qxzgj: 'ກາລຸນາລະບຸສັນຊາດ',
    hzhm: 'ເລກພາສພອດ',
    sfzyxq: 'ອາຍຸການນໍາໃຊ້ບັດປະຈໍາຕົວ',
    hzyxq: 'ອາຍຸການນໍາໃຊ້ພາສພອດ',
    qsrsfzhm: 'ກາລຸນາລະບຸເລກບັດປະຈໍາຕົວ',
    qsrhzhm: 'ກາລຸນາລະບຸເລກພາສພອດ',
    qxzsfzyxq: 'ກາລຸນາລະບຸອາຍຸການນໍາໃຊ້ບັດປະຈໍາຕົວ',
    qxzhzyxq: 'ກາລຸນາລະບຸອາຍຸການນໍາໃຊ້ພາສພອດ',
    sfzzmzp: 'ຮູບດ້ານໜ້າບັດປະຈໍາຕົວ',
    sfzbmzp: 'ຮູບຖ່າຍດ້ານຫຼັງບັດປະຈໍາຕົວ',
    grscsfz: 'ຮູບດ້ານໜ້າມືຖືບັດປະຈໍາຕົວຂອງບຸກຄົນ',
    hzxxyzp: 'ຮູບດ້ານທີ່ມີຂໍ້ມູນ ພາສພອດ',
    grschzxx: 'ຮູບດ້ານທີ່ມີຂໍ້ມູນ ມືຖືພາສພອດຂອງບຸກຄົນ',
    sfzdq: 'ວັນໝົດອາຍຸບັດປະຈໍາຕົວ ຍັງ10ວັນ, ກາລຸນາອັບເດດໂດຍໄວ',
    hzdq: 'ໜັງສືຜ່ານແດນຍັງ10ວັນຈະໝົດອາຍຸ, ກະລຸນາອັບເດດໃຫ້ທັນເວລາ',
    qsryzm: 'ກາລຸນາລະບຸລະຫັດຢືນຢັນ',
    qsrxsjh: 'ກາລຸນາລະບຸ ເບີໂທລະສັບ ໃໝ່',
    yzmcw: 'ລະຫັດຢືນຢັນ ບໍ່ຖືກຕ້ອງ',
    xsjhyzc: 'ເບີໂທລະສັບ ໃໝ່ໄດ້ລົງທະບຽນແລ້ວ',
    qysh: 'ເລກລະຫັດພາສີຂອງລັດວິສາຫະກິດ',
    yyzzbh: 'ເລກລະຫັດວິສາຫະກິດ',
    zczj: 'ທຶນຈົດທະບຽນ',
    bz: 'ລົດລົງ',
    jp: 'ກີບ',
    rmb: 'ຢວນ',
    meij: 'ໂດລາ',
    qxzbz: 'ກະລຸນາເລືອກສະກຸນເງິນ',
    sshy: 'ປະເພດອຸດສາຫະກຳຂື້ນກັບ',
    jjxz: 'ລັກສະນະເສດຖະກິດ',
    qyzh: 'ລັກສະນະວິສາຫະກິດ',
    jglx: 'ປະເພດອົງກອນ',
    qyyhzh: 'ບັນຊີທະນາຄານ ຂອງວິສາຫະກິດ',
    jyfw: 'ຂອບເຂດການດໍາເນີນທູລະກິດ',
    fddbr: 'ຜູ້ຕາງໜ້າທາງກົດໝາຍ',
    frgj: 'ສັນຊາດຂອງນິຕິບຸກຄົນ',
    ffsfzhm: 'ເລກບັດປະຈຳຕົວຂອງຜູ້ຕາງໜ້າ',
    ffsfzyxq: 'ໄລຍະການນຳໃຊ້ບັດປະຈຳຕົວຂອງຜູ້ຕາງໜ້າ',
    frhzhm: 'ເລກພາສພອດຂອງນິຕິບຸກຄົນ',
    frhzyxq: 'ອາຍຸການນໍາໃຊ້ບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    sjgs: 'ລະດັບຫົວໜ້າບໍລິສັດ',
    zjxx: 'ຂໍ້ມູນບັດ',
    zjxxts: 'ແນະນໍາໃຫ້ອັບໂຫລດໄຟລ໌ທີ່ສະແກນ; ກະລຸນາຫຼຸດຜ່ອນແສງສະທ້ອນໃນເວລາຖ່າຍຮູບ; ກະລຸນາໃຫ້ແນ່ໃຈວ່າຂໍ້ມູນທັງຫມົດໃນຮູບພາບແມ່ນເຫັນໄດ້ຊັດເຈນ, ເນື້ອຫາແມ່ນຖືກຕ້ອງ ແລະ ໃຊ້ໄດ້ ແລະ ບໍ່ມີການດັດແກ້; ຂະຫນາດໄຟລ໌ບໍ່ເກີນ 5MB, ຮູບແບບທີ່ຮອງຮັບ: .jpg .jpeg .bmp .png',
    wtzm: 'ໃບຢັ້ງຢືນມອບໝາຍ',
    yyzzyxq: 'ອາຍຸການນໍາໃຊ້ໃບທະບຽນວິສາຫະກິດ',
    wtzmyxq: 'ອາຍຸການນໍາໃຊ້ໃບຢັ້ງຢືນມອບໝາຍ',
    frsfzzmz: 'ຮູບດ້ານໜ້າບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    frsfzbmz: 'ກະລຸນາອັບໂຫຼດຮູບຖ່າຍດ້ານຫຼັງບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    frscsfzzmz: 'ຮູບດ້ານໜ້າມີຖີບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    zzzmcl: 'ເອກະສານຢັ້ງຢືນຄຸນວຸດທິ',
    syb: 'ຂັ້ນຕອນທີ່ແລ້ວ',
    ymzzzm: 'ໃບຢັ້ງຢືນຄຸນນະພາບການຂົນສົ່ງຖ່ານຫີນ',
    tdzzws: 'ເອກະສານການປູກພືດທົດແທນ',
    ymzzzmyxq: 'ອາຍຸການນໍາໃຊ້ໃບຢັ້ງຢືນຄຸນນະພາບການຂົນສົ່ງຖ່ານຫີນ',
    tdzzwsyxq: 'ອາຍຸການນໍາໃຊ້ໃບຢັ້ງຢືນການປູກພືດທົດແທນ',
    yksydzm: 'ໃບຢັ້ງຢືນການການເຄື່ອນຍ້າຍແຮ່ເຫຼັກ',
    yksydzmyxq: 'ອາຍຸການນໍາໃຊ້ໃບຢັ້ງຢືນການການເຄື່ອນຍ້າຍແຮ່ເຫຼັກ',
    jzxsyxy: 'ສັນຍາການນໍາໃຊ້ຕູ້ຄອນເທນເນີ',
    jzxsyxyyxq: 'ໄລຍະເວລາຂອງສັນຍາການນໍາໃຊ້ຕູ້ຄອນເທນເນີ',
    jzxsyxysy: 'ຮູບຖ່າຍໜ້າທໍາອິດຂອງສັນຍານໍາໃຊ້ຕູ້ຄອນເທນເນີ',
    qscjzxsyxysy: 'ກະລຸນາອັບໂຫຼດຮູບຖ່າຍໜ້າທໍາອິດຂອງສັນຍານໍາໃຊ້ຕູ້ຄອນເທນເນີ',
    jzxsyxywy: "集装箱使用协议双方盖章页照片(en)",
    qscjzxsyxywy: "请上传集装箱使用协议双方盖章页照片(en)",
    qscyxdzbxxy:"ກະລຸນາອັບໂຫຼດສັນຍານໍາໃຊ້ຕູ້ຄອນເທນເນີຂອງຕົນເອງ ທີ່ຍັງມີຜົນນໍາໃຊ້",
    zbxsyxy: 'ສັນຍານໍາໃຊ້ຕູ້ຄອນເທນເນີຂອງຕົນເອງ',
    zbxsyxyyxq: 'ໄລຍະເວລາທີ່ມີຜົນນໍາໃຊ້ຂອງສັນຍານໍາໃຊ້ຕູ້ຄອນເທນເນີຂອງຕົນເອງ',
    zbxsyxysy: 'ຮູບຖ່າຍໜ້າສຸດທ້າຍຂອງສັນຍານໍາໃຊ້ຕູ້ຄອນເທນເນີຂອງຕົນເອງ',
    qsczbxsyxysy: 'ກະລຸນາອັບໂຫຼດຮູບຖ່າຍໜ້າທໍາອິດຂອງສັນຍານໍາໃຊ້ຕູ້ຄອນເທນເນີຂອງຕົນເອງ',
    zbxsyxywy: 'ຮູບຖ່າຍໜ້າສຸດທ້າຍຂອງສັນຍານໍາໃຊ້ຕູ້ຄອນເທນເນີຂອງຕົນເອງ',
    qsczbxsyxywy: 'ກະລຸນາອັບໂຫຼດຮູບຖ່າຍໜ້າສຸດທ້າຍຂອງສັນຍານໍາໃຊ້ຕູ້ຄອນເທນເນີຂອງຕົນເອງ',
    qtcl: 'ເອກະສານອື່ນໆ',
    qtclyxq: 'ອາຍຸການນໍາໃຊ້ຂອງເອກະສານອື່ນໆ',
    jbrxx: 'ຂໍ້ມູນຂອງຜູ້ປະສານງານ',
    jbrxxts: 'ເນື່ອງຈາກວ່າທ່ານເປັນຜູ້ຕັ້ງຄ່າໃນລະບົບໃຫ້ກັບຜູ້ທີ່ມີສິດທິທາງກົດໝາຍເປັນຜູ້ດໍາເນີນການຂຽນຂໍ້ມູນພື້ນຖານຂອງບໍລິສັດຂອງທ່ານ, ສະນັ້ນຂໍ້ມູນຕ່າງໆທີ່ກ່ຽວຂອງ ຈະສະແດງໃຫ້ທ່ານຮັບຮູ້ໂດຍອັດໂຕໂນມັດ',
    sjyzm: 'ລະຫັດຢືນຢັນໂທລະສັບມືຖື',
    jsjhyzm: 'ລະຫັດຢືນຢັນເບີໂທລະສັບເກົ່າ',
    xsjh: 'ເບີໂທລະສັບໃໝ່',
    xsjhyzm: 'ລະຫັດຢືນຢັນເບີໂທລະສັບໃໝ່',
    ghsjh: 'ປ່ຽນເບີໂທລະສັບມືຖື',
    qscsfzzmz: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານໜ້າບັດປະຈໍາຕົວ',
    qscsfzbmz: 'ກະລຸນາອັບໂຫຼດຮູບບັດປະຈໍາຕົວດ້ານຫຼັງ',
    qscgrscsfzzmz: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານໜ້າມືຖືບັດປະຈໍາຕົວຂອງບຸກຄົນ',
    qschuxxy: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານຂໍ້ມູນພາສພອດ',
    qscgrschzxxy: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານຂໍ້ມູນມືຖືພາສພອດຂອງບຸກຄົນ',
    frhzxxy: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານຂໍ້ມູນພາສພອດຂອງນິຕິບຸກຄົນ',
    frschzxxy: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານຂໍ້ມູນມືຖືພາສພອດຂອງນິຕິບຸກຄົນ',
    yhqh: 'ການປ່ຽນຜູ້ນໍາໃຊ້',
    yhxxwh: 'ການປ້ອງກັນຂໍ້ມູນຜູ້ນໍາໃຊ້',
    qhqy: 'ການປ່ຽນວິສາຫະກິດ',
    sskh: 'ລູກຄ້າທີ່ສັງກັດ',
    khlx: 'ປະເພດລູກຄ້າ',
    sskhxx: 'ຂໍ້ມູນລູກຄ້າທີ່ສັງກັດ',
    khgx: 'ການພົວພັນກັບລູກຄ້າ',
    guanx: 'ການພົວພັນ',
    gjhdq: 'ປະເທດ/ເຂດ',
    sqyw: 'ໜ້າວຽກທີ່ໄດ້ຮັບສິດ',
    qx: 'ໄລຍະເວລາທີ່ກໍານົດ',
    jlrq: 'ວັນທີການສ້າງຕັ້ງ',
    baog: 'ການແຈ້ງພາສີ',
    dl: 'ຜູ້ຕາງໜ້າ ',
    bdl: 'ໄດ້ຮັບເປັນຜູ້ຕາງໜ້າ ',
    zc: 'ປົກກະຕິ',
    stop: 'ສິນສຸດ',
    gq: 'ເກີນກໍານົດເວລາ',
    slzt: 'ສະຖານະການໄດ້ຮັບສິດ',
    ysh: 'ໄດ້ກວດສອບແລ້ວ',
    shlb: 'ຕາຕະລາງການກວດສອບ',
    sqdl: 'ສະເໜີຂໍເປັນຜູ້ຕາງໜ້າ',
    ywfw: 'ຂອບເຂດການດໍາເນີນທຸລະກໍາ',
    dlkh: 'ຕາງໜ້າລູກຄ້າ',
    sqqx: 'ໄລຍະເວລາທີ່ໄດ້ຮັບການມອບສິດ',
    sm: 'ອະທິບາຍ',
    sqkh: 'ລູກຄ້າທີ່ສະເໜີ',
    sqjl: 'ບັນທຶກການສະເໜີ',
    sqrq: 'ວັນທີທີ່ສະເໜີ',
    khxq: 'ລາຍລະອຽດລູກຄ້າ',
    zzf: 'ຝ່າຍທີ່ຢຸດຕິ',
    zzrq: 'ວັນທີທີ່ຢຸດຕິ',
    zzsm: 'ສິ້ນສຸດການອະທິບາຍ',
    yq: 'ເລື່ອນເວລາ',
    bg: 'ປ່ຽນແປງໃໝ່',
    djckkhxq: 'ຂໍ້ມູນລູກຄ້າ, ກົດເພື່ອເບິ່ງລາຍລະອຽດ',
    zjlx: 'ປະເພດບັດ',
    zjh: 'ເລກບັດ ',
    yyzzh: 'ເລກລະຫັດວິສາຫະກິດ ',
    jbrgl: 'ການຄຸ້ມຄອງຜູ້ປະສານງານ ',
    jzrq: 'ວັນໝົດອາຍຸ',
    glqx: 'ໄລຍະເວລາຂອງການກ່ຽວພັນກັນ',
    xzjbr: 'ການເພີ່ມຜູ້ປະສານງານໃໝ່',
    bjjbr: 'ຜູ້ບັນນາທິການ',
    accept: 'ຍອມຮັບ',
    jbrsjh: 'ເບີໂທລະສັບມືຖືຂອງຜູ້ປະສານງານ',
    glzt: 'ສະຖານະການພົວພັນກັນ',
    tslx: 'ປະເພດການຮ້ອງທຸກ',
    clzt: 'ສະຖານະການດໍາເນີນການ',
    tjjs: 'ເວລາສົ່ງມອບ',
    cx: 'ຍົກເລີກ',
    xztsjy: 'ການສະເໜີຄໍາຮ້ອງທຸກທີ່ເພີ່ມໃໝ່',
    bjtsjy: 'ການກະກຽມຄໍາສະເໜີການຮ້ອງທຸກ',
    tppz: 'ຢັ້ງຢືນດ້ວຍຮູບພາບ',
    tjxx: 'ການສົ່ງຂໍ້ມູນ',
    slxx: 'ຂໍ້ມູນການຮັບສິດ',
    ddcx: 'ການກວດສອບໃບສັ່ງຈອງ',
    fhwt: 'ບັນຫາການຈັດສົ່ງສິນຄ້າ',
    shwt: 'ບັນຫາການຮັບສິນຄ້າ',
    slz: 'ໃນຊ່ວງການຮັບສິດ',
    ycx: 'ຍົກເລີກແລ້ວ',
    qxzytsj: 'ເລືອກເອົາໜຶ່ງຂໍ້ມູນເພື່ອດໍາເນີນການຢືນຢັນ',
    zzyy: 'ເຫດຜົນການຢຸດຕິ',
    qsrzzyy: 'ກາລຸນາລະລະບຸເຫດຜົນການຢຸດຕິ',
    qsrjjyy: 'ກາລຸນາລະລະບຸເຫດຜົນການປະຕິເສດ',
    qsrdlkh: 'ກາລຸນາລະບຸຜູ້ຕາງໜ້າລູກຄ້າ',
    qzsxzyxywfw: 'ກາລຸນາເລືອກຂອບເຂດທາງທຸລະກໍາໜຶ່ງລາຍການ',
    qxzsqqx: 'ກາລຸນາເລືອກໄລຍະເວລາການນໍາໃຊ້ສິດ',
    huz: 'ພາສພອດ',
    qyxq: 'ລາຍລະອຽດວິສາຫະກິດ',
    ygl: 'ໄດ້ພົວພັນກັນ',
    yzz: 'ໄດ້ຢຸດຕິແລ້ວ',
    sjhgh: 'ປ່ຽນເບີໂທລະສັບ',
    yzmyfs: 'ສົ່ງລະຫັດຢືນຢັນແລ້ວ',
    dxssh: 'ກຳລັງລໍຖ້າການກວດສອບອອນໄລນ໌',
    dxxqr: 'ກຳລັງລໍຖ້າການກວດສອບອອບໄລນ໌',
    dyhxg: 'ລໍຖ້າການ​ດັດ​ແກ້​ໂດຍ​ຜູ້​ໃຊ້​',
    shwb: 'ສຳເລັດການກວດສອບແລ້ວ',
    dgx: 'ລໍຖ້າການອັບເດດ',
    yyq: 'ເກີນກຳນົດ',
    tsr: 'ຜູ້ຮ້ອງທຸກ',
    mmxgcg: 'ປ່ຽນລະຫັດຜ່ານສຳເລັດແລ້ວ, ກະລຸນາເຂົ້າສູ່ລະບົບອີກຄັ້ງ!',
    mrshxx: 'ຕັ້ງຄ່າຂໍ້ມູນການຮັບວັດສະດຸເລີ່ມຕົ້ນສຳເລັດແລ້ວ!',
    mrfhxx: 'ຂໍ້ມູນການຈັດສົ່ງເລີ່ມຕົ້ນຖືກຕັ້ງສຳເລັດແລ້ວ!',
    qgxyscdh: 'ກະລຸນາກວດເບິ່ງແຖວທີ່ທ່ານຕ້ອງການລຶບ',
    qtxjbrsjh: 'ກະລຸນາຕື່ມໃສ່ເບີໂທລະສັບມືຖືຂອງຜູ້ຮັບຜິດຊອບ',
    sjhghcg: 'ປ່ຽນເບີໂທລະສັບສຳເລັດແລ້ວ!',
    qxzglqx: 'ກະລຸນາເລືອກໄລຍະເວລາຂອງຕິດຕໍ່',
    qsrjbrxm: 'ກະລຸນາໃສ່ຊື່ຂອງບຸກຄົນທີ່ຮັບຜິດຊອບ',
    xxshzt: 'ສະຖານະການກວດສອບຂໍ້ມູນ',
    qsrysmm: 'ກະລຸນາໃສ່ລະຫັດຜ່ານເກົ່າ',
    qqrdlmm: 'ກະລຸນາຢືນຢັນລະຫັດຜ່ານເຂົ້າສູ່ລະບົບ',
    jmmcw: 'ລະຫັດຜ່ານເກົ່າຜິດ',
    jxxz: 'ສືບຕໍ່ເພີ່ມຈໍານວນ',
    tcbj: 'ອອກຈາກການແກ້ໄຂ',
    gxqr: 'ຢືນຢັນຄວາມກ່ຽວພັນກັນ',
    qyqz: 'ລາຍເຊັນຂອງບໍລິສັດ',
    jqsdsjgl: 'ການຄຸ້ມຄອງພະນັກງານຂັບລົດຮັບສົ່ງສິນຄ້າ',
    qzlx: 'ປະເພດລາຍເຊັນ',
    qztsy: 'ລາຍເຊັນແລະກາຈໍ້າ ກໍາລັງຢູ່ໃນຂັ້ນຕອນລໍຖ້າການອະນຸມັດ, ການອັບໂຫຼດລາຍເຊັນແລະກາຈໍ້າໃໝ່ນັ້ນແມ່ນຍັງບໍ່ສາມາດດໍາເນີນທຸລະກໍາໄດ້ຊົ່ວຄາວ/ການກວດສອບຍັງບໍ່ຜ່ານ, ກະລຸນາອັບໂຫຼດລາຍເຊັນແລະກາຈໍ້າໃໝ່ອີກຄັ້ງ',
    qztsyShz: 'ລາຍເຊັນແລະກາຈໍ້າ ກໍາລັງຢູ່ໃນຂັ້ນຕອນລໍຖ້າການອະນຸມັດ, ການອັບໂຫຼດລາຍເຊັນແລະກາຈໍ້າໃໝ່ນັ້ນແມ່ນຍັງບໍ່ສາມາດດໍາເນີນທຸລະກໍາໄດ້ຊົ່ວຄາວ',
    qztsyWtg: 'ການກວດສອບຍັງບໍ່ຜ່ານ, ກະລຸນາອັບໂຫຼດລາຍເຊັນແລະກາຈໍ້າໃໝ່ອີກຄັ້ງ',
    cxsc: 'ອັບໂຫຼດໃໝ່ອີກຄັ້ງ',
    zwqzxx: 'ຍັງບໍ່ມີຂໍ້ມູນລາຍເຊັນແລະກາຈໍ້າເທື່ອ',
    ljsc: 'ອັບໂຫຼດຕອນນີ້',
    scqz: 'ອັບໂຫຼດລາຍເຊັນ',
    qscqztp: 'ກະລຸນາອັບໂຫຼດຮູບລາຍເຊັນ',
    qxzqzlx: 'ກະລຸນາເລືອກປະເພດລາຍເຊັນ',
    sjxm: 'ຊື່ຄົນຂັບລົດ',
    csrq: 'ວັນເດືອນປີເກີດ',
    zhuzhi: 'ທີ່ຢູ່ອາໄສ',
    jszzp: 'ໃບຂັບຂີ່',
    xzsjxx: 'ເພີ່ມພະນັກງານຂັບລົດໃໝ່',
    cksjxx: 'ກວດເບິ່ງຂໍ້ມູນພະນັກງານຂັບລົດ',
    bjsjxx: 'ແກ້ໄຂຂໍ້ມູນພະນັກງານຂັບລົດ',
    qsrsjxm: 'ກະລຸນາໃສ່ຊື່ຄົນຂັບລົດ',
    qsrzjhm: 'ກະລຸນາລະບຸເລກບັດ',
    gjqh: 'ລະຫັດໂທລະຫວ່າງປະເທດ',
    qsrgjqh: 'ໃສ່ລະຫັດໂທລະຫວ່າງປະເທດ',
    kchwh: 'ບໍາລຸງຮັກສາເລກລົດບັນທຸກ',
    hdzz: 'ບໍລິມາດນໍ້າໜັກມາດຖານ(t)',
    ztsy: 'ຢຸດນໍາໃຊ້ຊົ່ວຄາວ',
    trsy: 'ເລີ່ມນໍາໃຊ້ເປັນທາງການ',
    jk20: 'ລົດບັນທຸກ ຕູ້ຄອນເທນເນີ 20',
    jk40: 'ລົດບັນທຸກ ຕູ້ຄອນເທນເນີ 40',
    fjk: 'ລົດບັນທຸກທີ່ບໍ່ມີຕູ້ຄອນເທນເນີ',
  },
  transportConsultation: {
    fh: 'ກັບຄືນ',
    dqwz: 'ຕໍາແໜ່ງປັດຈຸບັນ',
    xq: 'ລະອຽດ',
    jgcx: 'ສອບຖາມລາຄາ',
    sy: 'ຫນ້າທໍາອິດ',
    tbjdxq: 'ການລາຍງານຄວາມຕ້ອງການຂັ້ນຕອນ',
    ywbllc: 'ຂະບວນການທຸລະກິດ',
    flfgjgfxwj: 'ກົດໝາຍ ແລະ ລະບຽບການ ແລະ ເອກະສານມາດຕະຖານ',
    fwcszhxx: 'ຂໍ້​ມູນ​ທີ່​ສົມ​ບູນ​ແບບ​ຂອງ​ສະ​ຖານ​ທີ່​ການ​ບໍ​ລິ​ການ',
    zxfw: 'ບໍລິການໃຫ້ຄໍາປຶກສາ',
    jmjm: 'ການປະມູນແລະການປະມູນ',
    clcs: 'ຕົວກໍານົດການຍານພາຫະນະ',
    gdyd: 'ຄໍາສັ່ງທີ່ຍັງຄ້າງຄວນຖືກສັ່ງ',
    hyblcjwt: 'ຄໍາຖາມທີ່ພົບເລື້ອຍກ່ຽວກັບການຈັດການກັບການຂົນສົ່ງ',
    gd: 'ເພີ່ມເຕີມ>',
    cc: 'ໄຂພວງ',
    tlzfsfxmhbz: 'ຄ່າບໍລິການທາງລົດໄຟ ແລະມາດຕະຖານອື່ນໆ',
    hwzzfjzflybjfv: 'ອັດຕາຄ່າທຳນຽມການຈັດການສິນຄ້າ ແລະ ອັດຕາປະກັນໄພ',
    hwyjl: 'ອັດຕາຄ່າຂົນສົ່ງສິນຄ້າ',
    yyzfwxxcx: 'ການສອບຖາມຂໍ້ມູນການບໍລິການຂອງສະຖານີບໍລິການ',
    yyzlstxzgg: 'ປະກາດໂຈະການຊົ່ວຄາວຂອງສະຖານີທຸລະກິດແລະການຕິດຕັ້ງຈໍາກັດ',
    gbjg: 'ເຜີຍແຜ່ຜົນໄດ້ຮັບ',
    qdht: 'ເຊັນສັນຍາ',
    zjjs: 'ການຊໍາລະເງິນທຶນ',
    jj: 'ປະມູນລາຄາ',
    fqxm: 'ລິເລີ່ມໂຄງການ',
    fqjyd: 'ເລີ່ມການສັ່ງຊື້ທຸລະກຳ',
    qdjyd: 'ກໍານົດຄໍາສັ່ງການເຮັດທຸລະກໍາ',
    dxjy: 'ການເຮັດທຸລະກໍາໂດຍກົງ',
    qryd: 'ຢືນຢັນຄໍາສັ່ງ',
    gxyd: 'ການສັ່ງຊື້ແລະການຂາຍ',
    gxgd: 'ຊື້ແລະຂາຍຄໍາສັ່ງທີ່ຍັງຄ້າງ',
    hwjf: 'ການຈັດສົ່ງສິນຄ້າ',
    hwzz: 'ການຕິດຕາມສິນຄ້າ',
    yfzf: 'ການຈ່າຍເງິນຄ່າຂົນສົ່ງ',
    tbrxq: 'ລາຍງານຄວາມຕ້ອງການປະຈໍາວັນ',
    ysfw: 'ບໍລິການການຂົນສົ່ງ',
    smjy: 'ການເຮັດທຸລະກໍາ'
  },
  legalDocument: {
    dqwz: 'ຕໍາແໜ່ງປັດຈຸບັນ',
    zxfw: 'ບໍລິການໃຫ້ຄໍາປຶກສາ',
    ffgjgfxwj: 'ກົດໝາຍ ແລະ ລະບຽບການ ແລະ ເອກະສານມາດຕະຖານ',
    xq: 'ລາຍລະອຽດ',
    xz: 'ເພີ່ມເຕີມ',
    fh: 'ກັບຄືນ',
    t: 'ບາ',
    y: 'ຫນ້າ'
  },
  stationinfo: {
    yyzlstxzgg: 'ປະກາດໂຈະການຊົ່ວຄາວຂອງສະຖານີທຸລະກິດແລະການຕິດຕັ້ງຈໍາກັດ',
    qsrfbdw: 'ກະລຸນາໃສ່ຫນ່ວຍພິມເຜີຍແຜ່',
    zyxsx: 'ຄຸນລັກສະນະເສັ້ນພິເສດ',
    fsplpm: 'ສົ່ງປະເພດ/ຊື່',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    qc: 'ຊື່ເຕັມ',
    qznl: 'ຄວາມອາດສາມາດຍົກ',
    bt: 'ຊື່',
    fz: 'ສົ່ງສະຖານີ',
    fwcszhxx: 'ຂໍ້​ມູນ​ທີ່​ສົມ​ບູນ​ແບບ​ຂອງ​ສະ​ຖານ​ທີ່​ການ​ບໍ​ລິ​ການ​',
    qxzs: 'ກະລຸນາເລືອກແຂວງໃດນຶ່ງ',
    dz: 'ສະຖານີປາຍທາງ',
    yyzfwxx: 'ຂໍ້ມູນການບໍລິການສະຖານີທຸລະກິດ',
    yyz: 'ສະຖານີທຸລະກິດ:',
    shdw: 'ໜ່ວຍຮັບ',
    cc: 'ລົດຍົກ',
    qxzyyz: 'ກະລຸນາເລືອກສະຖານີທຸລະກິດ',
    fbdw: 'ໜ່ວຍພິມຈຳໜ່າຍ:',
    ddplpm: 'ປະເພດມາຮອດ/ຊື່',
    qxzq: 'ກະລຸນາເລືອກພື້ນທີ່',
    tzsj: 'ເວລາຢຸດເຮັດວຽກ',
    tzlyj: 'ເຫດຜົນສໍາລັບການຢຸດການຕິດຕັ້ງ',
    yyzfwxxcx: 'ການສອບຖາມຂໍ້ມູນການບໍລິການຂອງສະຖານີບໍລິການ',
    s: 'ແຂວງ:',
    shi: 'ນະຄອນ',
    cx: 'ສອບຖາມ',
    zxfw: 'ບໍລິການໃຫ້ຄໍາປຶກສາ',
    xq: 'ຄາວຕີ້ (ເມືອງ):',
    fbsj: 'ເວລາເຜີຍແຜ່:',
    pm: 'ຊື່ສິນຄ້າ',
    fh: 'ກັບຄືນ',
  },
  containerDayDemand: {
    crumbs0: 'ຕົວໄປ',
    crumbs1: 'ການຕ້ອງຄວາມຕ້ອງການທີ່ປະຈຸບັນ',
    tbrq: 'ວັນທີ່ຂຽນຟອມ',
    kssj: 'ເລີ້ມໂປຣເເກຣມ',
    jsrq: 'ວັນທີ່ສິ້ນສຸດ',
    jssj: 'ວັນທີ່ສິ້ນສຸດ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    srdmhmcjzcx: 'ປ້ອນເລກໂຕເລກຫລື ຊື່ເພື່ອຫາຈົ້າຖືກຕິດຕັ້ງ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    ydh: 'ບັນທຶກໄຟລ໌',
    ydxqh: 'ກໍລະນີສິດລົງ ບໍ່ໄດ້',
    shouhr: 'ທົ່ວໄປ',
    shouhf: 'ປ້າຍໄປທີ່ ',
    tuoyf: 'ສະຖານີຕົ້ນທາງ',
    daoz: 'ສະຖານີປາຍທາງ',
    qsr: 'ຂໍ້ມູນຍົກເລີກການຜູກມັດທີ່ເລືອກ',
    chax: 'ຄົ້ນຫາ',
    qink: 'ລົບຂໍ້ມູນທັງໝົດ',
    xuhao: 'ລໍາດັບ',
    ydztbm: 'ໂປຣເເກຣມສະຖານະການຖ້າ',
    ydlxbm: 'ໂປຣເເກຣມຫລືໂຕເລກ',
    ysfsbm: 'ໂປຣເຊດຍ່າຍໃສ່',
    ysfs: 'ຮູບແບບການຂົນສົ່ງ',
    wxpbsbm: 'ໂຕເລກໂຕເລກລະຫັດຜ່ອນເສກີດ',
    yxpbz: 'ໂປຣເເກຣມທົວຈິດກ່ຽວກັບ',
    zyrq: 'ວັນທີ່ຂົນສົ່ງ',
    xqtcfs: 'ວິທີແຈ້ງແຜນຄວາມຕ້ອງການ',
    jdxqh: 'ເລກຄວາມຕ້ອງການປະຈຳເດືອນ',
    rxqzt: 'ສະຖານະຄວາມຕ້ອງການປະຈຳວັນ',
    pinm: 'ຊື່ຜູ້ຜະລິດຕະພັນ',
    zdaoz: 'ໂປຣເເກຣມເຄື່ອງມືອງ',
    daoj: 'ເຫລວດ້ວຍ',
    ssqymc: 'ຂື້ນກັບບໍລິສັດ',
    xianh: 'ເລກຕູ້',
    biaoz: 'ຮູບພາບ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    tcrxq: 'ແຈ້ງແຜນປະຈຳວັນ',
    ydcx: 'ໂປຣເເກຣມຫລືໂຕເລກ',
    yun: 'ສົງອອກສິນຄ້າ',
    ydxx: 'ຂໍ້ມູນທີ່ກ່ຽວກັບ',
    hpiaoh: 'ໂຕອັກສອນໂຟລ໌ບໍ່',
    ssqy: 'ຂື້ນກັບບໍລິສັດ',
    tbqy: 'ບໍລິສັດ ທີ່ແຈ້ງເຕືອນ',
    tyrjzsx: 'ໂຕກຕ່າງໆທີ່ຖ່າຍພາສີກ',
    cyrjzsx: 'ໂຕກຕ່າງໆທີ່ຖືກສ້າງຂໍ້ຜ່ອນຈັກ',
    ding: 'ຂ່າວ',
    dcxx: 'ກຳລັງຕັ້ງຄ່າຂໍ້ມູນກ່ຽວກັບ',
    ydcs: 'ໂຕເລກລ່ານໂຮງງານຕ່ອງ',
    dcfs: 'ວ່າຖ້າຮ່ວມກັນພັດທະນາ',
    checi: 'ໂຕເລກໂຮງ',
    yuyueh: 'ຂໍ້ມູນ ຕັ້ງ ບໍ່ມີ',
    dczt: 'Subscription status',
    zcrq: 'ໂຕເອີ້ນລະບົບ',
    huo: 'ສຸດ',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    xianx: 'ຂະໜາດຕູ້',
    xianl: 'ຊະນິດຕູ້',
    kongz: 'ເປົ່າ/ໜັກ',
    shifh: 'ເລກຫັຍງຈັກຢ່າງຢູ່ໃນລົດຂົນສົ່ງ',
    hwmc: 'ຊື່ສິນຄ້າ',
    hwpm: 'ສິນຄ້າ',
    hwjg: 'ຄ່າຈຳນວຍຄວາມສະດວກ',
    tyrtbzl: 'ຫນ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    cyrqdzl: 'ພົວເຕີນຊ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    wu: 'ບັນຫາ',
    wulxx: 'ຂໍ້ມູນລົບ',
    wl_mdz: 'ຄະນິດສາດ-ຂົນສົງສີນຄ້າກັບມາເຂົ້າສາຖານີ',
    lxrxm: 'ຊື່ຄົນຕິດຕໍ່',
    dianh: 'ໂທລະໂທ',
    qhdz: 'ກະລຸນາໃສ່ບັນທຶກ',
    lic: 'ໄລຍະທາງ',
    xqsm: 'ຄວາມຕ້ອງການ ຄຳບັນຍາຍ',
    qtsm: 'ຂໍ້ມູນອື່ນໆ',
    guanb: 'ປິດ',
    xzjdxqh: 'ບໍ່ມີຄວາມຕ້ອງການຂອງຂະແໜງຮູບແບບ',
    qsrjdxqh: 'ກະລຸນາໃສ່ແລກໂຕເລກທີ່ຕ້ອງການ',
    yslx: 'ຮູບແບບການຂົນສົ່ງ',
    gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',
    ptys: 'ຂົນສົ່ງທົ່ວໄປ',
    ches: 'ໂຕເລກໂທ',
    slcs: 'ວ່າຈຳນວຍຄວາມສະດວກຜູ້ໃຊ້',
    caoz: 'ການດຳເນີນການ',
    xz: 'ໂຕເລືອກ'
  },
  containerCartonNo: {
    ddxx: "ຂໍ້ມູນການສັ່ງຈອງ",
    crumbs0: 'ຕົວໄປ',
    crumbs1: 'ເຄື່ອງມືນຳໃຊ້ບໍ່ໄດ້',
    tbrq: 'ວັນທີ່ຂຽນຟອມ',
    to: 'to',
    ydxqh: 'ກໍລະນີສິດລົງ ບໍ່ໄດ້',
    yundh: 'ບັນທຶກໄຟລ໌',
    xianx: 'ຂະໜາດຕູ້',
    qxr: 'ກະລຸນາເລືອກ',
    xianl: 'ຊະນິດຕູ້',
    xianh: 'ເລກຕູ້',
    chax: 'ຄົ້ນຫາ',
    qink: 'ລົບຂໍ້ມູນທັງໝົດ',
    xuhao: 'ລໍາດັບ',
    ydId: 'ບັນທຶກໄຟລ໌(ພື້ນຖານ)',
    rxqh: 'ເລກຄວາມຕ້ອງການປະຈຳວັນ',
    xh1: 'ຂໍ້ມູນທີ່ບໍ່ແມ່ນ1',
    xh2: 'ຂໍ້ມູນທີ່ບໍ່ແມ່ນ2',
    ydzztbm: 'ໂປຣເເກຣມສະຖານະການຖ້າ',
    ydzt: 'ສະຖານະໃບບີນ',
    rxqzt: 'ສະຖານະຄວາມຕ້ອງການປະຈຳວັນ',
    ydlxbm: 'ໂປຣເເກຣມຫລືໂຕເລກ',
    ydlx: 'ປະເພດໃບບິນ',
    ysfsbm: 'ໂປຣເຊດຍ່າຍໃສ່',
    ysfs: 'ຮູບແບບການຂົນສົ່ງ',
    wxpbsbm: 'ໂຕເລກໂຕເລກລະຫັດຜ່ອນເສກີດ',
    wxpbs: 'ຮູ້ຈັດການຄ້າທີ່ມີບັນຫາ',
    tjrq: 'ວັນທີ ຍື່ນສະເໜີ',
    danx: 'ໂຕເລືອກທົ່ວໄປ',
    xianshu: 'ປະເພດຕູ້ຄອນເທັນເນີ',
    shi: 'ນະຄອນ',
    sfwz: 'ເປັນມາດຕະຖານ',
    sfdx: 'ໂຕເລືອກທົ່ວໄປ ຫລືບໍ່ໄດ້',
    sfzp: 'ກຳລັງຈະຖືກຮ້ອງຂໍ ໂຕເລືອກ',
    tbkhm: 'ຊື່ຂອງຜູ້ຈັກໃສ່ແຫ້ວ',
    sskhmc: 'ຊື່ຄ່າສ່ວນຕົວ',
    ssqy: 'ຂື້ນກັບບໍລິສັດ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    daoz: 'ສະຖານີປາຍທາງ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    shr: 'ທົ່ວໄປ',
    tbqymc: 'ຊື່ຂອງ ບໍລິສັນຍາ',
    tibqy: 'ສໍລະນີກ່ຽວກັບ',
    yyh: 'ເລກສັ່ງຈອງ',
    zysj: 'ການດຳເນີນການຕັ້ງ',
    hwjs: 'ຈຳນວນສິນຄ້າ',
    caoz: 'ການດຳເນີນການ',
    ydcx: 'ໂປຣເເກຣມຫລືໂຕເລກ',
    butxh: 'ເຄື່ອງມືນຳໃຊ້ບໍ່ໄດ້',
    yun: 'ສົງອອກສິນຄ້າ',
    ydxx: 'ຂໍ້ມູນທີ່ກ່ຽວກັບ',
    zzjgcl: 'ວັດສະດຸເພີ່ມຄວາມແໜ້ນໜາໃຫ້ສິນຄ້າ',
    canchu: 'ບັນທຶກໄຟລ໌',
    lcbw: 'ເກັບຮ້ອນໄວ້ທີ່ (ລວມທັງໂຮງ)',
    bxys: 'ປົນສຸດງອອກສິນຄ້າ',
    hph: 'ເລກໃບບິນ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    tyrjzsx: 'ໂຕກຕ່າງໆທີ່ຖ່າຍພາສີກ',
    cyrjzsx: 'ໂຕກຕ່າງໆທີ່ຖືກສ້າງຂໍ້ຜ່ອນຈັກ',
    ding: 'ຂ່າວ',
    dingcxx: 'ກຳລັງຕັ້ງຄ່າຂໍ້ມູນກ່ຽວກັບ',
    ydcs: 'ໂຕເລກລ່ານໂຮງງານຕ່ອງ',
    dcfs: 'ວ່າຖ້າຮ່ວມກັນພັດທະນາ',
    chec: 'ໂຕເລກໂຮງ',
    dczt: 'Subscription status',
    zcrq: 'ໂຕເອີ້ນລະບົບ',
    huo: 'ສຸດ',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    kongz: 'ເປົ່າ/ໜັກ',
    sfh: 'ເລກຫັຍງຈັກຢ່າງຢູ່ໃນລົດຂົນສົ່ງ',
    hwmc: 'ຊື່ສິນຄ້າ',
    hwjg: 'ຄ່າຈຳນວຍຄວາມສະດວກ',
    tyrtbzl: 'ຫນ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    cyrqdzl: 'ພົວເຕີນຊ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    qsrjdxqh: 'ກະລຸນາໃສ່ແລກໂຕເລກທີ່ຕ້ອງການ',
    guanb: 'ປິດ',
    btyd: 'ຕິດຕັ້ງຄຳສັ່ງ',
    ke: 'ຜູ້passຄື່ອນໄຫວ',
    kehxx: 'ຂໍ້ມູນທີ່ເປັນປະໂຫຍດກ່ຽວກັບ',
    fa: 'ສົ່ງ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    faj: 'ໂປຣເເກຣມຫ້ອງການການພັດທະນາ',
    tlhc: 'ລານສີນຄ້າທາງລົດໄຟ',
    yddh: 'ໂປຣເເກຣມໂປຣເເກຣມ',
    txdz: 'ທີ່ຢູ່',
    jbr: 'ຄົນດຳເນີນການ',
    sfzh: 'ເລກໂຕເລກ',
    lxrxm: 'ຊື່ຄົນຕິດຕໍ່',
    dianh: 'ໂທລະໂທ',
    dzyd: 'ໂຮງງານໄຟຟ້າ',
    xzdzyd: 'ໂຕເລືອກ້ານໂຕເລືອກ ທີ່ໂຕເລືອກ, ແລະ ໂຕເລືອກ້ານກ່ຽວກັບ ບ ບໍ່ຕ້ອງຖືກຕ້ອງ, ໂດຍສະເພາະ ການອະນຸລັບປຸງດ້ວຍສຸດ',
    yjxmh: 'ບໍ່ມີເເບບໃດ້',
    jtxcd: 'ຂໍ້ມູນທີ່ກ່ຽວຂ້ອງພາຍໃສ່',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    zhi: 'ຂດຂໍ້ມູນ',
    zfsz: 'ຕັ້ງຄ່າຈ່າຍລະອຽງ',
    zffs: 'ວິທີຈ່າຍເງີນ',
    yfk: 'ບັນຊີຊຳລະເງີນລວ່ງໜ້າ',
    xianjin: 'ເງີນສົດ',
    zhip: 'ກວດດ້ອບ',
    yhk: 'ຊ່ວແລກ໌',
    hzzf: 'ສຳຮອງຄວາມຈຳນວຍຄວາມສະດວກ',
    bizxz: 'ເລືອກປະເພດເງີນ',
    jipu: 'ກີບ',
    rmb: 'ຢວນ',
    myuan: 'ໂດລາ',
    pinl: 'ປະເພດສິນຄ້',
    cpchx: 'ຍ້າຍໄປທີ່ີໂຕເລືອກ',
    tyrtbzlqk: 'ຈູງລວມກັບຜູ້ສ້າງພາຍໂດຍ (kg)',
    jiage: 'ຄົນງ (ກູນ)',
    liang: 'two',
    ldwl: 'ການຂົນສົງລະຫວ່າງສະຖານີຕົ້ນທາງກັບປາຍທາງ',
    msg1: 'ອີງຕັ້ງຕ້ອງການທ່ານ,ເລືອກສະຖານີຕົ້ນທາງກັບປາຍທາງໃນການໄປຮັບ-ສົງ,ສາງແລະບໍລິການຂົນສົງອື່ນໆ',
    mdz: 'ຂົນສົງສີນຄ້າກັບມາເຂົ້າສາຖານີ',
    smqh: 'ກຳລັງອອກຈາກການຄົ້ນ.',
    zdm: 'ຂົນສົງສີນຄ້າຈາກສາຖານີໄປສົງ',
    qhdz: 'ກະລຸນາໃສ່ບັນທຶກ',
    qianmi: 'ພື້ນີ້',
    licheng: 'ໄລຍະທາງ(km)',
    tyrqdjs: 'ຜູ້ຂົນສົງສີນຄ້າຢືນຢັນຈຳນວນ',
    xuqsm: 'ຄວາມຕ້ອງການ ຄຳບັນຍາຍ',
    qhgsfy: 'ຄ່າໃຊ້ຈ່າຍໃນການໄປຮັບ-ສົງ',
    smsh: 'ຫນ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    shdz: 'ບັດຳເນີນການສົ່ງອອກ',
    tijiao: 'ສົ່ງອອກ',
    cywlxx: 'ຂໍ້ມູນໂລຈິດສະຕິກທີ່ນໍາໃຊ້ທົ່ວໄປ'
  },
  containerInvoice: {
    fkxx:"ຂໍ້ມູນບັນຊີຊຳລະເງີນລວ່ງໜ້າ",
    zyjs: 'ບັນທຶກອິດສະລະ ',
    crumbs0: 'ຕົວໄປ',
    crumbs1: 'ເຂົ້າຮ່ວມກັນພິມດ',
    ke: 'ຜູ້passຄື່ອນໄຫວ',
    kehxx: 'ຂໍ້ມູນທີ່ເປັນປະໂຫຍດກ່ຽວກັບ',
    ssqy: 'ຂື້ນກັບບໍລິສັດ',
    fa: 'ສົ່ງ',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    faj: 'ໂປຣເເກຣມຫ້ອງການການພັດທະນາ',
    qsr: 'ຂໍ້ມູນຍົກເລີກການຜູກມັດທີ່ເລືອກ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    qxz: 'ກະລຸນາເລືອກ',
    txdz: 'ທີ່ຢູ່',
    jbr: 'ຄົນດຳເນີນການ',
    sfzh: 'ເລກໂຕເລກ',
    jbrsj: 'ເບີໂທຜູ້ດຳເນີນການ',
    sou: 'ຕົວໄປ',
    shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',
    daoz: 'ສະຖານີປາຍທາງ',
    shr: 'ທົ່ວໄປ',
    zdaoz: 'ໂປຣເເກຣມເຄື່ອງມືອງ',
    daoj: 'ເຫລວດ້ວຍ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    bllx: 'ຮູບແບບການນຳ້',
    blcc: 'ໂຕເລກໂຮງ',
    zobl: 'ຈີນສຸງ ເອີຣົບ',
    zybl: 'ໂຮງຮຽນີອາຊີໃຕ້ດິນ',
    yun: 'ສົງອອກສິນຄ້າ',
    ysxx: 'ຂໍ້ມູນທີ່ກ່ຽວກັບ',
    zzjgcl: 'ວັດສະດຸເພີ່ມຄວາມແໜ້ນໜາໃຫ້ສິນຄ້າ',
    canchu: 'ບັນທຶກໄຟລ໌',
    lcbw: 'ເກັບຮ້ອນໄວ້ທີ່ (ລວມທັງໂຮງ)',
    plky: 'ແກ້ງຂໍ້ມູນເກົ່າ',
    bxys: 'ປົນສຸດງອອກສິນຄ້າ',
    jtxcd: 'ຂໍ້ມູນທີ່ກ່ຽວຂ້ອງພາຍໃສ່',
    jzsx: 'ລາຍການທີ່ບັນທຶກ',
    zhi: 'ຂດຂໍ້ມູນ',
    zfsz: 'ຕັ້ງຄ່າຈ່າຍລະອຽງ',
    zffs: 'ວິທີຈ່າຍເງີນ',
    yfk: 'ບັນຊີຊຳລະເງີນລວ່ງໜ້າ',
    xianjin: 'ເງີນສົດ',
    zhip: 'ກວດດ້ອບ',
    yhk: 'ຊ່ວແລກ໌',
    hzzf: 'ສຳຮອງຄວາມຈຳນວຍຄວາມສະດວກ',
    bizxz: 'ເລືອກປະເພດເງີນ',
    jipu: 'ກີບ',
    rmb: 'ຢວນ',
    myuan: 'ໂດລາ',
    huo: 'ສຸດ',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    dxyd: 'ເຂົ້າຮ່ວມອັກສອນໂປຣເເກຣມທົວໄປ',
    plzjxs: 'ເພີ່ມຈຳນວນຕູ້ເປັນຊຸດ',
    xzh: 'ເພີ່ມແຖວໃໝ່',
    sch: 'ລົບແຖວ',
    xuhao: 'ລໍາດັບ',
    xzhwmc: 'ເລືອກຊື່ຄ່າ',
    pinl: 'recursive',
    twbh: 'ຄວາມຮ້ອນໃຕ້ບໍ່',
    xianh: 'ເລກຕູ້',
    qsrxh: 'ກະລຸນາໃສ່ຊື່ເລກໂຕເລກໂຕເລກ',
    xianshu: 'ປະເພດຕູ້ຄອນເທັນເນີ',
    tielux: 'ຕູ້ທາງລົດໄຟ',
    zibeix: 'ຕູສວ່ນບຸກຄົນ',
    xianx: 'ຂະໜາດຕູ້',
    xianl: 'ຊະນິດຕູ້',
    kongz: 'ເປົ່າ/ໜັກ',
    kong: '(ລົບຂໍ້ມູນທັງໝົດ)',
    zhong: 'ມີຄວາມຫຍັງ',
    baozhuan: 'ແພັກເກດ',
    cpchx: 'ຍ້າຍໄປທີ່ີໂຕເລືອກ',
    tielcdx: 'ເຄື່ອງມືອ້າງປະກອນກ່ຽວກັບ',
    tezx: 'ຂໍ້ມູນທີ່ຈົງ',
    cquch: 'ຍ່າຍໄປທີ່ແລະຖືກໄປທີ່',
    xiasch: 'ຮ້ອງໃຊ້ຄືນຄ່າສະເພາະ',
    sfh: 'ເລກຫັຍງຈັກຢ່າງຢູ່ໃນລົດຂົນສົ່ງ',
    zhognlqk: 'ນ້ຳໜັກ(kg)',
    jiage: 'ຄົນງ (ກູນ)',
    msg1: '*ລາຍລະອຽດສີນຄ້າ:ຖ້າວ່າໃນຈຸດຊື່ສີ້ນຄ້າຊອກບໍ່ເຫັນ,ແມ່ນສາມາດຂຽນຊື່ສີນຄ້າໃສ່,ແລ້ວເລືອກທີ່ປະເພດທີ່ຖືກກັບສີ້ນຄ້າ.ຖ້ານຳໃຊ້ຕູ້ສວນບຸກຄົນ ຖ້າໃນຕູ້ບໍ່ມີສີນຄ້າ,ຊື່ສີນຄ້າແມ່ນໃຫ້ເລືອກຕູ້ສວນບຸກຄົນ（ຫຼືຕູຄອນເທັນເນີ）',
    msg2: 'ຖ້າໃສ່ຊື່ສີ້ນຄ້າປະເພດອື່ນ（ເຊັ່ນ:ຕູເປົ່າ,ຕູ້ເປົ່າສວນບຸກຄົນແລະອື່ນໆ）ລະບົບຊິຄິດໄລ່ເປັນຕູ້ໜັກ.',
    ri: 'ວັນນີ້',
    rysxq: 'ແຜນຂົນສົ່ງປະຈຳວັນ',
    zyrq: 'ວັນທີ່ຂົນສົ່ງ',
    xzrq: 'ກະລຸນາເລືອກວັນທີ່',
    xqtcfs: 'ວິທີແຈ້ງແຜນຄວາມຕ້ອງການ',
    zjtcrxq: 'ການຕ້ອງການຂອງປະຈຸບັນ',
    syjdxq: 'ໃຊ້ຄວາມຕ້ອງການຂອງຂະບວນການຍ່າງທຳ',
    jdxqh: 'ເລກຄວາມຕ້ອງການປະຈຳເດືອນ',
    qsrjdxqh: 'ກະລຸນາໃສ່ແລກໂຕເລກທີ່ຕ້ອງການ',
    ches: 'ໂຕເລກໂທ',
    chec: 'ໂຕເລກໂຮງ',
    liang: 'ສອງສົ້ນ',
    ldwl: 'ການຂົນສົງລະຫວ່າງສະຖານີຕົ້ນທາງກັບປາຍທາງ',
    msg3: 'ອີງຕັ້ງຕ້ອງການທ່ານ,ເລືອກສະຖານີຕົ້ນທາງກັບປາຍທາງໃນການໄປຮັບ-ສົງ,ສາງແລະບໍລິການຂົນສົງອື່ນໆ',
    mdz: 'ຂົນສົງສີນຄ້າກັບມາເຂົ້າສາຖານີ',
    smqh: 'ກຳລັງອອກຈາກການຄົ້ນ.',
    zdm: 'ຂົນສົງສີນຄ້າຈາກສາຖານີໄປສົງ',
    lxrxm: 'ຊື່ຄົນຕິດຕໍ່',
    dianh: 'ໂທລະໂທ',
    qhdz: 'ກະລຸນາໃສ່ບັນທຶກ',
    qianmi: 'ພື້ນີ້',
    licheng: 'ໄລຍະທາງ(km)',
    tyrqdjs: 'ຜູ້ຂົນສົງສີນຄ້າຢືນຢັນຈຳນວນ',
    xuqsm: 'ຄວາມຕ້ອງການ ຄຳບັນຍາຍ',
    qhgsfy: 'ຄ່າໃຊ້ຈ່າຍໃນການໄປຮັບ-ສົງ',
    smsh: 'ຫນ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
    shdz: 'ບັດຳເນີນການສົ່ງອອກ',
    tijiao: 'ສົ່ງອອກ',
    qink: 'ລົບຂໍ້ມູນທັງໝົດ',
    chax: 'ຄົ້ນຫາ ',
    yslx: 'ຮູບແບບການຂົນສົ່ງ',
    tuoyf: 'ສະຖານີຕົ້ນທາງ',
    souhf: 'ປ້າຍໄປທີ່ ',
    hwpm: 'ສິນຄ້າ',
    slcs: 'ວ່າຈຳນວຍຄວາມສະດວກຜູ້ໃຊ້',
    caoz: 'ການດຳເນີນການ',
    xuanzhe: 'ໂຕເລືອກ',
    xzjdxqh: 'ບໍ່ມີຄວາມຕ້ອງການຂອງຂະແໜງຮູບແບບ',
    hwmc: 'ຊື່ສິນຄ້າ',
    fhrxx: 'ຂໍ້ມູນຜູ້ຈັດສົ່ງສິນຄ້າ',
    zjh: 'ເລກບັດ',
    jbrsjh: 'ເບີໂທລະສັບມືຖືຂອງຜູ້ປະສານງານ',
    zzzmwj: 'ເອກະສານຢັ້ງຢືນ',
    bzjs: 'ໝາຍເຫດຕາມມາດຕະຖານ',
    zmwjmc: 'ຊື່ບັດ',
    hm: 'ເບີໝາຍເລກ',
    fj: 'ໄຟລ໌ແນບ',
    shrxx: 'ຂໍ້ມູນຜູ້ຮັບເຄື່ອງ',
    fkxx1: 'ຂໍ້ມູນບັນຊີຊຳລະເງີນລວ່ງໜ້າ',
    fkr: 'ຜູ້ຈ່າຍເງິນ',
    dxys: 'ຂົນສົ່ງຕູ້ຄອນເທນເນີດຽວ',
    ldwlts: 'ທ່ານສາມາດເລືອກປ້ອນຂໍ້ມູນບໍລິການໂລຈິດສະຕິກການຈັດສົ່ງ,ການຮັບ ແລະການຈັດສົ່ງຕາມຄວາມຕ້ອງການຂອງທ່ານໄດ້',
    xqsm: 'ຊີ້ແຈງຄວາມຕ້ອງການ',
    lc: 'ໄລຍະທາງ',
    dh: 'ເບີໂທ',
    qk: 'ລົບຂໍ້ມູນທັງໝົດ',
    tj: 'ຢືນຢັນ',
    jdxq: 'ຄວາມຕ້ອງການເປັນໄລຍະ',
    realHzmc: 'ເຈົ້າຂອງສິນຄ້າ',
    xj: 'ເງີນສົດ',
    wlgs: 'ບໍລິສັດຂົນສົ່ງ'
  },
  pathAnalysis: {
    crumbs0: 'ບໍ່ລິການ ກ່ຽວກັບການປ່ຽນແປງ',
    crumbs1: 'Transportation scheme selection',
    kaishi: 'ເລີ່ມຕົ້ນ',
    jiesu: 'ສຸດທ້າຍ',
    zss: 'ບັນທຶກໄຟລ໌',
    zsq: 'ເສດຖະກິດທີ່ໃຫຍ່ທີ່ສຸດ',
    huafei: 'ຂາດ້ວຍຄວາມຈຳ',
    haoshiyue: 'ມັນຮ້ອງກ່ຽວກັບ',
  },
  industryInfo: {
    fbsj: 'ເວລາຍື່ນແຈ້ງ',
    xzsj: 'ກະລຸນາເລືອກວັນທີ່',
    bt_nr: 'ຄຳແປ / ປະກອບໄປດ້ວຍ',
    chax: 'ຄົ້ນຫາ ',
    qink: 'ລົບຂໍ້ມູນທັງໝົດ',
    smjy: 'ການຄ້າສາກັດການຄ້າ',
    hyzx: 'ຂໍ້ມູນລະຫວ່າດ້ວຍສັງຄົມ',
    sy: 'ບ້ານເຄື່ອນໄຫວ',
    tzgg: 'ຂໍ້ມູນເພີ້ມຕັ້ງ',
    tlxw: 'ຂ່າວເຄເບີ້ນພັດທະນາ',
    dsly: 'ໂຮງງານໄຟຟ້າທີ່ມີການສົນສົງ',
    fh: 'ກັບຄືນ',
  },
  newsDetail: {
    sy: 'ບ້ານເຄື່ອນໄຫວ',
    smjy: 'ການຄ້າສາກັດການຄ້າ',
    hyzx: 'ຂໍ້ມູນລະຫວ່າດ້ວຍສັງຄົມ',
    tzgg: 'ຂໍ້ມູນເພີ້ມຕັ້ງ',
    tlxw: 'ຂ່າວເຄເບີ້ນພັດທະນາ',
    dsly: 'ໂຮງງານໄຟຟ້າທີ່ມີການສົນສົງ',
    hyzx2: 'ຂໍ້ມູນລະຫວ່າດ້ວຍສັງຄົມ',
    xq: 'ຂໍ້ມູນລາຍລະອຽດ',
    xz: 'ເພີ່ມເຕີມ',
    fh: 'ກັບຄືນ'
  },
  index_page: {
    ysxq: 'ຄວາມຕ້ອງການຂອງສົ່ງອອກ',
    zhenc: 'ການຂົນສົງໂດຍລົດໄຟ',
    jzx: 'ຕົວໄປ',
    guolian: 'ລົງກອນີກລົບ',
    yfcx: 'ກວດສອບຄ່າຂົນສົ່ງ',
    qsrcfz: 'ກະລຸນາເລືອກສະຖານີຕົ້ນທາງ',
    qsrddz: 'ກະລຸນາໃສ່ບັນກະລຸນາໃສ່',
    qsrds: 'ກະລຸນາໃສ່ວຍຄວາມຈຳ',
    chax: 'ຄົ້ນຫາ ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    daoz: 'ສະຖານີປາຍທາງ',
    duns: 'ຈຳນວນໂຕນ',
    yunf: 'ແວຣ໌',
    yuan: 'ຂໍ້ມູນເພີ້ມ',
    qued: 'ເພີ່ມເຕີມ',
    hwzz: 'ການຕິດຕາມສີ້ນຄ້າ',
    xqdh: 'ເລກຄວາມຕ້ອງການ',
    qsrxqdh: 'ກະລຸນາໃສ່ລາຍໃສ່ແພັກເກດ',
    ywjs: 'ການຕິດຕັ້ງທາງກົດລະບຽບທີ່ພົ້າກັນຂອງຈີນິລາ ໂອລິກາ',
    ysfw: 'ບໍລິການການຂົນສົ່ງ',
    ysfw_msg: 'ຈີນ ລາຊະອານາຈັກອັກທາງການຄ້າທີ່ເຊື່ອມຕໍ່ກັນຍັງເງື່ອໄຟຟ້າ, ປະເທດຈີນ, ແລະ ເລກໂຊນໂຊີດ, ປະເທດໂບລາຊະອານາຈັກອັນດ້ານສູງ 1,ສິນຄ້າ. ມັນຍັງເງື່ອໄຟຟ້າທີ່ມີຜ່ອນໄຟຟ້າ ແລະ 51 kg, ໂຮງງານໄຟຟ້າທີ່ມີຄວາມໄວຟ້າທີ່ມີສານເຕື່ອໄຟຟ້າທີ່ມີຄວາມໄວຂອງໂຮງງານໄຟຟ້າ, ສູງຂຶ້ນຈາກອນໄຟຟ້າທີ່ນໍາໃຊ້ເພື່ອໄຟຟ້າທີ່ສູງຂຶ້ນ ',
    jzx_msg: 'ການຕົວຈັດການຄ້າ ແມ່ນມີຂໍ້ໂຫຍດກ່ວນຫຼາຍທີ່ສຸດ, ເຊັ່ນ: ພາສີສຸລະກາກອນດ້ວຍສຸດ, ຄວາມກົດດ້ວຍສຸດ, ການປົກປ້ອງສິ່ງແວດລ້ອມທີ່ມີຂຶ້ນ, ສູນຄ່ ໃນປີ 1951, ຄວາມຕະຖານະຂອງຜູ້ຈັດການປ່ຽນແປງຂໍ້ມູນຳ້ທີ່ສຸດໃຈດ້ານການເມືອນໄຟຟ້າອາກາດໃຈດ້ານການເມືອນໄຟຟ້າອາກາດ ໄດ້ເຂົ້າຮ່ວມກັບພະລັງງານສົນທ ມີຫລາຍສິນຄ້າທີ່ສູງຂຶ້ນ 6%, ເຊິ່ງລາຊວນການພັດທະນາແບບຍ່າຍກວ່າທຳອິດຂອງຈີນ. ',
    gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',
    gjly_msg: 'ການກົນພັກທາງການຄ້າສາກົນ ຫມາຍເຖິງໂປຣເເກຣມສຳລັບຮ່ອນແກ້ວ ທີ່ໃຊ້ໂປຣເເກຣມທຳລັບສາກົນໃນລະຫວ່າງການຄ້າ, ການຕ່າງໆແມ່ນເປັນເຂົ້າຮ່ອນໃຕ້ດິນຟ້າອັງຫມົດຫາຍໃຈ ຫຼື ສົ່ງອອກປະເທດ, ແລະ ການຕ່າງໆຂອງລັດຖະບານຕ້ອງກັບຮ່ອນ ໂຮງຮຽກຮ້ອງໂຮງຮຽກຕ້າງປະເທດ ກ່ຽວກັບການແລກໂນໂລຢີຢ່າງປະເທດ ທີ່ມີຢູ່ໃຕ້ດິນນານ, ມີຄວນຈະເຂົ້າຮ່ວມຢູ່ໃຕ້ດິນນານ, ສູງລາໂຮງຮຽກຮ້ອງໃຫ້ປະເທດ ເອລິເວຍ ສະຖານທີ່ສູງຂຶ້ນ ແລະ ສົ່ງອອກສິນຄ້າຕ່າງໆ ທີ່ສູງຂຶ້ນ ',
    jqsd: 'ຫາຍໃຈ ແລະ ສົ່ງອອກ',
    jqsdqr: 'ການຢັ້ງຢືນຮັບສົ່ງສິນຄ້າເຖິງທີ່',
    jqsd_msg: 'ສໍາລັບການສົ່ງອອກສິນຄ້າອຸດ ຫຼື ຄວາມຮ່ອນໃຕ້ດິນຟ້າອຸດ ເພື່ອຕົວຈັດການຂົນສົ່ງອອກສິນຄ້າ ຫຼື ການຮ່ອນແກ້ງຂົນສົ່ງອອກສິນຄ້າ ຫຼື ການຮ່ອນແກ້ງຂົນສົ່ງອອກສິນຄ້າ ແລະ ການຮ່ອນແກ້ງຂົນສົ່ງອອກສິນຄ້າ ໃນສະຖານທີ່ໄດ້ຮັ ',
    bjbx: 'ລາຊະອານາຈັດກ່ອງ',
    bjbx_msg: 'ການກົ່ງອອກສິນຄ້າ ທີ່ປ້ອງກັນພັກທໍານຄ້າ ຫມາຍເຖິງການປະຕິບັດຕົວເສດຖະກິດ ທີ່ບໍລິສິນຄ້າ ທີ່ບໍລິສິນຄ້າ ໄດ້ຮັບຄ່າຂອງຜະລິດຕະພັບເຈົ້າ ແລະ ສິດທ ຈຸດເຈົ້າທຳອັນ ຫຼື ໂກຕ່າງໆທີ່ເຂົ້າຮ່ວມກັບການສົ່ງອອກສິນຄ້າຕ່າງໆ ທີ່ຈໍາລາຍສິນຄ້າທີ່ຖືກຕ້ອງກັນ ໃນລາຊະອານາຈັກອັນຄົມລາຊະອານາຈັກອັນທີ່ເປັນປະໂຫຍດກ່ຽວກັບສົນທີ່ເປັນປະໂຫຍດການຕະຫຼາດ, ຕາມ ທີ່ເປັນປະໂຫຍດກ່ຽວກັບຜົນທີ່ເປັນສະໂຫຍດກ ',
    tzgg: 'ຂໍ້ມູນເພີ້ມຕັ້ງ',
    tzgg_msg: 'ສຳລັບຜູ້ໃຊ້ປະເພດຕ່າງ · ຂຸດຜ່ອນຈຳ · ທົດສຳຕິດຕັ້ງ',
    gengduo: 'ຂໍ້ມູນເພີ້ມ',
    tlxw: 'ຂ່າວເຄເບີ້ນພັດທະນາ',
    tlxw_msg: 'ຂ້ອຍຮູ້ສິ່ງທີ່ເກີດຂໍ້ມູນ',
    hyzx: 'ຂໍ້ມູນລະຫວ່າດ້ວຍສັງຄົມ',
    hyzx_msg: 'ການຕິດຕັ້ງຂໍ້ມູນລຸ້ນສຸດທ້າຍໄປ',
    zltllt: 'ຈີນ ລວມ ກອງປະຊຸມສຸດຍອດ ລອນໄຟຟ້າ',
    jhwt: 'ວິທີດໜຶ່ງ (ຫຼາຍ)',
    hzhb: 'ຊື່ຄູ່ສົນທະນາ',
    bannertitle: " ແພລັດຟອມຄຸ້ມຄອງການຂົນສົ່ງລະຫວ່າງປະເທດ",
    zcwjgq: "ເອກະສານລົງທະບຽນໄດ້ໝົດອາຍຸແລ້ວ, ໜ້າຕາງປັດຈຸບັນບໍ່ສາມາດສົ່ງບົດລາຍງານໄດ້",
    zhysd: "您的账号已锁定，请联系公司进行处理！(ES)",
    yxqbzygyjsgx: "ເອກະສານຕໍ່ໄປນີ້ມີອາຍຸການນໍາໃຊ້ບໍ່ເຖິງ1ເດືອນ, ກະລຸນາຕໍ່ອາຍຸດ່ວນ",
    yxzjygq: "ເອກະສານຕໍ່ໄປນີ້ໄດ້ໝົດອາຍຸແລ້ວ, ກະລຸນາຕໍ່ອາຍຸດ່ວນ"
  },
  jsLang: {
    zg: 'ຈີນ',
    lw: 'ເເຣແກດ',
    tg: 'ປະເທດໄທ',
    zw: 'ຈິດເຊັ່ງ',
    ew: 'ພາສາເຄມີ',
    yw: 'ອັງກິດ'
  },
  hwydInfo: {
    xhsjy: 'ເວລາຂົນລົງ ເດືອນ-ວັນທີ--ໂມງມາຮອດ ໝາຍເລກໃບເກັບເງິນ',
    tzsjy: 'ເວລາແຈ້ງ ເດືອນ-ວັນທີ--ໂມງ ໝາຍເລກບັດປະຈຳຕົວຂອງຜູ້ຮັບສິນຄ້າ',
    yebzqq: 'ຍອດເງິນບໍ່ພຽງພໍ, ກະລຸນາເຕີມເງິນທີ່ອິນເຕີເຟສການຈັດການເງິນຝາກລ່ວງໜ້າ!',
    qqrxxw: 'ກະລຸນາຢືນຢັນວ່າຂໍ້ມູນແມ່ນຖືກຕ້ອງ, ທ່ານຈະສືບຕໍ່ຈ່າຍເງິນຫຼືບໍ?',
    yfkdyt: 'ໃບຢັ້ງຢືນຫັກເງິນທີ່ຈ່າຍລ່ວງໜ້າ (ການຄືນເງິນ) ',
    lkdwkh: 'ພວກສ່ວນຮັບເງິນເປີດບັນຊີ ແລະຮັບເງິນຄືນ',
    lkdwkh1: 'ໜ່ວຍງານຮັບເງິນເປີດບັນຊີເພື່ອຮັບເງິນຄືນ',
    czjjhr: 'ລາຍເຊັນແລະປະທັບຕາຂອງຜູ້ຮັບ (ມອບ)ສິນຄ້າຢູ່ສະຖານີ',
    lcsrmm: 'ລະຫັດຜ່ານທີ່ໃສ່ສອງເທື່ອບໍ່ກົງກັນ',
    zfcgcz: 'ຈ່າຍເງິນສຳເລັດ / ເຕີມເງິນສຳເລັດ',
    zfsbcz: 'ຈ່າຍເງິນລົ້ມເຫລວ / ເຕີມເງິນລົ້ມເຫລວ',
    qzsxzy3: 'ກະລຸນາເລືອກຢ່າງໜ້ອຍໜຶ່ງໃບບິນ',
    qhlckm: 'ໄລຍະທາງໄປຮັບສິນຄ້າ (km)',
    qxzyzf: 'ກະລຸນາເລືອກໃບບິນທີ່ຈ່າຍແລ້ວ',
    cyrqdzl: 'ນ້ໍາໜັກທີ່ກໍານົດຈາກຜູ້ບໍ່ລິການຂົນສົ່ງ',
    qsrtxj: 'ກະລຸນາຕື່ມຈໍານວນເງິນທີ່ຈະຖອນໃສ່',
    zyxmcd: 'ລະຫັດຊື່ເສັ້ນທາງສະເພາະ',
    zfzczz: 'ກໍາລັງຈ່າຍ / ເຕີມເງິນຢູ່',
    qsrymm: 'ກະລຸນາໃສ່ລະຫັດຜ່ານເດີມ',
    qsrxmm: 'ກະລຸນາໃສ່ລະຫັດຜ່ານປັດຈຸບັນ',
    gpjhwz: 'ໝາຍເລກໃບເກັບເງິນນີ້ຍັງບໍ່ທັນໄດ້ຈ່າຍເທື່ອ',
    gpjhyz: 'ໝາຍເລກໃບເກັບເງິນນີ້ໄດ້ຈ່າຍແລ້ວ',
    qqrsft: 'ກະລຸນາຢືນຢັນວ່າຈະຄືນເງິນຫຼືບໍ່',
    khhjzh: 'ທະນາຄານເປີດບັນຊີ ແລະ ເລກບັນຊີ',
    nsrsbh: 'ເລກທີປະຈໍາຕົວຜູ້ເສຍອາກອນ',
    zzdjcl: 'ວັດຖຸເພີ່ມຄວາມໝັ້ນຄົງໃນການບັນຈຸຂຶ້ນລົງ',
    crpzbh: 'ໝາຍເລກໃບຝາກ',
    crpzbhColon: 'ໝາຍເລກຢັ້ງຢືນການຝາກເງິນ',
    dyth: 'ຫັກເງິນ (ສົ່ງຄືນ)',
    yfkstj: 'ຂຽນຕື່ມໃສ່ໃນເວລາຈ່າຍເງິນລ່ວງໜ້າ',
    jyjcsb: 'ການກວດກາທຸລະກໍາລົ້ມເຫລວ',
    txshjj: 'ການກວດສອບການຖອນເງິນຖືກປະຕິເສດ',
    pjhbzq: 'ໝາຍເລກໃບເກັບເງິນບໍ່ຖືກຕ້ອງ',
    sfzhm: 'ເລກບັດປະຈຳຕົວ',
    spfmc: 'ຊື່ຜູ້ຮັບໃບບິນ',
    xqdh: 'ໝາຍເລກໃບສັ່ງຄວາມຕ້ອງການ',
    jey: 'ຍອດເງິນ (ຢວນ)',
    yfkdw: 'ໜ່ວຍງານຊໍາລະເງິນລ່ວງໜ້າ',
    skdwh: 'ໜ່ວຍງານຮັບເງິນແລະ',
    dyhth: ' ຫັກເງິນ ຫຼື ສົ່ງຄືນ',
    yxjzh: 'ທະນາຄານ ແລະ ເລກບັນຊີ',
    lqpzr: 'ຜູ້ຮັບເອົາໃບຢັ້ງຢືນ',
    jzxxx: 'ຮູບແບບຕູ້ຄອນເທັນເນີ  ',
    yyspj: 'ໃບບິນຂົນສົ່ງຕົ້ນສະບັບ',
    jzxxh1: 'ໝາຍເລກຕູ້ຄອນເທັນເນີ)',
    cyrjs: 'ບັນທຶກເຫດການຂອງຜູ້ຂົນສົ່ງ',
    tyrjs: 'ບົດລາຍງານຂອງຜູ້ຂົນສົງສີນຄ້າ',
    czrqc: 'ສະແຕມວັນທີສະຖານີ',
    shrqz: 'ລາຍເຊັນແລະປະທັບຕາຂອງຜູ້ຮັບສິນຄ້າ',
    yfkzf: 'ຈ່າຍເງິນຈ່າຍລ່ວງໜ້າ',
    yxkzf: 'ຈ່າຍດ້ວຍບັດທະນາຄານ',
    bczf: 'ຈ່າຍໃນຄັ້ງນີ້：',
    txshz: 'ການຖອນເງິນກໍາລັງກວດສອບຢູ່',
    yqxzf: 'ໄດ້ຍົກເລີກການຈ່າຍເງິນແລ້ວ',
    bjys: 'ຮັກສາລາຄາໃນການຂົນສົ່ງ',
    blzb: 'ປະເພດ ການຈັດການ',
    crumbs01: 'ໃບຂົນສົ່ງສິນຄ້າ',
    czcg: 'ການດໍາເນີນງານສໍາເລັດເເລ້ວ',
    czch: 'ໝາຍເລກ ແລະ ປະເພດລົດ',
    fplx: 'ປະເພດໃບບິນ ',
    fymx: 'ຄ່າໃຊຊໍາລະລະອຽດ',
    hwjg: 'ລາຄາສິນຄ້າ',
    hwmc: 'ຊື່ສິນຄ້າ',
    hwpm: 'ສິນຄ້າ',
    hwzl: 'ນ້ຳໜັກ ສິນຄ້າ',
    hzzf: 'ການຊໍາລະເງິນລວມ',
    lxdh: 'ເບີໂທຕິດຕໍ່',
    qhdd: 'ສະຖານທີໄປຮັບສີ້ນຮັບສີ້ນຄ້າ',
    shdd: 'ທີ່ຢູ່ທີ່ສົ່ງສິນຄ້າ',
    smqh: 'ເກັບເອົາສິນຄ້າຢູ່ບ້ານ',
    smsh: 'ສົ່ງສິນຄ້າຮອດບ້ານ',
    smxc: 'ບໍ່ລິການຂົນເຄື່ອງລົງຮອດບ້ານ',
    smzc: 'ບໍ່ລິການຂົນເຄື່ອງຂຶ້ນຮອດບ້ານ',
    wxts: 'ແຈ້ງເຕືອນ',
    yfzf: 'ຈ່າຍຄ່າຂົນສົ່ງ',
    zcrq: 'ວັນທີບັນຈຸໃສ່ລົດ',
    zffs: 'ວິທີຈ່າຍເງີນ',
    jjyy: 'ເຫດຜົນການປະຕິເສດ',
    bjpz: 'ແກ້ໄຂໃບຮັບຮອງ',
    lzgs: 'ບໍລິສັດ ລາວ-ຈີນ',
    skdw1: 'ໜ່ວຍງານຮັບເງິນ​',
    skdw1Colon: 'ໜ່ວຍງານຮັບເງິນ:',
    pjmc: 'ຊື່ໃບບິນ',
    dx: '(ຂຽນຕົວອັກສອນໃຫຍ່)',
    xjzf: 'ຊໍາລະໂດຍເງິນສົດ​',
    tkcg: 'ຄືນເງິນສຳເລັດເເລ້ວ',
    tksb: 'ຄືນເງິນລົ້ມເຫລວ',
    txcg: 'ຖອນເງິນສຳເລັດ',
    txsb: 'ຖອນເງິນລົ້ມເຫລວ',
    ptzc: 'ລົດເປັນຄັນທົ່ວໄປ',
    zlyz: 'ການດຳເນີນການໂດຍລໍ້ທີ່ຕົວເອງມີ',
    lshw: 'ສິນຄ້າທີ່ບໍ່ໄດ້ແພກຫໍ່',
    plhw: 'ສິນຄ້າເປັນຊຸດ',
    pmdm: 'ລະຫັດຊື່ສິນຄ້າ',
    fffs: 'ວິທີຈ່າຍເງິນ',
    lhfs: 'ວິທີການຮັບເອົາເຄື່ອງ',
    zzlh: 'ການຮັບເອົາເຄື່ອງໂດຍໃບບິນເຈ້ຍ',
    dzlh: 'ການຮັບເອົາເຄື່ອງໂດຍໃບບິນອີເລັກໂທຣນິກ',
    ydqx: 'ໄລຍະເວລາສົ່ງຮອດ',
    fyhj: 'ລວມຄ່າໃຊ້ຈ່າຍທັງໝົດ​',
    jfzl: 'ນ້ຳໜັກທີ່ນຳໃຊ້ໃນການຄິດໄລ່ຄ່າໃຊ້ຈ່າຍ',
    pjlx: 'ປະເພດໃບບິນ',
    xxxl: 'ຮູບແບບຕູ້ ແລະ ປະເພດຕູ້',
    sjhm: 'ເບີໂທລະສັບ',
    xzfw: 'ເລືອກບໍລິການ',
    qtfw: 'ບໍລິການອື່ນໆ',
    zdrq: 'ເວລາເຮັດບິນ',
    fkdw: 'ພາກສ່ວນຈ່າຍເງິນ',
    ssbz: 'ສະກຸນເງິນຮັບຕົວຈິງ',
    ssje: 'ຈໍານວນເງິນທີ່ໄດ້ຮັບຕົວຈິງ',
    zpzf: 'ຈ່າຍດ້ວຍໃບເຊັກ',
    bjyf: 'ຈ່າຍຄ່າຂົນສົ່ງເພີ່ມເຕີມ',
    ztwm: 'ຍັງບໍ່ຮູ້ສະຖານະ',
    crumbs02: 'ຕູ້ຄອນເທນເນີ ',
    dzf: 'ລໍຖ້າຊໍາລະ',
    jbr: 'ຄົນດຳເນີນການ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    rmb: 'ເງິນຢວນ',
    sfh: 'ເລກຫັຍງຈັກຢ່າງຢູ່ໃນລົດຂົນສົ່ງ',
    shouhr: 'ຜູ້ຮັບເຄື່ອງ',
    tuoyf: 'ຝ່າຍຮັບຂົນສົ່ງ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    xqh: 'ເລກຮ້ອງຂໍ',
    ybg: 'ປ່ຽນແປງແລ້ວ',
    yfk: 'ຊໍາລະເງິນລ່ວງໜ້າ',
    yhk: 'ບັດທະນາຄານ',
    ywc: 'ສໍາເລັດແລ້ວ',
    zyx: 'ສາຍສະເພາະ',
    zzs: 'ອາກອນມູນຄ່າເພີ່ມ',
    pjh: 'ໝາຍເລກໃບບິນ',
    hgr: 'ຫຼືບຸກຄົນ',
    lkr: 'ຜູ້ຮັບເງິນ',
    tkz: 'ກຳລັງສົ່ງເງິນຄືນ',
    txz1: 'ກຳລັງຖອນເງິນ',
    yzf1: 'ຍົກເລີກ',
    fkr: 'ຜູ້ຈ່າຍເງິນ',
    pbh1: 'ຂະບວນໂພນບູ',
    ptp1: 'ໃບເກັບເງິນທົ່ວໄປ',
    zyp: 'ໃບເກັບເງິນພິເສດ',
    hyy: 'ສະຖານີຕົ້ນທາງ',
    zdr: 'ຜູ້ເຮັດບິນ',
    fy: 'ຄ່າໃຊ້ຈ່າຍ：',
    yck: 'ເງິນຝາກລ່ວງໜ້າ',
    address: 'ທີ່ຢູ່',
    back: 'ກັບຄືນ',
    baozhuan: 'ເເພກ',
    bc: 'ບັນທຶກ',
    beiz: 'ໝາຍເຫດ',
    bz1: 'ນໍ້າໜັກມາດຕະຖານ',
    canchu: 'ສາງເກັບມ້ຽນ',
    ch: 'ເລກທີພາຫະນະ',
    chak: 'ກວດເບິ່ງ',
    daoz: 'ສະຖານີປາຍທາງ ',
    dh: 'ເບີໂທ',
    dy: 'ພິມ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    huoq: 'ເຂດວາງສິນຄ້າ',
    huow: 'ບ່ອນພັກເຊົາສິນຄ້າ',
    jianshu: 'ຈໍານວນເຄື່ອງ​',
    jipu: 'ກີບ',
    khhzh: 'ເລກບັນຊີທະນາຄານ',
    my: 'ເງິນໂດລາ',
    name: 'ຊື່',
    qd: 'ຢືນຢັນແນ່ນອນ',
    qink: 'ລົບຂໍ້ມູນທັງໝົດ',
    qr: 'ຢືນຢັນ',
    quxiao: 'ຍົກເລີກ',
    tiji: 'ປະລິມານ',
    ts: 'ຄໍາແນະນໍາ',
    xh3: 'ເລກຕູ້',
    xianjin: 'ເງິນສົດ',
    zaf: 'ຄ່າໃຊ້ຈ່າຍຕ່າງໆ',
    zhip: 'ໃບເຊັກ',
    zhongliang: 'ນ້ຳໜັກ',
    cz: 'ເຕີມເງິນ',
    tx: 'ຖອນອອກ',
    bh: 'ເລກ',
    qh: 'ເລກເລີ່ມຕົ້ນ',
    zh: 'ເລກສິ້ນສຸດ',
    zs: 'ຈໍານວນແຜ່ນ',
    ke: 'ຈໍານວນຍອດເງິນ',
    dw: 'ໜ່ວຍງານ',
    je: 'ຈໍານວນເງິນ',
    tk: 'ຄືນເງິນ',
    hj: 'ລວມ',
    fb: 'ປະເພດຄ່າໃຊ້ຈ່າຍ',
    fl: 'ອັດຕາຄ່າໃຊ້ຈ່າຍ',
    fj: 'ບັນທຶກຄັດຕິດ',
    gs: 'ບໍລິສັດ',
    fm: 'ລາຍການຄ່າໃຊ້ຈ່າຍ',
    se: 'ພາສີ',
    dx2: 'ເປັນຕົວໜັງສື',
    qz1: 'ລາຍເຊັນແລະປະທັບຕາ',
    zf1: 'ຈ່າຍເງິນ',
    ri: 'ວັນ',
    yuan: 'ຢວນ',
    y1: 'ຮ້ອຍລ້ານ',
    q: 'ພັນ',
    b: 'ຮ້ອຍ',
    s1: 'ສິບ',
    w1: 'ສິບພັນ',
    q1: 'ພັນ',
    b1: 'ຮ້ອຍ',
    s2: 'ສິບ',
    j: 'ຈຽວ',
    f: 'ເຟິ່ນ',
    n: 'ປີ',
    y2: 'ເດືອນ',
    shlc: 'ໄລຍະທາງການຈັດສົ່ງ',
    jzxsfh: 'ເລກທີຕິດປິດຕູ້ສິນຄ້າ',
    yjh: 'ເລກລະດັບລາຄາຂົນສົ່ງ',
    lcbw: 'ຕູ້ເເຊ່ເຢັນ (ຮັກສາອຸນຫະພູມ)',
    zcf: 'ຝ່າຍຂົນຂຶ້ນລົດ',
    sff: 'ຝ່າຍຕິດປິດ',
    qsrtyf: 'ກະລຸນາເລືອກຝ່າຍຝາກ',
    sxfk: 'ເງິນຈ່າຍລ່ວງໜ້າສຳລັບລາຍການຂ້າງເທິງນີ້',
    sxtk: 'ເງິນຄືນຂ້າງເທິງຈະ',
    rsdy: 'ໃຊ້ແທນຕາມຈໍານວນ',
    yxjzp: 'ຄືນເງິນຕາມຈໍານວນດ້ວຍເງິນສົດ/ເຊັກ',
    yh: 'ທະນາຄານ',
    sxyfkQ: 'ເງິນຈ່າຍລ່ວງໜ້າສຳລັບລາຍການຂ້າງເທິງນີ້ຈະຖືກຫັກອອກໃນວັນທີ  ເດືອນ  .',
    sxtkQ: 'ເງິນຄືນຂ້າງເທິງຈະຖືກສົ່ງຄືນເປັນເງິນສົດ/ເຊັກໃນວັນທີ  ເດືອນ  .',
  },
  stagedemand: {
    qxzdzqxzfz: 'ກະລຸນາເລືອກສະຖານີປາຍທາງ, ຖ້າຫາກຍັງບໍ່ເລືອກສະຖານີຕົ້ນທາງ,ກະລຸນາເລືອກສະຖານີຕົ້ນທາງກ່ອນ',
    qxzhwpm: 'ກະລຸນາໃສ່ຊື່ແພັກເກດ',
    qxzysrq: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງສົ່ງອອກ',
    jdxqtb: 'ຂອບເຂດຈຳນວນໂຕນທີ່ຕ້ອງການຍື່ນແຈ້ງເປັນໄລຍະແມ່ນ 10 ໂຕນຫາ 50 ໂຕນ',
    qdsfsc: 'ການດໍາເນີນງານນີ້ຈະລຶບຂໍ້ມູນນີ້ຖາວອນ, ຈະສືບຕໍ່ຫຼືບໍ່​?',
    hwtzfr: 'ຄຸນລັກສະນະສິນຄ້າ: ບໍ່ລິມາດຄວາມຮ້ອນ (kcal/ກິໂລ)：',
    hwtz: 'ລັກສະນະພິເສດຂອງສິນຄ່າ(kcal/ກິໂລ)',
    hwtzColon: 'ຄຸນລັກສະນະສິນຄ້າ: ບໍ່ລິມາດຄວາມຮ້ອນ (kcal/ກິໂລ):',
    frlbnc: 'ບໍ່ລິມາດຄວາມຮ້ອນບໍ່ໃຫ້ເກີນ 9999.99',
    qsrxcddszjy: 'ກະລຸນາເລືອກຕໍາເເໜ່ງທີ 2-400 ຂອງສະຖານທີ່ລົງລົດ',
    qsrzcddszjy: 'ກະລຸນາຕື່ມຕໍາເເໜ່ງທີ 2-400 ຂອງສະຖານທີ່ໃສ່ລົດໃສ່',
    ghsjgsbzq: 'ຮູບແບບເບີໂທລະສັບຕັ້ງໂຕະ ຫຼື ມືຖືບໍ່ຖືກຕ້ອງ',
    qnqdtb: 'ທ່ານກະລຸນາໄປຍື່ນຢູ່ໜ້າຂໍ້ມູນທີ່ລໍຖ້າການຍື່ນ',
    qnqdtbxxtj: 'ທ່ານກະລຸນາຢື່ນສົ່ງຢູ່ໜ້າຂໍ້ມູນທີ່ລໍຖ້າສົ່ງ！',
    qnqdtb1: 'ທ່ານກະລຸນາໄປຍື່ນຢູ່ໜ້າຂໍ້ມູນທີ່ລໍຖ້າການຍື່ນ',
    sctpjy5: ' ມີ   ໄຟລ໌, ໄດ້ເລືອກຈໍານວນທັງຫມົດ',
    dbcgqd: 'ລາຍງານແທນໄດ້ສໍາເລັດແລ້ວ, ກະລຸນາລໍຖ້າການຍອມຮັບ',
    qsrnsrsbh: 'ກະລຸນາຕື່ມເລກທີປະຈໍາຕົວຜູ້ເສຍອາກອນໃສ່',
    qsrspfmc: 'ກະລຸນາຕື່ມຊື່ຜູ້ຮັບໃບບິນໃສ່',
    qsrhwms: 'ກະລຸນາຕື່ມການບັນລະຍາສິນຄ້າໃສ່',
    qsrxcdd: 'ກະລຸນາເລືອກຈຸດລົງລົດ',
    qsrzcdd: 'ກະລຸນາຕື່ມຈຸດໃສ່ລົດໃສ່',
    qxzfplx: 'ກະລຸນາເລືອກປະເພດໃບບິນ',
    qxzhwm: 'ກະລຸນາເລຶອກຊື່ສິນຄ້າ',
    qxzjzxx: 'ກະລຸນາເລືອກລຸ້ນຕູ້ຄອນເທັນເນີ',
    qxzqsrq: 'ກະລຸນາເລືອກວັນທີເລີ່ມຕົ້ນ',
    qxzzzrq: 'ກະລຸນາເລືອກວັນທີສິ້ນສຸດ',
    qxztbf: 'ກະລຸນາເລືອກວິທີການລາຍງານຍື່ນສົ່ງ',
    frlbnw: 'ບໍ່ລິມາດຄວາມຮ້ອນບໍ່ສາມາດເປັນ 0',
    qxzdbx: 'ກະລຸນາເລືອກຂໍ້ມູນທີ່ແຈ້ງແທນ',
    impLsxq: 'ນໍາເຂົ້າປະຫວັດການຄວາມຕ້ອງການ',
    jdxqdb: 'ຍື່ນສົ່ງຄວາມຕ້ອງການເປັນໄລຍະໃຫ້ແທນ',
    jdxqlx: 'ປະເພດຄວາມຕ້ອງການເປັນໄລຍະ',
    lsxqImp: 'ນໍາເຂົ້າປະຫວັດການຄວາມຕ້ອງການ',
    lsxqImpColon: 'ການຍົກຍ້າຍ ຕາມຄວາມຮຽກຮ້ອງຕ້ອງການທີ່ບັນທຶກໄວ້',
    qsrkhh: 'ກະລຸນາໃສ່ຂໍ້ມູນທະນາຄານເປີດບັນຊີ',
    qsrshf: 'ກະລຸນາຕື່ມຜູ້ຮັບໃສ່',
    qsrtyf1: 'ກະລຸນາເລືອກຝ່າຍຝາກ',
    qsryhm: 'ກະລຸນາຕື່ມຊື່ຜູ້ນຳໃຊ້ໃສ່',
    qyzyhm: 'ກະລຸນາກວດກາຊື່ຜູ້ນຳໃຊ້',
    cyshf: 'ຜູ້ຮັບເຄື່ອງປະຈໍາວັນ',
    jdqxh: 'ເລກທີຄວາມຕ້ອງການເປັນໄລຍະ',
    mdj: 'ບໍ່ເຕນ (ຊາຍແດນ)',
    qsrbz: 'ກະລຸນາໃສ່ໝາຍເຫດ',
    qsrcs: 'ກະລຸນາຕື່ມຈຳນວນລົດ',
    qsrcz: 'ກະລຸນາເລືອກປະເພດພາຫະນະ ',
    qsrdh: 'ກະລຸນາໃສ່ເບີໂທ',
    qsrds: 'ກະລຸນາຕື່ມຈໍານວນໂຕນໃສ່',
    qsrdz: 'ກະລຸນາໃສ່ທີ່ຢູ່',
    qsrdz1: 'ກະລຸນາຕື່ມສະຖານີທີ່ສົ່ງຮອດໃສ່',
    qsrfz: 'ກະລຸນາເລືອກສະຖານີຕົ້ນທາງ',
    qsrzh: 'ກະລຸນາໃສ່ເລກບັນຊີ',
    sfzhm: 'ເລກບັດປະຈຳຕົວ',
    yqxsc: 'ຍົກເລີກການລົບລ້າງເເລ້ວ',
    zzsxx: 'ຂໍ້ມູນມູນຄ່າພາສີເພີ່ມເຕີມ',
    cyfhf: 'ມັກໃຊ້ປະຈຳໃນການສົ່ງສີນຄ້າ',
    qsrsz: 'ກະລຸນາຕື່ມຕົວເລກໃສ່',
    bxwsz: 'ຈະຕ້ອງເປັນຕົວເລກເທົ່ານັ້ນ',
    ysyf: 'ເດືອນທີ່ເຮັດການຂົ່ນສົ່ງ:',
    qxzcz1: 'ກະລຸນາເລືອກປະເພດພາຫະນະ',
    qsrcx: 'ກະລຸນາຕື່ມລຸ້ນພາຫະນະໃສ່',
    dsd: 'ຈໍານວນໂຕນ (ໂຕນ)',
    sccg: 'ລົບລ້າງສຳເລັດ',
    crumbs19: 'ຄວາມຕ້ອງການເປັນໄລຍະ',
    crumbs29: 'ຄວາມຕ້ອງການທີ່ຢາກຕັ້ງໃໝ່',
    czcg: 'ການດໍາເນີນງານສໍາເລັດເເລ້ວ',
    drcg: 'ດຶງເຂົ້າສຳເລັດ',
    drwj: 'ດຶງອອກເປັນໄຟລ໌',
    fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',
    fsdz: 'ບໍ່ໄດ້ເເພກຍ່ອຍ',
    gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',
    hqhw: 'ບ່ອນວາງສິນຄ້າ / ບ່ອນພັກເຊົາສິນຄ້າ',
    hwmc: 'ຊື່ສິນຄ້າ',
    hwms: 'ບັນລະຍາຍສິນຄ້າ',
    hwmsColon: 'ບັນລະຍາຍສິນຄ້າ:',
    hwpm1: 'ສິນຄ້າ',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    lsxq: 'ປະຫວັດຄວາມຕ້ອງ',
    lxdh1: 'ເບີໂທຕິດຕໍ່',
    ptys: 'ຂົນສົ່ງທົ່ວໄປ',
    qymc: 'ຊື່ວິສາຫະກິດ',
    shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',
    tjrq1: 'ວັນທີຍື່ນ',
    txdz1: 'ທີ່ຢູ່',
    wccs: 'ຈໍານວນພາຫະນະທີ່ສໍາເລັດ',
    wpmc: 'ຊື່ສິນຄ້າ    ',
    wpqd: 'ລາຍການເຄື່ອງຂອງ',
    wxts: 'ແຈ້ງເຕືອນ',
    xcdd1: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    xgcg: 'ເເກໄຂສຳເລັດ',
    xjcg: 'ຕັ້ງໃໝ່ສຳເລັດ',
    ysrq1: 'ວັນທີ່ຂົນສົ່ງ',
    ysxx: 'ຂໍ້ມູນຂົນສົ່ງ',
    zcdd1: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    zyrq: 'ວັນທີ່ຂົນສົ່ງ',
    zyrqColon: 'ວັນທີ່ຂົນສົ່ງ:',
    jjyy1: 'ເຫດຜົນປະຕິເສດ',
    jjyy1Colon: 'ເຫດຜົນປະຕິເສດ:',
    tyf1: 'ຜູ້ຂົນສົ່ງສິນຄ້າ:',
    khx1: 'ທະນາຄານເປີດບັນຊີ: ',
    crumbs02: 'ການຂົນສົ່ງສິນຄ້າທີ່ບໍ່ເຕັມລົດ',
    frl: 'ຄ່າແຄລໍຣີ່',
    gjz1: 'ສະຖານີຊາຍແດນ',
    jwz: 'ສະຖານີຕ່າງປະເທດ',
    qhf: 'ຝ່າຍຮັບເຄື່ອງ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    qxr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    sctpjy6: 'ມີ   ໄຟລ໌',
    tuoyf: 'ຝ່າຍຮັບຂົນສົ່ງ',
    xqh: 'ເລກຮ້ອງຂໍ',
    yuyueh: 'ເລກທີຈອງ',
    anc: 'ອີງຕາມລົດ',
    anD: 'ອີງຕາມນ້ຳໜັກ',
    baozhuan: 'ເເພກ',
    beiz: 'ໝາຍເຫດ',
    beizColon: 'ໝາຍເຫດ',
    caoz: 'ດໍາເນີນງານ',
    chax: 'ຄົ້ນຫາ ',
    congzhi: 'ຣີເຊັດ',
    daochu: 'ດຶງອອກ',
    daoz: 'ສະຖານີປາຍທາງ ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    guolian: 'ການຂົນສົ່ງລະຫວ່າງປະເທດ',
    jg: 'ລາຄາ',
    jianshu: 'ຈໍານວນເຄື່ອງ​',
    liangshi: 'ສະບຽງອາຫານ',
    qd: 'ຢືນຢັນແນ່ນອນ',
    qink: 'ລົບຂໍ້ມູນທັງໝົດ',
    quxiao: 'ຍົກເລີກ',
    sc: 'ລຶບ',
    sl: 'ຮັບການດໍາເນີນງານ',
    tiji: 'ປະລິມານ',
    tijiao: 'ຍື່ນ',
    ts: 'ແຈ້ງເຕືອນ',
    xg: 'ແປງ',
    xh: 'ລໍາດັບ',
    xiazai: 'ດາວໂຫລດ',
    xz1: 'ເພີ່ມໃໝ່',
    zhongliang: 'ນ້ຳໜັກ',
    zt2: 'ສະຖານະ',
    sp: 'ການອະນຸມັດ',
    md: 'ບໍ່ເຕັນ',
    ty1: 'ເຫັນດີ',
    jj1: 'ປະຕິເສດ',
    chang: 'ໄຂພວງ',
    collect: 'ຮັບ ',
    goods: 'ສິນຄ້າ',
    guan: 'ລົດກະປ໋ອງ',
    peng: 'ລົດພວງ',
    ping: 'ລົດພຽງ',
    to: 'ຫາ',
    w: 'ບໍ່ມີ',
    y: 'ໜ້າ',

    //
    tsqyby: 'ເເຈ້ງເຕືອນ: ກະລຸນາຍື່ນໃບບິນຂົນສົ່ງລະຫວ່າງປະເທດກ່ອນວັນທີ 19 ເດືອນນີ້',
    lxdh_txdz: 'ເບີໂທຕິດຕໍ່/ທີ່ຢູ່ໍ່',
    qsrfhrdh: 'ກະລຸນາຕື່ມເບີໂທຜູ້ສົ່ງເຄື່ອງໃສ່',
    qsrfhrdz: 'ກະລຸນາໃສ່ຂໍ້ມູນທີ່ຢູ່ຜູ້ສົ່ງສິນຄ້າ',
    qsrkhhmc: 'ກະລຸນາຕື່ມຊື່ທະນາຄານເປີດບັນຊີໃສ່',
    qsrkhhzh: 'ກະລຸນາຕື່ມເລກບັນຊີທະນາຄານໃສ່',
    dz_xcdd: 'ສະຖານີປາຍທາງ/ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    excelImp: 'ດຶງອອກເປັນexcel',
    excelImpColon: 'ດຶງເຂົ້າຈາກຟາຍ excel:',
    fz_zcdd: 'ສະຖານີຕົ້ນທາງ/ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    qsrjzsx: 'ກະລຸນາຕື່ມບັນທຶກໜ້າວຽກໃສ່:',
    qsrlxdh: 'ກະລຸນາຕື່ມເບີໂທຕິດຕໍ່ໃສ່',
    qsrtxdz: 'ກະລຸນາຕື່ມທີ່ຢູຕິດຕໍ່ໃສ່',
    qsrzcdd1: 'ກະລຸນາຕື່ມທີ່ຢູ່ລົງທະບຽນໃສ່',
    qxzxqlx: 'ກະລຸນາເລືອກປະເພດຄວາມຕ້ອງການ',
    qsrydd: 'ກະລຸນາຕື່ມເບີໂທລະສັບມືຖືໃສ່',
    nsrsbh: 'ເລກທີປະຈໍາຕົວຜູ້ເສຍອາກອນ:  ',
    nsrsbh1: 'ເລກທີປະຈໍາຕົວຜູ້ເສຍອາກອນ:  ',
    qxzgjz: 'ກະລຸນາເລືອກສະຖານີຊາຍແດນ',
    zzdjcl: 'ວັດຖຸເພີ່ມຄວາມໝັ້ນຄົງໃນການບັນຈຸຂຶ້ນລົງ',
    spfmc: 'ຊື່ຜູ້ຮັບໃບບິນ:',
    spfmc1: 'ຊື່ຜູ້ຮັບໃບບິນ:',
    dtbxx: 'ຂໍ້ມູນຮັບເຄື່ອງທີ່ໃຊ້ປະຈຳ',
    qxzyf: 'ກະລຸນາເລືອກເດືອນ',
    ysrq: 'ວັນທີ່ຂົນສົ່ງ:',
    zdjzl: 'ນໍ້າໜັກສູງສຸດ (ກິໂລ):',
    zdjzlColon: 'ນ້ໍາໜັກສິນຄ້າຫຼາຍສຸດ:',
    xqlx: 'ປະເພດຄວາມຕ້ອງການ :',
    tjrq: 'ວັນທີ ຍື່ນສະເໜີ：',
    hwpm: 'ສິນຄ້າ:',
    hwbz: 'ການເເພກສິນຄ້າ：',
    jzsx: 'ລາຍການທີ່ບັນທຶກ:',
    tbfs1: 'ວິທີແຈ້ງແຜນ:',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    lxdh: 'ເບີໂທຕິດຕໍ່:',
    txdz: 'ທີ່ຢູ່: ',
    ddgj: 'ປະເທດປາຍທາງ: ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ:',
    fplx: 'ປະເພດໃບບິນ ',
    fplx1: 'ປະເພດໃບບິນ ',
    bxys: 'ປະກັນໄພຂົນສົ່ງ',
    crumbs0: 'ບໍ່ລິການຂົນສົ່ງ',
    ddgj1: 'ປະເທດປາຍທາງ',
    gnbx: 'ປະກັນໄພພາຍໃນປະເທດ',
    hwtz1: 'ລັກສະນະພິເສດຂອງສິນຄ່າ ',
    jsrq: 'ວັນທີ່ສິ້ນສຸດ',
    jzsx1: 'ລາຍການທີ່ບັນທຶກ',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    plsc: 'ລົບຈຳນວນຫຼາຍ',
    ptfp: 'ໃບບິນທົ່ວໄປ',
    qzrq: 'ວັນທີ່ເລີ່ມຕົ້ນແລະສີ້ນສຸດ',
    sltc: 'ຜ່ານການດໍາເນີນການ',
    tbcs: 'ຈໍານວນພາຫະນະທີ່ຍື່ນແຈ້ງ',
    tbds: 'ແຈ້ງນ້ຳໜັກ',
    zyfp: 'ໃບບິນສະເພາະ',
    gjz: 'ສະຖານີຊາຍແດນ :',
    shf: 'ຜູ້ຮັບສິນຄ້າ',
    khx: 'ທະນາຄານເປີດບັນຊີ:',
    bps: 'ບໍ່ຢ້ານຄວາມຊຸ່ມ',
    ck: ' ຂາອອກ',
    dsl: 'ຖ້າການຍອມຮັບ',
    sdz: 'ເເພກຍ່ອຍ',
    yjj: 'ໄດ້ປະຕິເສດແລ້ວ',
    zzs: 'ອາກອນມູນຄ່າເພີ່ມ',
    ds: 'ຈໍານວນໂຕນ:',
    cz: 'ປະເພດພາຫະນະ:',
    cs: 'ຈໍານວນພາຫະນະ:',
    fz: 'ສະຖານີສົ່ງ:',
    fj: 'ກົມລົດໄຟສົ່ງອອກ ',
    dz: 'ສະຖານີທີ່ສົ່ງຮອດ:',
    zh: 'ເລກບັນຊີທະນາຄານ: ',
    dz1: 'ທີ່ຢູ່: ',
    dh: 'ເບີໂທ: ',
    zh1: 'ເລກບັນຊີທະນາຄານ:',
    dh1: 'ເບີໂທ:',
    dz2: 'ທີ່ຢູ່:',
    back: 'ກັບຄືນ',
    bc: 'ບັນທຶກ',
    canchu: 'ສາງເກັບມ້ຽນ',
    ches: 'ຈໍານວນພາຫະນະ',
    chesColon: 'ຈໍານວນພາຫະນະ：',
    chez: 'ປະເພດລົດ',
    chezColon: 'ຮູບແບບລົດ:',
    chuk: 'ຂາອອກ',
    ds1: 'ຈໍານວນໂຕນ',
    ds1Colon: 'ຈໍານວນໂຕນ:',
    pashi: 'ຊຸ່ມງ່າຍ',
    fa: 'ສົ່ງ',
    jie1: 'ໄລຍະ',
    move: 'ຂົນສົ່ງ',
    zen: 'ເພີ່ມ',

    //新增翻译
    fh: 'ສົ່ງສິນຄ້າ',
    sh: 'ຮັບສິນຄ້າ',
    myhwpm: 'ບໍ່ມີຊື່ສິນຄ້ານີ້',
    ch: 'ຈີນ',
    //new页面
    tbr: 'ຜູ້ຍື່ນຄຳຮ້ອງຂໍ',
    dbr: 'ຜູ້ຍື່ນຄຳຮ້ອງຂໍແທນ',
    shsj: 'ເວລາກວດສອບທົບທວນ',
    zcdz: 'ທີ່ຢູ່ຂົນຂຶ້ນລົດ',
    xcdz: 'ທີ່ຢູ່ຂົນລົງລົດ',
    ti: 'ຮັບ',
    tbrxx: 'ຂໍ້ມູນຂອງຜູ້ຍື່ນຄຳຮ້ອງຂໍ',
    hwtzfhl: 'ລັກສະນະພິເສດຂອງສິນຄ່າ: ບໍ່ລິມາດຄວາມຮ້ອນ (kcal/ກິໂລ)',
    tlhc: 'ລານສີນຄ້າທາງລົດໄຟ',
    qxzblzb: 'ກະລຸນາເລືອກປະເພດແອັບພລິເຄຊັນ',
    xzxz1: 'ປັດຈຸບັນຈໍາກັດໃຫ້ເລືອກພຽງແຕ່ 1 ໄຟລ໌,ເທື່ອນີ້ໄດ້ເລືອກ',
    xzxz2: 'ມີ   ໄຟລ໌, ໄດ້ເລືອກຈໍານວນທັງຫມົດ',
    xzxz3: 'ມີ   ໄຟລ໌',
    jdxqhw: 'ສະເຕດນຳເບີທີ່ຕ້ອງການຄື',
    qxzscnr: 'ກະລຸນາເລືອກລຶບເນື້ອຫາ',
    scjg: 'ການດໍາເນີນງານນີ້ຈະລຶບຂໍ້ມູນນີ້ຖາວອນ, ຈະສືບຕໍ່ຫຼືບໍ່​?',
    scsb: 'ການລົບລົ້ມເຫລວ',
    yhxxcw: 'ຂໍ້ມູນຜູ້ໃຊ້ບໍ່ຖືກຕ້ອງ, ກະລຸນາກວດເບິ່ງແລ້ວລາຍງານແທນ.',
    qhdyhxx: 'ກະລຸນານໍາເຂົ້າຄວາມຕ້ອງການໃນອະດີດຫຼັງຈາກກວດເບິ່ງວ່າຂໍ້ມູນຜູ້ໃຊ້ຖືກຕ້ອງ.',
    zg: 'ຈີນ',

    qsrysyf: 'ກະລຸນາຕື່ມວັນທີ່ຂົນສົ່ງ',
    qxzfkfs: 'ກາລຸນາເລືອກ ຮູບແບບການຊໍາລະເງິນ',
    qxzbz: 'ກະລຸນາເລືອກສະກຸນເງິນ',
    qxzfkr: 'ກາລຸນາເລືອກຜູ້ຊໍາລະເງິນ',
    qsrzjh: 'ກາລຸນາລະບຸ ເລກບັດຢັ້ງຢືນ',
    bxwzs: 'ຕົວເລກຕ້ອງຄົບຖ້ວນ',
    bnw0: 'ບໍ່ສາມາດໃຫ້ເປັນ 0',
    bncg9999: 'ບໍ່ສາມາດເກີນ 9999',
    bctip: ',ກາລຸນາສົ່ງໃບສັ່ງຈອງໃຫ້ຂ້ອຍໄວໆ!',
    tjtip: 'ປ່າຍໄປທີ່ສຳເລັບຜູ້ໃຊ້,ໝາຍເລກຄວາມຕ້ອງການແມ່ນ:',
    tdtip: 'ການຍົກເລີກໃບສັ່ງຈອງໃນເດືອນນີ້ຮອດ5ຄັ້ງແລ້ວ, ບໍ່ສາມາດເພີ່ມຄວາມຕ້ອງໃນເດືອນໄດ້ອີກ !',
    xybtip: 'ບໍ່ມີຂັ້ນຕອນຕໍ່ໄປໃນການຄວບຄຸມສໍາລັບຂໍ໊ມູນນີ້!',
  },

  delivery: {
    sxtkyy: 'ເງິນຄືນຂ້າງເທິງຈະຖືກສົ່ງຄືນເປັນເງິນສົດ/ເຊັກໃນວັນທີ  ເດືອນ  .',
    xhsjy: 'ເວລາຂົນລົງ ເດືອນ-ວັນທີ--ໂມງມາຮອດ ໝາຍເລກໃບເກັບເງິນ',
    tzsjy: 'ເວລາແຈ້ງ ເດືອນ-ວັນທີ--ໂມງ ໝາຍເລກບັດປະຈຳຕົວຂອງຜູ້ຮັບສິນຄ້າ',
    yebzqq: 'ຍອດເງິນບໍ່ພຽງພໍ, ກະລຸນາເຕີມເງິນທີ່ອິນເຕີເຟສການຈັດການເງິນຝາກລ່ວງໜ້າ!',
    sxyfky: 'ເງິນຈ່າຍລ່ວງໜ້າສຳລັບລາຍການຂ້າງເທິງນີ້ຈະຖືກຫັກອອກໃນວັນທີ  ເດືອນ  .',
    ryxjzp: 'ຖືກສົ່ງຄືນເປັນເງິນສົດ/ເຊັກໃນວັນທີ ',
    gxqdhb: 'ໝາຍເລກໃບລາຍຊື່ຕ້ອງການນີ້ບໍ່ໄດ້ຕົກຢູ່ສະຖານະເສ້ງເງິນແລ້ວ',
    yfkdyt: 'ໃບຢັ້ງຢືນຫັກເງິນທີ່ຈ່າຍລ່ວງໜ້າ (ການຄືນເງິນ) ',
    lkdwkh: 'ພວກສ່ວນຮັບເງິນເປີດບັນຊີ ແລະຮັບເງິນຄືນ',
    sctpjy5: ' ມີ   ໄຟລ໌, ໄດ້ເລືອກຈໍານວນທັງຫມົດ',
    lkdwkh1: 'ໜ່ວຍງານຮັບເງິນເປີດບັນຊີເພື່ອຮັບເງິນຄືນ',
    czjjhr: 'ລາຍເຊັນແລະປະທັບຕາຂອງຜູ້ຮັບ (ມອບ)ສິນຄ້າຢູ່ສະຖານີ',
    qzsxzy3: 'ກະລຸນາເລືອກຢ່າງໜ້ອຍໜຶ່ງໃບບິນ',
    qhlckm: 'ໄລຍະທາງໄປຮັບສິນຄ້າ (km)',
    gxqdhy: 'ໝາຍເລກໃບລາຍຊື່ຕ້ອງການນີ້ໄດ້ສົ່ງມອບແລ້ວ',
    qxzyjq: 'ກະລຸນາເລືອກຂໍ້ມູນເສ້ງເງິນແລ້ວ',
    cyrqdzl: 'ນ້ໍາໜັກທີ່ກໍານົດຈາກຜູ້ບໍ່ລິການຂົນສົ່ງ',
    nsrsbh1: 'ເລກທີປະຈໍາຕົວຜູ້ເສຍອາກອນ:  ',
    qzxxzd: 'ກະລຸນາເລືອກໃບບິນໃໝ່',
    khhjzh: 'ທະນາຄານເປີດບັນຊີ ແລະ ເລກບັນຊີ',
    zzdjcl: 'ວັດຖຸເພີ່ມຄວາມໝັ້ນຄົງໃນການບັນຈຸຂຶ້ນລົງ',
    crpzbh: 'ໝາຍເລກໃບຝາກ:',
    crpzbhColon: 'ໝາຍເລກຢັ້ງຢືນການຝາກເງິນ',
    dyth: 'ຫັກເງິນ (ສົ່ງຄືນ)',
    yfkstj: 'ຂຽນຕື່ມໃສ່ໃນເວລາຈ່າຍເງິນລ່ວງໜ້າ',
    spfmc1: 'ຊື່ຜູ້ຮັບໃບບິນ:',
    jzxsfh: 'ເລກທີຕິດປິດຕູ້ສິນຄ້າ',
    sxyfky2: 'ເງິນຈ່າຍລ່ວງໜ້າສຳລັບລາຍການຂ້າງເທິງນີ້',
    rrsdy: 'ຖືກຫັກອອກໃນວັນທີ  ',
    sfzhm: 'ເລກບັດປະຈຳຕົວ',
    jey: 'ຍອດເງິນ (ຢວນ)',
    yfkdw: 'ໜ່ວຍງານຊໍາລະເງິນລ່ວງໜ້າ',
    skdwh: 'ໜ່ວຍງານຮັບເງິນແລະ',
    dyhth: ' ຫັກເງິນ ຫຼື ສົ່ງຄືນ',
    yxjzh: 'ທະນາຄານ ແລະ ເລກບັນຊີ',
    lqpzr: 'ຜູ້ຮັບເອົາໃບຢັ້ງຢືນ',
    cyrjs: 'ບັນທຶກເຫດການຂອງຜູ້ຂົນສົ່ງ',
    tyrjs: 'ບົດລາຍງານຂອງຜູ້ຂົນສົງສີນຄ້າ',
    czrqc: 'ສະແຕມວັນທີສະຖານີ',
    shrqz: 'ລາຍເຊັນແລະປະທັບຕາຂອງຜູ້ຮັບສິນຄ້າ',
    bczf: 'ຈ່າຍໃນຄັ້ງນີ້:',
    zffs: 'ວິທີຈ່າຍເງີນ:',
    jfzt: 'ສະຖານະການສົ່ງມອບ:',
    dybjd: 'ປິ້ນໃບເກັບຄືນຄ່າໃຊ້ຈ່າຍຕ່າງໆ',
    zhye: 'ຍອດຄົງເຫຼືອບັນຊີ:',
    yjfxq: 'ລາຍລະອຽດການຈ່າຍເງິນແລ້ວ',
    fyje: 'ຈໍານວນຄ່າໃຊ້ຈ່າຍ:',
    bjfxq: 'ລາຍລະອຽດຄ່າຈ່າຍເພີ່ມເຕີມ',
    sxtky: 'ເງິນຄືນຂ້າງເທິງຈະ',
    bjys: 'ຮັກສາລາຄາໃນການຂົນສົ່ງ',
    ckxq: 'ກວດສອບລາຍລະອຽດ',
    crumbs01: 'ໃບຂົນສົ່ງສິນຄ້າ',
    czcg: 'ການດໍາເນີນງານສໍາເລັດເເລ້ວ',
    czch: 'ໝາຍເລກ ແລະ ປະເພດລົດ',
    fplx2: 'ປະເພດໃບບິນ ',
    fymx: 'ຄ່າໃຊຊໍາລະລະອຽດ',
    hwjg: 'ລາຄາສິນຄ້າ',
    hwmc: 'ຊື່ສິນຄ້າ',
    hwpm1: 'ສິນຄ້າ',
    hzzf: 'ການຊໍາລະເງິນລວມ',
    jfrq: 'ວັນທີສົ່ງມອບສິນຄ້າ',
    jfrqColon: 'ວັນທີສົ່ງມອບສິນຄ້າ：',
    jsrq: 'ວັນທີສິ້ນສຸດ',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    lxdh1: 'ເບີໂທຕິດຕໍ່',
    ptys: 'ຂົນສົ່ງທົ່ວໄປ',
    qhdd: 'ສະຖານທີໄປຮັບສີ້ນຮັບສີ້ນຄ້າ',
    shdd: 'ທີ່ຢູ່ທີ່ສົ່ງສິນຄ້າ',
    sltc: 'ຜ່ານການດໍາເນີນການ',
    smqh: 'ເກັບເອົາສິນຄ້າຢູ່ບ້ານ',
    smsh: 'ສົ່ງສິນຄ້າຮອດບ້ານ',
    smxc: 'ບໍ່ລິການຂົນເຄື່ອງລົງຮອດບ້ານ',
    smzc: 'ບໍ່ລິການຂົນເຄື່ອງຂຶ້ນຮອດບ້ານ',
    wxts: 'ແຈ້ງເຕືອນ',
    xqdh1: 'ເລກໃບຮ້ອງຂໍ',
    ysfs: 'ຮູບແບບການຂົນສົ່ງ',
    yslx: 'ຮູບແບບການຂົນສົ່ງ',
    bjpz: 'ແກ້ໄຂໃບຮັບຮອງ',
    lzgs: 'ບໍລິສັດ ລາວ-ຈີນ',
    skdw1: 'ໜ່ວຍງານຮັບເງິນ',
    skdw1Colon: 'ໜ່ວຍງານຮັບເງິນ:',
    pjmc: 'ຊື່ໃບບິນ',
    dx: '(ຂຽນຕົວອັກສອນໃຫຍ່)',
    bjzf: 'ເກັບຄືນຄ່າໃຊ້ຈ່າຍຕ່າງໆ',
    fffs: 'ວິທີຈ່າຍເງິນ',
    lhfs: 'ວິທີການຮັບເອົາເຄື່ອງ',
    zzlh: 'ການຮັບເອົາເຄື່ອງໂດຍໃບບິນເຈ້ຍ',
    dzlh: 'ການຮັບເອົາເຄື່ອງໂດຍໃບບິນອີເລັກໂທຣນິກ',
    ydqx: 'ໄລຍະເວລາສົ່ງຮອດ',
    fyhj: 'ລວມຄ່າໃຊ້ຈ່າຍທັງໝົດ​',
    jfzl: 'ນ້ຳໜັກທີ່ນຳໃຊ້ໃນການຄິດໄລ່ຄ່າໃຊ້ຈ່າຍ',
    pjlx: 'ປະເພດໃບບິນ',
    xxxl: 'ຮູບແບບຕູ້ ແລະ ປະເພດຕູ້',
    sjhm: 'ເບີໂທລະສັບ',
    xzfw: 'ເລືອກບໍລິການ',
    qtfw: 'ບໍລິການອື່ນໆ',
    zdrq: 'ເວລາເຮັດບິນ',
    tyf1: 'ຜູ້ຂົນສົ່ງສິນຄ້າ:',
    shf: 'ຜູ້ຮັບສິນຄ້າ',
    yyh: 'ເລກສັ່ງຈອງ',
    bccg: 'ບັນທຶກສຳເລັດແລ້ວ',
    jfz: 'ສົ່ງມອບຢູ່:',
    jfsj: 'ເວລາສົ່ງມອບ',
    jfqr: 'ຢືນຢັນການສົ່ງມອບ',
    shlc: 'ໄລຍະທາງການຈັດສົ່ງ',
    zfr: 'ຜູ້ຈ່າຍເງິນ:',
    crumbs02: 'ຕູ້ຄອນເທນເນີ ',
    dsl: 'ຖ້າການຍອມຮັບ',
    hph: 'ເລກໃບບິນ',
    jbr: 'ຄົນດຳເນີນການ',
    qhf: 'ຝ່າຍຮັບເຄື່ອງ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    rmb: 'ເງິນຢວນ',
    sctpjy6: 'ມີ   ໄຟລ໌',
    sfh: 'ເລກຫັຍງຈັກຢ່າງຢູ່ໃນລົດຂົນສົ່ງ',
    shouhr: 'ຜູ້ຮັບເຄື່ອງ',
    tuoyf: 'ຝ່າຍຮັບຂົນສົ່ງ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    xqh: 'ເລກຮ້ອງຂໍ',
    ydd1: 'ມາຮອດແລ້ວ',
    ydh: 'ເລກທີໃບຂົນສົ່ງ',
    yfc: 'ລົດອອກແລ້ວ',
    yfk: 'ຊໍາລະເງິນລ່ວງໜ້າ',
    yhk: 'ບັດທະນາຄານ',
    yjf: 'ສົ່ງມອບແລ້ວ',
    yjj: 'ໄດ້ປະຕິເສດແລ້ວ',
    yxc: 'ລົງລົດແລ້ວ ',
    yzc: 'ຂື້ນລົດແລ້ວ',
    zyx: 'ສາຍສະເພາະ',
    zzs: 'ອາກອນມູນຄ່າເພີ່ມ',
    pjh: 'ໝາຍເລກໃບບິນ',
    hgr: 'ຫຼືບຸກຄົນ',
    lkr: 'ຜູ້ຮັບເງິນ',
    fkr: 'ຜູ້ຈ່າຍເງິນ',
    pbh1: 'ຂະບວນໂພນບູ',
    ptp1: 'ໃບເກັບເງິນທົ່ວໄປ',
    zyp: 'ໃບເກັບເງິນພິເສດ',
    hyy: 'ສະຖານີຕົ້ນທາງ',
    zdr: 'ຜູ້ເຮັດບິນ',
    fy: 'ຄ່າໃຊ້ຈ່າຍ:',
    yck: 'ເງິນຝາກລ່ວງໜ້າ',
    fz: 'ສະຖານີສົ່ງອອກ：',
    dz: 'ສະຖານີສົ່ງຮອດ:',
    dh1: 'ເບີໂທ: ',
    djf: 'ລໍຖ້າສົ່ງມອບ',
    yjq: 'ຊຳລະແລ້ວ',
    zj: 'ລວມທັງໝົດ:',
    yjf1: 'ສົ່ງມອບແລ້ວ',
    bjf: 'ຄ່າຈ່າຍເພີ່ມເຕີມ',
    zcf: 'ຝ່າຍຂົນຂຶ້ນລົດ',
    sff: 'ຝ່າຍຕິດປິດ',
    yjh: 'ເລກລະດັບລາຄາຂົນສົ່ງ',
    address: 'ທີ່ຢູ່',
    back: 'ກັບຄືນ',
    baozhuan: 'ເເພກ',
    bc: 'ບັນທຶກ',
    beiz: 'ໝາຍເຫດ',
    bz1: 'ນໍ້າໜັກມາດຕະຖານ',
    canchu: 'ສາງເກັບມ້ຽນ',
    chax: 'ຄົ້ນຫາ ',
    daoz: 'ສະຖານີປາຍທາງ ',
    dy: 'ພິມ',
    faz: 'ສະຖານີຕົ້ນທາງ',
    huoq: 'ເຂດວາງສິນຄ້າ',
    huow: 'ບ່ອນພັກເຊົາສິນຄ້າ',
    jianshu: 'ຈໍານວນເຄື່ອງ​',
    jipu: 'ເງິນກີບ',
    khhzh: 'ເລກບັນຊີທະນາຄານ',
    my: 'ເງິນໂດລາ',
    name: 'ຊື່',
    qd: 'ຢືນຢັນແນ່ນອນ',
    qink: 'ລົບຂໍ້ມູນທັງໝົດ',
    tiji: 'ປະລິມານ',
    xh3: 'ເລກຕູ້ຄອນເທັນເນີ',
    xianjin: 'ເງິນສົດ',
    yunf: 'ຄ່າຂົນສົ່ງ',
    zaf: 'ຄ່າໃຊ້ຈ່າຍຕ່າງໆ',
    zc: 'ເປັນຄັນລົດ',
    zhip: 'ໃບເຊັກ',
    zhongliang: 'ນ້ຳໜັກ',
    zt2: 'ສະຖານະ',
    bh: 'ເລກ',
    qh: 'ເລກເລີ່ມຕົ້ນ',
    zh2: 'ເລກສິ້ນສຸດ',
    zs: 'ຈໍານວນແຜ່ນ',
    ke: 'ຈໍານວນຍອດເງິນ',
    dw: 'ໜ່ວຍງານ',
    je: 'ຈໍານວນເງິນ',
    hj: 'ລວມ',
    gs: 'ບໍລິສັດ',
    fm: 'ລາຍການຄ່າໃຊ້ຈ່າຍ',
    se: 'ພາສີ',
    dx2: 'ເປັນຕົວໜັງສື',
    qz1: 'ລາຍເຊັນແລະປະທັບຕາ',
    yt: 'ຄືນຄ່າຂົນສົ່ງ',
    zt3: 'ຄືນຄ່າເບັດຕະເລັດ',
    jk1: 'ຂາເຂົ້າ',
    fc: 'ລົດອອກເດີນທາງ',
    ri: 'ວັນ',
    t: 'ລາຍການ',
    w: 'ບໍ່ມີ',
    yuan: 'ຢວນ',
    y1: 'ຮ້ອຍລ້ານ',
    q: 'ພັນ',
    b: 'ຮ້ອຍ',
    s1: 'ສິບ',
    w1: 'ສິບພັນ',
    q1: 'ພັນ',
    b1: 'ຮ້ອຍ',
    s2: 'ສິບ',
    j: 'ຈຽວ',
    f: 'ເຟິ່ນ',
    n: 'ປີ',
    y2: 'ເດືອນ',
    sctpjy3: 'ໄຟລ໌ທີ່ອັບໂຫລດທັງໝົດບໍ່ສາມາດເກີນ 20Mໄດ້',
    qxzfyj: 'ກະລຸນາເລືອກໃບຂົນສົ່ງສິນຄ້າທີ່ຍັງບໍ່ທັນເສ້ງເງິນ',
    gwjycz: 'ໄຟລ໌ນີ້ມີຢູ່ແລ້ວ!',
    jfqrcg: 'ການຢືນຢັນການສົ່ງມອບສຳເລັດແລ້ວ',
    jfqrsb: 'ການຢືນຢັນການສົ່ງມອບລົ້ມເຫລວ',
    qxzyd: 'ກະລຸນາເລືອກໃບຂົນສົ່ງ',
    yd: 'ໃບຂົນສົ່ງ',
    //goodsOrder
    dwjfbz: 'ໝາຍເຫດຂອງທີ່ຍັງບໍ່ທັນສົ່ງມອບນັ້ນຍັງບໍ່ທັນໄດ້ຕື່ມຂໍ້ມູນ, ກະລຸນາຕື່ມຂໍ້ມູນໃສ່ແລະຍື່ນ!',
    zltlgf: 'ບໍລິສັດ ທາງລົດໄຟ ລາວ-ຈີນ ຈຳກັດ',
    zyxmcd: 'ຊື່ສາຍສະເພາະ (ລະຫັດ)',
    fkdwhx: 'ພາກສ່ວນຈ່າຍເງິນ ຫຼືຊື່',
    jzxxx: 'ຮູບແບບຕູ້ຄອນເທັນເນີ  ',
    yyspj: 'ໃບບິນຂົນສົ່ງຕົ້ນສະບັບ',
    jzxhm: 'ນຳເບີຕູ້ສິນຄ້າ',
    qrcg: 'ສຳເລັດການຢືນຢັນ!',
    blzb1: 'ປະເພດທີ່ດໍາເນີນການ:',
    hwzl: 'ນ້ຳໜັກ ສິນຄ້າ',
    pmdm: 'ລະຫັດຊື່ສິນຄ້າ',
    zprq: 'ວັນທີ່ອອກໃບບິນ',
    zpr: 'ຜູ້ເຮັດປີ້',
    bjd: 'ໃບຈ່າຍເງິນເພີ່ມເຕີມ',
    sbm: 'ເລກປະຈໍາຕົວ',
    dhw: 'ເລກໃບບິນຄື',
    fb: 'ປະເພດຄ່າໃຊ້ຈ່າຍ',
    fl: 'ອັດຕາຄ່າໃຊ້ຈ່າຍ',
    fj1: 'ບັນທຶກຄັດຕິດ',
    dm: 'ເລກລະຫັດ',
    //手动新增
    lcbw: 'ຕູ້ເເຊ່ເຢັນ (ຮັກສາອຸນຫະພູມ)',
    qdyc: 'ຕົກລົງທີ່ຈະເອົາອອກ',
    dqxzxz3: 'ປັດຈຸບັນນີ້ຈຳກັດໃຫ້ເລືອກໄດ້ແຕ່ 3 ໄຟລ໌, ຄັ້ງນີ້ໄດ້ເລືອກເເລ້ວ',
    xqdh1Colon: 'ໝາຍເລກໃບສັ່ງຄວາມຕ້ອງການ:',
    zyxmcdm: 'ຊື່ສາຍສະເພາະ (ລະຫັດ)',
  },
  parrent: {
    qsrsjhm: 'ກະລຸນາຕື່ມເບີໂທລະສັບໃສ່',
    qxzjxxx: 'ກະລຸນາເລືອກລຸ້ນຕູ້ຄອນເທັນເນີ',
    qsrhwms: 'ກະລຸນາຕື່ມການບັນລະຍາສິນຄ້າໃສ່',
    qsryhm: 'ກະລຸນາຕື່ມຊື່ຜູ້ນຳໃຊ້ໃສ່',
    qyzyhm: 'ກະລຸນາກວດກາຊື່ຜູ້ນຳໃຊ້',
    qxzysrq: 'ກະລຸນາເລືອກວັນທີຂົນສົ່ງ',
    qxzhwpm: 'ກະລຸນາເລຶອກຊື່ສິນຄ້າ',
    qsrcs: 'ກະລຸນາຕື່ມຈຳນວນລົດ',
    xqcsbnw0: 'ຄວາມຕ້ອງການຂອງຈຳນວນພາຫະນະບໍ່ສາມາດເປັນ 0',
    xqds0_99: 'ຈຳນວນໂຕນທີ່ຄວາມຕ້ອງການ 0~9999999',
    xqdsbnw0: 'ຈຳນວນໂຕນທີ່ຕ້ອງການບໍ່ສາມາດເປັນ0',
    xqdsbncg9999: 'ຈຳນວນໂຕນທີ່ຄວາມຕ້ອງການຫ້າມກາຍ 9999',
    qsrtyf: 'ກະລຸນາເລືອກຝ່າຍຝາກ',
    qxzfz: 'ກະລຸນາເລືອກສະຖານີທີ່ສົ່ງອອກ',
    qsrzcdd: 'ກະລຸນາຕື່ມຈຸດໃສ່ລົດໃສ່',
    qsr2_400wzcdd: 'ກະລຸນາຕື່ມຕໍາເເໜ່ງທີ 2-400 ຂອງສະຖານທີ່ໃສ່ລົດໃສ່',
    qsrjbr: 'ກະລຸນາຕື່ມຂໍ້ມູນຜູ້ດຳເນີນການໃສ່',
    qsr15h18wsfzhm: 'ກະລຸນາຕື່ມເລກປະຈຳຕົວ 15 ຫຼື 18 ໂຕເລກໃສ່',
    qsrshf: 'ກະລຸນາຕື່ມຜູ້ຮັບໃສ່',
    qxzgjz: 'ກະລຸນາເລືອກສະຖານີຊາຍແດນ',
    qxzdz: 'ກະລຸນາເລືອກສະຖານນີທີ່ສົ່ງຮອດ',
    qsrxcdd: 'ກະລຸນາເລືອກຈຸດລົງລົດ',
    qsr2_400wxcdd: 'ກະລຸນາເລືອກຕໍາເເໜ່ງທີ 2-400 ຂອງສະຖານທີ່ລົງລົດ',
    qsrdz: 'ກະລຸນາໃສ່ທີ່ຢູ່',
    qsrmz: 'ກະລຸນາໃສ່ຊື່',
    qsrtyrqdjs: 'ກະລຸນາຕື່ມຈໍານວນທີ່ຜູ້ຝາກເຄື່ອງຢືນຢັນໃສ່',
    qsrqhfygs: 'ກະລຸນາຕື່ມຄ່າໄປຮັບສິນຄ້າທີ່ຄາດຄະເນໃສ່​',
    qsrlc: 'ກະລຸນາຕື່ມໄລຍະທາງໃສ່',
    qsrds: 'ກະລຸນາຕື່ມຈໍານວນໂຕນໃສ່',
    dtblbzd: 'ໃນລາຍການສະການລໍຖ້າລາຍງານສາມາດບັນທຶກຂໍ້ມູນໄດ້ສູງສຸດ 20 ລາຍການ. ກະລຸນາຈັດການຂໍ້ມູນທີ່ມີຢູ່ກ່ອນການລາຍງານ.',
    qnqdtbxxltj: 'ທ່ານກະລຸນາໄປຍື່ນຢູ່ໜ້າຂໍ້ມູນທີ່ລໍຖ້າການຍື່ນ',
    xgcg: 'ເເກໄຂສຳເລັດ',
    xqdhw: 'ໝາຍເລກອໍເດີ້ແມ່ນ',
    xjcg: 'ຕັ້ງໃໝ່ສຳເລັດ',
    qd: 'ຢືນຢັນແນ່ນອນ',
    qxdjyfss: 'ກະລຸນາຄລິກໃສ່ການລອງຄິດໄລ່ຄ່າຂົນສົ່ງກ່ອນ',
    dqbzw: 'ເງິນຕາໃນປະຈຸບັນ',
    czcg: 'ການດໍາເນີນງານສໍາເລັດເເລ້ວ',
    wxts: 'ແຈ້ງເຕືອນ',
    qx: 'ຍົກເລີກ',
    ts: 'ແຈ້ງເຕືອນ',
    sfscckhxx: 'ຈະລົບຂໍ້ມູນລູກຄ້ານີ້ຫຼືບໍ່?',
    sccc: 'ລົບລ້າງສຳເລັດ',
    yqxsc: 'ຍົກເລີກການລົບລ້າງເເລ້ວ',
    sfbdckhmc: 'ຈະຜູກມັດຊື່ລູກຄ້ານີ້ຫຼືບໍ່?',
    bdcg: 'ການຜູກມັດສຳເລັດແລ້ວ',
    qxzycdsj: 'ກະລຸນາເລືອກເອົາ ຂໍ້ມູນທີ່ຈະລົບ',
    cczjyjscgwj: 'ການປະຕິບັດນີ້ຈະລົບເອກະສານໄປຕະຫຼອດໄປ, ຢືນຢັນວ່າຈະຖືກລົບບໍ?',
    yhxxbcz: 'ຂໍ້ມູນຜູ້ໃຊ້ ບໍ່ມີ',
    yhjs: 'ບົດບາດຂອງຜູ້ໃຊ້',
    js: 'ບົດບາດ',
    dqglydhw: 'ເລກໃບຂົນສົ່ງສາກົນໃນປະຈຸບັນແມ່ນ',
    qzsxzytsj: 'ກະລຸນາເລືອກຂໍ້ມູນຢ່າງຕໍ່າໜຶ່ງຂໍ້ມູນ',
    sfscxzyd: 'ລົບໃບບິນທີ່ເລືອກຫຼືບໍ່ ?',
    qxztbnr: 'ກະລຸນາເລືອກເນື້ອໃນທີ່ຈະສົ່ງ',
    tjkxydcg: 'ການສັ່ງຈອງຕູ້ຄອນເທນເນີເປົ່າ ສໍາເລັດ:',
    tjtxydcg:'ຕື່ມຂໍ້ມູນແລະສົ່ງໃບຂົນສົ່ງສິນຄ້າ ສໍາເລັດ',
    ydhw: 'ໝາຍເລກຈອງແມ່ນ',
    xxts: 'ຂໍ້​ຄວາມ​ແຈ້ງ​ເຕືອນ',
    qrtjm: 'ແນ່ໃຈບໍ່ວ່າຈະຍື່ນສະເໜີ?',
    bcmbbxtxmbmc: 'ແມ່ແບບໄຊຟຈໍາຕ້ອງຂຽນຊື່ແມ່ແບບ',
    qxzybtxhdyd: 'ກະລຸນາເລືອກໃບຂົນສົ່ງທີ່ໄດ້ຂຽນເລກຕູ້ເຕີມ',
    qrzfsxjlm: 'ແນ່ໃຈບໍ່ວ່າຈະປະຖິ້ມການບັນທຶກທີ່ເລື້ອກ?',
    zfcg: 'ການຍົກເລີກສໍາເລັດ',
    zsxzytjl: 'ຢ່າງໜ້ອຍເລືອກໜຶ່ງຂໍ້ບັນທຶກ',
    zdxz60tjl: 'ຫຼາຍສຸດໃຫ້ເລືອກການບັນທຶກ60ຂໍ້ ',
    d: 'ສະຖານີມາຮອດຂໍ້',
    tzyrqbnwk: 'ບໍ່ສາມາດເວັ້ນວ່າງໄດ້',
    ttcrxqfsbnwk: 'ບໍ່ສາມາດເວັ້ນວ່າງໄດ້',
    qxztcrxqfs: 'ກະລຸນາເລືອກວິທີສະເຫນີຄວາມຕ້ອງການປະຈໍາວັນ',
    tzdwgjz: 'ເປັນສະຖານີຊາຍແດນ,ຈໍາຕ້ອງໃຊ້ຄວາມຕ້ອງການຂັ້ນຕອນ!',
    qxzjdxq: 'ກະລຸນາເລືອກຄວາມຕ້ອງການຂັ້ນຕອນ',
    tjdxqhbkwk: 'ບໍ່ສາມາດເວັ້ນວ່າງໄດ້',
    qxzjdxqh: 'ກະລຸນາເລືອກເລກຄວາມຕ້ອງການຂັ້ນຕອນ',
    qxzxt: "ກະລຸນາເລືອກແບບດຽວກັນ",
    drxqjxtj: 'ຍື່ນສະເໜີຄວາມຕ້ອງການປະຈໍາວັນຂອງ！',
    qxztyz: 'ກະລຸນາເລືອກແບບດຽວກັນ',
    xqtcfs: 'ວິທີແຈ້ງແຜນຄວາມຕ້ອງການ',
    jxtj: 'ຍື່ນສະເໜີ！',
    qxztyg: 'ກະລຸນາເລືອກອັນດຽວກັນ',
    tcbkwk: 'ບໍ່ສາມາດເວັ້ນວ່າງໄດ້',
    qxzblcc: 'ກະລຸນາເລືອກຖ້ຽວລົດໄຟ',
    dsjcssyrxq: 'ໜ້ອຍກວ່າຈຳນວນລົດທັງໝົດທີ່ລາຍງານໃນ ຄວາມຕ້ອງການປະຈໍາວັນທີ່ເລືອກ!ກະລຸນາເລືອກເລກຄວາມຕ້ອງການຂັ້ນຕອນໃໝ່',
    qdjxrxqtbm: 'ແນ່ໃຈບໍ່ວ່າຈະລາຍງານຄວາມຕ້ອງການປະຈໍາວັນ?',
    tcrxqcg: 'ສະເຫນີຄວາມຕ້ອງການປະຈໍາວັນສໍາເລັດ',
    tcrxqsb: 'ສະເຫນີຄວາມຕ້ອງການປະຈໍາວັນລົ້ມເຫຼວ',
    hgbgdwj: "ເອກະສານແຈ້ງພາສີ",
    xghgbgd:'ດັດແກ້ ໃບແຈ້ງພາສີ',
    czsdbgwjsj:"ເວລາທີ່ສະຖານີລົດໄຟ ໄດ້ຮັບເອກະສານລາຍງານ",
    qxzzcdd: "ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ",
    qxzxcdd: 'ກະລຸນາເລືອກສະຖານທີ່ຂົນລົງລົດ',
    dzbnyfzyz: 'ສະຖານີຮອດແລະສະຖານີອອກ ບໍ່ສາມາດເປັນອັນດຽວໄດ້',
    zsytjythwxx: 'ຢ່າງໜ້ອຍຕ້ອງຕື່ມຂໍ້ມູນສິນຄ້າໜຶ່ງຂໍ້',
    ycxdxsbndy120: 'ຈຳນວນຕູ້ຂະໜາດ 20 ຟຸດບໍ່ສາມາດກາຍ 120ໄດ້',
    xsbndy60: 'ຈຳນວນຕູ້ຂະໜາດ 40 ຟຸດບໍ່ສາມາດກາຍ  60 ໄດ້',
    qxzfkxx: 'ກະລຸນາເລືອກຂໍ້ມູນຈ່າຍເງິນ',
    qsrffhm: 'ກະລຸນາໃສ່ນໍ້າເບີ້ຈ່າຍເງິນ',
    qxzbzxx: 'ກະລຸນາເລືອກຂໍ້ມູນສະກຸນເງິນ',
    cjxsxh: 'ເລກຕູ້ນໍ້າຂາອອກບໍ່ສາມາດເວັ້ນເປົ່າໄດ້, ກະລຸນາຂຽນເລກຕູ້',
    qsryxqy: 'ກະລຸນາໃສ່ບໍລິສັດໃຊ້ຕູ້',
    yxqyyw: 'ບໍລິສັດໃຊ້ຕູ້ມີຂໍ້ຜິດພາດ, ບໍ່ມີເລກໃບເອົາຕູ້ທີ່ກ່ຽວຂ້ອງ, ກະລຸນາພິມໃຫມ່',
    qxzxqtcfs: 'ກະລຸນາເລືອກວິທີສະເຫນີຄວາມຕ້ອງການ',
    hhwxxbwk: 'ຂໍ້ມູນສິນຄ້າບໍ່ສາມາດເວັ້ນວ່າງໄດ້',
    zhwmc: 'ຊື່ສິນຄ້າ, ເລກຕູ້, ຂະໜາດຕູ້, ປະເພດຕູ້, ກຳມະສິດຕູ້,ຕູ້ເປົ່າຫຼືຕູ້ໜັກບໍ່ສາມາດເວັ້ນວ່າງໄດ້',
    zhwmckc: 'ຊື່ສິນຄ້າ,ເລກຕູ້ຄອນເທນເນີ,ປະເພດຕູ້ຄອນເທນເນີ,ຊະນິດຕູ້ຄອນເທນເນີ,ເຈົ້າຂອງຕູ້,ຕູ້ຄອນເທນເນີເປົ່າ,ເລກລົດບັນທຸກ ແລະຂໍ້ມູນຄົນຂັບລົດ ທັງໝົດນີ້ແມ່ນ ບໍ່ສາມາດຈົ່ງຫວ່າງເປົ່າໄດ້',
    zy20yc: 'ມີພຽງແຕ່ປະເພດຕູ້ 20 ຟຸດ ຈິ່ງເລືອກໃບສົ່ງຕູ້ດຽວໄດ້',
    bcmbbxtx: 'ແມ່ແບບໄຊຟຈໍາຕ້ອງຂຽນຊື່ແມ່ແບບ',
    txydbxyyxhsj: 'ການຂຽນໃບສົ່ງສິນຄ້າຕ້ອງມີຂໍ້ມູນເລກຕູ້',
    gjzdz: 'ສະຖານີຮອດຜ່ານຊາຍແດນຕ້ອງມີຂໍ້ມູນເລກຕູ້',
    gjzdzbxyxh: 'ສະຖານີຮອດຜ່ານຊາຍແດນຕ້ອງມີຂໍ້ມູນເລກຕູ້',
    txzbnwk: 'ສະຖານີເອົາຕູ້ບໍ່ສາມາດເວັ້ນວ່າງໄດ້',
    qxztxrq: 'ກະລຸນາເລືອກວັນທີເອົາຕູ້',
    q5xyz: 'ກະລຸນາເລືອກສະຖານີຕົ້ນທາງ,ສະຖານີປາຍ,ຊື່ສິນຄ້າ,ຜູ້ຈັດສົ່ງແລະຜູ້ຮັບສິນຄ້າ ທີ່ເປັນຖານຂໍ້ມູນທັງ5ລາຍການທີ່ສອດຄ່ອງກັນ',
  },
  billTypesFile: {
    ptfp: 'ໃບບິນທົ່ວໄປ',
    zyfp: 'ໃບບິນສະເພາະ'
  },
  advancePayCustomer: {
    grmc: 'ຊື່ສ່ວນຕົວ',
    qsrgrmc: 'ກະລຸນາໃສ່ຊື່ສ່ວນຕົວ',
    yckje: 'ຈຳນວນເງິນຝາກລ່ວງໜ້າ (ຢວນ)',

  },
  state: {
    czz: 'ກຳລັງເຕີມເງິນ',
    czcg: 'ເຕີມເງິນສໍາເລັດແລ້ວ',
    czsb: 'ເຕີມເງິນບໍ່ສຳເລັດ',
    yfkkz: 'ກຳລັງຫັກຄ່າຂົນສົ່ງ',
    yfkkcg: 'ຫັກຄ່າຂົນສົ່ງສຳເລັດແລ້ວ',
    yfkksb: 'ຫັກຄ່າຂົນສົ່ງບໍ່ສຳເລັດ',
    dsh: 'ລໍຖ້າກວດສອບຢືນຢັນ'
  },
  customer: {
    dzzh: 'ບັນຊີທີ່ຮັບເງິນ',
    skrxm: 'ຊື່ຜູ້ຮັບເງິນ',
    ssyh: 'ທະນາຄານທີ່ຂຶ້ນກັບ',
    txyy: 'ເຫດຜົນການຖອນເງິນ',
    jjyy: 'ເຫດຜົນປະຕິເສດ',
    sbyy: 'ເຫດຜົນທີ່ລົ້ມເຫຼວ',
    tg: 'ຮັບຮອງເອົາ'
  },
  lp: {
    tpr: 'ຜູ້ຮ້ອງຂໍທ່າທົດແທນ',
    hwsssl: 'ຈຳນວນສິນຄ້າທີ່ສູນເສຍ',
    tprq: 'ວັນທີຮ້ອງຂໍທ່າທົດແທນ',
    tpje: 'ຈໍານວນເງິນທົດແທນທີ່ຮ້ອງຂໍ',
    sjpcje: 'ຈໍານວນເງິນທົດແທນຕົວຈິງ',
    ajh: 'ເລກເອກະສານກໍລະນີ',
    jlhm: 'ບັນທຶກຫມາຍເລກ',
    bzrq: 'ວັນທີສ້າງຕັ້ງ',
    jlbzz: 'ສະຖານີບັນທຶກຮຽບຮຽງ',
    hyjl: 'ບັນທຶກການຂົນສົ່ງ',
    hwssfcs: 'ໃບກວດຕອບການເສຍຫາຍສິນຄ້າ',
    hwssdztzs: 'ໃບແຈ້ງການກ່ຽວກັບຄວາມຮັບຜິດຊອບຕໍ່ການເສຍຫາຍສິນຄ້າ',
    aj: 'ເອກະສານກໍລະນີ',
    fs: 'ຍື່ນສົ່ງ',
    hyjlh: 'ເລກບັນທຶກການສົ່ງສິນຄ້າ',
    dzrq: 'ວັນທີກໍານົດຄວາມຮັບຜິດຊອບ',
    zsz: 'ສະຖານີຈັດສົ່ງຫລັກ',
    bzz: 'ສະຖານີຮຽບຮຽງ',
    dsgs: 'ບໍລິສັດປະເມີນການສູນເສຍ',
    z: 'ສະຖານີ',
    tbr: 'ຜູ້ຂຽນແບບຟອມ',
    tzh: 'ເລກໃບແຈ້ງການ',
    clz: 'ສະຖານີຈັດການ',
    sgdw: 'ພາກສ່ວນເກັບຊື້',
    yjrq: 'ວັນທີສົ່ງມອບ',
    lcsj: 'ເວລາລົດໄຟ',
    fgs: 'ບໍລິສັດສົ່ງ',
    dgs: 'ບໍລິສັດຮອດ',
    djcz: 'ສະຖານີລົງທະບຽນ',
    djrq: 'ວັນທີລົງທະບຽນ',
    zt: 'ທາງລົດໄຟຈີນ',
    lt: 'ທາງລົດໄຟລາວ'
  },
  register: {
    md: 'ບໍ່ເຕນ',
    nd: 'ນາເຕີຍ',
    lblb: 'ຫຼວງພະບາງ',
    wxn: 'ວຽງຈັນໃຕ້',

    qyxx: 'ຂໍ້ມູນບໍລິສັດ',
    qyzcmc: 'ຊື່ວິສາຫະກິດທີ່ລົງທະບຽນ',
    wljlqyda: 'ເພື່ອສ້າງໂປຣໄຟລ໌ຂອງບໍລິສັດ,ແລະສະແດງການຄ້າທຸລະກິດຂອງບໍລິສັດ,ກະລຸນາຕື່ມປະຫວັດໂດຍຫຍໍ້ຂອງບໍລິສັດຢ່າງລະອຽດ',
    xyb: 'ຂັ້ນ​ຕອນ​ຕໍ່​ໄປ',
    qy: 'ວິສາຫະກິດ',
    gr: 'ບຸກຄົນ',

    scsfz: 'ກະລຸນາອັບໂຫລດບັດປະຈຳຕົວ',
    tjrmx: 'ເພີ່ມໃບໜ້າ',
    tjfrmx: 'ເພີ່ມໃບໜ້າທີ່ບໍ່ແມ່ນຂອງຄົນ',
    dlmm: 'ລະຫັດຜ່ານເຂົ້າສູ່ລະບົບ',
    wsqyxxh: 'ຫຼັງຈາກຕື່ມຂໍ້ມູນບໍລິສັດສຳເລັດແລ້ວ,ສາມາດເພີດເພີນກັບບໍລິການຕໍ່ໄປນີ້:',
    gdxwzx: 'ຂໍ້ມູນຂ່າວສານເພີ່ມເຕີມ',
    tbysxq: 'ສົ່ງຄວາມຕ້ອງການການຂົນສົ່ງ',
    ydyszy: 'ຈອງຊັບພະຍາກອນການຂົນສົ່ງ',
    hwqcgz: 'ຕິດຕາມສິນຄ້າທຸກຂັ້ນຕອນ',
    bjgt: 'ການສື່ສານສະດວກ,ການບໍລິການທີ່ມີຄຸນນະພາບ',
    yhxx: 'ຂໍ້ມູນຜູ້ນໍາໃຊ້',
    gly: 'ຜູ້ບໍລິຫານ',
    zhcy: 'ບໍລິສັດກວມລວມ',
    cmqy: 'ວິສາຫະກິດຜະລິດຖ່ານຫີນ',
    hmqy: 'ວິສາຫະກິດທີ່ນໍາໃຊ້ຖ່ານຫີນ',
    xjqyxx: 'ຂໍ້ມູນການກໍ່ຕັ້ງວິສາຫະກິດໃໝ່',

    yhzc: 'ລົງທະບຽນຜູ້ນໍາໃຊ້ ',
    zcwtgxg: 'ການລົງທະບຽນບໍ່ໄດ້ຜ່ານການດັດແກ້ຂໍ້ມູນ ',
    gryh: 'ຜູ້ນໍາໃຊ້ ບຸກຄົນ',
    qyyh: 'ຜູ້ນໍາໃຊ້ ວິສາຫະກິດ',
    zcshwtg: 'ການລົງທະບຽນ ຍັງບໍ່ໄດ້ຮັບການກວດສອບເທື່ອ',
    ljxg: 'ແກ້ໄຂຕອນນີ້',
    ckshwtgyy: 'ຍັງບໍ່ຜ່ານເຫດຜົນການກວດສອບ',
    txqyjbxx: 'ຂຽນຂໍ້ມູນພື້ນຖານວິສາຫະກິດ',
    sczjzl: 'ອັບໂຫຼດຂໍ້ມູນບັດຢັ້ງຢືນ',
    txjbrxx: 'ຂຽນຂໍ້ມູນຜູ້ປະສານງານ',
    xzfwcz: 'ເລືອກສະຖານນີລົດບໍລິການ',
    hz: 'ການກ່ຽວພັນຂອງຕົວແທນຂົນສົ່ງສິນຄ້າ',
    hd: 'ເຈົ້າຂອງສິນຄ້າ',
    frzjlx: 'ປະເພດບັດ ນິຕິບຸກຄົນ',
    sfz: 'ໂປຣເເກຣມ',
    huzhao: 'ພາສພອດ',
    djsc: 'ກົດເພື່ອອັບໂຫຼດ',
    clsm: 'ຄູ່ມືວັດສະດຸ',
    zjlx: 'ປະເພດບັດ',
    fsyzm: 'ສົ່ງລະຫັດຢືນຢັນ',
    fwcz: 'ສະຖານນີລົດບໍລິການ ',
    fwcztext: 'ກະລຸນາເລືອກສະຖານີບໍລິການ. ຫຼັງຈາກການກວດສອບອອນໄລນ໌ສໍາເລັດແລ້ວ, ທ່ານຈໍາເປັນຕ້ອງເອົາເອກະສານທີ່ກ່ຽວຂ້ອງໄປສະຖານີເພື່ອສໍາເລັດການກວດສອບການຢືນຢັນແບບອອບໄລນ໌.',
    tj: 'ສົ່ງອອກ',
    txgrjbxx: 'ຂຽນຂໍ້ມູນພື້ນຖານບຸກຄົນ',
    cksl: 'ເບິ່ງໃນຕົວຢ່າງ',
    zcxxtjcg: 'ສົ່ງຂໍ້ມູນການລົງທະບຽນສຳເລັດແລ້ວ',
    zcjg1: 'ຜົນ​ການກວດກາ​ອອນ​ໄລ​ນ​ຈະ​ຖືກ​ສົ່ງ​ໄປ​ຫາ​ທາງ SMS / ອີ​ເມວ​ພາຍ​ໃນ 48 ຊົ່ວ​ໂມງ​',
    zcjg2: 'ກະ​ລຸ​ນາ​ກວດ​ສອບ​ເບີໂທລະ​ສັບ​ / ອີ​ເມວ​ຂອງ​ທ່ານ​!',
    zcsj: 'ເບີໂທລະສັບລົງທະບຽນ',
    jbr: 'ຄົນດຳເນີນການ',
    qd: 'ຢືນຢັນແນ່ນອນ',
    apptext: 'ບໍລິການຂົນສົ່ງສິນຄ້າຄົບວົງຈອນ APP',
    apptext1: 'ເພື່ອຍົກລະດັບປະສົບການການເຮັດວຽກການຂົນສົ່ງສິນຄ້າຂອງທ່ານໃຫ້ສູງຂຶ້ນ，ກາລຸນາສະແກນ ຄິວອາໂຄດ，ໂຫຼດAPP ການບໍລິການຂົນສົ່ງສິນຄ້າຄົບວົງຈອນ',
    qyxxxg: 'ດັດແກ້ຂໍ້ມູນວິສາຫະກິດ',
    jbrsjh: 'ເບີໂທລະສັບມືຖືຂອງຜູ້ປະສານງານ',
    zcmm: 'ລະຫັດຜ່ານເຂົ້າສູ່ລະບົບ',
    yzm: 'ລະຫັດຢືນຢັນ',
    grxxxg: 'ດັດແກ້ຂໍ້ມູນການລົງທະບຽນຂອງບຸກຄົນ',
    khfwxy: 'ສັນຍາການບໍລິການລູກຄ້າ',
    ji: 'ແລະ',
    ysqzc: 'ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ',
    sltp: 'ຮູບພາບຕົວຢ່າງ',
    qxzyxgdyhlx: 'ກາລຸນາເລືອກປະເພດຜູ້ນໍາໃຊ້ ເພື່ອດັດແກ້ສິ່ງທີ່ຕ້ອງການ',
    qtxqymc: 'ຂຽນຊື່ວິສາຫະກິດ',
    qtxtyshxydm: 'ກາລຸນາລະບຸເລກບັດເຄດິດ',
    qtxqyyyzzhm: 'ກາລຸນາລະບຸ ເລກລະຫັດວິສາຫະກິດ',
    qtxzczj: 'ກາລຸນາລະບຸ ທຶນຈົດທະບຽນ',
    qxzzczjbz: 'ກາລຸນາເລືອກ ສະກຸນເງິນທຶນຈົດທະບຽນ',
    qxzsshy: 'ກາລຸນາລະບຸ ທຸລະກິດຂອງທ່ານ',
    qxzjjxz: 'ກາລຸນາລະບຸ ລັກສະນະເສດຖະກິດ',
    qtxjjxzms: 'ກາລຸນາຂຽນລາຍລະອຽດ ລັກສະນະເສດຖະກິດ',
    qxzqyxz: 'ກາລຸນາລະບຸ ລັກສະນະວິສາຫະກິດ',
    qxzjglx: 'ກາລຸນາເລືອກ ປະເພດອົງກອນ',
    qtxjyfw: 'ກາລຸນາຂຽນຂໍ້ມູນ ຂອບເຂດການດໍາເນີນທຸລະກິດ ',
    qtxfddbr: 'ກາລຸນາຂຽນຊື່ຜູ້ຕາງໜ້ານິຕິບຸກຄົນ',
    qxzfrzjlx: 'ກາລຸນາເລືອກບັດຢັ້ງຢືນນິຕິບຸກຄົນ',
    qxzfrgj: 'ກາລຸນາລະບຸສັນຊາດຂອງນິຕິບຸກຄົນ',
    qtxfrsfzhm: 'ກາລຸນາລະບຸເລກບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    qxzfrsfzyxq: 'ກາລຸນາລະບຸ ອາຍຸການນໍາໃຊ້ບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    qtxfrhzhm: 'ກາລຸນາລະບຸ ເລກພາສພອດຂອງນິຕິບຸກຄົນ',
    qxzfrhzyxq: 'ກາລຸນາລະບຸ ອາຍຸການນໍາໃຊ້ພາສພອດຂອງນິຕິບຸກຄົນ',
    sshy1: 'ກະສິກໍາ, ປ່າໄມ້, ລ້ຽງສັດ ແລະການປະມົງ',
    sshy2: 'ອຸດສາຫະກໍາຂຸດຄົ້ນບໍ່ແຮ່',
    sshy3: 'ການຜະລິດ',
    sshy4: 'ອຸດສາຫະກໍາສໍາລັບການຜະລິດ ແລະການສະໜອງໄຟຟ້າ,ນໍ້າ ແລະອາຍແກດ',
    sshy5: 'ອຸດສາຫະກໍາກໍ່ສ້າງ',
    sshy6: 'ອຸດສຫະກໍາ ໄປສະນີ,ສາງ ແລະການຄົມມະນາຄົມຂົນສົ່ງ',
    sshy7: 'ອຸດສາຫະກໍາດ້ານຂໍ້ມູນຂ່າວສານ, ບໍລິການຄອມພິວເຕີ ແລະຊອບແວ',
    sshy8: 'ທຸລະກິດຂາຍສົ່ງ ແລະຂາຍຍ່ອຍ',
    sshy9: 'ທຸລະກິດໂຮງແຮມ ແລະຮ້ານກິນດື່ມ',
    sshy10: 'ທຸລະກິດດ້ານການເງິນ',
    sshy11: 'ທຸລະກິດດ້ານອະສັງຫາລິມະສັບ',
    sshy12: 'ທຸລະກິດບໍລິການດ້ານການຄ້າ ແລະການໃຫ້ເຊົ່າ',
    sshy13: 'ທຸລະກິດດ້ານການສໍາຫຼວດ, ການຄົ້ນຄ້ວາວິທະຍາສາດ ແລະການບໍລິການເຕັກໂນໂລຊີ',
    sshy14: 'ວຽກງານຄຸ້ມຄອງນໍ້າ, ສິ່ງແວດລ້ອມ ແລະຄຸ້ມຄອງສະຖານທີ່ສາທາລະນະ',
    sshy15: 'ການບໍລິການທີຢູ່ອາໃສ ແລະການບໍລິການອື່ນໆ',
    sshy16: 'ການສຶກສາ',
    sshy17: 'ວຽກງານສາທາລະນາສຸກ, ສະວັດດີການ ແລະປະກັນສັງຄົມ',
    sshy18: 'ດ້ານວັດທະນາທໍາ, ກິລາ ແລະບັນເທີງ',
    jjxz1: 'ວິສາຫະກິດເອກະຊົນ',
    jjxz2: 'ລັດວິສາຫະກິດ',
    jjxz3: 'ວິສາຫະກິດປະສົມ',
    jjxz4: 'ກຸ່ມວິສາຫະກິດ',
    jjxz5: 'ອື່ນ ໆ',
    jjlx1: 'ວິສາຫະກິດ ມີນິຕິບຸກຄົນ',
    jjlx2: 'ວິສາຫະກິດ ທີ່ບໍ່ມີນິຕິບຸກຄົນ',
    jjlx3: 'ທຸລະກິດ ມີນິຕິບຸກຄົນ',
    jjlx4: 'ທຸລະກິດ ທີ່ບໍ່ມີນິຕິບຸກຄົນ',
    jjlx5: 'ກຸ່ມບໍລິສັດ ມີນິຕິບຸກຄົນ',
    jjlx6: 'ກຸ່ມບໍລິສັດ ທີ່ບໍ່ມີນິຕິບຸກຄົນ',
    jjlx7: 'ອົງກອນ ມີນິຕິບຸກຄົນ',
    jjlx8: 'ອົງກອນ ທີ່ບໍ່ມີນິຕິບຸກຄົນ',
    jjlx9: 'ບຸກຄົນ',
    jjlx10: 'ສະພາແຮງງານ ມີນິຕິບຸກຄົນ',
    jjlx11: 'ອົງກອນ ທີ່ບໍ່ແມ່ນວິສາຫະກິດ',
    jjlx12: 'ປະເພດອື່ນໆ',
    qscyyzz: 'ກາລຸນາອັບໂຫຼດໃບທະບຽນວິສາຫະກິດ',
    qscwtzm: 'ກາລຸນາອັບໂຫຼດໃບຢັ້ງຢືນການມອບໝາຍ',
    qxzyzzzyxq: 'ກາລຸນາລະບຸ ອາຍຸການນໍາໃຊ້ໃບທະບຽນວິສາຫະກິດ',
    qscfrsfzzmzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານໜ້າ ບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    qscfrsfzbmzp: 'ກະລຸນາອັບໂຫຼດຮູບຖ່າຍດ້ານຫຼັງບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    qscfrscsfzzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານໜ້າ ມືຖືບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    qscfrhzxxyzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານທີ່ມີຂໍ້ມູນ ພາສພອດຂອງນິຕິບຸກຄົນ',
    qscfrschzxxyzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານທີ່ມີຂໍ້ມູນ ມືຖືພາສພອດຂອງນິຕິບຸກຄົນ',
    qxzymzzzmyxq: 'ກາລຸນາລະບຸ ອາຍຸການນໍາໃຊ້ ໃບຢັ້ງຢືນຄຸນນະພາບການຂົນສົ່ງຖ່ານຫີນ',
    qxztdzzwsyxq: 'ກາລຸນາລະບຸ ອາຍຸການນໍາໃຊ້ ເອກະສານການປູກພືດທົດແທນ',
    qxztksydzmyxq: 'ກາລຸນາລະບຸ ອາຍຸການນໍາໃຊ້ ໃບຢັ້ງຢືນການເຄື່ອນຍ້າຍແຮ່ເຫຼັກ',
    qxjzxxxyxq: 'ກະລຸນາເລືອກໄລຍະເວລາທີ່ມີຜົນນໍາໃຊ້ຂອງສັນຍາຕູ້ຄອນເທນເນີ',
    qxzscclyxq: 'ກາລຸນາເລືອກການອັບໂຫຼດ ອາຍຸການນໍາໃຊ້ເອກະສານ',
    qtxscclms: 'ກາລຸນາລະບຸລາຍລະອຽດ ເອກະສານ',
    qtxxm: 'ກາລຸນາລະບຸ ຊື່ແລະນາມສະກຸນ',
    qxzgj: 'ກາລຸນາລະບຸ ສັນຊາດ',
    qxzzjlx: 'ກາລຸນາລະບຸ ປະເພດບັດຢັ້ງຢືນ',
    qtxsfzhm: 'ກາລຸນາລະບຸ ເລກບັດປະຈໍາຕົວ',
    qxzsfzyxq: 'ກາລຸນາລະບຸ ອາຍຸການນໍາໃຊ້ບັດປະຈໍາຕົວ ',
    qtxhzhm: 'ກາລຸນາລະບຸ ເລກພາສພອດ ',
    qxzhzyxq: 'ກາລຸນາລະບຸ ອາຍຸການນໍາໃຊ້ພາສພອດ ',
    qtxdlmm: 'ກາລຸນາລະບຸ ລະຫັດຜ່ານເພື່ອເຂົ້າລະບົບ ',
    qtxqrmm: 'ກາລຸນາລະບຸ ລະຫັດຜ່ານເພື່ອຢືນຢັນເຂົ້າລະບົບ ',
    lcsrdmmbyz: 'ການໃສ່ລະຫັດຜ່ານສອງຄັ້ງບໍ່ຄືກັນ ',
    qxzdhgjqh: 'ກາລຸນາລະບຸ ລະຫັດໂທລະສັບລະຫວ່າງປະເທດ ',
    qsrsjh: 'ກາລຸນາລະບຸໝາຍເລກໂທລະສັບມືຖື ',
    sjhyzc: 'ເບີໂທລະສັບ ໄດ້ລົງທະບຽນແລ້ວ ',
    qsryzm: 'ກາລຸນາລະບຸລະຫັດຢືນຢັນ',
    qscsfzzmzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານໜ້າບັດປະຈໍາຕົວ',
    qscgrscsfzzmzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານໜ້າມືຖືບັດປະຈໍາຕົວຂອງບຸກຄົນ',
    qschzxxyzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານຂໍ້ມູນພາສພອດ',
    qscgrschzxxyzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານຂໍ້ມູນມືຖືພາສພອດຂອງບຸກຄົນ',
    qxzfwcz: 'ກາລຸນາເລືອກ ສະຖານນີລົດບໍລິການ ',
    qtxzcmm: 'ກະລຸນາລະບຸລະຫັດຜ່ານລົງທະບຽນ',
    tis0: 'ບັນຊີນີ້ບໍ່ມີຂໍ້ມູນການລົງທະບຽນ ຫຼືການກວດສອບຂໍ້ມູນມີການຜິດພາດແມ່ນບໍ່',
    tis1: 'ການອັບໂຫຼດຮູບຕ້ອງແມ່ນ ຮູບແບບ JPG、JPEG、BMP、PNG ເທົ່ານັ້ນ  ',
    tis3: 'ການອັບໂຫຼດຮູບຕ້ອງແມ່ນ ຮູບແບບ JPG、JPEG、BMP、PNG、DOC、DOCX、TXT、PDF   ເທົ່ານັ້ນ!',
    tis2: 'ຂະໜາດການອັບໂຫຼດຮູບ ບໍ່ສາມາດເກີນ 5MB',
    frdbsfzzmzp: 'ຮູບດ້ານໜ້າບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    frdbsfzbmzp: 'ຮູບບັດປະຈໍາຕົວດ້ານຫຼັງຂອງຜູ້ຕາງໜ້ານິຕິບຸກຄົນ',
    frdbscsfzzm: 'ຮູບດ້ານໜ້າມີຖີບັດປະຈໍາຕົວຂອງນິຕິບຸກຄົນ',
    frdbhzzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານຂໍ້ມູນພາສພອດຂອງນິຕິບຸກຄົນ',
    frdbschzzp: 'ກາລຸນາອັບໂຫຼດຮູບດ້ານຂໍ້ມູນມືຖືພາສພອດຂອງນິຕິບຸກຄົນ',
    text1: 'ຍິນດີຕ້ອນຮັບເຂົ້າສູ່ການລົງທະບຽນ!',
    text2: 'ກະລຸນາເລືອກປະເພດຜູ້ໃຊ້ທີ່ທ່ານຕ້ອງການລົງທະບຽນ',
    text3: 'ລົງທະບຽນ',
    text4: 'ວິສາຫະກິດ',
    text5: 'ຜູ້ນໍາໃຊ້ ບຸກຄົນ',
    text6: 'ໄປລົງທະບຽນ',
    yzx: 'ຮູ້ຈັກແລ້ວ',
    ycxzdtj5wj: 'ເພີ່ມໄດ້ສູງສຸດ 5 ໄຟລ໌ຕໍ່ຄັ້ງ',
    cksltip1: 'ກະລຸນາອັບໂຫລດຮູບ ຫຼື ສະແກນເອກະສານຕົ້ນສະບັບ ແລະ ໃຫ້ແນ່ໃຈວ່າຮູບພາບເຫັນໄດ້ຊັດເຈນ',
    cksltip2: 'ຫຼັງຈາກການດາວໂຫຼດແມ່ແບບໃບຢັ້ງຢືນການມອບໝາຍ, ພິມ ແລະ ປະທັບຕາຢ່າງເປັນທາງການຂອງບໍລິສັດ, ສະແກນ ຫຼື ຖ່າຍຮູບ ແລະ ອັບໂຫລດ.',
    sfjbr: 'ແມ່ນຜູ້ປະຕິບັດງານບໍ່',
    zccghts: 'ຫຼັງຈາກສໍາເລັດການລົງທະບຽນແລ້ວ, ຜູ້ປະຕິບັດງານແມ່ນມີໜ້າທີ່ຮັບຜິດຊອບໃນການຮັກສາໃບສະເໜີແລະຂໍ້ມູນຂອງວິສະຫະກິດ/ກວດສອບຕົວແທນບໍລິການ, ເພີ່ມຜູ້ປະຕິບັດງານ ແລະໜ້າຮັບຜິດຊອບອື່ນໆ.',
  },
  jkck: {
    jjsj: 'ເວລາມອບຮັບ',
    gd: 'ເສັ້ນທາງລົດໄຟທີ່ມີຕົວເລກພາຍໃນສະຖານີ',
    hybx: 'ປະກັນໄພສິນຄ້າ',
    hccljjd: 'ໃບມອບຮັບລົດສິນຄ້າ',
    cxdh: 'ຊອກເລກໃບບິນ',
    be: 'ຈຳນວນປະກັນໄພ',
    bf: 'ລາຄາປະກັນໄພ',
    zc: 'ປົກກະຕິ',
  },
  reg: {
    qsrqymc: 'ກະລຸນາຕື່ມຊື່ບໍລິສັດຈຳນວນ2-50ຕົວ',
    qxzshj: 'ກະລຸນາເລືອກກົມທີ່ກວດສອບ',
    qydz: 'ກະລຸນາຕື່ມທີ່ຕັ້ງບໍລິສັດຈຳນວນ4-100ຕົວ',
    qylx: 'ກະລຸນາເລືອກປະເພດບໍລິສັດ',
    qyjj: 'ກະລຸນາຕື່ມປະຫວັດຂອງບໍລິສັດໂດຍຫຍໍ້',
    qsrzqsz: 'ກະລຸນາຕື່ມຕົວເລກໃຫ້ຖືກຕ້ອງຈຳນວນ1-20ຕົວ',
    qsrmc: 'ກະລຸນາຕື່ມຊື່ຈຳນວນ4-50ຕົວ',
    qsrljdz: 'ກະລຸນາຕື່ມທີ່ຢູ່ເວັບໄຊລ໌ຈຳນວນ1-50ຕົວ',
    qsrqydh: 'ກະລຸນາຕື່ມເບີໂທບໍລິສັດ',
    qsryx: 'ກະລຸນາຕື່ມທາງທ້າຍຂອງອີເມວcomຫຼືcom.cnໃຫ້ຖືກຕ້ອງ',
    qsrzh: 'ກະລຸນາຕື່ມຕົວອັກສອນຫຼືຕົວເລກຫຼືຕົວອັກສອນກັບຕົວເລກປະສົມກັນຈຳນວນ2-20ຕົວ',
    qxzssqy: 'ກະລຸນາເລືອກຂື້ນກັບບໍລິສັດ',
    qxzyhjs: 'ກະລຸນາເລືອກຂື້ນກັບບໍລິສັດ',
    qsrxm: 'ກະລຸນາຕື່ມຊື່ຈຳນວນ2-20ຕົວ',
    qxzjglx: 'ກະລຸນາເລືອກປະເພດ',
    qzcsrmm: 'ກະລຸນາໃສ່ລະຫັດອີກຄັ້ງ',
    qscyyzz: 'ກະລຸນາອັບໂຫລດໃບທະບຽນວິສະຫະກິດ',
    qscjg: 'ກະລຸນາອັບໂຫລດລະຫັດໃບຢັ້ງຢືນອົງການຈັດຕັ້ງ',
    qscsw: 'ກະລຸນາອັບໂຫລດໃບຢັງຢືນການລົງທະບຽນພາສີ',
    qsclogo: 'ກະລຸນາອັບໂຫລດໂລໂກຂອງບໍລິສັດ',
    qsctp: 'ກະລຸນາອັບໂຫລດຂະໜາດຮູບນ້ອຍກ່ວາ2M',
  },
  header: {
    xxzx: 'ສູນຂໍ້ມູນຂ່າວສານ',
    yjjc: 'ຂໍ້ຕົກລົງການແຈ້ງເຕືອນໄພລ່ວງໜ້າ',
    ngxt: 'ລະບົບການຄຸ້ມຄອງພາຍໃນ',
    czsc: 'ຄູ່ມືດໍາເນີນງານ',
    sz: 'ຕັ້ງຄ່າ',
    tc: 'ອອກຈາກລະບົບ',
    zc: 'ລົງທະບຽນ'
  },
  consultation: {
    chengshi: 'ເມືອງ',
    zm: 'ຊື່ສະຖານີ',
    czjj: 'ການແນະນຳສະຖານີໂດຍຫຍໍ້',
    yyzdz: 'ທີ່ຢູ່ສະຖານີທຸລະກິດ',
    slfwdh: 'ເບີໂທສາຍດ່ວນບໍລິການ',
    bllbmc: 'ຊື່ປະເພດການບໍລິການ',
    jij1: 'ລາຄາຕົ້ນທຶນ1',
    jij2: 'ລາຄາຕົ້ນທຶນ2',
    bz: 'ມາດຕະຖານ',
    hwzxjzfl1: 'ອັດຕາຄ່າໂຫຼດແລະປ່ຽນຖ່າຍສິນຄ້າທີ່ເປັນມາດຖານກໍານົດໄວ້(ຢວນ/ໂຕນ)',
    czzxfl: 'ອັດຕາຄ່າໂຫຼດແລະປ່ຽນຖ່າຍສິນຄ້າຢູ່ໃນສະຖານີລົດໄຟ',
    smzxfl: 'ອັດຕາຄ່າບໍລິການໂຫຼດແລະປ່ຽນຖ່າຍສິນຄ້າເພື່ອການຂົນສົ່ງ ເຖິງສະຖານທີ່',
    bjfl: 'ອັດຕາຄ່າປະກັນໄພ %',
    xh: 'ລໍາດັບ',
    sfbz: 'ມາດຕະຖານເກັບຄ່າບໍລິການ',
    sfxm: 'ລາຍການເກັບຄ່າບໍລິການ',
    sfyj: 'ພື້ນຖານເກັບຄ່າບໍລິການ',
    czcx: 'ປະເພດຍານພາຫະນະ',
    qxzczcx: 'ກະລຸນາເລືອກປະເພດຍານພາຫະນະ',
    zz: 'ນໍ້າໜັກຕົວຍານພາຫະນະ(t)',
    qtxzz: 'ກະລຸນາລະບຸນໍ້າໜັກຕົວຍານພາຫະນະ',
    zaiz: 'ນໍ້າໜັກບັນທຸກ(t):',
    qtxzaiz: 'ກະລຸນາລະບຸນໍ້າໜັກໂຫຼດສິນຄ້າ',
    czdm: 'ລະຫັດປະເພດຍານພາຫະນະ',
    zs: 'ຈໍານວນແກນ',
    syyxsd: 'ລະດັບຄວາມໄວທາງການຄ້າ(km/h)',
    yxrj: 'ປະສິດທິພາບທີບັນຈຸໄດ້(m³)',
    clzdkg: 'ຍານພາຫະນະທີ່ໃຫຍ່ສຸດ(ກ້ວາງxສູງ)(mm)',
    cnckg: 'ດ້ານໃນຍານພາຫະນະ(ຍາວxກ້ວາງxສູງ)(mm)',
    ctcz: 'ວັດສະດຸຂອງຕົວລົດ'
  },
  trackStateQuery: {
    wlgs_wpdMsg: '当前接取送达单未派单，请先派单后再继续打印提箱单！(ES)',
    wpdMsg: '物流公司未派单，请先联系物流公司！(ES)',
    dqwz: 'ສະຖານທີ່ປະຈຸບັນ',
    track: 'ກວດສອບແລະຕິດຕາມທຸກຂັ້ນຕອນການຂົນສົ່ງ',
    blztcx: 'ກວດເບິ່ງສະຖານະການດໍາເນີນການ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    qxz: '==ກະລຸນາເລືອກ==',
    xqh: 'ເລກທີຄວາມຕ້ອງການ',
    qsrxqh: 'ກະລຸນາຕື່ມເລກທີຄວາມຕ້ອງການໃສ່',
    zcrq: 'ວັນທີບັນຈຸໃສ່ລົດ',
    ksrq: 'ວັນທີ່ເລີ່ມຕົ້ນ',
    zhi: 'ຫາ',
    jsrq: 'ວັນທີສິ້ນສຸດ',
    hwmc: 'ຊື່ສິນຄ້າ',
    qsrhwmc: 'ກະລຸນາໃສ່ຊື່ຂອງສິນຄ້າ',
    tyr: 'ຜູ້ຂົນສົງສີ້ນຄ້າ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    zyx: 'ສາຍສະເພາະ',
    tlhc: 'ລານສີນຄ້າທາງລົດໄຟ',
    shr: 'ຜູ້ຮັບເຄື່ອງ',
    dz: 'ສະຖານີລົດໄຟທີ່ສົ່ງຮອດ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    ch: 'ເລກທີພາຫະນະ',
    xh: 'ລໍາດັບ',
    fkfs: 'ວິທີການຊໍາລະເງິນ',
    yck: 'ເງິນຝາກລ່ວງໜ້າ',
    xj: 'ເງິນສົດ',
    zhip: 'ໃບເຊັກ',
    yhk: 'ບັດທະນາຄານ',
    hzzf: 'ການຊໍາລະເງິນລວມ',
    ydh: 'ເລກທີໃບຂົນສົ່ງ',
    zdsj: 'ເວລາປິ່ນໃບບິນ',
    kssj: 'ເວລາເລີ່ມຕົ້ນ',
    jssj: 'ເວລາສິ້ນສຸດ',
    ydlx: 'ປະເພດໃບຂົນສົ່ງ',
    gjly: 'ການຂົນສົ່ງລະຫວ່າງປະເທດ',
    ptys: 'ການຂົນສົ່ງທົ່ວໄປ',
    zfzt: 'ສະຖານະການຊໍາລະ',
    dzf: 'ລໍຖ້າຊໍາລະ',
    yzhif: 'ຍົກເລີກ',
    zfz: 'ກຳລັງຊໍາລະເງິນ',
    yjs: 'ໄດ້ສໍາເລັດສະຫຼຸບບັນຊີລາຍຮັບລາຍຈ່າຍ',
    ydzt: 'ສະຖານະໃບບິນ',
    dsl: 'ລໍຖ້າຍອມຮັບ',
    dddsl: 'ລໍຖ້າພະແນກຄວບຄຸມການເດີນລົດຍອມຮັບແຜນ',
    sltg: 'ຜ່ານການດໍາເນີນການ',
    slwtg: 'ການຍອມຮັບລົ້ມເຫລວ',
    yzc: 'ບັນຈຸໃສ່ລົດແລ້ວ',
    yzd: 'ສ້າງລາຍການແລ້ວ',
    yfc: 'ລົດອອກໄປແລ້ວ',
    ydd: 'ມາຮອດແລ້ວ',
    yxc: 'ຂົນເຄື່ອງລົງແລ້ວ',
    hwyjf: 'ໄດ້ສົ່ງມອບສິນຄ້າແລ້ວ',
    yzuof: 'ຍົກເລີກແລ້ວ',
    chax: 'ຄົ້ນຫາ ',
    qingk: 'ລົບຂໍ້ມູນທັງໝົດ',
    syrxqcx: 'ກວດເບິ່ງຄວາມຕ້ອງການປະຈໍາວັນ',
    zhank: 'ຂະຫຍາຍ',
    shouq: 'ທົບເຂົ້າ',
    zj: 'ລວມທັງໝົດ',
    t: 'ລາຍການ',
    ckxq: 'ກວດສອບລາຍລະອຽດ',
    ybg: 'ປ່ຽນແປງແລ້ວ',
    chak: 'ກວດເບິ່ງ',
    bgdz: 'ປ່ຽນສະຖານີທີ່ສົ່ງຮອດ',
    pldy: 'ປິ້ນເປັນງວດ',
    daochu: 'ດຶງອອກ',
    yyh: 'ຄິວຈອງ',
    ddmlh: 'ໝາຍເລກຄໍາສັ່ງຈັດສັນ',
    bgyqr: 'ຜູ້ສະເໜີໃຫ້ປ່ຽນແປງ​',
    xshr: 'ຜູ້ຮັບສິນຄ້າໃໝ່',
    xdaoz: 'ສະຖານີສົ່ງຮອດໃໝ່',
    bgyy: 'ເຫດຜົນປ່ຽນແປງ',
    sctp: 'ອັບໂຫຼດຮູບພາບ',
    qd: 'ຢືນຢັນແນ່ນອນ',
    zdsctp3: 'ອັບໂຫຼດຮູບພາບໄດ້ຫຼາຍສຸດ3ໃບ',
    ydxx: 'ຂໍ້ມູນໃບຂົນສົ່ງ',
    bllb: 'ປະເພດການດຳເນີນງານ',
    yslx: 'ປະເພດຂົນສົ່ງ',
    fhxx: 'ຂໍ້ມູນສົ່ງສິນຄ້າ',
    tuoyf: 'ຜູ້ຝາກເຄື່ອງ ',
    txdz: 'ທີ່ຢູ່ການຕິດຕໍ່',
    dianh: 'ເບີໂທ',
    fj: 'ກົມລົດໄຟສົ່ງອອກ ',
    rxsjz: 'ເວລາເຊື່ອມຕໍ່ເຂົ້າສູ່ລະບົບ(ໂຫຼດສິນຄ້າເພື່ອບັນຈຸ)',
    kzsj: 'ເວລາເລີ່ມຕົ້ນ',
    zwsj: 'ເວລາສິ້ນສຸດ',
    cxsjz: 'ເວລາອອກຈາກລະບົບ(ໂຫຼດສິນຄ້າເພື່ອບັນຈຸ)',
    shxx: 'ຂໍ້ມູນຮັບເຄື່ອງ',
    shouhf: 'ຜູ້ຮັບເຄື່ອງ',
    daoj: 'ກົມລົດໄຟທີ່ສົ່ງຮອດ',
    rxsjx: 'ເວລາເຊື່ອມຕໍ່ເຂົ້າສູ່ລະບົບ(ປ່ຽນຖ່າຍສິນຄ້າ)',
    kxsj: 'ເວລາການເລີ່ມຂົນສິນຄ້າລົງ',
    xwsj: 'Time for completing unloading ',
    cxsjx: 'ເວລາອອກຈາກລະບົບ(ປ່ຽນຖ່າຍສິນຄ້າ)',
    jfsjx: 'ເວລາສົ່ງມອບສິນຄ້າ(ປ່ຽນຖ່າຍສິນຄ້າ)',
    hwxx: 'ຂໍ້ມູນສິນຄ້າ',
    hwjs: 'ຈຳນວນສິນຄ້າ',
    hwtz: 'ຄຸນລັກສະນະຂອງສິນຄ້າ ',
    sfh: 'ເລກຫັຍງຈັກຢ່າງຢູ່ໃນລົດຂົນສົ່ງ',
    pbh: 'ເລກຜ້າປົກ',
    hwms: 'ບັນລະຍາຍສິນຄ້າ',
    ysxx: 'ຂໍ້ມູນຂົນສົ່ງ',
    chez: 'ປະເພດລົດ',
    chengz: 'ເປັນກຸ່ມ',
    dzbg: 'ປ່ຽນແປງທາງເອເລັກໂທນິກ',
    jzsx: 'ເຫດການບັນທຶກ',
    bx: 'ປະກັນໄພ',
    zffs: 'ວິທີການຊໍາລະ',
    bz: 'ສະກຸນເງິນ',
    dzzfyhfzf: 'ຄ່າໃຊ້ຊໍາລະອື່ນແມ່ນຝ່າຍໃດຮັບຜິດຊອບ',
    back: 'ກັບຄືນ',
    zt: 'ສະຖານະ',
    ytb: 'ລາຍງານແລ້ວ',
    dccg: 'ຈອງລົດ ສໍາເລັດ',
    dcwcg: 'ຈອງລົດ ຍັງບໍ່ສໍາເລັດ',
    qcfs: 'ຮູບແບບການຂໍນໍາໃຊ້ຍານພາຫະນະ',
    crxq: 'ຄວາມຕ້ອງການໃນວັນຕໍ່ໄປ',
    bcxq: 'ຄວາມຕ້ອງການເພີ່ມເຕີມ',
    yunf: 'ຄ່າຂົນສົ່ງ',
    fksj: 'ເວລາຊໍາລະເງິນ',
    fccc: 'ເລກຖຽວລົດໄຟທີ່ປ່ອຍອອກ',
    fcsj: 'ເວລາລົດໄຟທີ່ຖືກປ່ອຍອອກ',
    dzsj: 'ເວລາຮອດສະຖານີ',
    jfsj: 'ເວລາສົ່ງມອບ',
    ddmlm: 'ເລກລະຫັດຄໍາສັ່ງຄວບຄຸມຕາຕະລາງຈັດຂົນສົ່ງ',
    cyrqdzl: 'ນ້ໍາໜັກທີ່ກໍານົດຈາກຜູ້ບໍ່ລິການຂົນສົ່ງ (ກິໂລ)',
    cyjs: 'ຈໍານວນສິນຄ້າທີ່ຖືກຂົນສົ່ງ',
    slh: 'ເລກທີດໍາເນີນການ',
    hwpl: 'ປະເພດສິນຄ້າ',
    xqcs: 'ຈໍານວນພາຫະນະທີ່ຕ້ອງການ',
    xqds: 'ຈຳນວນໂຕນທີ່ຄວາມຕ້ອງການ',
    dccgs: 'ຈໍານວນລົດທີ່ສໍາເລັດການຈອງລົດ',
    dccgds: 'ຈໍານວນໂຕນທີ່ສໍາເລັດການຈອງລົດ',
    wccs: 'ຈໍານວນພາຫະນະທີ່ສໍາເລັດ',
    ystz: 'ລັກສະນະ ການຂົ່ນສົ່ງ',
    tbsj: 'ເວລາ ການແຈ້ງເຕືອນ',
    tbqy: 'ບໍລິສັດ ທີ່ແຈ້ງເຕືອນ',
    quanx: 'ລຶບບ',
    zhanwusj: 'ບໍ່​ມີ​ຂໍ້​ມູນ',
    caoz: 'ດໍາເນີນງານ',
    qxzyd: 'ກະລຸນາເລືອກໃບຂົນສົ່ງ',
  },
  trackGlyd: {
    ytblb:"ໄດ້ສົ່ງໃບແຈ້ງລາຍການ",
    wdyxq:"ຄວາມຕ້ອງການປະຈໍາເດືອນຂອງຂ້ອຍ",
    // fzdm:"发站代码",
    // ddldm:"到达路代码",
    // dzdm:"到站代码",
    // cyrjc:"承运人简称",
    // ffdm:"付费代码",
    // zfrmc:"支付人名称",
    // jianc:"简称",
    // qidian:"起点",
    // zhongdian:"终点",
    // daima:"代码",
    // wjlx:"文件类型",
    // fenshu:"份数",
    // wwmc:"外文名称",
    // wjhm:"文件号码",
    // bzrq:"编制日期",
    // djyshtdrq:"缔结运输合同的日期",
    glhwzz: 'ການຕິດຕາມສິນຄ້າລະຫວ່າງປະເທດ',
    ckyd: 'ໃບບິນສົ່ງອອກ',
    jkyd: 'ໃບບິນຂາເຂົ້າ',
    chax: 'ຄົ້ນຫາ',
    qingk: 'ລົບຂໍ້ມູນທັງໝົດ',
    zhank: 'ຂະຫຍາຍ',
    shouq: 'ທົບເຂົ້າ',
    ckgj: 'ເບິ່ງຕິດຕາມ',
    hwgj: 'ຕິດຕາມສິນຄ້າ',
    hwjz: 'ສິນຄ້າຂາເຂົ້າ',
    zche: 'ບັນຈຸໃສ່ລົດ',
    fche: 'ລົດອອກເດີນທາງ',
    zait: 'ກຳລັງຂົນສົ່ງ',
    dz: 'ສະຖານີລົດໄຟທີ່ສົ່ງຮອດ',
    xche: 'ຂົນລົງຈາກລົດ',
    xqh: 'ເລກທີຄວາມຕ້ອງການ',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    tuoyf: 'ຜູ້ຝາກເຄື່ອງ',
    ch: 'ເລກທີພາຫະນະ',
    ydh: 'ເລກທີໃບຂົນສົ່ງ',
    shouhf: 'ຜູ້ຮັບເຄື່ອງ',
    hwmc: 'ຊື່ສິນຄ້າ',
    chuj: 'ອອກນອກປະເທດ',
    yjddsj: 'ຄາດວ່າຈະມາຮອດໃນເວລາ',
    yjsylc: 'ໄລຍະທາງທີ່ຍັງເຫຼືອປະມານ',
    back: 'ກັບຄືນ',
    pjlx: 'ປະເພດໃບບິນ',
    dzpj: 'ໃບເກັບເງິນເອເລັກໂຕຣນິກ',
    dzhp: 'ປີ້ສິນຄ້າອີເລັກໂທຣນິກ',
    dzyzf: 'ຄ່າຂົນສົ່ງທາງອີເລັກໂທຣນິກ',
    glyd: 'ໃບບິນຂົນສົ່ງສາກົນ',
    ydhbcz: 'ບໍ່ມີໝາຍເລກໃບບິນ',
    qb: 'ທັງໝົດ',
    dy1: 'ໜ້າທີໜຶ່ງ',
    dy2: 'ໜ້າທີສອງ',
    dy3: 'ໜ້າທີສາມ',
    dy4: 'ໜ້າທີສີ່',
    dy5: 'ໜ້າທີຫ້າ',
    dy6: 'ໜ້າທີຫົກ',
    dy7: 'ຄູ່ທີເຈັດ',
    dy: 'ພິມ',
    zprq: 'ວັນທີ່ອອກໃບບິນ',
    ksrq: 'ວັນທີເລີ່ມຕົ້ນ',
    zhi: 'ຫາ',
    jsrq: 'ວັນທີສິ້ນສຸດ',
    gjz: 'ສະຖານີຊາຍແດນ ',
    bllx: 'ຮູບແບບການນຳ້',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    qxz: '==ກະລຸນາເລືອກ==',
    zhengc: 'ການຂົນສົງໂດຍລົດໄຟ',
    jzx: 'ການຂົນສົ່ງສິນຄ້າທີ່ບໍ່ເຕັມລົດ',
    xh: 'ລໍາດັບ',
    mdj: 'ບໍ່ເຕນ (ຊາຍແດນ)',
    qxzzprq: 'ກະລຸນາເລືອກວັນທີປິ່ນໃບບິນ',
    qxzgjz: 'ກະລຸນາລະບຸສະຖານີຊາຍແດນ',
    xh1: 'ເລກຕູ້:',
    xx: 'ຮູບແບບຕູ້ຄອນເທັນເນີ:',
    xl: 'ປະເພດຕູ້ຄອນເທັນເນີ :',
    ziz: 'ນໍ້າໜັກຕົນ​ເອງ:',
    yyh: 'ຄິວຈອງ',
    xqdh: 'ຕອບສະຫນອງຂໍ້ມູນ',
    tbrq: 'ວັນທີ່ຂຽນຟອມ',
    ph: 'ເລກທີງວດ',
    ydzt: 'ສະຖານະໃບບິນ',
    dsl: 'ລໍຖ້າຍອມຮັບ',
    dddsl: 'ລໍຖ້າພະແນກຄວບຄຸມການເດີນລົດຍອມຮັບແຜນ',
    sltg: 'ຜ່ານການດໍາເນີນການ',
    slwtg: 'ການຍອມຮັບລົ້ມເຫລວ',
    yzc: 'ບັນຈຸໃສ່ລົດແລ້ວ',
    yzp: 'ອອກໃບບິນແລ້ວ',
    zjf: 'ຈ່າຍແລ້ວ',
    yzd: 'ສ້າງລາຍການແລ້ວ',
    yfc: 'ລົດອອກໄປແລ້ວ',
    ydd: 'ມາຮອດແລ້ວ',
    yddkaz: 'ຮອດດ່ານແລ້ວ',
    ycj: 'ອອກປະເທດແລ້ວ',
    mdrj: 'ເຂົ້າດ່ານບໍ່ເຕັນ',
    yxc: 'ຂົນເຄື່ອງລົງແລ້ວ',
    hwyjf: 'ໄດ້ສົ່ງມອບສິນຄ້າແລ້ວ',
    yzuof: 'ຍົກເລີກແລ້ວ',
    bllb: 'ປະເພດການດຳເນີນງານ',
    fhr: 'ຜູ້ຝາກເຄື່ອງ',
    daoj: 'ກົມລົດໄຟທີ່ສົ່ງຮອດ',
    tbqy: 'ບໍລິສັດ ທີ່ແຈ້ງເຕືອນ',
    jzxxx: 'ຂໍ້ມູນຕູ້ຄອນເທນເນີ',
    slbtgyy: 'ເຫດຜົນທີ່ບໍ່ຜ່ານການຈັດການ',
    hggj: 'ຜ່ານດ່ານພາສີ',
    kadl: 'ຕົວແທນຂອງດ່ານ',
    jianshu: 'ຈໍານວນເຄື່ອງ​',
    hwzl: 'ນ້ຳໜັກ ສິນຄ້າ',
    hth: 'ເລກທີສັນຍາ',
    tyfjs: 'ບັນທຶກຜູ້ຈັດສົ່ງສິນຄ້າ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    lxfs: 'ວິທີຕິດຕໍ່​',
    md: 'ບໍ່ເຕັນ',

    yrj: 'ເຂົ້າ​ໄປ​ໃນ​ປະ​ເທດແລ້ວ',
    fzw: 'ສະຖານີສົ່ງອອກແມ່ນ:',
    ccw: 'ໂຕເລກໂຮງ:',
    hwjg: 'ສິນຄ້າຜ່ານ',
    dzw: 'ສະຖານີຮອດແມ່ນ:',
    xqdhbcz: 'ບໍ່ມີເລກທີໃບລາຍການຄວາມຕ້ອງການ',
  },
  trackGoods: {
    hwddyc: 'ຄາດການສິນຄ້າຮອດປາຍທາງ',
    fdlx: 'ປະເພດຂໍ້ມູນຕົ້ນທາງແລະປາຍທາງ',
    fh: 'ສົ່ງສິນຄ້າ',
    shouh: 'ຮັບສິນຄ້າ',
    dz: 'ສະຖານີລົດໄຟທີ່ສົ່ງຮອດ',
    shouhf: 'ຜູ້ຮັບເຄື່ອງ',
    xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',
    ydsj: 'ເວລາທີ່ຄາດການຮອດປາຍທາງ',
    hwmc: 'ຊື່ສິນຄ້າ',
    chez: 'ປະເພດລົດ',
    ksrq: 'ວັນທີເລີ່ມຕົ້ນ',
    qsr: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    qxz: '==ກະລຸນາເລືອກ==',
    zyx: 'ສາຍສະເພາະ',
    tlhc: 'ລານສີນຄ້າທາງລົດໄຟ',
    guanc: 'ລົດກະປ໋ອງ',
    pengc: 'ລົດພວງ',
    changc: 'ໄຂພວງ',
    pingc: 'ລົດພຽງ',
    lengcc: 'ລົດເຢັນ',
    jzxc: 'ລົດຄອນເທັນເນີ',
    kuangsc: 'ລົດບັນທຸກແຮ່',
    changhdwc: 'ລົດບັນທຸກສິນຄ້າຍາວແລະໃຫຍ່',
    dupc: 'ລົດຂົນສົ່ງຢາເສບຕິດ',
    jiacc: 'ລົດຂົນສົ່ງລັດລ້ຽງ',
    sanzlsc: 'ລົດບັນສະບຽງອາຫານທີ່ບໍ່ໄດ້ຫຸ້ມຫໍ່',
    tezc: 'ຍານພາຫະນະພິເສດ',
    qit: 'ອື່ນໆ',
    qsrdz: 'ກະລຸນາຕື່ມສະຖານີທີ່ສົ່ງຮອດໃສ່',
    qsrshf: 'ກະລຸນາຕື່ມຜູ້ຮັບໃສ່',
    fz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',
    tuoyf: 'ຜູ້ຝາກເຄື່ອງ',
    zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',
    qsrfz: 'ກະລຸນາເລືອກສະຖານີຕົ້ນທາງ',
    qsrfhf: 'ກະລຸນາຕື່ມຂໍ້ມູນຜູ້ສົ່ງເຄື່ອງອອກໃສ່',
    hwpl: 'ປະເພດສິນຄ້າ',
    ches: 'ຈໍານວນພາຫະນະ',
    hwyjddqk1: 'ສະຖານີ>',
    hwyjddqk: 'ຄາດການສິນຄ້າຈາກສະຖານີຮອດປາຍທາງ',
    nengy: 'ພະລັງງານ',
    kuangs: 'ແຮ່',
    gcqx: 'ເຄຶ່ອງອຸປະກອນ ແລະວັດສະດູເຫຼັກ',
    jzx: 'ການຂົນສົ່ງສິນຄ້າທີ່ບໍ່ເຕັມລົດ',
    lsnf: 'ອາຫານ ແລະຜະລິດຕະພັນກະສິກໍາ',
    shyp: 'ຜະລິດຕະພັນເຄື່ອງໃຊ້ປະຈໍາວັນ',
    qthzhw: 'ສິນຄ້າປະສົມຕ່າງໆ',
    chax: 'ຄົ້ນຫາ',
    qingk: 'ລົບຂໍ້ມູນທັງໝົດ',
    zhank: 'ຂະຫຍາຍ',
    shouq: 'ທົບເຂົ້າ',
    ckdt: 'ກວດເບິ່ງແຜນທີ່',
  },
  myMessage: {
    xxxq: 'ລາຍລະອຽດຂໍ້ມູນ',
    qbxx: 'ຂໍ້ມູນທັງໝົດ',
    ysfw: 'ບໍ່ລິການຂົນສົ່ງ',
    daib: 'ກໍາລັງດໍາເນີນການ',
    qb: 'ທັງໝົດ',
    yd: 'ອ່ານແລ້ວ',
    wd: 'ຍັງບໍ່ໄດ້ອ່ານ',
    back: 'ກັບຄືນ',
    title: 'ຫົວຂໍ້',
    sous: 'ຄົ້ນຫາ',
    plyd: 'ຈໍານວນຊຸດສິນຄ້າ ໄດ້ອ່ານແລ້ວ',
    plsc: 'ລົບຈຳນວນຫຼາຍ',
    sj: 'ເວລາ',
    lx: 'ປະເພດ',
    title1: 'ການດໍາເນີນງານນີ້ຈະລຶບຂໍ້ມູນນີ້ຖາວອນ, ຈະສືບຕໍ່ຫຼືບໍ່​?',
    title2: 'ຂໍ້​ຄວາມ​ແຈ້ງ​ເຕືອນ',
    yes: 'ແມ່ນ',
    no: 'ປະຕິເສດ',
    yqxsc: 'ຍົກເລີກການລົບລ້າງເເລ້ວ',
    czcg: 'ການດໍາເນີນງານສໍາເລັດເເລ້ວ',
    sccg: 'ລົບລ້າງສໍາເລັດ',
  },
  jzxwork: {
    qscwj:"ກະລຸນາອັບໂຫຼດໄຟລ",
    dqscxz:"ປັດຈຸບັນສາມາດອັບໂຫຼດໄດ້ພຽງ 10ໄຟລ ເທົ່ານັ້ນ",
    cftpsc:"ອັບໂຫຼດຮູບພາບໃໝ່ອີກຄັ້ງ",
    qsczdgs: "ກະລຸນາອັບໂຫຼດຮູບພາບໃນຮູບແບບຕ່າງເຊັ່ນ: .jpg,.bmp,.jpeg,.png",
    dytxd: "ປິ້ນໃບຮັບຕູ້ຄອນເທນເນີ",
    txd: "ໃຈແຈ້ງຂໍເອົາຕູ້",
    tip61: 'ວັນທີຮອດ',
    gdmc: 'ເສັ້ນທາງລົດໄຟໃນສະຖານີ',
    tip380: 'ກະລຸນາໃສ່ຊື່ເສັ້ນທາງລົດໄຟໃນສະຖານນີ',
    tip37: 'ລົດ​ທັງ​ຫມົດ​',
    swh: 'ເລກອັນດັບ',
    czch: 'ຮູບແບບລົດ/ເລກລົດ',
    tip492: 'ເລກໃບຮ້ອງຂໍ1',
    tip493: 'ເລກໃບຮ້ອງຂໍ2',
    tip494: 'ເລກໃບຮ້ອງຂໍ3',
    tip431: 'ເລກລົດ/ຖ້ຽວລົດ',
    ddsj: 'ເວລາຮອດ',
    xh3: 'ເລກຕູ້3',
    tip343: 'ແຜນການບັນຈຸໃສ່ລົດ',
    rxsj: 'ເວລາເຂົ້າເສັ້ນ',
    xzrxsj: 'ເລືອກເວລາເຂົ້າເສົ້ນ',
    xzkzsj: 'ເລືອກເວລາເລີ່ມຈັດໂຫຼດ',
    xzzwsj: 'ເລືອກເວລາທີ່ບັນຈຸໃຫ້ສໍາເລັດ',
    rxbnzydd: 'ເວລາເຂົ້າເສັ້ນບໍ່ສາມາດໄວກວ່າເວລາມາຮອດ',
    kzbnzyrx: 'ເວລາເລີ່ມໂຫຼດເຄື່ອງບໍ່ສາມາດໄວກວ່າເວລາເຂົ້າເສັ້ນ',
    zwbnzykz: 'ເວລາທີ່ບັນຈຸໃຫ້ສຳເລັດບໍ່ສາມາດໄວກວ່າເວລາເລີ່ມບັນຈຸ',
    rxsjbnwk: 'ເວລາເຂົ້າເສັ້ນບໍ່ສາມາດເປົ່າຫວ່າງ',
    kzsjbnwk: 'ເວລາເລີ່ມໂຫຼດເຄື່ອງບໍ່ໃຫ້ປະຫວ່າງ',
    zwsjbnwk: 'ທີ່ເວລາບັນຈຸໃຫ້ສຳເລັດບໍ່ໃຫ້ປະຫວ່າງ',
    qxzgd: 'ກະລຸນາເລືອກເສັ້ນທາງລົດໄຟ',
    qdtjgxx: 'ຢືນຢັນສົ່ງຂໍ້ມູນນີ້ຫຼືບໍ?',
    tip163: 'ຍື່ນສົ່ງສຳເລັດ,ກະລຸນາດໍາເນີນການ "ຢືນຢັນການອອກເສັ້ນ" ໃຫ້ທັນເວລາ',
    tip5: 'ບໍ່ສາມາດສົ່ງຊໍ້າແຜນການຂໍ້ມູນທີ່ໂຫຼດເຄື່ອງໃສ່ລົດ!!!',
    tip544: 'ການສະເໜີຕູ້ລົດໄຟໄດ້ຮັບອະນຸມັດ',
    tip545: 'ການສະເໜີຕູ້ລົດໄຟຍັງບໍ່ທັນໄດ້ຮັບອະນຸມັດ',
    tip200: 'ຂໍ້ມູນບໍ່ຖືກເລືອກ!',
    tip272: 'ຂໍ້ມູນຕູ້ເກີດຄວາມເສຍຫາຍ!',
    tip351: 'ກະລຸນາຢ່າເລືອກໃບຮ້ອງຂໍທີ່ບໍ່ໄດ້ຮັບການອະນຸມັດ!',
    qbyxcfxh: 'ກະລຸນາຢ່າເລືອກບ່ອນວ່າງຕູ້ທີ່ຊໍ້າກັນ！',
    tip378: 'ກະລຸນາໃສ່ເລກຕູ້1！',
    tip211: 'ພື້ນທີ່ຫວ່າງຂອງລົດຄັນນີ້ບໍ່ພຽງພໍທີ່ໃສ່ຕູ້ນີ້ໄດ້!',
    tip209: 'ຕູ້ນີ້ແມ່ນຮອດສະຖານີ 【',
    tip2: '】ບໍ່ຕົງກັບຕູ້ເລກທີ 1 ທີ່ຮອດສະຖານີ !',
    tip210: 'ເລກຕູ້ນີ້ແມ່ນຊໍ້າກັບເລກຕູ້ເບີ 1!',
    tip212: 'ພື້ນທີ່ຫວ່າງຂອງລົດຄັນນີ້ບໍ່ພຽງພໍ!',
    qxzzsyt: 'ກະລຸນາເລືອກໜຶ່ງຂໍ້ບັນທຶກຢ່າງໜ້ອຍ',
    tip4: 'ບໍ່ສາມາດຍົກເລີກຂໍ້ມູນທີ່ຍັງບໍ່ທັນສົ່ງ!!!',
    qdcxm: 'ຢືນຢັນຍົກເລີກຫຼືບໍ?',
    yqxcx: 'ຍົກເລີກການຍົກເລີກແລ້ວ',
    tip489: 'ແຜນການບັນຈຸຄອນເທັນເນີໃສ່ລົດ',
    tip486: 'ແຜນການບັນຈຸຄອນເທນເນີລົງລົດ',
    tip416: 'ວັນທີສັ່ງໃຫ້ເຂົ້າ',
    tip501: 'ຮັບລົດລ່ວງໜ້າ',
    ydh: 'ເລກໃບຂົນສົ່ງ',
    tip155: 'ນ້ໍາຫນັກທີ່ໄດ້ຂົນສົ່ງ',
    tip398: 'ກະລຸນາເລືອກເວລາເລີ່ມຕົ້ນ',
    tip410: 'ກະລຸນາເລືອກເວລາຈົບ',
    cxsj: 'ເວລາອອກເສັ້ນ',
    tip395: 'ກະລຸນາເລືອກເວລາເດີນທາງອອກເສັ້ນ',
    tip17: 'ປະເພດວຽກທີ່ດຳເນີນ',
    tip308: 'ປະເພດ1',
    tip393: 'ກະລຸນາເລືອກປະເພດການເຮັດວຽກ',
    tip14: 'ວິທີດຳເນີນວຽກ',
    tip186: 'ຮູບແບບ1',
    tip392: 'ກະລຸນາເລືອກວິທີການເຮັດວຽກ',
    tip328: 'ຜູ້ບັນຈຸແລະຂົນສົງສິນຄ້າ​',
    tip381: 'ກະລຸນາໃສ່ຜູ້ບັນຈຸແລະຂົນລົງ',
    tip230: 'ຜູ້ຕິດຕາມການໂຫຼດແລະຂົນລົງສິນຄ້າ',
    tip231: 'ຜູ້ຕິດຕາມການໂຫຼດແລະຂົນລົງສິນຄ້າບໍ່ໃຫ້ປະຫວ່າງ',
    tip375: 'ກະລຸນາໃສ່ຜູ້ຕິດຕາມການບັນຈຸແລະຂົນລົງ',
    tip331: 'ທີມງານບັນຈຸສິນຄ້າ',
    tip332: 'ທີ່ທີມງານບັນຈຸສິນຄ້າບໍ່ໃຫ້ປະຫວ່າງ',
    tip383: 'ກະລຸນາໃສ່ທີມງານບັນຈຸແລະຂົນລົງ',
    tip66: 'ຂົນສິນຄ້າລົງຈາກລົດ',
    tip127: 'ເວລາເລີ່ມຕົ້ນບໍ່ສາມາດໄວກວ່າເວລາເຂົ້າເສັ້ນ',
    tip314: 'ເວລາສິ້ນສຸດບໍ່ສາມາດໄວກວ່າເວລາເລີ່ມຕົ້ນ',
    tip46: 'ເວລາອອກເສັ້ນບໍ່ສາມາດໄວກວ່າເວລາຈົບ',
    tip63: 'ເວລາຮອດບໍ່ສາມາດເປົ່າຫວ່າງ',
    tip126: 'ເວລາເລີ່ມຕົ້ນບໍ່ໃຫ້ປະຫວ່າງ',
    tip313: 'ເວລາສິ້ນສຸດບໍ່ໃຫ້ປະຫວ່າງ',
    tip45: 'ເວລາອອກເສັ້ນບໍ່ສາມາດເປົ່າຫວ່າງ',
    tip329: 'ຜູ້ບັນຈຸແລະຂົນສົງສິນຄ້າບໍ່ໃຫ້ປະຫວ່າງ',
    tip405: 'ກະລຸນາເລືອກບ່ອນໃສ່ຕູ້！',
    tip240: 'ຢືນຢັນຂົນລົງສິນຄ້າຫຼືບໍ?',
    tip48: 'ສະຖານະການອອກເສັ້ນ',
    tip498: 'ອັນດັບ',
    xzcxsj: 'ເລືອກເວລາອອກເສົ້ນ',
    lx: 'ປະເພດ',
    tip10: 'ຈຳນວນເຄື່ອງ',
    tip44: 'ເວລາອອກເສັ້ນບໍ່ສາມາດໄວກວ່າເວລາໂຫຼດໃສ່ເຄື່ອງໃຫ້ສຳເລັດ',
    tip239: 'ຕົກລົງຢືນຢັນອອກເສັ່ນຫຼືບໍ?',
    tip115: 'ໄດ້ດຳເນີນການຍົກເລີກແລ້ວ',
    tip113: 'ຂໍ້​ມູນ​ທີ່ອອກເສັ້ນແລ້ວ​ບໍ່​ສາ​ມາດ​ສົ່ງຊໍ້າໄດ້!!!',
    tip49: 'ຢືນຢັນອອກເສັ້ນ',
    tip82: 'ເອົາປີ້',
    tip568: 'ຍັງບໍ່ທັນອອກສາຍ',
    tip569: 'ອອກສາຍແລ້ວ',
    tip318: 'ຂໍ້ມູນເສັ້ນທາງລົດໄຟໃນສະຖານີ',
    ch: 'ເລກລົດ',
    tip502: 'ສັນ​ຍາ​ລັກລົດທີ່ຈະຮັບ',
    tip438: 'ເລກໃບຂົນສົ່ງ3',
    tip427: 'ປະເພດ/ຮູບແບບ/ເລກລົດ',
    tip418: 'ນ້ຳໜັກສິນຄ້າ',
    tip35: 'ຢືນຢັນເຂົ້າເສັ້ນ',
    tip197: 'ຊອກລາຍການໂຫຼດແລະຂົນລົງສິນຄ້າບໍ່ເຫັນ',
    tip140: 'ເລກຕູ້ທີ່ເລືອກແມ່ນຊໍ້າກັນ',
    tip56: 'ປະເພດຂອງສະຖານີຕົ້ນທາງແລະປາຍທາງ',
    tip396: 'ກະລຸນາເລືອກເຄື່ອງໝາຍແຈ້ງທິດທາງຂອງສະຖານີອອກເດີນທາງ ແລະ ສະຖານີຮອດ',
    tip104: 'ເລີ່ມຈັດສົ່ງ',
    tip310: 'ປາຍທາງ',
    tip467: 'ແຈ້ງຮັບເອົາລົດ',
    wtz: 'ບໍ່ໄດ້ແຈ້ງການ',
    ytz: 'ແຈ້ງການແລ້ວ',
    tip468: 'ສະຖານະພາບການແຈ້ງມາຮັບເອົາລົດ',
    tip522: 'ສະຖານີລົດໄຟ',
    tip327: 'ເວລາບັນຈຸຂື້ນ/ລົງ',
    tip413: 'ກະລຸນາເລືອກຂໍ້ບັນທຶກທີ່ຕ້ອງແຈ້ງ',
    tip354: 'ກະລຸນາເລືອກເຄື່ອງໝາຍແຈ້ງທິດທາງຂອງສະຖານີອອກເດີນທາງ ແລະ ສະຖານີຮອດກ່ອນ',
    tip214: 'ລາຍການ',
    tip121: 'ການແຈ້ງເຕືອນສຳເລັດແລ້ວ, ບໍ່ຈໍາເປັນດຳເນີນຊ້ໍາອີກ!',
    tip134: 'ຕູ້ປະຈຸບັນ',
    tip348: 'ທີ່ບັນທຶກບໍ່ມີເລກລາຍການ ແລະບໍ່ສາມາດຈັດການຮັບເອົາລົດໄດ້!',
    tip470: 'ແຈ້ງສຳເລັດ',
    tip135: 'ບັນ​ທຶກປະຈຸ​ບັນ​ໄດ້​​ແຈ້ງ​ໃຫ້ມາເອົາ​ລົດ​ແລ້ວ, ບໍ່​​ຕ້ອງດຳເນີນອີກ​!',
    tip136: 'ບັນທຶກປະຈຸບັນຂາດໝາຍເລກລາຍການ ,ບໍ່ສາມາດດຳເນີນການຮັບເອົາລົດໄດ້!',
    tip469: 'ແຈ້ງບໍ່ສຳເລັດ',
    lhrq: 'ວັນທີເອົາເຄື່ອງ',
    jssj: 'ເວລາສິ້ນສຸດ',
    dxtzbz: 'ເຄື່ອງໝາຍການແຈ້ງການຂອງຂໍ້ຄວາມ',
    cz: 'ຕັ້ງໃໝ່',
    lhid: 'IDທີ່ເອົາເຄື່ອງ',
    xxdh: 'ເລກໃບຮ້ອງຂໍ',
    shjbr: 'ຜູ້ດຳເນີນການຮັບສິນຄ້າ',
    shjbrdh: 'ເບີໂທຂອງຜູ້ດຳເນີນການຮັບສິນຄ້າ',
    fhjbr: 'ຜູ້ດຳເນີນການຝາກເຄື່ອງ',
    fhjbrdh: 'ເບີໂທລະສັບທີ່ຜູ້ດຳເນີນການຝາກເຄື່ອງອອກ',
    tznr: 'ເນື້ອໃນແຈ້ງການ',
    tzfs: 'ວິທີແຈ້ງ',
    lhdh: 'ເບີໂທສຳລັບການເອົາເຄື່ອງ',
    xcsj: 'ເວລາຂົນລົງສິນຄ້າ',
    zsxzytjl: 'ຢ່າງໜ້ອຍເລືອກໜຶ່ງຂໍ້ບັນທຶກ',
    qxzwtzsj: 'ກະລຸນາເລືອກຂໍ້ມູນທີ່ບໍ່ໄດ້ແຈ້ງເຕືອນເພື່ອຢືນຢັນສົ່ງ',
    ts: 'ຄໍາເຕືອນ',
    czcg: 'ດຳເນີນການສຳເລັດ',
    jflx: 'ປະເພດມອບຮັບ',
    xsxh: 'ເຈົ້າຂອງຕູ້/ເລກຕູ້',
    txfs: 'ວິທີເອົາສິນຄ້າອອກຈາກຄອນເທັນເນີ',
    sfhm: 'ໝາຍເລກຫັຍງຈັກຢ່າງຢູ່ໃນລົດຂົນສົ່ງ',
    pszt: 'ສະພາບຄວາມເສຍຫາຍ',
    qxztxdd: 'ກະລຸນາເລືອກສະຖານທີ່ເອົາສິນຄ້າອອກຕູ້!',
    qxzwjf: 'ກະລຸນາເລືອກບັນທຶກທີ່ຍັງບໍ່ໄດ້ມອບຮັບ',
    hyid: 'IDການຂົນສົ່ງສິນຄ້າ',
    yudh: 'ເລກຈອງຕູ້',
    ydxs: 'ຈໍານວນຕູ້ທີ່ຈອງໄວ້',
    hsxs: 'ກວດ​​ສອບແລະຢືນຢັນ​ຈຳນວນຕູ້ຄອນເທັນເນີ',
    pxs: 'ຈຳນວນທີ່ປະກອບຕູ້',
    tdxs: 'ຈຳນວນຕູ້ທີ່ຍົກ​ເລີກ​ການຈອງ',
    ytxs: 'ຈຳນວນຕູ້ທີ່ໄດ້ຮັບເອົາ',
    apkx: 'ຈັດຕູ້ເປົ່າ',
    pxsj: 'ເວລາຈັດຕູ້',
    lkzr: 'ຄວາມ​ຮັບ​ຜິດ​ຊອບ​ໃນການນຳໃຊ້ຕູ້ຢ່າງບໍ່ໄດ້ຕາມແຜນ',
    lkyy: 'ເຫດຜົນການໃຊ້ຕູ້ບັນຈຸທີ່ບໍ່ໄດ້ຕາມແຜນ',
    tx: 'ຍົກ​ເລີກ​ການໃຊ້ຕູ້',
    hx: 'ປ່ຽນຕູ້',
    zxdd: 'ສະຖານທີ່ບັນຈຸໃສ່ຕູ້',
    tuid: 'ຍົກ​ເລີກ​ການຈອງ',
    khtxhx: 'ລູກຄ້າເອົາຕູ້ - ປ່ຽນຕູ້',
    khtxtx: 'ລູກຄ້າເອົາຕູ້ - ຍົກ​ເລີກ​ການໃຊ້ຕູ້',
    ddh: 'ໝາຍເລກໃບບິນ',
    jzsj: 'ເວລາເຂົ້າສະຖານີ',
    yxxx: 'ຂໍ້ມູນຕູ້ເດີມ',
    xxxx: 'ຂໍ້ມູນຕູ້ໃໝ່',
    qdtjtxd: 'ຢືນຢັນສົ່ງຂໍ້ມູນໃບແຈ້ງເອົາຕູ້ນີ້ຫຼືບໍ?',
    xzxhyw: 'ໝາຍເລກຕູ້ທີ່ເລືອກຜິດ, ກະລຸນາເລືອກໃໝ່ອີກຄັ້ງ',
    xzxhbcz: 'ບໍ່ມີໝາຍເລກຕູ້ທີ່ເລືອກ, ກະລຸນາເລືອກອີກຄັ້ງ',
    xhbncf: 'ເລກຕູ້ບໍ່ສາມາດຊ້ຳກັນ',
    xtdxsbx: 'ຈຳນວນຕູ້20ຟຸດທີ່ຍົກເລີກຈອງຈຳເປັນຕ້ອງແມ່ນຈຳນວນຄູ່',
    xtdxsbx1: 'ຈໍານວນປະເພດຕູ້ 20 ຟຸດຕ້ອງເປັນຈໍານວນຄູ່',
    qdtdcz: 'ຢືນຢັນຍົກເລີກປະຕິບັດການຈອງຫຼືບໍ່?',
    qdtxm: 'ຢືນຢັນຍົກ​ເລີກ​ການໃຊ້ຕູ້ຫຼືບໍ່',
    xxhbncf: 'ເລກທີຕູ້ໃໝ່ບໍ່ສາມາດຊ້ຳກັບເລກທີຕູ້ເກົ່າ',
    qdhxm: 'ຢືນຢັນປ່ຽນຕູ້ຫຼືບໍ່?',
    qsrxqdh: 'ກະລຸນາໃສ່ໝາຍເລກໃບຮ້ອງຂໍ',
    cyrzl: 'ນ້ຳໜັກທີ່ຢືນຢັນໂດຍຜູ້ຂົນສົ່ງ(ກິໂລ)',
    tyrzl: 'ນ້ຳໜັກທີ່ຢືນຢັນໂດຍຜູ້ຝາກເຄື່ອງ(ກິໂລ)',
    qsrxhzz: 'ກະລຸນາໃສ່ນໍ້າໜັກລວມຂອງຕູ້ແລະສິນຄ້າ',
    qsrtyrzl: 'ກະລຸນາໃສ່ນ້ຳໜັກທີ່ຢືນຢັນໂດຍຜູ້ຝາກເຄື່ອງ',
    qsrcyrzl: 'ກະລຸນາໃສ່ນ້ຳໜັກທີ່ຢືນຢັນໂດຍຜູ້ຮັບຜິດຊອບສົ່ງເຄື່ອງ',
    qsrsfh: 'ກະລຸນາໃສ່ໝາຍເລກຫຍັງຈັກຢ່າງທີ່ຢູ່ໃນຂົນສົ່ງ',
    jyyxc: 'ກວດ​ສອບ​ລົດ​ທີ່​ຂົນ​ສົ່ງ​ເຄື່ອງແລ້ວ',
    qrtj: 'ຢືນຢັນຈະສົ່ງບໍ່',
    qrxg: 'ຢືນຢັນການປ່ຽນແປງຫຼືບໍ່?',
    xhzlbnwk: 'ນ້ໍາຫນັກລວມຂອງຕູ້ແລະສິນຄ້າບໍ່ໃຫ້ປະຫວ່າງ',
    tyrzlts: 'ນ້ຳໜັກທີ່ຢືນຢັນໂດຍຜູ້ຝາກເຄື່ອງບໍ່ໃຫ້ປະຫວ່າງ',
    cyrzlts: 'ນ້ຳໜັກທີ່ຢືນຢັນໂດຍຜູ້ຂົນສົ່ງບໍ່ໃຫ້ປະຫວ່າງ',
    xhzzts: 'ນ້ໍາຫນັກລວມຂອງຕູ້ແລະສິນຄ້າບໍ່ສາມາດໜ້ອຍກວ່ານ້ຳໜັກທີ່ຕື່ມໂດຍຜູ້ຮັບສົ່ງ',
    sfhts: 'ເລກຫັຍງຈັກຢ່າງຢູ່ໃນລົດຂົນສົ່ງບໍ່ໃຫ້ປະຫວ່າງ',
    kzxxlb: 'ລາຍການຂໍ້ມູນທີ່ສາມາດໂຫຼດເຄື່ອງໃສ່ໄດ້',
    yznzxlb: 'ລາຍການທີ່ໄດ້ໂຫຼດໃສ່ຕູ້ຢູ່ພາຍໃນສະຖານີ',
    fhdwmc: 'ຊື່ຫນ່ວຍງານຜູ້ຝາກເຄື່ອງ',
    shdwmc: 'ຊື່ໜ່ວຍງານຮັບສິນຄ້າ ',
    fzmc: 'ຊື່ສະຖານີຕົ້ນທາງ',
    dzmc: 'ຊື່ສະຖານີປາຍທາງ',
    xlmc: 'ຊື່ປະເພດຕູ້',
    xsmc: 'ຊື່ເຈົ້າຂອງຕູ້',
    xxmc: 'ຊື່ຮູບແບບຕູ້',
    tip122: 'ລາຍການທີ່ໂຫຼດໃສ່ຕູ້ບໍ່ຕ້ອງດຳເນີນການໂຫຼດຊ້ໍາອີກ',
    tip190: 'ຕ້ອງການຍື່ນສົ່ງຫຼືບໍ',
    zc: 'ບັນຈຸໃສ່ລົດ',
    qxzxh1: 'ກະລຸນາເລືອກເລກຕູ້1',
    qxzxh2: 'ກະລຸນາເລືອກເລກຕູ້2',
    qxzxh3: 'ກະລຸນາເລືອກເລກຕູ້3',
    jg: 'ກົມຄຸ້ມຄອງ',
    fjg: 'ບໍ່​ແມ່ນປົກຄອງໂດຍກົມລົດໄຟ',
    cxbnzyzw: 'ເວລາອອກເສັ້ນບໍ່ສາມາດໄວກວ່າເວລາໂຫຼດໃສ່ເຄື່ອງໃຫ້ສຳເລັດ',
    dzmcbcz: 'ຊື່ສະຖານີປາຍທາງງບໍ່ມີຢູ່, ກະລຸນາເລືອກອີກຄັ້ງ',
    dzbnwk: 'ສະຖານີປາຍທາງບໍ່ສາມາດເປົ່າຫວ່າງ',
    dlhbnwk: 'ໝາຍເລກຄຳສັ່ງບໍ່ສາມາດຫວ່າງເປົ່າໄດ້',
    qdzcm: 'ຢືນຢັນໂຫຼດສິນຄ້າໃສ່ລົດຫຼືບໍ?',
    qdcxdqhs: 'ຢືນຢັນໃຫ້ຍົກເລີກບັນທຶກທີ່ສົ່ງລົດຄືນເພື່ອໂຫຼດໃສ່ສິນຄ້າປະຈຸບັນນີ້ຫຼືບໍ?',
    tip221: 'ເລກຕູ້ທີ1ຂອງXແມ່ນຄືກັນກັບເລກຕູ້ທີ2',
    tip222: 'ເລກຕູ້ທີ1ຂອງXແມ່ນຄືກັນກັບເລກຕູ້ທີ3',
    tip223: 'ເລກຕູ້ທີ1ແລະເລກທີອັນດັບຂອງX',
    tip224: 'ເລກຕູ້ທີ1ຂອງXແມ່ນຄືກັນ',
    tip225: 'ເລກຕູ້ທີ2ຂອງXແມ່ນຄືກັນກັບເລກຕູ້ທີ3',
    tip226: 'ເລກຕູ້ທີ2ແລະເລກທີອັນດັບຂອງX',
    tip227: 'ເລກຕູ້ທີ2ຂອງXແມ່ນຄືກັນ',
    tip228: 'ເລກຕູ້ທີ3ແລະເລກທີອັນດັບຂອງX',
    tip229: 'ເລກຕູ້ທີ3ຂອງXແມ່ນຄືກັນ',
    tip199: 'ບໍ່ໄດ້ເພີ່ມເລກຕູ້ໃດໆ',
    xhbcz: 'ບໍ່ມີເລກຕູ້, ກະລຸນາເພີ່ມໃໝ່ອີກຄັ້ງ',
    wei: 'ເປັນ',
    wzcbktj: 'ເປັນລົດໜັກ,ບໍ່ສາມາດຈັດສົ່ງໄດ້!!!',
    tip323: 'ຕູ້ບັນຈຸທົ່ວໄປບໍ່ສາມາດກັບ',
    tip322: 'ຕູ້ບັນຈຸທົ່ວໄປ',
    tip334: 'ບັນຈຸໃສ່ນຳກັນ',
    tip92: 'ລົດຄັນດຽວສາມາດໂຫຼດໄດ້ພຽງຕູ້ທົ່ວໄປ ຕູ້ 20 ຟຸດ 2 ຕູ້ເທົ່ານັ້ນ',
    clwls: 'ຍານພາຫະນະບໍ່ໄດ້ຮັບການຢືນຢັນແລະບໍ່ສາມາດໂຫຼດໃສ່ໄດ້',
    tip3: 'ບໍ່ສາມາດຍົກເລີກຂໍ້ມູນທີ່ຍັງບໍ່ທັນອອກເສັ້ນ!!!',
    tip120: 'ການຂົນລົງເຄື່ອງຈາກລົດ​ໄດ້ສຳເລັດແລ້ວ, ບໍ່ສາມາດຍົກເລີກໄດ້!!!',
    tip564: 'ລໍຖ້າກວດນໍ້າໜັກ',
    tip565: 'ກວດນໍ້າໜັກແລ້ວ',
    tip566: 'ລໍຖ້າສົ່ງມອບນອກສະຖານີ',
    tip567: 'ສົ່ງມອບນອກສະຖານີແລ້ວ',
    jzxwjf: 'ການມອບຮັບຄອນເທັນເນີທີ່ທາງນອກ',
    zntx: 'ເອົາສິນຄ້າອອກຈາກຄອນເທັນເນີໃນສະຖານີ',
    tzqh: 'ແຈ້ງຮັບເອົາສິນຄ້າ',
    kxhs: 'ສົ່ງຄືນຕູ້ເປົ່າ',
    jjyh: 'ກວດ​ສອບ​ແລະຢືນຢັນ​ນ້ຳໜັກສິນຄ້າ',
    znzx: 'ບັນຈຸໃສ່ຕູ້ໃນສະຖານີ',
    txlr: 'ບັນທຶກການເອົາຕູ້',
    tip196: 'ຍັງບໍ່ໄດ້ເຮັດປີ້,ບໍ່ສາມາດຈັດການດໍາເນີນການອອກເສັ້ນ.',
    xhzz: 'ຕິດຕາມເລກຕູ້',
    xq: 'ຄວາມຕ້ອງການ',
    yianpai: 'ຈັດການແລ້ວ',
    sbxhw: 'ບໍລິສັດຮັບແລະຈັດສົ່ງສິນຄ້າ ໄດ້ກໍານົດຂັ້ນຕອນການຈັດສົ່ງຕູ້ຄອນເທນເນີຈໍານວນໜຶ່ງແລ້ວ ແລະບໍ່ອະນຸຍາດໃຫ້ຍົກເລີກການຈອງຕູ້ຄອນເທນເນີຈໍານວນດັ່ງກ່າວທີ່ຈະເຂົ້າມາຮອດສະຖານນີ'
  },
  confirmationBill: {
    qrzt: 'ຢືນຢັນສະຖານະ',
    dqr: 'ລໍຖ້າການຢືນຢັນ',
    yqr: 'ຢືນຢັນແລ້ວ',
    qrpj: 'ຢືນຢັນປີ້',
    qztitle: 'ຫຼັງ​ຈາກ​ການ​ຢືນ​ຢັນ​, ທ່ານ​ຈະ​ໄດ້​ຮັບ​ການ​ລົງ​ນາມ​ ແລະ​ ຈໍາກາ​ອັດ​ຕະ​ໂນ​ມັດ​, ກະລຸນາຢືນຢັນ',
  },
  jqsd: {
    yssl: 'ປະລິມານການຂົນສົ່ງ',
    dh: 'ເລກໃບບິນ',
    dpd: 'ກໍາລັງລໍຖ້າຈັດສົ່ງ',
    ypd: 'ໄດ້ຈັດສັນໃບສັ່ງຊື້ແລ້ວ',
    pdsj: 'ເວລາລໍຖ້າການຈັດສົ່ງ',
    pdzt: 'ສະຖານະລໍຖ້າການຈັດສົ່ງ',
    jqsdxq: 'ລາຍລະອຽດການຮັບຈັດສົ່ງ',
    cxpd: 'ຈັດສັນການຈັດສົ່ງຄືນໃໝ໋',
    jqsdqrzt: 'ສະຖານະລົງລາຍເຊັນຢືນຢັນ',
    yqr: 'ຢືນຢັນລົງລາຍເຊັນແລ້ວ',
    wqr: 'ຍັງບໍ່ໄດ້ຢືນຢັນລົງລາຍເຊັນ',
    qianren: 'ຢືນຢັນການລົງນາມ',
    qrsj: 'ເວລາເຊັນຢືນຢັນ',
    yxzt: 'ສະຖານະຄວາມມີປະສິດທິພາບ',
    wxnj: 'ສະຖານີລົດໄຟວຽງຈັນໃຕ້(ຊາຍແດນ)',
    hscl: 'ການຈັດການສິນຄ້າທີ່ເສຍຫາຍ',
    plzf: 'ຍົກເລີກຈຳນວນຫຼາຍ',
    slzx: 'ສູນໃຫ້ບໍລິການດໍາເນີນການ',
    qxzslcz: 'ກະລຸນາເລືອກສະຖານີໃຫ້ບໍລິການ',
    slcztext: 'ກະລຸນາເລືອກສະຖານີໃຫ້ບໍລິການ, ຫຼັງຈາກໄດ້ຮັບອະນຸມັດຜ່ານທາງອອນລາຍແລ້ວ, ຕ້ອງນໍາເອົາຂໍ້ມູນຕ່າງໆທີ່ກ່ຽວຂ້ອງເຂົ້າໄປຍືນສົ່ງໃຫ້ກັບສະຖານນີດັ່ງກ່າວເພື່ອນຢືນຢັນພິຈາລະນາອະນຸມັດແບບອອບລາຍ',
    q7tndlxt: 'ກະລຸນາກວດເບິ່ງຄວາມຄືບໜ້າການພິຈາລະນາອະນຸມາດໃນລະບົບ ພາຍໃນ7ວັນ',
    qxdzzwjjxsh: "ກະລຸນາ ນໍາເອົາເອກກະສານສໍາເນົາທີ່ຜ່ານການອັບໂຫຼດລົງທະບຽນແລ້ວ ຕິດຂັດໃສ່ນໍາກັນທັງໝົດ , ແລະໃຫ້ເອົາໄປມອບໃຫ້ກັບສູນຮັບດໍາເນີນການ ເພື່ອຜ່ານການກວດສອບພິຈາລະນາ",
    shjd: 'ຄວາມຄືບໜ້າຂອງການພິຈາລະນາ',
    wcsj: 'ເວລາສໍາເລັດ',
    jg: 'ຜົນຮັບ',
    sjzt: 'ສະຖານະຂໍ້ມູນ',
    czry: 'ຜູ້ດໍາເນີນການໃນລະບົບ',
    wwc: 'ບໍສໍາເລັດ',
    ygx: 'ອັບເດດແລ້ວ',
    zjygx: 'ໜັງສືຢືນຢັນໄດ້ຖືກປັບປຸງແລ້ວ',
    qxg: 'ດໍາເນີນການດັດແກ້',
    scxy: "ອັບໂຫຼດສັນຍາ",
    frsfz: 'ບັດປະຈຳຕົວນິຕິບຸກຄົນ',
    frhz: 'ໜັງສືຜ່ານແດນນິຕິບຸກຄົນ',
    jbrhz: 'ໜັງສືຜ່ານແດນຂອງຕົວແທນທີ່ເປັນຜູ້ປະສານງານ',
    yfkxy: 'ສັນຍາຊໍາລະເງິນລ່ວງໜ້າ',
    yfkxysy: 'ຮູບໜ້າທໍາອິດຂອງສັນຍາຊໍາລະເງິນລ່ວງໜ້າ',
    qscyfkxysy: 'ກະລຸນາອັບໂຫຼດຮູບໜ້າທໍາອິດຂອງສັນຍາຊໍາລະເງິນລ່ວງໜ້າ',
    yfkxywy: '预付款协议双方盖章页照片(es)',
    qscyfkxywy: '请上传预付款协议双方盖章页照片(es)',
    yfkxyyxq: 'ໄລຍະເວລາມີຜົນນໍາໃຊ້ຂອງສັນຍາຊໍາລະເງິນລ່ວງໜ້າ',
    qxzyfkxyyxq: 'ກະລຸນາເລືອກໄລຍະເວລາມີຜົນນໍາໃຊ້ຂອງສັນຍາຊໍາລະເງິນລ່ວງໜ້າ',
    cxtb: "ສົ່ງບົດລາຍງານໃໝ່ອີກຄັ້ງ",
    xgrqyyrqyz: "ວັນທີດັດແກ້ແມ່ນໃຫ້ຄືກັບວັນທີເດີມ",
    tddjj: "ການສົ່ງບົດລາຍງານທີ່ຜ່ານການປັບປຸງ ຖືກປະຕິເສດ",
    jjnr: "ເນື້ອໃນທີ່ປະຕິເສດ",
    xgnr: "ເນື້ອໃນທີ່ດັດແກ້",
    jsrqdayksrq: "ວັນທີວັນສິ້ນສຸດຕ້ອງມີໄລຍະເວລາຫຼາຍກວ່າວັນທີເລີ່ມຕົ້ນ",
    gwjbspdf: "ໄຟລນີ້ ບໍ່ແມ່ນຮູບແບບpdf ແລະບໍ່ສາມາດສະແດງຜົນໄດ້",
    xglc: "ດັດແກ້ ໄລຍະທາງ",
    wlgsjjzt: "ສະຖານະການປະຕິເສດ ບໍລິສັດໂລຈິດສະຕິກ"
  },
  wtlh: {
     qxzqh:"ກະລຸນາເລືອກລະຫັດເຂດ",
    qh:"ລະຫັດເຂດ",
    czslzt:"ສະຖານະການໃຫ້ບໍລິການຂອງສະຖານນີລົດໄຟ",
    wtlh: 'ມອບໝາຍ ຮັບສິນຄ້າ',
    lhcz: 'ສະຖານນີທີ່ຮັບສິນຄ້າ',
    cxdlhw: 'ຄົ້ນຫາຜູ້ຕາງໜັາຮັບສິນຄ້າ',
    lhphone: 'ເບີໂທລະສັບມືຖື ຮັບສິນຄ້າ',
    jbrzjz: 'ຮູບບັດຜູ້ດໍາເນີນການ',
    dlhw: "ລໍຖ້າຮັບສິນຄ້າ",
    qsc: 'ກະລຸນາອັບໂຫຼດ',
    qtwj: 'ເອກະສານອື່ນໆ',
    benren: 'ຜູ້ກ່ຽວ',
    weituo: 'ມອບໝາຍ  ',
    dqxzsc1: 'ປັດຈຸບັນສາມາດອັບໂຫຼດໄດ້ພຽງໄຟລດຽວເທົ່ານັ້ນ',
    zhuxiao: "ລຶບບັນຊີ",
    qdzxdqzhm: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະລຶບບັນຊີປະຈຸບັນຂອງທ່ານ？",
    zcqrzxdqzh: 'ການອອກຈາກລະບົບຈະລຶບຜູ້ໃຊ້ວິສາຫະກິດໃນປະຈຸບັນແລະບໍ່ສາມາດເຂົ້າສູ່ລະບົບໄດ້. ທ່ານຢືນຢັນບໍ？',
    cgnzfbxyfydsj: "ການຍົກເລີກໃນຟັ່ງຊັນນີ້ ແມ່ນບໍ່ມີຄວາມຕ້ອງການດ້ານຂໍ້ມູນການສັ່ງຈອງຕູ້ຄອນເທນເນີເພື່ອການຈັດສົ່ງ, ກະລຸນາຢືນຢັນອີກຄັ້ງ!",
    czyxglyd: "ໃບຂົນສົ່ງສິນຄ້າລະຫວ່າງປະເທດ ຍັງຢູ່ໃນສະຖານະມີຜົນນໍາໃຊ້ຢູ່, ບໍ່ສາມາດຍົກເລີກໄດ້",
    zuid8ws: "ໜ້ອຍສຸດ8ຕົວເລກ",

    zdtj: "ເງື່ອນໄຂການພັບ",
    gdtj: "ເງື່ອນໄຂທີ່ຫຼວງຫຼາຍ",
    dl: "ເຂົ້າສູ່ລະບົບ"
  },
    guide :{
    czsdbgwjsj:"ເວລາທີ່ສະຖານີລົດໄຟ ໄດ້ຮັບເອກະສານລາຍງານ",
    jsqOnly:"ສາມາດດໍາເນີນການ JSQ ເທົ່ານັ້ນ",
    gccyOnly:"ພຽງແຕ່ສາມາດຂົນສົ່ງນໍ້າມັນກະຊວນດ້ວຍຕູ້ຄອນເທນເນີຕາມຮູບແບບຖັງຂະໜາດ20ຟຸດ ເທົ່ານັ້ນ"
  },
  jqsdtj:{
       yilian:'ໃບບິນຢັ້ງຢືນພາສີ ສໍາລັບຜູ້ຮັບສິນຄ້າ',
       binglian:'ໃບບິນຢັ້ງຢືນຄ່າບໍລິການຂອງຜູ້ໃຫ້ບໍລິການ',
      dywlpsd:'ປິ້ນໃບບິນສົ່ງສິນຄ້າໂລຈິດສະຕິກ',
       wlpsd: "ໃບບິນສົ່ງສິນຄ້າໂລຈິດສະຕິກ",
        pddw: "ໜ່ວຍງານຈັດຕັ້ງແບ່ງວຽກງງານ",
        pdr: "ຜູ້ມອບວຽກງງານ",
        pdsj: "ເວລາລໍຖ້າການຈັດສົ່ງ",
        jhsj: "ເວລາສົ່ງມອບສິນຄ້າ",
        khdw: "ໜ່ວຍງານລູກຄ້າ",
        sqhxxdz: "ທີ່ຢູ່ ສົ່ງ(ຮັບ)ສິນຄ້າ ຢ່າງລະອຽດ",
        gls: "ຈໍານວນ ກິໂລແມັດ",
        cxch: "ເລກລົດ ແລະປະເພດລົດ",
        gbdd: "ຈຸດຊັ່ງນໍ້າໜັກ",
        qhshwzk: "ສະພາບສິນຄ້າໃນເວລາຮັບສິນຄ້າ",
        jhshwzk: "ສະພາບສິນຄ້າໃນເວລາສົ່ງມອບສິນຄ້າ",
        zxap: "ການຈັດໂຫຼດແລະຂົນປ່ຽນຖ່າຍສິນຄ້າ",
        hwysyq: "ຂໍ້ກໍານົດການຂົນສົ່ງສິນຄ້າ",
        wtqcysgs: "ມອບໝາຍໃຫ້ບໍລິສັດຂົນສົ່ງລົດ",
        khdfwzlpj: "ລູກຄ້າຕີລາຄາຕໍ່ກັບຄຸນນະພາບການໃຫ້ບໍລິການ",
        fcmy: "ພໍໃຈຫຼາຍ",
        my: "ພໍໃຈ",
        bmy: "ບໍ່ພໍໃຈ",
        yr: "ໄວໄຟ",
        yb: "ລະເບີດງ່າຍ",
        ys: "ແຕກງ່າຍ",
        ps: "ຊຸ່ມງ່າຍ",
        yw: "ມີກິ່ນ",
        yc: "ຂີ້ຝຸ່ນໄງ່ກຸ້ມ",
        jzfg: "ຫ້າມປົກປິດ",
        jzzy: "ຫ້າມກົດແຮງດັນນໍ້າໜັກຫຼາຍ",
        zzfx: "ທິດທາງການໂຫຼດ",
        fzhd: "ປ້ອງກັນການເລື່ອນ",
        fzpz: "ປ້ອງກັນການຕໍາກັນ",
        hwjfr: "ຜູ້ສົ່ງມອບສິນຄ້າ",
        jsy: "ຄົນຂັບລົດ",
        fwlgs: 'ສົ່ງບໍລິສັດຂົນສົ່ງ',
        dwlgs: 'ຮອດບໍລິສັດຂົນສົ່ງ',
        tks:"ຫີນແຮ່ເຫຼັກ",
        tks1:"ຊາຍແຮ່ເຫຼັກ",
        tkf:"ຝຸ່ນແຮ່ເຫຼັກ",
        tjk:"ແຮ່ເຫຼັກທີ່ເຂັ້ມຂຸ້ນ",
			  tjkf:"ຝຸ່ນແຮ່ເຫຼັກທີ່ເຂັ້ມຂຸ້ນ",
			  qttks:"ຫີນແຮ່ເຫຼັກອື່ນໆ"
  },
    zcxz: {
    zcxz1: "Notice on Registration for the Laos-China Railway International Logistics Platform",
    zcxz2: "Welcome to register as a user of the Laos-China Railway International Logistics Platform! Before you begin the registration process, please carefully read the following content to understand our services and user rights and obligations.",
    zcxz3: "User registration and login",
    zcxz4: "You must be at least 19 years old or reach legal age according to the laws of your country/region in order to register as a user. You need to provide accurate, complete, and truthful business or personal information, and ensure timely updates to maintain the accuracy of the information.",
    zcxz5: "Materials required for registration：",
    zcxz6: "Individual users: Name, nationality, mailing address, ID card/passport number and expiration date, mobile phone number, email, photo of the front of the ID card/passport information page, photo of the front of the ID card/passport information page held by the individual.",
    zcxz7: "Enterprise users: enterprise name, enterprise tax number, business license number, registered capital, industry, economic nature, enterprise nature, institution type, enterprise bank account, account opening bank, enterprise phone number, enterprise email, business scope, enterprise address, legal person name, legal person nationality, legal person ID card/passport number and validity period, superior company name, superior company tax number, superior company business license number, business license image and validity period, legal person ID card front/passport information page photo, legal person holding legal person ID card front/passport information page photo, qualification front material image and validity period, authorization certificate image and validity period (to be submitted when the legal person is not the operator), operator name, operator nationality, operator communication address, operator ID card Passport number and expiration date Operator's mobile phone number, operator's email, operator's ID card front/passport information page photo, operator holding ID card front/passport information page photo.",
    zcxz8: "Registration process: ",
    zcxz9: "Individual users: 1. Fill in personal basic information; 2. Choose a service station; 3. Through online review; 4. Bring registration materials to complete offline confirmation.",
    zcxz10: "Enterprise users: 1. Fill in the basic information of the enterprise; 2. Upload identification documents; 3. Fill in the information of the handling person; 4. Choose a service station; 3. Through online review; 4. Carry registration materials and company seal to complete offline confirmation. For enterprise users, you need to provide unique agent information. Once registered successfully, the agent has full authority to handle the enterprise's freight business.",
    zcxz11: "Login process: ",
    zcxz12: "Individual user: Enter the registered phone number and password on the login interface to complete the first login.",
    zcxz13: "Enterprise users: Enter the operator's phone number and registration password on the login interface to complete the first login.",
    zcxz14: "Account security",
    zcxz15: "You are responsible for protecting the security of your account. Please set a password with a length of 8-15 characters, including numbers and uppercase and lowercase letters, and change the password regularly.",
    zcxz16: "Please keep your account information safe and do not share or disclose it with others. If any abnormalities or suspected unauthorized use of your account are found, please contact the official phone number immediately.",
    zcxz17: "User Rights",
    zcxz18: "As a registered user, you have the right to handle freight services within the validity period of relevant documents and certificates. For more details, please refer to the 'Customer Service Agreement of Laos-China Railway International Logistics Platform '.",
    zcxz19: "We will strictly protect your personal information and comply with applicable privacy policies and legal regulations.",
    zcxz20: "User Responsibility",
    zcxz21: "You are responsible for all activities conducted using your account.",
    zcxz22: "You are not allowed to use your account to engage in any illegal, irregular or infringing behavior on the rights and interests of others.",
    zcxz23: "Please comply with the platform's usage standards and code of conduct, and maintain the normal operation of the platform.",
    zcxz24: "Privacy Policy",
    zcxz25: "Our Privacy Policy provides detailed instructions on how we collect, use, store, and protect your personal information. Please read the Privacy Policy to understand how your personal information is processed and used.",
    zcxz26: "Contact Information",
    zcxz27: "If you have any other opinions or suggestions, please contact 856-2026887846.",
    cyjbr:"ຜູ້ດໍາເນີນງານທົ່ວໄປ",
    sfblzcyw:"ສາມາດຂົນສົງເຄືອງຂື້ນລົດໄຟໂດຍຕົງ",
sfbljzxyw:"ສາມາດຂົນສົງຜ່ານຕູຄອນເທັນເນີ",
sfswxp:"ແມ່ນສິນຄ້າທີ່ອັນຕະລາຍຫຼືບໍ່",
lfm:"ແມັດກ້ອນ",
dun:"ໂຕນ",
xj:"ຢາງພາລາ",
lseahf:"ໄດແອມໂມນຽມຟອສເຟດ(ປຸ໋ຍ)",
sf:"ແປ້ງມັນຕົ້ນ",
ms:"ມັນຕົ້ນ",
tks:"ຫີນແຮ່ເຫຼັກ",
tksha:"ໍຊາຍແຮ່ເຫຼັກ",
dg:"ເຫຼັກແຜ່ນບາງ",
xsg:"ໝາກໄມ້ສົດ",
ly:"ໝາກລໍາໄຍ",
xsc:"ຜັກສົດ",
lwg:"ເຫຼັກເສັ້ນ",
scwj:"ອັບໂຫຼດໄຟລ",
spxs:'审批箱数(es)',
hyz:'货运站(es)',
zdqznl:"最大起重能力(es)",
ccqznl:"叉车起重能力(es)",
jzxqznl20:"20英尺集装箱起重能力(es)",
jzxqznl40:"40(45)英尺集装箱起重能力(es)",
hwzzxdbjzz:"箱货总重必须小于等于标记总重(es)",
blfw:"办理范围(es)",
zcblfw:'整车办理范围(es)',
blfspl:"办理发送品类(es)",
blddpl:"办理到达品类(es)",
bblfspl:"不办理发送品类(es)",
bblddpl:"不办理到达品类(es)",
blhwtz:'办理货物特征(es)',
cz:"超重(es)",
cx:'超限(es)',
jzxblfw:"集装箱办理范围(es)",
ycx20:"20英尺箱(es)",
ycx40:"40(45)英尺箱(es)",
gsx20:'20英尺干散箱(es)',
sng20:"20英尺水泥罐式箱(es)",
ytg20:'20英尺液体罐式箱(es)',
lqg20:'20英尺石油沥青罐式箱(es)',
jgx20:'20英尺台架式卷钢箱(es)',
tcd35:"20英尺35t敞顶箱(es)",
wxpblfw:'危险品办理范围(es)',
fspm:"发送品名(es)",
ddpm:"到达品名(es)",
xxxx:'详细信息(es)',
yidao:'已到(es)',
cong:'从(es)',
dao:'到(es)',
dydy0dzs:"请输入大于等于0的整数(es)",
yty:"已同意(es)",
ysx:'已失效(es)',
qxmr:'取消默认(es)',
ddmfzf:"等待买方支付(es)",
qrsh:'确认收货(es)',
ddmfqrsh:"等待买方确认收货(es)",
jiaofu:'交付(es)',
ckjgd:'查看交割单(es)',
smzx:'上门装箱(es)',
wl_zdm:'物流-站到门(es)',
smtx:'上门掏箱(es)',
max40000:'最大值限制为40000kg(es)',
ydyjtjbnxg:'运单一经提交，不能修改，您确认提交？(es)',
ydgxcg:"运单更新成功(es)",
qxzybgdsj:"请选择要变更到站的数据!(es)",
lpxx:"理赔信息(es)",
pctzs:'赔偿通知书(es)',
tpcg:"提赔成功(es)",
myd:'满意度(es)',
jicha:"极差(es)",
shiwang:"失望(es)",
yiban:"一般(es)",
chaozan:"超赞(es)",
tipei:"提赔(es)",
wstpxz:"网上提赔须知(es)",
cxhyjl:"查询货运记录(es)",
tjlpsqs:"提交理赔申请书(es)",
tpsqcg:'提赔申请成功(es)',
hyjlbzzjhm:"货运记录编制站及号码：(es)",
kuche:'库车，王家营192839，1929384(es)',
tpr:"提赔人(单位或姓名)(es)",
yqpcke:"要求赔偿款额(元)(es)",
xxtxdz:"详细通信地址(es)",
lkfs:"领款方式(es)",
yhzzzf:'银行转账支付(es)',
czlqxj:"车站领取现金(es)",
skr:"收款人(单位或姓名)(es)",
skyh:"收款银行(es)",
skzh:"收款账号(es)",
qxzslz:"请选择受理站(es)",
zysx:"注意事项(es)",
zysx1:"填写内容应清楚、准确。(es)",
zysx2:"提赔单位、姓名必须与货物运单或快运货票记载的收货方或托运方相符。(es)",
zysx3:"领款方式选择“银行转账支付”，收款人（单位或姓名）、收款银行、收款账号信息必须填写完整。(es)",
zysx4:"建议您上传理赔的相关资料，并确保资料真实、有效，网上提交资料将加快理赔办理进度。(es)",
zysx5:"您提交的相关资料仅用于本次理赔办理，我们承诺不会向第三方提供。(es)",
dlm:"动力煤(es)",
ljm:"炼焦煤(es)",
wym:"无烟煤(es)",
pcm:"喷吹煤(es)",
kmei:"块煤(es)",
lant:"兰炭(es)",
lplc:"理赔流程(es)",
spxz:"索赔须知(es)",
spxz1:'尊敬的客户：(es)',
spxz2:"在铁路运输过程中，货物发生灭失、短少或者损坏，您可自领到货运记录的次日起180日内，向到站或发站提出赔偿要求。 如果货物超过运到期限，经过30日铁路部门仍不能向您交付货物时，您可以按货物灭失向到站或发站提出赔偿要求。 下列原因造成的货物损失,铁路不承担赔偿责任:(es)",
spxz3:"1.不可抗力;(es)",
spxz4:"2.货物本身的自然属性或者合理损耗;(es)",
spxz5:"3.托运方、收货方或押运人的过错。(es)",
spxz6:"您向铁路提出赔偿要求时，请准确、清楚填写《理赔申请书》，其中提赔单位、姓名必须与货物运单记载的收货方或托运方相符。需转账的，提供的开户行、户名和账号信息必须一致。同时，还需提供以下证明材料：",
spxz7:"1.货运记录（货主页）原件;(es)",
spxz8:"2.货物运单原件;(es)",
spxz9:"3.物品清单（发站没有填制的除外);(es)",
spxz10:"4.其他必要的证明材料。(es)",
spxz11:'如委托他人代理时，还须提供委托书、委托人和被委托人的身份证明复印件。(es)',
spxz12:'办理保价运输的货物，全批货物损失时，赔偿金额最高不超过保价金额；部分损失时，赔偿金额按损失货物占全批货物的比例乘以保价金额赔偿。(es)',
spxz13:"未办理保价运输的货物，按照实际损失赔偿，但最高不超过规定的赔偿限额。(es)",
spxz14:'办理保险运输的货物，您可凭车站出具的货运记录，按照保险合同的约定，到保险公司办理赔偿。(es)',
spxz15:"您在网上提出赔偿要求时，如您已在到站领取货运记录，请您提供货运记录货主页原件的清晰扫描件或照片。(es)",
spxz16:"如您委托他人代理时，还须提供委托书、委托人和被委托人的身份证明原件的清晰扫描件或照片。(es)",
spxz17:"您所提交的资料应真实有效。铁路部门将对您提供的资料进行审核。(es)",
spxz18:'如您需要详细了解有关货物损失赔偿方面的具体事宜，请与车站联系。(es)',
bty:"不同意(es)",
hao:"号(es)",
guanyu:"关于(es)",
you:"由(es)",
zcyd:"站承运到(es)",
hydh:"货运单号(es)",
fasheng:'发生(es)',
hwsspcyqry:'货物损失，赔偿要求人于(es)',
yqtlpc:"要求铁路赔偿(es)",
yiche:"一车，(es)",
yu:"于(es)",
sljshtypc:"受理，经审核同意赔偿(es)",
lqcz:"领取车站(es)",
skrdwhxm:"收款人（单位或姓名）(es)",
bclpdmyd:"本次理赔的满意度(es)",
sfyjtzs:'是否邮寄通知书(es)',
youji:"邮寄(es)",
buyouji:"不邮寄(es)",
jinyi:"建议(es)",
qtcchdl:"请退出重新登录(es)",
yhzz:"银行转账(es)",
czlxj:"车站领现金(es)",
buchong:"补充(es)",
sbd:"所编第(es)",
jilu:"记录(es)",
yshm:"运输号码(es)",
chengyun:"承运(es)",
zcdw:'装车单位(es)',
xcdw:'卸车单位(es)',
chezlx:"车种类型(es)",
clcdd:"次列车到达(es)",
ksxc:'开始卸车(es)',
xiewan:'卸完(es)',
fysfdw:"封印：施封单位(es)",
sfbh:"施封编号(es)",
pbpbhm:'篷布：篷布号码(es)',
baojia:"保价(es)",
xiangmu:"项目(es)",
cyf:"承运方(es)",
pjyjz:'票据原记载按照实际货物损失详细情况(es)',
gcrxhjh:"该车入线货检好，封施有效，开启车门卸见上货码7-9个高，实卸1153件，较王家营站2015年2月9日编1545101号货运记录实装1160件不足7件，车容未满，能容少件，全车卸空无残。(es)",
cjrqz:"参加人签章(es)",
czfzr:"车站负责人(es)",
bzr:"编制人(es)",
gary:"公安人员(es)",
qtry:"其他人员(es)",
zhuangxie:"装卸(es)",
fengyin:'封印(es)',
jfhwsshryj:"交付货物时收货人意见(es)",
yijian:"意见(es)",
kmtlj:"昆明铁路局(es)",
bianzhi:"编制(es)",
qsrzqcxtj:"请输入正确的查询条件(es)",
lingtan:"零摊(es)",
qxzxthwmcsh:'请选择相同货物名称数据(es)',
qxzxthwfwsh:'请选择相同货物范围数据(es)',
jzxyjhz:"集装箱押金回执(es)",
jzxyjhzzp:"集装箱押金回执照片(es)",
jzxyjhzyxq:"集装箱押金回执有效期(es)",
xzdqxqdjxywqqhdsj:"选择当前需求单进行月需求切换的数据有：(es)",
xytcbqwczjjzt:'已提出并且为车站拒绝状态的日需求数据：(es)',
wtcrxqdxqdsj:'未提出日需求的需求单数据有：(es)',
zdksr300:"(最多可输入300字)(es)",
htqsrq:'合同起始日期(es)',
htjzrq:"合同截止日期(es)",
ydlcxqsctxzm:"预订冷藏箱，请上传提箱证明(es)",
gjhgyqydhbtfpbl:"ອີງຕາມຂໍ້ກຳນົດຂອງກົມພາສີ, ສິນຄ້າທີ່ມີເລກຈອງຕູ້ຄອນເທັນເນີທີ່ຕ່າງກັນ，ໃຫ້ດຳເນີນການແຈ້ງພາສີແຍກເປັນແຕ່ລະຊຸດ/ງວດ",
xgyxqh:"修改月需求号(es)",
zbxxx:"自备箱信息(es)",
lwbg:"老挝报关:(es)",
mhbggs:"磨憨报关公司:(es)"
  }
};
